(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree41b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree41b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("afiXk", function(module, exports) {

$parcel$export(module.exports, "Animation", () => $775a02569e721fa4$export$c35d437ae5945fcd);

var $8PkEU = parcelRequire("8PkEU");
parcelRequire("kOgzt");
var $6oLIz = parcelRequire("6oLIz");
const $775a02569e721fa4$var$fetchAnimationData = async (src)=>{
    try {
        const response = await fetch(src);
        return await response.json();
    } catch (error) {
        console.error('Error fetching animation data', error);
        return false;
    }
};
class $775a02569e721fa4$export$c35d437ae5945fcd {
    constructor(canvas, src, options = {}){
        const { autoplay: autoplay = false, loop: loop = false, triggerElement: triggerElement = '', onLoad: onLoad = function() {}, pauseOnExit: pauseOnExit = true, workerId: workerId = 'default' } = options;
        this.canvas = canvas;
        this.src = src;
        // Options
        this.autoplay = autoplay;
        this.loop = loop;
        this.onLoad = onLoad;
        this.pauseOnExit = pauseOnExit;
        this.workerId = workerId;
        this.dotLottie = null;
        // Check for triggers
        if (triggerElement) document.querySelectorAll(triggerElement).forEach((trigger)=>{
            trigger.addEventListener('mouseenter', ()=>{
                this.play();
            });
        });
        // Observe the canvas element
        this.intersectionObserverCallback = this.intersectionObserverCallback.bind(this);
        this.intersectionObserver = new IntersectionObserver(this.intersectionObserverCallback, {
            rootMargin: '400px'
        });
        this.intersectionObserver.observe(this.canvas);
        (0, $6oLIz.addWindowResizeEvent)(()=>this.resize());
    }
    initAnimation = async ()=>{
        const { data: data, aspectRatio: aspectRatio } = await $775a02569e721fa4$var$fetchAnimationData(this.src);
        // If data is false, unobserve the current entry and exit early
        if (!data) {
            this.intersectionObserver.unobserve(this.canvas);
            return;
        }
        // Set the aspect ratio
        if (aspectRatio) {
            this.canvas.style.setProperty('--aspect-ratio', aspectRatio);
            this.canvas.classList.add('known-aspect-ratio');
        }
        this.dotLottie = new (0, $8PkEU.DotLottieWorker)({
            canvas: this.canvas,
            data: data,
            autoplay: this.autoplay,
            loop: this.loop,
            workerId: this.workerId,
            layout: {
                fit: 'contain',
                align: aspectRatio ? [
                    0,
                    0
                ] : [
                    0.5,
                    0.5
                ]
            }
        });
        // On load callback
        this.dotLottie.addEventListener('load', ()=>{
            this.canvas.classList.add('loaded');
            this.onLoad(this.dotLottie);
        });
    };
    intersectionObserverCallback(entries) {
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                if (this.dotLottie === null) this.initAnimation();
                else if (this.autoplay) this.dotLottie.play();
            } else if (this.dotLottie !== null && this.autoplay && this.dotLottie.isPlaying && this.pauseOnExit) this.dotLottie.pause();
        });
    }
    play() {
        this.dotLottie?.play();
    }
    pause() {
        this.dotLottie?.pause();
    }
    stop() {
        this.dotLottie?.stop();
    }
    resize() {
        this.dotLottie?.resize();
    }
}

});
parcelRegister("8PkEU", function(module, exports) {

$parcel$export(module.exports, "DotLottie", () => $66d31c93ca24442f$export$2c434b74e61f4f56);
$parcel$export(module.exports, "DotLottieWorker", () => $66d31c93ca24442f$export$ab8c8a3fed0b35de);
var $66d31c93ca24442f$var$t0 = Object.defineProperty;
var $66d31c93ca24442f$var$n0 = (h, n, a)=>n in h ? $66d31c93ca24442f$var$t0(h, n, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: a
    }) : h[n] = a;
var $66d31c93ca24442f$var$v = (h, n, a)=>$66d31c93ca24442f$var$n0(h, typeof n != "symbol" ? n + "" : n, a);
var $66d31c93ca24442f$var$n2 = class {
    requestAnimationFrame(n) {
        return requestAnimationFrame(n);
    }
    cancelAnimationFrame(n) {
        cancelAnimationFrame(n);
    }
}, $66d31c93ca24442f$var$r2 = class {
    constructor(){
        $66d31c93ca24442f$var$v(this, "_lastHandleId", 0);
        $66d31c93ca24442f$var$v(this, "_lastImmediate", null);
    }
    requestAnimationFrame(n) {
        return this._lastHandleId >= Number.MAX_SAFE_INTEGER && (this._lastHandleId = 0), this._lastHandleId += 1, this._lastImmediate = setImmediate(()=>{
            n(Date.now());
        }), this._lastHandleId;
    }
    cancelAnimationFrame(n) {
        this._lastImmediate && clearImmediate(this._lastImmediate);
    }
}, $66d31c93ca24442f$var$R1 = class {
    constructor(){
        $66d31c93ca24442f$var$v(this, "_strategy");
        this._strategy = typeof requestAnimationFrame == "function" ? new $66d31c93ca24442f$var$n2 : new $66d31c93ca24442f$var$r2;
    }
    requestAnimationFrame(n) {
        return this._strategy.requestAnimationFrame(n);
    }
    cancelAnimationFrame(n) {
        this._strategy.cancelAnimationFrame(n);
    }
};
var $66d31c93ca24442f$var$E = typeof window < "u" && typeof window.document < "u";
var $66d31c93ca24442f$var$O1 = new Uint8Array([
    80,
    75,
    3,
    4
]), $66d31c93ca24442f$var$Q2 = [
    "v",
    "ip",
    "op",
    "layers",
    "fr",
    "w",
    "h"
], $66d31c93ca24442f$var$i2 = "0.47.0", $66d31c93ca24442f$var$a2 = "@lottiefiles/dotlottie-web", $66d31c93ca24442f$var$q2 = .75, $66d31c93ca24442f$var$Y2 = 4;
var $66d31c93ca24442f$var$r0 = (()=>{
    var h = typeof document < "u" ? document.currentScript?.src : void 0;
    return function(n = {}) {
        var a, s = n, m, P, H = new Promise((e, t)=>{
            m = e, P = t;
        }), z = Object.assign({}, s), _1 = "./this.program", A = "", h2;
        typeof document < "u" && document.currentScript && (A = document.currentScript.src), h && (A = h), A.startsWith("blob:") ? A = "" : A = A.substr(0, A.replace(/[?#].*/, "").lastIndexOf("/") + 1), h2 = async (e)=>{
            if (e = await fetch(e, {
                credentials: "same-origin"
            }), e.ok) return e.arrayBuffer();
            throw Error(e.status + " : " + e.url);
        };
        var r3 = s.print || console.log.bind(console), Z = s.printErr || console.error.bind(console);
        Object.assign(s, z), z = null, s.thisProgram && (_1 = s.thisProgram);
        var g1 = s.wasmBinary, y1, b1 = false, D1, K, I, e1, r1, Y, w, p2, f2;
        function v2() {
            var e = y1.buffer;
            s.HEAP8 = K = new Int8Array(e), s.HEAP16 = e1 = new Int16Array(e), s.HEAPU8 = I = new Uint8Array(e), s.HEAPU16 = r1 = new Uint16Array(e), s.HEAP32 = Y = new Int32Array(e), s.HEAPU32 = w = new Uint32Array(e), s.HEAPF32 = p2 = new Float32Array(e), s.HEAPF64 = f2 = new Float64Array(e);
        }
        var m2 = [], _2 = [], g2 = [];
        function i3() {
            var e = s.preRun.shift();
            m2.unshift(e);
        }
        var X = 0, i1 = null;
        function w1(e) {
            throw s.onAbort?.(e), e = "Aborted(" + e + ")", Z(e), b1 = true, e = new WebAssembly.RuntimeError(e + ". Build with -sASSERTIONS for more info."), P(e), e;
        }
        var y2 = (e)=>e.startsWith("data:application/octet-stream;base64,"), W1;
        async function a3(e) {
            if (!g1) try {
                var t = await h2(e);
                return new Uint8Array(t);
            } catch  {}
            if (e == W1 && g1) e = new Uint8Array(g1);
            else throw "both async and sync fetching of the wasm failed";
            return e;
        }
        async function o3(e, t) {
            try {
                var r = await a3(e);
                return await WebAssembly.instantiate(r, t);
            } catch (i) {
                Z(`failed to asynchronously prepare wasm: ${i}`), w1(i);
            }
        }
        async function s3(e) {
            var t = W1;
            if (!g1 && typeof WebAssembly.instantiateStreaming == "function" && !y2(t) && typeof fetch == "function") try {
                var r = fetch(t, {
                    credentials: "same-origin"
                });
                return await WebAssembly.instantiateStreaming(r, e);
            } catch (i) {
                Z(`wasm streaming compile failed: ${i}`), Z("falling back to ArrayBuffer instantiation");
            }
            return o3(t, e);
        }
        class b2 {
            constructor(t){
                $66d31c93ca24442f$var$v(this, "name", "ExitStatus");
                this.message = `Program terminated with exit(${t})`, this.status = t;
            }
        }
        var U1 = (e)=>{
            for(; 0 < e.length;)e.shift()(s);
        }, z1 = s.noExitRuntime || true, w2 = typeof TextDecoder < "u" ? new TextDecoder : void 0, a1 = (e, t = 0, r = NaN)=>{
            var i = t + r;
            for(r = t; e[r] && !(r >= i);)++r;
            if (16 < r - t && e.buffer && w2) return w2.decode(e.subarray(t, r));
            for(i = ""; t < r;){
                var o = e[t++];
                if (o & 128) {
                    var d = e[t++] & 63;
                    if ((o & 224) == 192) i += String.fromCharCode((o & 31) << 6 | d);
                    else {
                        var l = e[t++] & 63;
                        o = (o & 240) == 224 ? (o & 15) << 12 | d << 6 | l : (o & 7) << 18 | d << 12 | l << 6 | e[t++] & 63, 65536 > o ? i += String.fromCharCode(o) : (o -= 65536, i += String.fromCharCode(55296 | o >> 10, 56320 | o & 1023));
                    }
                } else i += String.fromCharCode(o);
            }
            return i;
        }, o1 = 0;
        class L2 {
            constructor(t){
                this.Pa = t - 24;
            }
        }
        var d3 = ()=>{
            var e = [], t = o1;
            if (!t) return f1(0), 0;
            var r = new L2(t);
            w[r.Pa + 16 >> 2] = t;
            var i = w[r.Pa + 4 >> 2];
            if (!i) return f1(0), t;
            for (var o of e){
                if (o === 0 || o === i) break;
                if (B2(o, i, r.Pa + 16)) return f1(o), t;
            }
            return f1(i), t;
        }, s1 = (e, t, r)=>{
            var i = I;
            if (0 < r) {
                r = t + r - 1;
                for(var o = 0; o < e.length; ++o){
                    var d = e.charCodeAt(o);
                    if (55296 <= d && 57343 >= d) {
                        var l = e.charCodeAt(++o);
                        d = 65536 + ((d & 1023) << 10) | l & 1023;
                    }
                    if (127 >= d) {
                        if (t >= r) break;
                        i[t++] = d;
                    } else {
                        if (2047 >= d) {
                            if (t + 1 >= r) break;
                            i[t++] = 192 | d >> 6;
                        } else {
                            if (65535 >= d) {
                                if (t + 2 >= r) break;
                                i[t++] = 224 | d >> 12;
                            } else {
                                if (t + 3 >= r) break;
                                i[t++] = 240 | d >> 18, i[t++] = 128 | d >> 12 & 63;
                            }
                            i[t++] = 128 | d >> 6 & 63;
                        }
                        i[t++] = 128 | d & 63;
                    }
                }
                i[t] = 0;
            }
        }, L1 = {}, $1 = (e)=>{
            for(; e.length;){
                var t = e.pop();
                e.pop()(t);
            }
        };
        function d1(e) {
            return this.fromWireType(w[e >> 2]);
        }
        var t1 = {}, J = {}, C1 = {}, u1, q = (e, t, r)=>{
            function i(u) {
                if (u = r(u), u.length !== e.length) throw new u1("Mismatched type converter count");
                for(var c = 0; c < e.length; ++c)$(e[c], u[c]);
            }
            e.forEach((u)=>C1[u] = t);
            var o = Array(t.length), d = [], l = 0;
            t.forEach((u, c)=>{
                J.hasOwnProperty(u) ? o[c] = J[u] : (d.push(u), t1.hasOwnProperty(u) || (t1[u] = []), t1[u].push(()=>{
                    o[c] = J[u], ++l, l === d.length && i(o);
                }));
            }), d.length === 0 && i(o);
        }, C2, T = (e)=>{
            for(var t = ""; I[e];)t += C2[I[e++]];
            return t;
        }, g;
        function l3(e, t, r = {}) {
            var i = t.name;
            if (!e) throw new g(`type "${i}" must have a positive integer typeid pointer`);
            if (J.hasOwnProperty(e)) {
                if (r.vb) return;
                throw new g(`Cannot register type '${i}' twice`);
            }
            J[e] = t, delete C1[e], t1.hasOwnProperty(e) && (t = t1[e], delete t1[e], t.forEach((o)=>o()));
        }
        function $(e, t, r = {}) {
            return l3(e, t, r);
        }
        var j1 = (e)=>{
            throw new g(e.Oa.Ra.Qa.name + " instance already deleted");
        }, B1 = false, M2 = ()=>{}, E2 = (e, t, r)=>t === r ? e : r.Ua === void 0 ? null : (e = E2(e, t, r.Ua), e === null ? null : r.ob(e)), P2 = {}, c3 = {}, h3 = (e, t)=>{
            if (t === void 0) throw new g("ptr should not be undefined");
            for(; e.Ua;)t = e.eb(t), e = e.Ua;
            return c3[t];
        }, M1 = (e, t)=>{
            if (!t.Ra || !t.Pa) throw new u1("makeClassHandle requires ptr and ptrType");
            if (!!t.Va != !!t.Ta) throw new u1("Both smartPtrType and smartPtr must be specified");
            return t.count = {
                value: 1
            }, l1(Object.create(e, {
                Oa: {
                    value: t,
                    writable: true
                }
            }));
        }, l1 = (e)=>typeof FinalizationRegistry > "u" ? (l1 = (t)=>t, e) : (B1 = new FinalizationRegistry((t)=>{
                t = t.Oa, --t.count.value, t.count.value === 0 && (t.Ta ? t.Va.Ya(t.Ta) : t.Ra.Qa.Ya(t.Pa));
            }), l1 = (t)=>{
                var r = t.Oa;
                return r.Ta && B1.register(t, {
                    Oa: r
                }, t), t;
            }, M2 = (t)=>{
                B1.unregister(t);
            }, l1(e));
        function E1() {}
        var c1 = (e, t)=>Object.defineProperty(t, "name", {
                value: e
            }), I2 = (e, t, r)=>{
            if (e[t].Sa === void 0) {
                var i = e[t];
                e[t] = function(...o) {
                    if (!e[t].Sa.hasOwnProperty(o.length)) throw new g(`Function '${r}' called with an invalid number of arguments (${o.length}) - expects one of (${e[t].Sa})!`);
                    return e[t].Sa[o.length].apply(this, o);
                }, e[t].Sa = [], e[t].Sa[i.ab] = i;
            }
        }, H1 = (e, t, r)=>{
            if (s.hasOwnProperty(e)) {
                if (r === void 0 || s[e].Sa !== void 0 && s[e].Sa[r] !== void 0) throw new g(`Cannot register public name '${e}' twice`);
                if (I2(s, e, e), s[e].Sa.hasOwnProperty(r)) throw new g(`Cannot register multiple overloads of a function with the same number of arguments (${r})!`);
                s[e].Sa[r] = t;
            } else s[e] = t, s[e].ab = r;
        }, f3 = (e)=>{
            e = e.replace(/[^a-zA-Z0-9_]/g, "$");
            var t = e.charCodeAt(0);
            return 48 <= t && 57 >= t ? `_${e}` : e;
        };
        function v3(e, t, r, i, o, d, l, u) {
            this.name = e, this.constructor = t, this.$a = r, this.Ya = i, this.Ua = o, this.qb = d, this.eb = l, this.ob = u, this.xb = [];
        }
        var V1 = (e, t, r)=>{
            for(; t !== r;){
                if (!t.eb) throw new g(`Expected null or instance of ${r.name}, got an instance of ${t.name}`);
                e = t.eb(e), t = t.Ua;
            }
            return e;
        };
        function m3(e, t) {
            if (t === null) {
                if (this.hb) throw new g(`null is not a valid ${this.name}`);
                return 0;
            }
            if (!t.Oa) throw new g(`Cannot pass "${X1(t)}" as a ${this.name}`);
            if (!t.Oa.Pa) throw new g(`Cannot pass deleted object as a pointer of type ${this.name}`);
            return V1(t.Oa.Pa, t.Oa.Ra.Qa, this.Qa);
        }
        function _3(e, t) {
            if (t === null) {
                if (this.hb) throw new g(`null is not a valid ${this.name}`);
                if (this.gb) {
                    var r = this.ib();
                    return e !== null && e.push(this.Ya, r), r;
                }
                return 0;
            }
            if (!t || !t.Oa) throw new g(`Cannot pass "${X1(t)}" as a ${this.name}`);
            if (!t.Oa.Pa) throw new g(`Cannot pass deleted object as a pointer of type ${this.name}`);
            if (!this.fb && t.Oa.Ra.fb) throw new g(`Cannot convert argument of type ${t.Oa.Va ? t.Oa.Va.name : t.Oa.Ra.name} to parameter type ${this.name}`);
            if (r = V1(t.Oa.Pa, t.Oa.Ra.Qa, this.Qa), this.gb) {
                if (t.Oa.Ta === void 0) throw new g("Passing raw pointer to smart pointer is illegal");
                switch(this.Cb){
                    case 0:
                        if (t.Oa.Va === this) r = t.Oa.Ta;
                        else throw new g(`Cannot convert argument of type ${t.Oa.Va ? t.Oa.Va.name : t.Oa.Ra.name} to parameter type ${this.name}`);
                        break;
                    case 1:
                        r = t.Oa.Ta;
                        break;
                    case 2:
                        if (t.Oa.Va === this) r = t.Oa.Ta;
                        else {
                            var i = t.clone();
                            r = this.yb(r, S1(()=>i.delete())), e !== null && e.push(this.Ya, r);
                        }
                        break;
                    default:
                        throw new g("Unsupporting sharing policy");
                }
            }
            return r;
        }
        function g3(e, t) {
            if (t === null) {
                if (this.hb) throw new g(`null is not a valid ${this.name}`);
                return 0;
            }
            if (!t.Oa) throw new g(`Cannot pass "${X1(t)}" as a ${this.name}`);
            if (!t.Oa.Pa) throw new g(`Cannot pass deleted object as a pointer of type ${this.name}`);
            if (t.Oa.Ra.fb) throw new g(`Cannot convert argument of type ${t.Oa.Ra.name} to parameter type ${this.name}`);
            return V1(t.Oa.Pa, t.Oa.Ra.Qa, this.Qa);
        }
        function h1(e, t, r, i, o, d, l, u, c, p, f) {
            this.name = e, this.Qa = t, this.hb = r, this.fb = i, this.gb = o, this.wb = d, this.Cb = l, this.mb = u, this.ib = c, this.yb = p, this.Ya = f, o || t.Ua !== void 0 ? this.toWireType = _3 : (this.toWireType = i ? m3 : g3, this.Xa = null);
        }
        var S2 = (e, t, r)=>{
            if (!s.hasOwnProperty(e)) throw new u1("Replacing nonexistent public symbol");
            s[e].Sa !== void 0 && r !== void 0 ? s[e].Sa[r] = t : (s[e] = t, s[e].ab = r);
        }, S, y3 = (e, t, r = [])=>(e.includes("j") ? (e = e.replace(/p/g, "i"), t = (0, s["dynCall_" + e])(t, ...r)) : t = S.get(t)(...r), t), b3 = (e, t)=>(...r)=>y3(e, t, r), O = (e, t)=>{
            e = T(e);
            var r = e.includes("j") ? b3(e, t) : S.get(t);
            if (typeof r != "function") throw new g(`unknown function pointer with signature ${e}: ${t}`);
            return r;
        }, T2, F2 = (e)=>{
            e = $2(e);
            var t = T(e);
            return N(e), t;
        }, P1 = (e, t)=>{
            function r(d) {
                o[d] || J[d] || (C1[d] ? C1[d].forEach(r) : (i.push(d), o[d] = true));
            }
            var i = [], o = {};
            throw t.forEach(r), new T2(`${e}: ` + i.map(F2).join([
                ", "
            ]));
        }, N1 = (e, t)=>{
            for(var r = [], i = 0; i < e; i++)r.push(w[t + 4 * i >> 2]);
            return r;
        };
        function w3(e) {
            for(var t = 1; t < e.length; ++t)if (e[t] !== null && e[t].Xa === void 0) return true;
            return false;
        }
        function Q1(e, t, r, i, o) {
            var d = t.length;
            if (2 > d) throw new g("argTypes array size mismatch! Must at least get return value and 'this' types!");
            var l = t[1] !== null && r !== null, u = w3(t), c = t[0].name !== "void", p = d - 2, f = Array(p), _ = [], b = [];
            return c1(e, function(...W) {
                if (b.length = 0, _.length = l ? 2 : 1, _[0] = o, l) {
                    var C = t[1].toWireType(b, this);
                    _[1] = C;
                }
                for(var M = 0; M < p; ++M)f[M] = t[M + 2].toWireType(b, W[M]), _.push(f[M]);
                if (W = i(..._), u) $1(b);
                else for(M = l ? 1 : 2; M < t.length; M++){
                    var j = M === 1 ? C : f[M - 2];
                    t[M].Xa !== null && t[M].Xa(j);
                }
                return C = c ? t[0].fromWireType(W) : void 0, C;
            });
        }
        var x2 = (e)=>{
            e = e.trim();
            let t = e.indexOf("(");
            return t !== -1 ? e.substr(0, t) : e;
        }, q1 = [], V = [], Y1 = (e)=>{
            9 < e && --V[e + 1] === 0 && (V[e] = void 0, q1.push(e));
        }, I1 = (e)=>{
            if (!e) throw new g("Cannot use deleted val. handle = " + e);
            return V[e];
        }, S1 = (e)=>{
            switch(e){
                case void 0:
                    return 2;
                case null:
                    return 4;
                case true:
                    return 6;
                case false:
                    return 8;
                default:
                    let t = q1.pop() || V.length;
                    return V[t] = e, V[t + 1] = 1, t;
            }
        }, R2 = {
            name: "emscripten::val",
            fromWireType: (e)=>{
                var t = I1(e);
                return Y1(e), t;
            },
            toWireType: (e, t)=>S1(t),
            Wa: 8,
            readValueFromPointer: d1,
            Xa: null
        }, L3 = (e, t, r)=>{
            switch(t){
                case 1:
                    return r ? function(i) {
                        return this.fromWireType(K[i]);
                    } : function(i) {
                        return this.fromWireType(I[i]);
                    };
                case 2:
                    return r ? function(i) {
                        return this.fromWireType(e1[i >> 1]);
                    } : function(i) {
                        return this.fromWireType(r1[i >> 1]);
                    };
                case 4:
                    return r ? function(i) {
                        return this.fromWireType(Y[i >> 2]);
                    } : function(i) {
                        return this.fromWireType(w[i >> 2]);
                    };
                default:
                    throw new TypeError(`invalid integer width (${t}): ${e}`);
            }
        }, T1 = (e, t)=>{
            var r = J[e];
            if (r === void 0) throw e = `${t} has unknown type ${F2(e)}`, new g(e);
            return r;
        }, X1 = (e)=>{
            if (e === null) return "null";
            var t = typeof e;
            return t === "object" || t === "array" || t === "function" ? e.toString() : "" + e;
        }, C3 = (e, t)=>{
            switch(t){
                case 4:
                    return function(r) {
                        return this.fromWireType(p2[r >> 2]);
                    };
                case 8:
                    return function(r) {
                        return this.fromWireType(f2[r >> 3]);
                    };
                default:
                    throw new TypeError(`invalid float width (${t}): ${e}`);
            }
        }, M3 = (e, t, r)=>{
            switch(t){
                case 1:
                    return r ? (i)=>K[i] : (i)=>I[i];
                case 2:
                    return r ? (i)=>e1[i >> 1] : (i)=>r1[i >> 1];
                case 4:
                    return r ? (i)=>Y[i >> 2] : (i)=>w[i >> 2];
                default:
                    throw new TypeError(`invalid integer width (${t}): ${e}`);
            }
        }, E3 = Object.assign({
            optional: true
        }, R2), O2 = typeof TextDecoder < "u" ? new TextDecoder("utf-16le") : void 0, P3 = (e, t)=>{
            for(var r = e >> 1, i = r + t / 2; !(r >= i) && r1[r];)++r;
            if (r <<= 1, 32 < r - e && O2) return O2.decode(I.subarray(e, r));
            for(r = "", i = 0; !(i >= t / 2); ++i){
                var o = e1[e + 2 * i >> 1];
                if (o == 0) break;
                r += String.fromCharCode(o);
            }
            return r;
        }, I3 = (e, t, r)=>{
            if (r ?? (r = 2147483647), 2 > r) return 0;
            r -= 2;
            var i = t;
            r = r < 2 * e.length ? r / 2 : e.length;
            for(var o = 0; o < r; ++o)e1[t >> 1] = e.charCodeAt(o), t += 2;
            return e1[t >> 1] = 0, t - i;
        }, S3 = (e)=>2 * e.length, T3 = (e, t)=>{
            for(var r = 0, i = ""; !(r >= t / 4);){
                var o = Y[e + 4 * r >> 2];
                if (o == 0) break;
                ++r, 65536 <= o ? (o -= 65536, i += String.fromCharCode(55296 | o >> 10, 56320 | o & 1023)) : i += String.fromCharCode(o);
            }
            return i;
        }, F3 = (e, t, r)=>{
            if (r ?? (r = 2147483647), 4 > r) return 0;
            var i = t;
            r = i + r - 4;
            for(var o = 0; o < e.length; ++o){
                var d = e.charCodeAt(o);
                if (55296 <= d && 57343 >= d) {
                    var l = e.charCodeAt(++o);
                    d = 65536 + ((d & 1023) << 10) | l & 1023;
                }
                if (Y[t >> 2] = d, t += 4, t + 4 > r) break;
            }
            return Y[t >> 2] = 0, t - i;
        }, x3 = (e)=>{
            for(var t = 0, r = 0; r < e.length; ++r){
                var i = e.charCodeAt(r);
                55296 <= i && 57343 >= i && ++r, t += 4;
            }
            return t;
        }, J1 = 0, A2 = (e, t, r)=>{
            var i = [];
            return e = e.toWireType(i, r), i.length && (w[t >> 2] = S1(i)), e;
        }, G1 = [], R3 = (e)=>{
            var t = G1.length;
            return G1.push(e), t;
        }, O3 = (e, t)=>{
            for(var r = Array(e), i = 0; i < e; ++i)r[i] = T1(w[t + 4 * i >> 2], "parameter " + i);
            return r;
        }, A3 = Reflect.construct, p1 = {}, k2 = (e)=>{
            if (!(e instanceof b2 || e == "unwind")) throw e;
        }, D2 = (e)=>{
            throw D1 = e, z1 || 0 < J1 || (s.onExit?.(e), b1 = true), new b2(e);
        }, k3 = (e)=>{
            if (!b1) try {
                if (e(), !(z1 || 0 < J1)) try {
                    D1 = e = D1, D2(e);
                } catch (t) {
                    k2(t);
                }
            } catch (t) {
                k2(t);
            }
        }, Z1 = {}, W2 = ()=>{
            if (!K1) {
                var e = {
                    USER: "web_user",
                    LOGNAME: "web_user",
                    PATH: "/",
                    PWD: "/",
                    HOME: "/home/web_user",
                    LANG: (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8",
                    _: _1 || "./this.program"
                }, t;
                for(t in Z1)Z1[t] === void 0 ? delete e[t] : e[t] = Z1[t];
                var r = [];
                for(t in e)r.push(`${t}=${e[t]}`);
                K1 = r;
            }
            return K1;
        }, K1, D3 = [
            null,
            [],
            []
        ], W3 = ()=>{
            if (typeof crypto == "object" && typeof crypto.getRandomValues == "function") return (e)=>crypto.getRandomValues(e);
            w1("initRandomDevice");
        }, U2 = (e)=>(U2 = W3())(e);
        u1 = s.InternalError = class extends Error {
            constructor(e){
                super(e), this.name = "InternalError";
            }
        };
        for(var z2 = Array(256), F1 = 0; 256 > F1; ++F1)z2[F1] = String.fromCharCode(F1);
        C2 = z2, g = s.BindingError = class extends Error {
            constructor(e){
                super(e), this.name = "BindingError";
            }
        }, Object.assign(E1.prototype, {
            isAliasOf: function(e) {
                if (!(this instanceof E1 && e instanceof E1)) return false;
                var t = this.Oa.Ra.Qa, r = this.Oa.Pa;
                e.Oa = e.Oa;
                var i = e.Oa.Ra.Qa;
                for(e = e.Oa.Pa; t.Ua;)r = t.eb(r), t = t.Ua;
                for(; i.Ua;)e = i.eb(e), i = i.Ua;
                return t === i && r === e;
            },
            clone: function() {
                if (this.Oa.Pa || j1(this), this.Oa.cb) return this.Oa.count.value += 1, this;
                var e = l1, t = Object, r = t.create, i = Object.getPrototypeOf(this), o = this.Oa;
                return e = e(r.call(t, i, {
                    Oa: {
                        value: {
                            count: o.count,
                            bb: o.bb,
                            cb: o.cb,
                            Pa: o.Pa,
                            Ra: o.Ra,
                            Ta: o.Ta,
                            Va: o.Va
                        }
                    }
                })), e.Oa.count.value += 1, e.Oa.bb = false, e;
            },
            delete () {
                if (this.Oa.Pa || j1(this), this.Oa.bb && !this.Oa.cb) throw new g("Object already scheduled for deletion");
                M2(this);
                var e = this.Oa;
                --e.count.value, e.count.value === 0 && (e.Ta ? e.Va.Ya(e.Ta) : e.Ra.Qa.Ya(e.Pa)), this.Oa.cb || (this.Oa.Ta = void 0, this.Oa.Pa = void 0);
            },
            isDeleted: function() {
                return !this.Oa.Pa;
            },
            deleteLater: function() {
                if (this.Oa.Pa || j1(this), this.Oa.bb && !this.Oa.cb) throw new g("Object already scheduled for deletion");
                return this.Oa.bb = true, this;
            }
        }), Object.assign(h1.prototype, {
            rb (e) {
                return this.mb && (e = this.mb(e)), e;
            },
            kb (e) {
                this.Ya?.(e);
            },
            Wa: 8,
            readValueFromPointer: d1,
            fromWireType: function(e) {
                function t() {
                    return this.gb ? M1(this.Qa.$a, {
                        Ra: this.wb,
                        Pa: r,
                        Va: this,
                        Ta: e
                    }) : M1(this.Qa.$a, {
                        Ra: this,
                        Pa: e
                    });
                }
                var r = this.rb(e);
                if (!r) return this.kb(e), null;
                var i = h3(this.Qa, r);
                if (i !== void 0) return i.Oa.count.value === 0 ? (i.Oa.Pa = r, i.Oa.Ta = e, i.clone()) : (i = i.clone(), this.kb(e), i);
                if (i = this.Qa.qb(r), i = P2[i], !i) return t.call(this);
                i = this.fb ? i.nb : i.pointerType;
                var o = E2(r, this.Qa, i.Qa);
                return o === null ? t.call(this) : this.gb ? M1(i.Qa.$a, {
                    Ra: i,
                    Pa: o,
                    Va: this,
                    Ta: e
                }) : M1(i.Qa.$a, {
                    Ra: i,
                    Pa: o
                });
            }
        }), T2 = s.UnboundTypeError = ((e, t)=>{
            var r = c1(t, function(i) {
                this.name = t, this.message = i, i = Error(i).stack, i !== void 0 && (this.stack = this.toString() + `
` + i.replace(/^Error(:[^\n]*)?\n/, ""));
            });
            return r.prototype = Object.create(e.prototype), r.prototype.constructor = r, r.prototype.toString = function() {
                return this.message === void 0 ? this.name : `${this.name}: ${this.message}`;
            }, r;
        })(Error, "UnboundTypeError"), V.push(0, 1, void 0, 1, null, 1, true, 1, false, 1), s.count_emval_handles = ()=>V.length / 2 - 5 - q1.length;
        var U3 = {
            d: (e, t, r, i)=>w1(`Assertion failed: ${e ? a1(I, e) : ""}, at: ` + [
                    t ? t ? a1(I, t) : "" : "unknown filename",
                    r,
                    i ? i ? a1(I, i) : "" : "unknown function"
                ]),
            c: ()=>d3(),
            n: (e, t, r)=>{
                var i = new L2(e);
                throw w[i.Pa + 16 >> 2] = 0, w[i.Pa + 4 >> 2] = t, w[i.Pa + 8 >> 2] = r, o1 = e, o1;
            },
            e: (e)=>{
                throw o1 || (o1 = e), o1;
            },
            T: ()=>{},
            Q: ()=>{},
            R: ()=>{},
            V: function() {},
            S: ()=>{},
            X: ()=>w1(""),
            w: (e)=>{
                var t = L1[e];
                delete L1[e];
                var r = t.ib, i = t.Ya, o = t.lb, d = o.map((l)=>l.ub).concat(o.map((l)=>l.Ab));
                q([
                    e
                ], d, (l)=>{
                    var u = {};
                    return o.forEach((c, p)=>{
                        var f = l[p], _ = c.sb, b = c.tb, W = l[p + o.length], C = c.zb, M = c.Bb;
                        u[c.pb] = {
                            read: (j)=>f.fromWireType(_(b, j)),
                            write: (j, v1)=>{
                                var U = [];
                                C(M, j, W.toWireType(U, v1)), $1(U);
                            }
                        };
                    }), [
                        {
                            name: t.name,
                            fromWireType: (c)=>{
                                var p = {}, f;
                                for(f in u)p[f] = u[f].read(c);
                                return i(c), p;
                            },
                            toWireType: (c, p)=>{
                                for(var f in u)if (!(f in p)) throw new TypeError(`Missing field: "${f}"`);
                                var _ = r();
                                for(f in u)u[f].write(_, p[f]);
                                return c !== null && c.push(i, _), _;
                            },
                            Wa: 8,
                            readValueFromPointer: d1,
                            Xa: i
                        }
                    ];
                });
            },
            H: ()=>{},
            fa: (e, t, r, i)=>{
                t = T(t), $(e, {
                    name: t,
                    fromWireType: function(o) {
                        return !!o;
                    },
                    toWireType: function(o, d) {
                        return d ? r : i;
                    },
                    Wa: 8,
                    readValueFromPointer: function(o) {
                        return this.fromWireType(I[o]);
                    },
                    Xa: null
                });
            },
            u: (e, t, r, i, o, d, l, u, c, p, f, _, b)=>{
                f = T(f), d = O(o, d), u && (u = O(l, u)), p && (p = O(c, p)), b = O(_, b);
                var W = f3(f);
                H1(W, function() {
                    P1(`Cannot construct ${f} due to unbound types`, [
                        i
                    ]);
                }), q([
                    e,
                    t,
                    r
                ], i ? [
                    i
                ] : [], (C)=>{
                    if (C = C[0], i) var M = C.Qa, j = M.$a;
                    else j = E1.prototype;
                    C = c1(f, function(...t2) {
                        if (Object.getPrototypeOf(this) !== v1) throw new g("Use 'new' to construct " + f);
                        if (U.Za === void 0) throw new g(f + " has no accessible constructor");
                        var N2 = U.Za[t2.length];
                        if (N2 === void 0) throw new g(`Tried to invoke ctor of ${f} with invalid number of parameters (${t2.length}) - expected (${Object.keys(U.Za).toString()}) parameters instead!`);
                        return N2.apply(this, t2);
                    });
                    var v1 = Object.create(j, {
                        constructor: {
                            value: C
                        }
                    });
                    C.prototype = v1;
                    var U = new v3(f, C, v1, b, M, d, u, p);
                    if (U.Ua) {
                        var m1;
                        (m1 = U.Ua).jb ?? (m1.jb = []), U.Ua.jb.push(U);
                    }
                    return M = new h1(f, U, true, false, false), m1 = new h1(f + "*", U, false, false, false), j = new h1(f + " const*", U, false, true, false), P2[e] = {
                        pointerType: m1,
                        nb: j
                    }, S2(W, C), [
                        M,
                        m1,
                        j
                    ];
                });
            },
            t: (e, t, r, i, o, d)=>{
                var l = N1(t, r);
                o = O(i, o), q([], [
                    e
                ], (u)=>{
                    u = u[0];
                    var c = `constructor ${u.name}`;
                    if (u.Qa.Za === void 0 && (u.Qa.Za = []), u.Qa.Za[t - 1] !== void 0) throw new g(`Cannot register multiple constructors with identical number of parameters (${t - 1}) for class '${u.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
                    return u.Qa.Za[t - 1] = ()=>{
                        P1(`Cannot construct ${u.name} due to unbound types`, l);
                    }, q([], l, (p)=>(p.splice(1, 0, null), u.Qa.Za[t - 1] = Q1(c, p, null, o, d), [])), [];
                });
            },
            h: (e, t, r, i, o, d, l, u)=>{
                var c = N1(r, i);
                t = T(t), t = x2(t), d = O(o, d), q([], [
                    e
                ], (p)=>{
                    function f() {
                        P1(`Cannot call ${_} due to unbound types`, c);
                    }
                    p = p[0];
                    var _ = `${p.name}.${t}`;
                    t.startsWith("@@") && (t = Symbol[t.substring(2)]), u && p.Qa.xb.push(t);
                    var b = p.Qa.$a, W = b[t];
                    return W === void 0 || W.Sa === void 0 && W.className !== p.name && W.ab === r - 2 ? (f.ab = r - 2, f.className = p.name, b[t] = f) : (I2(b, t, _), b[t].Sa[r - 2] = f), q([], c, (C)=>(C = Q1(_, C, p, d, l), b[t].Sa === void 0 ? (C.ab = r - 2, b[t] = C) : b[t].Sa[r - 2] = C, [])), [];
                });
            },
            da: (e)=>$(e, R2),
            y: (e, t, r, i)=>{
                function o() {}
                t = T(t), o.values = {}, $(e, {
                    name: t,
                    constructor: o,
                    fromWireType: function(d) {
                        return this.constructor.values[d];
                    },
                    toWireType: (d, l)=>l.value,
                    Wa: 8,
                    readValueFromPointer: L3(t, r, i),
                    Xa: null
                }), H1(t, o);
            },
            l: (e, t, r)=>{
                var i = T1(e, "enum");
                t = T(t), e = i.constructor, i = Object.create(i.constructor.prototype, {
                    value: {
                        value: r
                    },
                    constructor: {
                        value: c1(`${i.name}_${t}`, function() {})
                    }
                }), e.values[r] = i, e[t] = i;
            },
            E: (e, t, r)=>{
                t = T(t), $(e, {
                    name: t,
                    fromWireType: (i)=>i,
                    toWireType: (i, o)=>o,
                    Wa: 8,
                    readValueFromPointer: C3(t, r),
                    Xa: null
                });
            },
            v: (e, t, r, i, o, d)=>{
                var l = N1(t, r);
                e = T(e), e = x2(e), o = O(i, o), H1(e, function() {
                    P1(`Cannot call ${e} due to unbound types`, l);
                }, t - 1), q([], l, (u)=>(S2(e, Q1(e, [
                        u[0],
                        null
                    ].concat(u.slice(1)), null, o, d), t - 1), []));
            },
            p: (e, t, r, i, o)=>{
                if (t = T(t), o === -1 && (o = 4294967295), o = (u)=>u, i === 0) {
                    var d = 32 - 8 * r;
                    o = (u)=>u << d >>> d;
                }
                var l = t.includes("unsigned") ? function(u, c) {
                    return c >>> 0;
                } : function(u, c) {
                    return c;
                };
                $(e, {
                    name: t,
                    fromWireType: o,
                    toWireType: l,
                    Wa: 8,
                    readValueFromPointer: M3(t, r, i !== 0),
                    Xa: null
                });
            },
            k: (e, t, r)=>{
                function i(d) {
                    return new o(K.buffer, w[d + 4 >> 2], w[d >> 2]);
                }
                var o = [
                    Int8Array,
                    Uint8Array,
                    Int16Array,
                    Uint16Array,
                    Int32Array,
                    Uint32Array,
                    Float32Array,
                    Float64Array
                ][t];
                r = T(r), $(e, {
                    name: r,
                    fromWireType: i,
                    Wa: 8,
                    readValueFromPointer: i
                }, {
                    vb: true
                });
            },
            x: (e)=>{
                $(e, E3);
            },
            la: (e, t, r, i, o, d, l, u, c, p, f, _)=>{
                r = T(r), d = O(o, d), u = O(l, u), p = O(c, p), _ = O(f, _), q([
                    e
                ], [
                    t
                ], (b)=>(b = b[0], [
                        new h1(r, b.Qa, false, false, true, b, i, d, u, p, _)
                    ]));
            },
            ea: (e, t)=>{
                t = T(t), $(e, {
                    name: t,
                    fromWireType: function(r) {
                        for(var i = w[r >> 2], o = r + 4, d, l = o, u = 0; u <= i; ++u){
                            var c = o + u;
                            (u == i || I[c] == 0) && (l = l ? a1(I, l, c - l) : "", d === void 0 ? d = l : (d += "\0", d += l), l = c + 1);
                        }
                        return N(r), d;
                    },
                    toWireType: function(r, i) {
                        i instanceof ArrayBuffer && (i = new Uint8Array(i));
                        var o, d = typeof i == "string";
                        if (!(d || i instanceof Uint8Array || i instanceof Uint8ClampedArray || i instanceof Int8Array)) throw new g("Cannot pass non-string to std::string");
                        if (d) for(var l = o = 0; l < i.length; ++l){
                            var u = i.charCodeAt(l);
                            127 >= u ? o++ : 2047 >= u ? o += 2 : 55296 <= u && 57343 >= u ? (o += 4, ++l) : o += 3;
                        }
                        else o = i.length;
                        if (l = e2(4 + o + 1), u = l + 4, w[l >> 2] = o, d) s1(i, u, o + 1);
                        else if (d) for(d = 0; d < o; ++d){
                            var c = i.charCodeAt(d);
                            if (255 < c) throw N(u), new g("String has UTF-16 code units that do not fit in 8 bits");
                            I[u + d] = c;
                        }
                        else for(d = 0; d < o; ++d)I[u + d] = i[d];
                        return r !== null && r.push(N, l), l;
                    },
                    Wa: 8,
                    readValueFromPointer: d1,
                    Xa (r) {
                        N(r);
                    }
                });
            },
            A: (e, t, r)=>{
                if (r = T(r), t === 2) var i = P3, o = I3, d = S3, l = (u)=>r1[u >> 1];
                else t === 4 && (i = T3, o = F3, d = x3, l = (u)=>w[u >> 2]);
                $(e, {
                    name: r,
                    fromWireType: (u)=>{
                        for(var c = w[u >> 2], p, f = u + 4, _ = 0; _ <= c; ++_){
                            var b = u + 4 + _ * t;
                            (_ == c || l(b) == 0) && (f = i(f, b - f), p === void 0 ? p = f : (p += "\0", p += f), f = b + t);
                        }
                        return N(u), p;
                    },
                    toWireType: (u, c)=>{
                        if (typeof c != "string") throw new g(`Cannot pass non-string to C++ string type ${r}`);
                        var p = d(c), f = e2(4 + p + t);
                        return w[f >> 2] = p / t, o(c, f + 4, p + t), u !== null && u.push(N, f), f;
                    },
                    Wa: 8,
                    readValueFromPointer: d1,
                    Xa (u) {
                        N(u);
                    }
                });
            },
            s: (e, t, r, i, o, d)=>{
                L1[e] = {
                    name: T(t),
                    ib: O(r, i),
                    Ya: O(o, d),
                    lb: []
                };
            },
            m: (e, t, r, i, o, d, l, u, c, p)=>{
                L1[e].lb.push({
                    pb: T(t),
                    ub: r,
                    sb: O(i, o),
                    tb: d,
                    Ab: l,
                    zb: O(u, c),
                    Bb: p
                });
            },
            ga: (e, t)=>{
                t = T(t), $(e, {
                    Db: true,
                    name: t,
                    Wa: 0,
                    fromWireType: ()=>{},
                    toWireType: ()=>{}
                });
            },
            O: ()=>{
                z1 = false, J1 = 0;
            },
            I: ()=>{
                throw 1 / 0;
            },
            F: (e, t, r)=>(e = I1(e), t = T1(t, "emval::as"), A2(t, r, e)),
            ja: (e, t, r, i)=>(e = G1[e], t = I1(t), e(null, t, r, i)),
            M: Y1,
            ia: (e, t, r)=>{
                var i = O3(e, t), o = i.shift();
                e--;
                var d = Array(e);
                return t = `methodCaller<(${i.map((l)=>l.name).join(", ")}) => ${o.name}>`, R3(c1(t, (l, u, c, p)=>{
                    for(var f = 0, _ = 0; _ < e; ++_)d[_] = i[_].readValueFromPointer(p + f), f += i[_].Wa;
                    return l = r === 1 ? A3(u, d) : u.apply(l, d), A2(o, c, l);
                }));
            },
            ka: (e)=>{
                9 < e && (V[e + 1] += 1);
            },
            ha: (e)=>{
                var t = I1(e);
                $1(t), Y1(e);
            },
            r: (e, t)=>(e = T1(e, "_emval_take_value"), e = e.readValueFromPointer(t), S1(e)),
            K: (e, t)=>{
                if (p1[e] && (clearTimeout(p1[e].id), delete p1[e]), !t) return 0;
                var r = setTimeout(()=>{
                    delete p1[e], k3(()=>j2(e, performance.now()));
                }, t);
                return p1[e] = {
                    id: r,
                    Eb: t
                }, 0;
            },
            L: (e, t, r, i)=>{
                var o = new Date().getFullYear(), d = new Date(o, 0, 1).getTimezoneOffset();
                o = new Date(o, 6, 1).getTimezoneOffset(), w[e >> 2] = 60 * Math.max(d, o), Y[t >> 2] = +(d != o), t = (l)=>{
                    var u = Math.abs(l);
                    return `UTC${0 <= l ? "-" : "+"}${String(Math.floor(u / 60)).padStart(2, "0")}${String(u % 60).padStart(2, "0")}`;
                }, e = t(d), t = t(o), o < d ? (s1(e, r, 17), s1(t, i, 17)) : (s1(e, i, 17), s1(t, r, 17));
            },
            ca: ()=>performance.now(),
            N: (e)=>{
                var t = I.length;
                if (e >>>= 0, 2147483648 < e) return false;
                for(var r = 1; 4 >= r; r *= 2){
                    var i = t * (1 + .2 / r);
                    i = Math.min(i, e + 100663296);
                    e: {
                        i = (Math.min(2147483648, 65536 * Math.ceil(Math.max(e, i) / 65536)) - y1.buffer.byteLength + 65535) / 65536 | 0;
                        try {
                            y1.grow(i), v2();
                            var o = 1;
                            break e;
                        } catch  {}
                        o = void 0;
                    }
                    if (o) return true;
                }
                return false;
            },
            Z: (e, t)=>{
                var r = 0;
                return W2().forEach((i, o)=>{
                    var d = t + r;
                    for(o = w[e + 4 * o >> 2] = d, d = 0; d < i.length; ++d)K[o++] = i.charCodeAt(d);
                    K[o] = 0, r += i.length + 1;
                }), 0;
            },
            _: (e, t)=>{
                var r = W2();
                w[e >> 2] = r.length;
                var i = 0;
                return r.forEach((o)=>i += o.length + 1), w[t >> 2] = i, 0;
            },
            W: ()=>52,
            U: ()=>52,
            B: (e, t, r, i)=>{
                for(var o = 0, d = 0; d < r; d++){
                    var l = w[t >> 2], u = w[t + 4 >> 2];
                    t += 8;
                    for(var c = 0; c < u; c++){
                        var p = e, f = I[l + c], _ = D3[p];
                        f === 0 || f === 10 ? ((p === 1 ? r3 : Z)(a1(_)), _.length = 0) : _.push(f);
                    }
                    o += u;
                }
                return w[i >> 2] = o, 0;
            },
            $: Z3,
            aa: G3,
            J: K3,
            j: H3,
            i: X3,
            g: Y3,
            ba: $3,
            z: J3,
            C: q3,
            D: N3,
            a: z3,
            b: j3,
            f: B3,
            o: Q3,
            q: V3,
            G: e0,
            Y: D2,
            P: (e, t)=>(U2(I.subarray(e, e + t)), 0)
        }, y;
        (async function() {
            function e(i) {
                return y = i.exports, y1 = y.ma, v2(), S = y.ra, _2.unshift(y.na), X--, s.monitorRunDependencies?.(X), X == 0 && i1 && (i = i1, i1 = null, i()), y;
            }
            X++, s.monitorRunDependencies?.(X);
            var t = {
                a: U3
            };
            if (s.instantiateWasm) try {
                return s.instantiateWasm(t, e);
            } catch (i) {
                Z(`Module.instantiateWasm callback failed with error: ${i}`), P(i);
            }
            W1 ?? (W1 = y2("DotLottiePlayer.wasm") ? "DotLottiePlayer.wasm" : s.locateFile ? s.locateFile("DotLottiePlayer.wasm", A) : A + "DotLottiePlayer.wasm");
            try {
                var r = await s3(t);
                return e(r.instance), r;
            } catch (i) {
                P(i);
            }
        })();
        var e2 = (e)=>(e2 = y.oa)(e), $2 = (e)=>($2 = y.pa)(e), N = (e)=>(N = y.qa)(e), j2 = (e, t)=>(j2 = y.sa)(e, t), F = (e, t)=>(F = y.ta)(e, t), f1 = (e)=>(f1 = y.ua)(e), x = (e)=>(x = y.va)(e), R = ()=>(R = y.wa)(), B2 = (e, t, r)=>(B2 = y.xa)(e, t, r);
        s.dynCall_iijj = (e, t, r, i, o, d)=>(s.dynCall_iijj = y.ya)(e, t, r, i, o, d), s.dynCall_vijj = (e, t, r, i, o, d)=>(s.dynCall_vijj = y.za)(e, t, r, i, o, d), s.dynCall_jiii = (e, t, r, i)=>(s.dynCall_jiii = y.Aa)(e, t, r, i);
        var H2 = s.dynCall_vijjjj = (e, t, r, i, o, d, l, u, c, p)=>(H2 = s.dynCall_vijjjj = y.Ba)(e, t, r, i, o, d, l, u, c, p);
        s.dynCall_jii = (e, t, r)=>(s.dynCall_jii = y.Ca)(e, t, r), s.dynCall_vjii = (e, t, r, i, o)=>(s.dynCall_vjii = y.Da)(e, t, r, i, o), s.dynCall_vjfii = (e, t, r, i, o, d)=>(s.dynCall_vjfii = y.Ea)(e, t, r, i, o, d), s.dynCall_vjiii = (e, t, r, i, o, d)=>(s.dynCall_vjiii = y.Fa)(e, t, r, i, o, d), s.dynCall_vj = (e, t, r)=>(s.dynCall_vj = y.Ga)(e, t, r), s.dynCall_vjiiiii = (e, t, r, i, o, d, l, u)=>(s.dynCall_vjiiiii = y.Ha)(e, t, r, i, o, d, l, u), s.dynCall_vjiffii = (e, t, r, i, o, d, l, u)=>(s.dynCall_vjiffii = y.Ia)(e, t, r, i, o, d, l, u), s.dynCall_vjiiii = (e, t, r, i, o, d, l)=>(s.dynCall_vjiiii = y.Ja)(e, t, r, i, o, d, l), s.dynCall_viijii = (e, t, r, i, o, d, l)=>(s.dynCall_viijii = y.Ka)(e, t, r, i, o, d, l), s.dynCall_iiiiij = (e, t, r, i, o, d, l)=>(s.dynCall_iiiiij = y.La)(e, t, r, i, o, d, l), s.dynCall_iiiiijj = (e, t, r, i, o, d, l, u, c)=>(s.dynCall_iiiiijj = y.Ma)(e, t, r, i, o, d, l, u, c), s.dynCall_iiiiiijj = (e, t, r, i, o, d, l, u, c, p)=>(s.dynCall_iiiiiijj = y.Na)(e, t, r, i, o, d, l, u, c, p);
        function z3(e, t) {
            var r = R();
            try {
                S.get(e)(t);
            } catch (i) {
                if (x(r), i !== i + 0) throw i;
                F(1, 0);
            }
        }
        function $3(e, t, r, i, o) {
            var d = R();
            try {
                return S.get(e)(t, r, i, o);
            } catch (l) {
                if (x(d), l !== l + 0) throw l;
                F(1, 0);
            }
        }
        function j3(e, t, r) {
            var i = R();
            try {
                S.get(e)(t, r);
            } catch (o) {
                if (x(i), o !== o + 0) throw o;
                F(1, 0);
            }
        }
        function B3(e, t, r, i) {
            var o = R();
            try {
                S.get(e)(t, r, i);
            } catch (d) {
                if (x(o), d !== d + 0) throw d;
                F(1, 0);
            }
        }
        function H3(e, t) {
            var r = R();
            try {
                return S.get(e)(t);
            } catch (i) {
                if (x(r), i !== i + 0) throw i;
                F(1, 0);
            }
        }
        function V3(e, t, r, i, o, d) {
            var l = R();
            try {
                S.get(e)(t, r, i, o, d);
            } catch (u) {
                if (x(l), u !== u + 0) throw u;
                F(1, 0);
            }
        }
        function N3(e) {
            var t = R();
            try {
                S.get(e)();
            } catch (r) {
                if (x(t), r !== r + 0) throw r;
                F(1, 0);
            }
        }
        function Q3(e, t, r, i, o) {
            var d = R();
            try {
                S.get(e)(t, r, i, o);
            } catch (l) {
                if (x(d), l !== l + 0) throw l;
                F(1, 0);
            }
        }
        function q3(e, t, r, i, o, d, l, u) {
            var c = R();
            try {
                return S.get(e)(t, r, i, o, d, l, u);
            } catch (p) {
                if (x(c), p !== p + 0) throw p;
                F(1, 0);
            }
        }
        function Y3(e, t, r, i) {
            var o = R();
            try {
                return S.get(e)(t, r, i);
            } catch (d) {
                if (x(o), d !== d + 0) throw d;
                F(1, 0);
            }
        }
        function X3(e, t, r) {
            var i = R();
            try {
                return S.get(e)(t, r);
            } catch (o) {
                if (x(i), o !== o + 0) throw o;
                F(1, 0);
            }
        }
        function J3(e, t, r, i, o, d) {
            var l = R();
            try {
                return S.get(e)(t, r, i, o, d);
            } catch (u) {
                if (x(l), u !== u + 0) throw u;
                F(1, 0);
            }
        }
        function G3(e, t, r, i) {
            var o = R();
            try {
                return S.get(e)(t, r, i);
            } catch (d) {
                if (x(o), d !== d + 0) throw d;
                F(1, 0);
            }
        }
        function Z3(e, t) {
            var r = R();
            try {
                return S.get(e)(t);
            } catch (i) {
                if (x(r), i !== i + 0) throw i;
                F(1, 0);
            }
        }
        function K3(e, t, r) {
            var i = R();
            try {
                return S.get(e)(t, r);
            } catch (o) {
                if (x(i), o !== o + 0) throw o;
                F(1, 0);
            }
        }
        function e0(e, t, r, i, o, d, l, u, c, p) {
            var f = R();
            try {
                H2(e, t, r, i, o, d, l, u, c, p);
            } catch (_) {
                if (x(f), _ !== _ + 0) throw _;
                F(1, 0);
            }
        }
        var x1;
        i1 = function e() {
            x1 || V2(), x1 || (i1 = e);
        };
        function V2() {
            function e() {
                if (!x1 && (x1 = true, s.calledRun = true, !b1)) {
                    if (U1(_2), m(s), s.onRuntimeInitialized?.(), s.postRun) for(typeof s.postRun == "function" && (s.postRun = [
                        s.postRun
                    ]); s.postRun.length;){
                        var t = s.postRun.shift();
                        g2.unshift(t);
                    }
                    U1(g2);
                }
            }
            if (!(0 < X)) {
                if (s.preRun) for(typeof s.preRun == "function" && (s.preRun = [
                    s.preRun
                ]); s.preRun.length;)i3();
                U1(m2), 0 < X || (s.setStatus ? (s.setStatus("Running..."), setTimeout(()=>{
                    setTimeout(()=>s.setStatus(""), 1), e();
                }, 1)) : e());
            }
        }
        if (s.preInit) for(typeof s.preInit == "function" && (s.preInit = [
            s.preInit
        ]); 0 < s.preInit.length;)s.preInit.pop()();
        return V2(), a = H, a;
    };
})(), $66d31c93ca24442f$var$X2 = $66d31c93ca24442f$var$r0;
var $66d31c93ca24442f$var$G = class {
    constructor(){
        throw new Error("RendererLoader is a static class and cannot be instantiated.");
    }
    static async _tryLoad(n) {
        return await $66d31c93ca24442f$var$X2({
            locateFile: ()=>n
        });
    }
    static async _loadWithBackup() {
        return this._ModulePromise || (this._ModulePromise = this._tryLoad(this._wasmURL).catch(async (n)=>{
            let a = `https://unpkg.com/${$66d31c93ca24442f$var$a2}@${$66d31c93ca24442f$var$i2}/dist/dotlottie-player.wasm`;
            console.warn(`Primary WASM load failed from ${this._wasmURL}. Error: ${n.message}`), console.warn(`Attempting to load WASM from backup URL: ${a}`);
            try {
                return await this._tryLoad(a);
            } catch (s) {
                throw console.error(`Primary WASM URL failed: ${n.message}`), console.error(`Backup WASM URL failed: ${s.message}`), new Error("WASM loading failed from all sources.");
            }
        })), this._ModulePromise;
    }
    static async load() {
        return this._loadWithBackup();
    }
    static setWasmUrl(n) {
        n !== this._wasmURL && (this._wasmURL = n, this._ModulePromise = null);
    }
};
$66d31c93ca24442f$var$v($66d31c93ca24442f$var$G, "_ModulePromise", null), $66d31c93ca24442f$var$v($66d31c93ca24442f$var$G, "_wasmURL", `https://cdn.jsdelivr.net/npm/${$66d31c93ca24442f$var$a2}@${$66d31c93ca24442f$var$i2}/dist/dotlottie-player.wasm`);
var $66d31c93ca24442f$var$n1 = class {
    constructor(){
        $66d31c93ca24442f$var$v(this, "_eventListeners", new Map);
    }
    addEventListener(n, a) {
        let s = this._eventListeners.get(n);
        s || (s = new Set, this._eventListeners.set(n, s)), s.add(a);
    }
    removeEventListener(n, a) {
        let s = this._eventListeners.get(n);
        s && (a ? (s.delete(a), s.size === 0 && this._eventListeners.delete(n)) : this._eventListeners.delete(n));
    }
    dispatch(n) {
        this._eventListeners.get(n.type)?.forEach((s)=>s(n));
    }
    removeAllEventListeners() {
        this._eventListeners.clear();
    }
};
var $66d31c93ca24442f$var$k = class {
    static _initializeObserver() {
        if (this._observer) return;
        let n = (a)=>{
            a.forEach((s)=>{
                let m = this._observedCanvases.get(s.target);
                m && (s.isIntersecting ? m.unfreeze() : m.freeze());
            });
        };
        this._observer = new IntersectionObserver(n, {
            threshold: 0
        });
    }
    static observe(n, a) {
        this._initializeObserver(), !this._observedCanvases.has(n) && (this._observedCanvases.set(n, a), this._observer?.observe(n));
    }
    static unobserve(n) {
        this._observer?.unobserve(n), this._observedCanvases.delete(n), this._observedCanvases.size === 0 && (this._observer?.disconnect(), this._observer = null);
    }
};
$66d31c93ca24442f$var$v($66d31c93ca24442f$var$k, "_observer", null), $66d31c93ca24442f$var$v($66d31c93ca24442f$var$k, "_observedCanvases", new Map);
var $66d31c93ca24442f$var$D = class {
    static _initializeObserver() {
        if (this._observer) return;
        let n = (a)=>{
            a.forEach((s)=>{
                let m = this._observedCanvases.get(s.target);
                if (!m) return;
                let [P, H] = m;
                clearTimeout(H);
                let z = setTimeout(()=>{
                    P.resize();
                }, 100);
                this._observedCanvases.set(s.target, [
                    P,
                    z
                ]);
            });
        };
        this._observer = new ResizeObserver(n);
    }
    static observe(n, a) {
        this._initializeObserver(), !this._observedCanvases.has(n) && (this._observedCanvases.set(n, [
            a,
            0
        ]), this._observer?.observe(n));
    }
    static unobserve(n) {
        let a = this._observedCanvases.get(n);
        if (a) {
            let s = a[1];
            s && clearTimeout(s);
        }
        this._observer?.unobserve(n), this._observedCanvases.delete(n), !this._observedCanvases.size && this._observer && (this._observer.disconnect(), this._observer = null);
    }
};
$66d31c93ca24442f$var$v($66d31c93ca24442f$var$D, "_observer", null), $66d31c93ca24442f$var$v($66d31c93ca24442f$var$D, "_observedCanvases", new Map);
function $66d31c93ca24442f$var$i0(h) {
    return /^#([\da-f]{6}|[\da-f]{8})$/iu.test(h);
}
function $66d31c93ca24442f$var$G2(h) {
    if (!$66d31c93ca24442f$var$i0(h)) return 0;
    let n = h.replace("#", "");
    return n = n.length === 6 ? `${n}ff` : n, parseInt(n, 16);
}
function $66d31c93ca24442f$var$o2(h) {
    if (h.byteLength < 4) return false;
    let n = new Uint8Array(h.slice(0, $66d31c93ca24442f$var$O1.byteLength));
    for(let a = 0; a < $66d31c93ca24442f$var$O1.length; a += 1)if ($66d31c93ca24442f$var$O1[a] !== n[a]) return false;
    return true;
}
function $66d31c93ca24442f$var$J2(h) {
    return $66d31c93ca24442f$var$Q2.every((n)=>Object.prototype.hasOwnProperty.call(h, n));
}
function $66d31c93ca24442f$var$s2(h) {
    if (typeof h == "string") try {
        return $66d31c93ca24442f$var$J2(JSON.parse(h));
    } catch  {
        return false;
    }
    else return $66d31c93ca24442f$var$J2(h);
}
function $66d31c93ca24442f$var$Q() {
    return 1 + (($66d31c93ca24442f$var$E ? window.devicePixelRatio : 1) - 1) * $66d31c93ca24442f$var$q2;
}
function $66d31c93ca24442f$var$A1(h) {
    let n = h.getBoundingClientRect();
    return n.top >= 0 && n.left >= 0 && n.bottom <= (window.innerHeight || document.documentElement.clientHeight) && n.right <= (window.innerWidth || document.documentElement.clientWidth);
}
var $66d31c93ca24442f$var$d2 = (h, n)=>h === "reverse" ? n.Mode.Reverse : h === "bounce" ? n.Mode.Bounce : h === "reverse-bounce" ? n.Mode.ReverseBounce : n.Mode.Forward, $66d31c93ca24442f$var$a0 = (h, n)=>h === "contain" ? n.Fit.Contain : h === "cover" ? n.Fit.Cover : h === "fill" ? n.Fit.Fill : h === "fit-height" ? n.Fit.FitHeight : h === "fit-width" ? n.Fit.FitWidth : n.Fit.None, $66d31c93ca24442f$var$o0 = (h, n)=>{
    let a = new n.VectorFloat;
    return a.push_back(h[0]), a.push_back(h[1]), a;
}, $66d31c93ca24442f$var$u2 = (h, n)=>{
    let a = new n.VectorFloat;
    return h.length !== 2 || (a.push_back(h[0]), a.push_back(h[1])), a;
}, $66d31c93ca24442f$var$l2 = (h, n)=>h ? {
        align: $66d31c93ca24442f$var$o0(h.align ?? [
            .5,
            .5
        ], n),
        fit: $66d31c93ca24442f$var$a0(h.fit ?? "contain", n)
    } : n.createDefaultLayout(), $66d31c93ca24442f$var$L = class L {
    constructor(n){
        $66d31c93ca24442f$var$v(this, "_canvas");
        $66d31c93ca24442f$var$v(this, "_context", null);
        $66d31c93ca24442f$var$v(this, "_eventManager");
        $66d31c93ca24442f$var$v(this, "_animationFrameId", null);
        $66d31c93ca24442f$var$v(this, "_frameManager");
        $66d31c93ca24442f$var$v(this, "_dotLottieCore", null);
        $66d31c93ca24442f$var$v(this, "_renderConfig", {});
        $66d31c93ca24442f$var$v(this, "_isFrozen", false);
        $66d31c93ca24442f$var$v(this, "_backgroundColor", null);
        $66d31c93ca24442f$var$v(this, "_pointerUpMethod");
        $66d31c93ca24442f$var$v(this, "_pointerDownMethod");
        $66d31c93ca24442f$var$v(this, "_pointerMoveMethod");
        $66d31c93ca24442f$var$v(this, "_pointerEnterMethod");
        $66d31c93ca24442f$var$v(this, "_pointerExitMethod");
        this._canvas = n.canvas, this._eventManager = new $66d31c93ca24442f$var$n1, this._frameManager = new $66d31c93ca24442f$var$R1, this._renderConfig = {
            ...n.renderConfig,
            devicePixelRatio: n.renderConfig?.devicePixelRatio || $66d31c93ca24442f$var$Q(),
            freezeOnOffscreen: n.renderConfig?.freezeOnOffscreen ?? true
        }, $66d31c93ca24442f$var$G.load().then((a)=>{
            L._wasmModule = a, this._dotLottieCore = new a.DotLottiePlayer({
                animationId: n.animationId ?? "",
                themeId: n.themeId ?? "",
                stateMachineId: "",
                autoplay: n.autoplay ?? false,
                backgroundColor: 0,
                loopAnimation: n.loop ?? false,
                mode: $66d31c93ca24442f$var$d2(n.mode ?? "forward", a),
                segment: $66d31c93ca24442f$var$u2(n.segment ?? [], a),
                speed: n.speed ?? 1,
                useFrameInterpolation: n.useFrameInterpolation ?? true,
                marker: n.marker ?? "",
                layout: $66d31c93ca24442f$var$l2(n.layout, a)
            }), this._eventManager.dispatch({
                type: "ready"
            }), n.data ? this._loadFromData(n.data) : n.src && this._loadFromSrc(n.src), n.backgroundColor && this.setBackgroundColor(n.backgroundColor);
        }).catch((a)=>{
            this._eventManager.dispatch({
                type: "loadError",
                error: new Error(`Failed to load wasm module: ${a}`)
            });
        }), this._pointerUpMethod = this._onPointerUp.bind(this), this._pointerDownMethod = this._onPointerDown.bind(this), this._pointerMoveMethod = this._onPointerMove.bind(this), this._pointerEnterMethod = this._onPointerEnter.bind(this), this._pointerExitMethod = this._onPointerLeave.bind(this);
    }
    _dispatchError(n) {
        console.error(n), this._eventManager.dispatch({
            type: "loadError",
            error: new Error(n)
        });
    }
    async _fetchData(n) {
        let a = await fetch(n);
        if (!a.ok) throw new Error(`Failed to fetch animation data from URL: ${n}. ${a.status}: ${a.statusText}`);
        let s = await a.arrayBuffer();
        return $66d31c93ca24442f$var$o2(s) ? s : new TextDecoder().decode(s);
    }
    _loadFromData(n) {
        if (this._dotLottieCore === null) return;
        let a = this._canvas.width, s = this._canvas.height, m = false;
        if (typeof n == "string") {
            if (!$66d31c93ca24442f$var$s2(n)) {
                this._dispatchError("Invalid Lottie JSON string: The provided string does not conform to the Lottie JSON format.");
                return;
            }
            m = this._dotLottieCore.loadAnimationData(n, a, s);
        } else if (n instanceof ArrayBuffer) {
            if (!$66d31c93ca24442f$var$o2(n)) {
                this._dispatchError("Invalid dotLottie ArrayBuffer: The provided ArrayBuffer does not conform to the dotLottie format.");
                return;
            }
            m = this._dotLottieCore.loadDotLottieData(n, a, s);
        } else if (typeof n == "object") {
            if (!$66d31c93ca24442f$var$s2(n)) {
                this._dispatchError("Invalid Lottie JSON object: The provided object does not conform to the Lottie JSON format.");
                return;
            }
            m = this._dotLottieCore.loadAnimationData(JSON.stringify(n), a, s);
        } else {
            this._dispatchError(`Unsupported data type for animation data. Expected: 
          - string (Lottie JSON),
          - ArrayBuffer (dotLottie),
          - object (Lottie JSON). 
          Received: ${typeof n}`);
            return;
        }
        m ? (this._eventManager.dispatch({
            type: "load"
        }), $66d31c93ca24442f$var$E && this.resize(), this._eventManager.dispatch({
            type: "frame",
            currentFrame: this.currentFrame
        }), this._render(), this._dotLottieCore.config().autoplay && (this._dotLottieCore.play(), this._dotLottieCore.isPlaying() ? (this._eventManager.dispatch({
            type: "play"
        }), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this))) : console.error("something went wrong, the animation was suppose to autoplay")), $66d31c93ca24442f$var$E && this._canvas instanceof HTMLCanvasElement && (this._renderConfig.freezeOnOffscreen && $66d31c93ca24442f$var$k.observe(this._canvas, this), this._renderConfig.autoResize && $66d31c93ca24442f$var$D.observe(this._canvas, this))) : this._dispatchError("Failed to load animation data");
    }
    _loadFromSrc(n) {
        this._fetchData(n).then((a)=>this._loadFromData(a)).catch((a)=>this._dispatchError(`Failed to load animation data from URL: ${n}. ${a}`));
    }
    get buffer() {
        return this._dotLottieCore ? this._dotLottieCore.buffer() : null;
    }
    get activeAnimationId() {
        return this._dotLottieCore?.activeAnimationId();
    }
    get activeThemeId() {
        return this._dotLottieCore?.activeThemeId();
    }
    get layout() {
        let n = this._dotLottieCore?.config().layout;
        if (n) return {
            align: [
                n.align.get(0),
                n.align.get(1)
            ],
            fit: (()=>{
                switch(n.fit){
                    case L._wasmModule?.Fit.Contain:
                        return "contain";
                    case L._wasmModule?.Fit.Cover:
                        return "cover";
                    case L._wasmModule?.Fit.Fill:
                        return "fill";
                    case L._wasmModule?.Fit.FitHeight:
                        return "fit-height";
                    case L._wasmModule?.Fit.FitWidth:
                        return "fit-width";
                    case L._wasmModule?.Fit.None:
                        return "none";
                    default:
                        return "contain";
                }
            })()
        };
    }
    get marker() {
        return this._dotLottieCore?.config().marker;
    }
    get manifest() {
        try {
            let n = this._dotLottieCore?.manifestString();
            if (this._dotLottieCore === null || !n) return null;
            let a = JSON.parse(n);
            return Object.keys(a).length === 0 ? null : a;
        } catch  {
            return null;
        }
    }
    get renderConfig() {
        return this._renderConfig;
    }
    get segment() {
        let n = this._dotLottieCore?.config().segment;
        if (n && n.size() === 2) return [
            n.get(0),
            n.get(1)
        ];
    }
    get loop() {
        return this._dotLottieCore?.config().loopAnimation ?? false;
    }
    get mode() {
        let n = this._dotLottieCore?.config().mode;
        return n === L._wasmModule?.Mode.Reverse ? "reverse" : n === L._wasmModule?.Mode.Bounce ? "bounce" : n === L._wasmModule?.Mode.ReverseBounce ? "reverse-bounce" : "forward";
    }
    get isFrozen() {
        return this._isFrozen;
    }
    get backgroundColor() {
        return this._backgroundColor ?? "";
    }
    get autoplay() {
        return this._dotLottieCore?.config().autoplay ?? false;
    }
    get useFrameInterpolation() {
        return this._dotLottieCore?.config().useFrameInterpolation ?? false;
    }
    get speed() {
        return this._dotLottieCore?.config().speed ?? 0;
    }
    get isReady() {
        return this._dotLottieCore !== null;
    }
    get isLoaded() {
        return this._dotLottieCore?.isLoaded() ?? false;
    }
    get isPlaying() {
        return this._dotLottieCore?.isPlaying() ?? false;
    }
    get isPaused() {
        return this._dotLottieCore?.isPaused() ?? false;
    }
    get isStopped() {
        return this._dotLottieCore?.isStopped() ?? false;
    }
    get currentFrame() {
        return this._dotLottieCore ? Math.round(this._dotLottieCore.currentFrame() * 100) / 100 : 0;
    }
    get loopCount() {
        return this._dotLottieCore?.loopCount() ?? 0;
    }
    get totalFrames() {
        return this._dotLottieCore?.totalFrames() ?? 0;
    }
    get duration() {
        return this._dotLottieCore?.duration() ?? 0;
    }
    get segmentDuration() {
        return this._dotLottieCore?.segmentDuration() ?? 0;
    }
    get canvas() {
        return this._canvas;
    }
    load(n) {
        this._dotLottieCore === null || L._wasmModule === null || (this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null), this._isFrozen = false, this._dotLottieCore.setConfig({
            animationId: n.animationId ?? "",
            themeId: n.themeId ?? "",
            stateMachineId: "",
            autoplay: n.autoplay ?? false,
            backgroundColor: 0,
            loopAnimation: n.loop ?? false,
            mode: $66d31c93ca24442f$var$d2(n.mode ?? "forward", L._wasmModule),
            segment: $66d31c93ca24442f$var$u2(n.segment ?? [], L._wasmModule),
            speed: n.speed ?? 1,
            useFrameInterpolation: n.useFrameInterpolation ?? true,
            marker: n.marker ?? "",
            layout: $66d31c93ca24442f$var$l2(n.layout, L._wasmModule)
        }), n.data ? this._loadFromData(n.data) : n.src && this._loadFromSrc(n.src), this.setBackgroundColor(n.backgroundColor ?? ""));
    }
    _render() {
        if (this._dotLottieCore === null) return false;
        if (!this._context && "getContext" in this._canvas && typeof this._canvas.getContext == "function" && (this._context = this._canvas.getContext("2d")), this._dotLottieCore.render()) {
            if (this._context) {
                let a = this._dotLottieCore.buffer(), s = this._canvas.width * this._canvas.height * $66d31c93ca24442f$var$Y2;
                if (a.byteLength !== s) return console.warn(`Buffer size mismatch: got ${a.byteLength}, expected ${s}`), false;
                let m = null, P = new Uint8ClampedArray(a, 0, a.byteLength);
                typeof ImageData > "u" ? (m = this._context.createImageData(this._canvas.width, this._canvas.height), m.data.set(P)) : m = new ImageData(P, this._canvas.width, this._canvas.height), this._context.putImageData(m, 0, 0);
            }
            return this._eventManager.dispatch({
                type: "render",
                currentFrame: this.currentFrame
            }), true;
        }
        return false;
    }
    _draw() {
        if (!(this._dotLottieCore === null || !this._dotLottieCore.isPlaying())) try {
            let n = Math.round(this._dotLottieCore.requestFrame() * 1e3) / 1e3;
            if (this._dotLottieCore.setFrame(n) && (this._eventManager.dispatch({
                type: "frame",
                currentFrame: this.currentFrame
            }), this._render() && this._dotLottieCore.isComplete())) {
                if (this._dotLottieCore.config().loopAnimation) this._eventManager.dispatch({
                    type: "loop",
                    loopCount: this._dotLottieCore.loopCount()
                });
                else {
                    this._eventManager.dispatch({
                        type: "complete"
                    });
                    return;
                }
            }
            this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this));
        } catch (n) {
            console.error("Error in animation frame:", n), this._eventManager.dispatch({
                type: "renderError",
                error: n
            }), n instanceof WebAssembly.RuntimeError && this.destroy();
        }
    }
    play() {
        if (this._dotLottieCore === null) return;
        this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null), (this._dotLottieCore.play() || this._dotLottieCore.isPlaying()) && (this._isFrozen = false, this._eventManager.dispatch({
            type: "play"
        }), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this))), $66d31c93ca24442f$var$E && this._canvas instanceof HTMLCanvasElement && this._renderConfig.freezeOnOffscreen && !$66d31c93ca24442f$var$A1(this._canvas) && this.freeze();
    }
    pause() {
        if (this._dotLottieCore === null) return;
        (this._dotLottieCore.pause() || this._dotLottieCore.isPaused()) && this._eventManager.dispatch({
            type: "pause"
        });
    }
    stop() {
        if (this._dotLottieCore === null) return;
        this._dotLottieCore.stop() && (this._eventManager.dispatch({
            type: "frame",
            currentFrame: this.currentFrame
        }), this._render(), this._eventManager.dispatch({
            type: "stop"
        }));
    }
    setFrame(n) {
        if (this._dotLottieCore === null || n < 0 || n > this._dotLottieCore.totalFrames()) return;
        this._dotLottieCore.seek(n) && (this._eventManager.dispatch({
            type: "frame",
            currentFrame: this.currentFrame
        }), this._render());
    }
    setSpeed(n) {
        this._dotLottieCore !== null && this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            speed: n
        });
    }
    setBackgroundColor(n) {
        this._dotLottieCore !== null && ($66d31c93ca24442f$var$E && this._canvas instanceof HTMLCanvasElement ? this._canvas.style.backgroundColor = n : this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            backgroundColor: $66d31c93ca24442f$var$G2(n)
        }), this._backgroundColor = n);
    }
    setLoop(n) {
        this._dotLottieCore !== null && this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            loopAnimation: n
        });
    }
    setUseFrameInterpolation(n) {
        this._dotLottieCore !== null && this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            useFrameInterpolation: n
        });
    }
    addEventListener(n, a) {
        this._eventManager.addEventListener(n, a);
    }
    removeEventListener(n, a) {
        this._eventManager.removeEventListener(n, a);
    }
    destroy() {
        this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null), $66d31c93ca24442f$var$E && this._canvas instanceof HTMLCanvasElement && ($66d31c93ca24442f$var$k.unobserve(this._canvas), $66d31c93ca24442f$var$D.unobserve(this._canvas)), this._dotLottieCore?.delete(), this._dotLottieCore = null, this._context = null, this._eventManager.dispatch({
            type: "destroy"
        }), this._eventManager.removeAllEventListeners(), this._cleanupStateMachineListeners();
    }
    freeze() {
        this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null, this._isFrozen = true, this._eventManager.dispatch({
            type: "freeze"
        }));
    }
    unfreeze() {
        this._animationFrameId === null && (this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this)), this._isFrozen = false, this._eventManager.dispatch({
            type: "unfreeze"
        }));
    }
    resize() {
        if (!this._dotLottieCore || !this.isLoaded) return;
        if ($66d31c93ca24442f$var$E && this._canvas instanceof HTMLCanvasElement) {
            let a = this._renderConfig.devicePixelRatio || window.devicePixelRatio || 1, { height: s, width: m } = this._canvas.getBoundingClientRect();
            s !== 0 && m !== 0 && (this._canvas.width = m * a, this._canvas.height = s * a);
        }
        this._dotLottieCore.resize(this._canvas.width, this._canvas.height) && this._render();
    }
    setSegment(n, a) {
        this._dotLottieCore === null || L._wasmModule === null || this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            segment: $66d31c93ca24442f$var$u2([
                n,
                a
            ], L._wasmModule)
        });
    }
    setMode(n) {
        this._dotLottieCore === null || L._wasmModule === null || this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            mode: $66d31c93ca24442f$var$d2(n, L._wasmModule)
        });
    }
    setRenderConfig(n) {
        let { devicePixelRatio: a, freezeOnOffscreen: s, ...m } = n;
        this._renderConfig = {
            ...this._renderConfig,
            ...m,
            devicePixelRatio: a || $66d31c93ca24442f$var$Q(),
            freezeOnOffscreen: s ?? true
        }, $66d31c93ca24442f$var$E && this._canvas instanceof HTMLCanvasElement && (this._renderConfig.autoResize ? $66d31c93ca24442f$var$D.observe(this._canvas, this) : $66d31c93ca24442f$var$D.unobserve(this._canvas), this._renderConfig.freezeOnOffscreen ? $66d31c93ca24442f$var$k.observe(this._canvas, this) : ($66d31c93ca24442f$var$k.unobserve(this._canvas), this._isFrozen && this.unfreeze()));
    }
    loadAnimation(n) {
        if (this._dotLottieCore === null || this._dotLottieCore.activeAnimationId() === n) return;
        this._dotLottieCore.loadAnimation(n, this._canvas.width, this._canvas.height) ? (this._eventManager.dispatch({
            type: "load"
        }), this.resize()) : this._eventManager.dispatch({
            type: "loadError",
            error: new Error(`Failed to animation :${n}`)
        });
    }
    setMarker(n) {
        this._dotLottieCore !== null && this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            marker: n
        });
    }
    markers() {
        let n = this._dotLottieCore?.markers();
        if (n) {
            let a = [];
            for(let s = 0; s < n.size(); s += 1){
                let m = n.get(s);
                a.push({
                    name: m.name,
                    time: m.time,
                    duration: m.duration
                });
            }
            return a;
        }
        return [];
    }
    setTheme(n) {
        if (this._dotLottieCore === null) return false;
        let a = this._dotLottieCore.setTheme(n);
        return this._render(), a;
    }
    resetTheme() {
        return this._dotLottieCore === null ? false : this._dotLottieCore.resetTheme();
    }
    setThemeData(n) {
        if (this._dotLottieCore === null) return false;
        let a = this._dotLottieCore.setThemeData(n);
        return this._render(), a;
    }
    setSlots(n) {
        this._dotLottieCore !== null && this._dotLottieCore.setSlots(n);
    }
    setLayout(n) {
        this._dotLottieCore === null || L._wasmModule === null || this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            layout: $66d31c93ca24442f$var$l2(n, L._wasmModule)
        });
    }
    setViewport(n, a, s, m) {
        return this._dotLottieCore === null ? false : this._dotLottieCore.setViewport(n, a, s, m);
    }
    static setWasmUrl(n) {
        $66d31c93ca24442f$var$G.setWasmUrl(n);
    }
    loadStateMachine(n) {
        return this._dotLottieCore?.stateMachineLoad(n) ?? false;
    }
    startStateMachine() {
        if (L._wasmModule === null || this._dotLottieCore === null) return false;
        let n = L._wasmModule.createDefaultOpenURL(), a = this._dotLottieCore.stateMachineStart(n);
        return a && this._setupStateMachineListeners(), a;
    }
    stopStateMachine() {
        let n = this._dotLottieCore?.stateMachineStop() ?? false;
        return n && this._cleanupStateMachineListeners(), n;
    }
    _getPointerPosition(n) {
        let a = this._canvas.getBoundingClientRect(), s = this._canvas.width / a.width, m = this._canvas.height / a.height, P = this._renderConfig.devicePixelRatio || window.devicePixelRatio || 1, H = (n.clientX - a.left) * s / P, z = (n.clientY - a.top) * m / P;
        return {
            x: H,
            y: z
        };
    }
    _onPointerUp(n) {
        let { x: a, y: s } = this._getPointerPosition(n);
        this.postPointerUpEvent(a, s);
    }
    _onPointerDown(n) {
        let { x: a, y: s } = this._getPointerPosition(n);
        this.postPointerDownEvent(a, s);
    }
    _onPointerMove(n) {
        let { x: a, y: s } = this._getPointerPosition(n);
        this.postPointerMoveEvent(a, s);
    }
    _onPointerEnter(n) {
        let { x: a, y: s } = this._getPointerPosition(n);
        this.postPointerEnterEvent(a, s);
    }
    _onPointerLeave(n) {
        let { x: a, y: s } = this._getPointerPosition(n);
        this.postPointerExitEvent(a, s);
    }
    postPointerUpEvent(n, a) {
        return this._dotLottieCore?.stateMachinePostPointerUpEvent(n, a);
    }
    postPointerDownEvent(n, a) {
        return this._dotLottieCore?.stateMachinePostPointerDownEvent(n, a);
    }
    postPointerMoveEvent(n, a) {
        return this._dotLottieCore?.stateMachinePostPointerMoveEvent(n, a);
    }
    postPointerEnterEvent(n, a) {
        return this._dotLottieCore?.stateMachinePostPointerEnterEvent(n, a);
    }
    postPointerExitEvent(n, a) {
        return this._dotLottieCore?.stateMachinePostPointerExitEvent(n, a);
    }
    getStateMachineListeners() {
        if (!this._dotLottieCore) return [];
        let n = this._dotLottieCore.stateMachineFrameworkSetup(), a = [];
        for(let s = 0; s < n.size(); s += 1)a.push(n.get(s));
        return a;
    }
    _setupStateMachineListeners() {
        if ($66d31c93ca24442f$var$E && this._canvas instanceof HTMLCanvasElement && this._dotLottieCore !== null && this.isLoaded) {
            let n = this.getStateMachineListeners();
            n.includes("PointerUp") && this._canvas.addEventListener("pointerup", this._pointerUpMethod), n.includes("PointerDown") && this._canvas.addEventListener("pointerdown", this._pointerDownMethod), n.includes("PointerMove") && this._canvas.addEventListener("pointermove", this._pointerMoveMethod), n.includes("PointerEnter") && this._canvas.addEventListener("pointerenter", this._pointerEnterMethod), n.includes("PointerExit") && this._canvas.addEventListener("pointerleave", this._pointerExitMethod);
        }
    }
    _cleanupStateMachineListeners() {
        $66d31c93ca24442f$var$E && this._canvas instanceof HTMLCanvasElement && (this._canvas.removeEventListener("pointerup", this._pointerUpMethod), this._canvas.removeEventListener("pointerdown", this._pointerDownMethod), this._canvas.removeEventListener("pointermove", this._pointerMoveMethod), this._canvas.removeEventListener("pointerenter", this._pointerEnterMethod), this._canvas.removeEventListener("pointerleave", this._pointerExitMethod));
    }
    loadStateMachineData(n) {
        return this._dotLottieCore?.stateMachineLoadData(n) ?? false;
    }
    animationSize() {
        let n = this._dotLottieCore?.animationSize().get(0) ?? 0, a = this._dotLottieCore?.animationSize().get(1) ?? 0;
        return {
            width: n,
            height: a
        };
    }
    setStateMachineBooleanContext(n, a) {
        return this._dotLottieCore?.stateMachineSetBooleanInput(n, a) ?? false;
    }
    setStateMachineNumericContext(n, a) {
        return this._dotLottieCore?.stateMachineSetNumericInput(n, a) ?? false;
    }
    setStateMachineStringContext(n, a) {
        return this._dotLottieCore?.stateMachineSetStringInput(n, a) ?? false;
    }
    getLayerBoundingBox(n) {
        let a = this._dotLottieCore?.getLayerBounds(n);
        if (!a || a.size() !== 8) return;
        let s = [];
        for(let m = 0; m < 8; m += 1)s.push(a.get(m));
        return s;
    }
    static transformThemeToLottieSlots(n, a) {
        return L._wasmModule?.transformThemeToLottieSlots(n, a) ?? "";
    }
};
$66d31c93ca24442f$var$v($66d31c93ca24442f$var$L, "_wasmModule", null);
var $66d31c93ca24442f$export$2c434b74e61f4f56 = $66d31c93ca24442f$var$L;
var $66d31c93ca24442f$var$c2 = class {
    constructor(){
        if (typeof Worker > "u") throw new Error("Worker is not supported in this environment.");
        let n = new Blob([
            new Uint8Array([
                34,
                117,
                115,
                101,
                32,
                115,
                116,
                114,
                105,
                99,
                116,
                34,
                59,
                10,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                95,
                100,
                101,
                102,
                80,
                114,
                111,
                112,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                100,
                101,
                102,
                105,
                110,
                101,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                95,
                100,
                101,
                102,
                78,
                111,
                114,
                109,
                97,
                108,
                80,
                114,
                111,
                112,
                32,
                61,
                32,
                40,
                111,
                98,
                106,
                44,
                32,
                107,
                101,
                121,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                61,
                62,
                32,
                107,
                101,
                121,
                32,
                105,
                110,
                32,
                111,
                98,
                106,
                32,
                63,
                32,
                95,
                95,
                100,
                101,
                102,
                80,
                114,
                111,
                112,
                40,
                111,
                98,
                106,
                44,
                32,
                107,
                101,
                121,
                44,
                32,
                123,
                32,
                101,
                110,
                117,
                109,
                101,
                114,
                97,
                98,
                108,
                101,
                58,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                117,
                114,
                97,
                98,
                108,
                101,
                58,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                119,
                114,
                105,
                116,
                97,
                98,
                108,
                101,
                58,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                125,
                41,
                32,
                58,
                32,
                111,
                98,
                106,
                91,
                107,
                101,
                121,
                93,
                32,
                61,
                32,
                118,
                97,
                108,
                117,
                101,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                32,
                61,
                32,
                40,
                111,
                98,
                106,
                44,
                32,
                107,
                101,
                121,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                61,
                62,
                32,
                95,
                95,
                100,
                101,
                102,
                78,
                111,
                114,
                109,
                97,
                108,
                80,
                114,
                111,
                112,
                40,
                111,
                98,
                106,
                44,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                107,
                101,
                121,
                32,
                33,
                61,
                61,
                32,
                34,
                115,
                121,
                109,
                98,
                111,
                108,
                34,
                32,
                63,
                32,
                107,
                101,
                121,
                32,
                43,
                32,
                34,
                34,
                32,
                58,
                32,
                107,
                101,
                121,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                45,
                102,
                114,
                97,
                109,
                101,
                45,
                109,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                87,
                101,
                98,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                83,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                105,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                105,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                78,
                111,
                100,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                83,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                108,
                97,
                115,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                73,
                100,
                34,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                108,
                97,
                115,
                116,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                73,
                100,
                32,
                62,
                61,
                32,
                78,
                117,
                109,
                98,
                101,
                114,
                46,
                77,
                65,
                88,
                95,
                83,
                65,
                70,
                69,
                95,
                73,
                78,
                84,
                69,
                71,
                69,
                82,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                73,
                100,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                73,
                100,
                32,
                43,
                61,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                32,
                61,
                32,
                115,
                101,
                116,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                40,
                68,
                97,
                116,
                101,
                46,
                110,
                111,
                119,
                40,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                95,
                105,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                108,
                101,
                97,
                114,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                115,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                32,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                63,
                32,
                110,
                101,
                119,
                32,
                87,
                101,
                98,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                83,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                40,
                41,
                32,
                58,
                32,
                110,
                101,
                119,
                32,
                78,
                111,
                100,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                83,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                46,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                105,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                46,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                105,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                99,
                111,
                110,
                115,
                116,
                97,
                110,
                116,
                115,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                119,
                105,
                110,
                100,
                111,
                119,
                32,
                33,
                61,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                38,
                38,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                32,
                33,
                61,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                90,
                73,
                80,
                95,
                83,
                73,
                71,
                78,
                65,
                84,
                85,
                82,
                69,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                91,
                56,
                48,
                44,
                32,
                55,
                53,
                44,
                32,
                51,
                44,
                32,
                52,
                93,
                41,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                76,
                79,
                84,
                84,
                73,
                69,
                95,
                74,
                83,
                79,
                78,
                95,
                77,
                65,
                78,
                68,
                65,
                84,
                79,
                82,
                89,
                95,
                70,
                73,
                69,
                76,
                68,
                83,
                32,
                61,
                32,
                91,
                34,
                118,
                34,
                44,
                32,
                34,
                105,
                112,
                34,
                44,
                32,
                34,
                111,
                112,
                34,
                44,
                32,
                34,
                108,
                97,
                121,
                101,
                114,
                115,
                34,
                44,
                32,
                34,
                102,
                114,
                34,
                44,
                32,
                34,
                119,
                34,
                44,
                32,
                34,
                104,
                34,
                93,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                86,
                69,
                82,
                83,
                73,
                79,
                78,
                32,
                61,
                32,
                34,
                48,
                46,
                52,
                55,
                46,
                48,
                34,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                78,
                65,
                77,
                69,
                32,
                61,
                32,
                34,
                64,
                108,
                111,
                116,
                116,
                105,
                101,
                102,
                105,
                108,
                101,
                115,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                45,
                119,
                101,
                98,
                34,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                68,
                69,
                70,
                65,
                85,
                76,
                84,
                95,
                68,
                80,
                82,
                95,
                70,
                65,
                67,
                84,
                79,
                82,
                32,
                61,
                32,
                48,
                46,
                55,
                53,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                66,
                89,
                84,
                69,
                83,
                95,
                80,
                69,
                82,
                95,
                80,
                73,
                88,
                69,
                76,
                32,
                61,
                32,
                52,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                99,
                111,
                114,
                101,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                45,
                112,
                108,
                97,
                121,
                101,
                114,
                46,
                106,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                32,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                115,
                99,
                114,
                105,
                112,
                116,
                78,
                97,
                109,
                101,
                32,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                32,
                33,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                63,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                83,
                99,
                114,
                105,
                112,
                116,
                63,
                46,
                115,
                114,
                99,
                32,
                58,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                109,
                111,
                100,
                117,
                108,
                101,
                65,
                114,
                103,
                32,
                61,
                32,
                123,
                125,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                82,
                116,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                107,
                32,
                61,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                65,
                114,
                103,
                44,
                32,
                97,
                97,
                44,
                32,
                98,
                97,
                44,
                32,
                99,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                40,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                97,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                44,
                32,
                100,
                97,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                97,
                115,
                115,
                105,
                103,
                110,
                40,
                123,
                125,
                44,
                32,
                107,
                41,
                44,
                32,
                101,
                97,
                32,
                61,
                32,
                34,
                46,
                47,
                116,
                104,
                105,
                115,
                46,
                112,
                114,
                111,
                103,
                114,
                97,
                109,
                34,
                44,
                32,
                113,
                32,
                61,
                32,
                34,
                34,
                44,
                32,
                105,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                33,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                32,
                38,
                38,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                83,
                99,
                114,
                105,
                112,
                116,
                32,
                38,
                38,
                32,
                40,
                113,
                32,
                61,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                83,
                99,
                114,
                105,
                112,
                116,
                46,
                115,
                114,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                115,
                99,
                114,
                105,
                112,
                116,
                78,
                97,
                109,
                101,
                32,
                38,
                38,
                32,
                40,
                113,
                32,
                61,
                32,
                95,
                115,
                99,
                114,
                105,
                112,
                116,
                78,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                113,
                46,
                115,
                116,
                97,
                114,
                116,
                115,
                87,
                105,
                116,
                104,
                40,
                34,
                98,
                108,
                111,
                98,
                58,
                34,
                41,
                32,
                63,
                32,
                113,
                32,
                61,
                32,
                34,
                34,
                32,
                58,
                32,
                113,
                32,
                61,
                32,
                113,
                46,
                115,
                117,
                98,
                115,
                116,
                114,
                40,
                48,
                44,
                32,
                113,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                47,
                91,
                63,
                35,
                93,
                46,
                42,
                47,
                44,
                32,
                34,
                34,
                41,
                46,
                108,
                97,
                115,
                116,
                73,
                110,
                100,
                101,
                120,
                79,
                102,
                40,
                34,
                47,
                34,
                41,
                32,
                43,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                97,
                32,
                61,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                102,
                101,
                116,
                99,
                104,
                40,
                97,
                44,
                32,
                123,
                32,
                99,
                114,
                101,
                100,
                101,
                110,
                116,
                105,
                97,
                108,
                115,
                58,
                32,
                34,
                115,
                97,
                109,
                101,
                45,
                111,
                114,
                105,
                103,
                105,
                110,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                97,
                46,
                111,
                107,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                46,
                97,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                97,
                46,
                115,
                116,
                97,
                116,
                117,
                115,
                32,
                43,
                32,
                34,
                32,
                58,
                32,
                34,
                32,
                43,
                32,
                97,
                46,
                117,
                114,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                106,
                97,
                32,
                61,
                32,
                107,
                46,
                112,
                114,
                105,
                110,
                116,
                32,
                124,
                124,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                108,
                111,
                103,
                46,
                98,
                105,
                110,
                100,
                40,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                41,
                44,
                32,
                114,
                32,
                61,
                32,
                107,
                46,
                112,
                114,
                105,
                110,
                116,
                69,
                114,
                114,
                32,
                124,
                124,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                101,
                114,
                114,
                111,
                114,
                46,
                98,
                105,
                110,
                100,
                40,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                97,
                115,
                115,
                105,
                103,
                110,
                40,
                107,
                44,
                32,
                100,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                97,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                116,
                104,
                105,
                115,
                80,
                114,
                111,
                103,
                114,
                97,
                109,
                32,
                38,
                38,
                32,
                40,
                101,
                97,
                32,
                61,
                32,
                107,
                46,
                116,
                104,
                105,
                115,
                80,
                114,
                111,
                103,
                114,
                97,
                109,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                107,
                97,
                32,
                61,
                32,
                107,
                46,
                119,
                97,
                115,
                109,
                66,
                105,
                110,
                97,
                114,
                121,
                44,
                32,
                108,
                97,
                44,
                32,
                109,
                97,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                110,
                97,
                44,
                32,
                117,
                44,
                32,
                120,
                44,
                32,
                121,
                44,
                32,
                122,
                44,
                32,
                65,
                44,
                32,
                66,
                44,
                32,
                111,
                97,
                44,
                32,
                112,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                113,
                97,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                32,
                61,
                32,
                108,
                97,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                56,
                32,
                61,
                32,
                117,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                73,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                49,
                54,
                32,
                61,
                32,
                121,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                73,
                110,
                116,
                49,
                54,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                85,
                56,
                32,
                61,
                32,
                120,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                85,
                49,
                54,
                32,
                61,
                32,
                122,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                49,
                54,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                51,
                50,
                32,
                61,
                32,
                65,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                73,
                110,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                85,
                51,
                50,
                32,
                61,
                32,
                66,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                70,
                51,
                50,
                32,
                61,
                32,
                111,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                70,
                108,
                111,
                97,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                70,
                54,
                52,
                32,
                61,
                32,
                112,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                70,
                108,
                111,
                97,
                116,
                54,
                52,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                114,
                97,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                115,
                97,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                116,
                97,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                117,
                97,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                32,
                61,
                32,
                107,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                46,
                115,
                104,
                105,
                102,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                97,
                46,
                117,
                110,
                115,
                104,
                105,
                102,
                116,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                67,
                32,
                61,
                32,
                48,
                44,
                32,
                68,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                118,
                97,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                111,
                110,
                65,
                98,
                111,
                114,
                116,
                63,
                46,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                34,
                65,
                98,
                111,
                114,
                116,
                101,
                100,
                40,
                34,
                32,
                43,
                32,
                97,
                32,
                43,
                32,
                34,
                41,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                46,
                82,
                117,
                110,
                116,
                105,
                109,
                101,
                69,
                114,
                114,
                111,
                114,
                40,
                97,
                32,
                43,
                32,
                34,
                46,
                32,
                66,
                117,
                105,
                108,
                100,
                32,
                119,
                105,
                116,
                104,
                32,
                45,
                115,
                65,
                83,
                83,
                69,
                82,
                84,
                73,
                79,
                78,
                83,
                32,
                102,
                111,
                114,
                32,
                109,
                111,
                114,
                101,
                32,
                105,
                110,
                102,
                111,
                46,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                119,
                97,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                97,
                46,
                115,
                116,
                97,
                114,
                116,
                115,
                87,
                105,
                116,
                104,
                40,
                34,
                100,
                97,
                116,
                97,
                58,
                97,
                112,
                112,
                108,
                105,
                99,
                97,
                116,
                105,
                111,
                110,
                47,
                111,
                99,
                116,
                101,
                116,
                45,
                115,
                116,
                114,
                101,
                97,
                109,
                59,
                98,
                97,
                115,
                101,
                54,
                52,
                44,
                34,
                41,
                44,
                32,
                120,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                121,
                97,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                107,
                97,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                105,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                97,
                32,
                61,
                61,
                32,
                120,
                97,
                32,
                38,
                38,
                32,
                107,
                97,
                41,
                32,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                107,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                34,
                98,
                111,
                116,
                104,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                97,
                110,
                100,
                32,
                115,
                121,
                110,
                99,
                32,
                102,
                101,
                116,
                99,
                104,
                105,
                110,
                103,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                119,
                97,
                115,
                109,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                122,
                97,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                121,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                40,
                99,
                44,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                40,
                96,
                102,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                97,
                115,
                121,
                110,
                99,
                104,
                114,
                111,
                110,
                111,
                117,
                115,
                108,
                121,
                32,
                112,
                114,
                101,
                112,
                97,
                114,
                101,
                32,
                119,
                97,
                115,
                109,
                58,
                32,
                36,
                123,
                100,
                125,
                96,
                41,
                44,
                32,
                118,
                97,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                65,
                97,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                120,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                107,
                97,
                32,
                38,
                38,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                83,
                116,
                114,
                101,
                97,
                109,
                105,
                110,
                103,
                32,
                38,
                38,
                32,
                33,
                119,
                97,
                40,
                98,
                41,
                32,
                38,
                38,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                102,
                101,
                116,
                99,
                104,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                102,
                101,
                116,
                99,
                104,
                40,
                98,
                44,
                32,
                123,
                32,
                99,
                114,
                101,
                100,
                101,
                110,
                116,
                105,
                97,
                108,
                115,
                58,
                32,
                34,
                115,
                97,
                109,
                101,
                45,
                111,
                114,
                105,
                103,
                105,
                110,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                83,
                116,
                114,
                101,
                97,
                109,
                105,
                110,
                103,
                40,
                99,
                44,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                40,
                96,
                119,
                97,
                115,
                109,
                32,
                115,
                116,
                114,
                101,
                97,
                109,
                105,
                110,
                103,
                32,
                99,
                111,
                109,
                112,
                105,
                108,
                101,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                58,
                32,
                36,
                123,
                100,
                125,
                96,
                41,
                44,
                32,
                114,
                40,
                34,
                102,
                97,
                108,
                108,
                105,
                110,
                103,
                32,
                98,
                97,
                99,
                107,
                32,
                116,
                111,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                105,
                111,
                110,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                122,
                97,
                40,
                98,
                44,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                66,
                97,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                110,
                97,
                109,
                101,
                34,
                44,
                32,
                34,
                69,
                120,
                105,
                116,
                83,
                116,
                97,
                116,
                117,
                115,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                32,
                61,
                32,
                96,
                80,
                114,
                111,
                103,
                114,
                97,
                109,
                32,
                116,
                101,
                114,
                109,
                105,
                110,
                97,
                116,
                101,
                100,
                32,
                119,
                105,
                116,
                104,
                32,
                101,
                120,
                105,
                116,
                40,
                36,
                123,
                97,
                125,
                41,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                115,
                116,
                97,
                116,
                117,
                115,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                67,
                97,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                59,
                32,
                48,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                41,
                32,
                97,
                46,
                115,
                104,
                105,
                102,
                116,
                40,
                41,
                40,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                68,
                97,
                32,
                61,
                32,
                107,
                46,
                110,
                111,
                69,
                120,
                105,
                116,
                82,
                117,
                110,
                116,
                105,
                109,
                101,
                32,
                124,
                124,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                69,
                97,
                32,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                33,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                84,
                101,
                120,
                116,
                68,
                101,
                99,
                111,
                100,
                101,
                114,
                32,
                63,
                32,
                110,
                101,
                119,
                32,
                84,
                101,
                120,
                116,
                68,
                101,
                99,
                111,
                100,
                101,
                114,
                40,
                41,
                32,
                58,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                44,
                32,
                71,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                32,
                61,
                32,
                48,
                44,
                32,
                99,
                32,
                61,
                32,
                78,
                97,
                78,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                32,
                43,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                99,
                32,
                61,
                32,
                98,
                59,
                32,
                97,
                91,
                99,
                93,
                32,
                38,
                38,
                32,
                33,
                40,
                99,
                32,
                62,
                61,
                32,
                100,
                41,
                59,
                32,
                41,
                32,
                43,
                43,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                49,
                54,
                32,
                60,
                32,
                99,
                32,
                45,
                32,
                98,
                32,
                38,
                38,
                32,
                97,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                32,
                38,
                38,
                32,
                69,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                69,
                97,
                46,
                100,
                101,
                99,
                111,
                100,
                101,
                40,
                97,
                46,
                115,
                117,
                98,
                97,
                114,
                114,
                97,
                121,
                40,
                98,
                44,
                32,
                99,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                100,
                32,
                61,
                32,
                34,
                34,
                59,
                32,
                98,
                32,
                60,
                32,
                99,
                59,
                32,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                97,
                91,
                98,
                43,
                43,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                32,
                38,
                32,
                49,
                50,
                56,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                97,
                91,
                98,
                43,
                43,
                93,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                49,
                57,
                50,
                32,
                61,
                61,
                32,
                40,
                101,
                32,
                38,
                32,
                50,
                50,
                52,
                41,
                41,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                40,
                101,
                32,
                38,
                32,
                51,
                49,
                41,
                32,
                60,
                60,
                32,
                54,
                32,
                124,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                97,
                91,
                98,
                43,
                43,
                93,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                50,
                50,
                52,
                32,
                61,
                61,
                32,
                40,
                101,
                32,
                38,
                32,
                50,
                52,
                48,
                41,
                32,
                63,
                32,
                40,
                101,
                32,
                38,
                32,
                49,
                53,
                41,
                32,
                60,
                60,
                32,
                49,
                50,
                32,
                124,
                32,
                102,
                32,
                60,
                60,
                32,
                54,
                32,
                124,
                32,
                104,
                32,
                58,
                32,
                40,
                101,
                32,
                38,
                32,
                55,
                41,
                32,
                60,
                60,
                32,
                49,
                56,
                32,
                124,
                32,
                102,
                32,
                60,
                60,
                32,
                49,
                50,
                32,
                124,
                32,
                104,
                32,
                60,
                60,
                32,
                54,
                32,
                124,
                32,
                97,
                91,
                98,
                43,
                43,
                93,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                62,
                32,
                101,
                32,
                63,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                101,
                41,
                32,
                58,
                32,
                40,
                101,
                32,
                45,
                61,
                32,
                54,
                53,
                53,
                51,
                54,
                44,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                53,
                53,
                50,
                57,
                54,
                32,
                124,
                32,
                101,
                32,
                62,
                62,
                32,
                49,
                48,
                44,
                32,
                53,
                54,
                51,
                50,
                48,
                32,
                124,
                32,
                101,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                73,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                70,
                97,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                80,
                97,
                32,
                61,
                32,
                97,
                32,
                45,
                32,
                50,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                72,
                97,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                98,
                32,
                61,
                32,
                73,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                74,
                40,
                48,
                41,
                44,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                70,
                97,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                91,
                99,
                46,
                80,
                97,
                32,
                43,
                32,
                49,
                54,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                66,
                91,
                99,
                46,
                80,
                97,
                32,
                43,
                32,
                52,
                32,
                62,
                62,
                32,
                50,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                100,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                74,
                40,
                48,
                41,
                44,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                101,
                32,
                111,
                102,
                32,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                48,
                32,
                61,
                61,
                61,
                32,
                101,
                32,
                124,
                124,
                32,
                101,
                32,
                61,
                61,
                61,
                32,
                100,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                71,
                97,
                40,
                101,
                44,
                32,
                100,
                44,
                32,
                99,
                46,
                80,
                97,
                32,
                43,
                32,
                49,
                54,
                41,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                74,
                40,
                101,
                41,
                44,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                74,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                73,
                97,
                32,
                61,
                32,
                48,
                44,
                32,
                75,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                48,
                32,
                60,
                32,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                98,
                32,
                43,
                32,
                99,
                32,
                45,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                48,
                59,
                32,
                101,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                53,
                53,
                50,
                57,
                54,
                32,
                60,
                61,
                32,
                102,
                32,
                38,
                38,
                32,
                53,
                55,
                51,
                52,
                51,
                32,
                62,
                61,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                43,
                43,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                32,
                61,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                43,
                32,
                40,
                40,
                102,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                41,
                32,
                60,
                60,
                32,
                49,
                48,
                41,
                32,
                124,
                32,
                104,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                49,
                50,
                55,
                32,
                62,
                61,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                62,
                61,
                32,
                99,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                48,
                52,
                55,
                32,
                62,
                61,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                43,
                32,
                49,
                32,
                62,
                61,
                32,
                99,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                49,
                57,
                50,
                32,
                124,
                32,
                102,
                32,
                62,
                62,
                32,
                54,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                54,
                53,
                53,
                51,
                53,
                32,
                62,
                61,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                43,
                32,
                50,
                32,
                62,
                61,
                32,
                99,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                50,
                50,
                52,
                32,
                124,
                32,
                102,
                32,
                62,
                62,
                32,
                49,
                50,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                43,
                32,
                51,
                32,
                62,
                61,
                32,
                99,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                50,
                52,
                48,
                32,
                124,
                32,
                102,
                32,
                62,
                62,
                32,
                49,
                56,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                49,
                50,
                56,
                32,
                124,
                32,
                102,
                32,
                62,
                62,
                32,
                49,
                50,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                49,
                50,
                56,
                32,
                124,
                32,
                102,
                32,
                62,
                62,
                32,
                54,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                49,
                50,
                56,
                32,
                124,
                32,
                102,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                93,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                74,
                97,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                75,
                97,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                59,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                97,
                46,
                112,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                112,
                111,
                112,
                40,
                41,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                76,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                66,
                91,
                97,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                77,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                78,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                76,
                97,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                77,
                97,
                44,
                32,
                80,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                100,
                40,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                61,
                32,
                99,
                40,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                103,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                33,
                61,
                61,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                40,
                34,
                77,
                105,
                115,
                109,
                97,
                116,
                99,
                104,
                101,
                100,
                32,
                116,
                121,
                112,
                101,
                32,
                99,
                111,
                110,
                118,
                101,
                114,
                116,
                101,
                114,
                32,
                99,
                111,
                117,
                110,
                116,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                48,
                59,
                32,
                108,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                108,
                41,
                32,
                79,
                40,
                97,
                91,
                108,
                93,
                44,
                32,
                103,
                91,
                108,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                76,
                97,
                91,
                103,
                93,
                32,
                61,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                65,
                114,
                114,
                97,
                121,
                40,
                98,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                41,
                44,
                32,
                102,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                104,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                103,
                44,
                32,
                108,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                103,
                41,
                32,
                63,
                32,
                101,
                91,
                108,
                93,
                32,
                61,
                32,
                78,
                91,
                103,
                93,
                32,
                58,
                32,
                40,
                102,
                46,
                112,
                117,
                115,
                104,
                40,
                103,
                41,
                44,
                32,
                77,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                103,
                41,
                32,
                124,
                124,
                32,
                40,
                77,
                91,
                103,
                93,
                32,
                61,
                32,
                91,
                93,
                41,
                44,
                32,
                77,
                91,
                103,
                93,
                46,
                112,
                117,
                115,
                104,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                91,
                108,
                93,
                32,
                61,
                32,
                78,
                91,
                103,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                43,
                43,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                32,
                61,
                61,
                61,
                32,
                102,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                38,
                38,
                32,
                100,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                102,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                38,
                38,
                32,
                100,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                78,
                97,
                44,
                32,
                81,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                34,
                34,
                59,
                32,
                120,
                91,
                97,
                93,
                59,
                32,
                41,
                32,
                98,
                32,
                43,
                61,
                32,
                78,
                97,
                91,
                120,
                91,
                97,
                43,
                43,
                93,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                82,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                79,
                97,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                32,
                61,
                32,
                123,
                125,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                46,
                110,
                97,
                109,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                116,
                121,
                112,
                101,
                32,
                34,
                36,
                123,
                100,
                125,
                34,
                32,
                109,
                117,
                115,
                116,
                32,
                104,
                97,
                118,
                101,
                32,
                97,
                32,
                112,
                111,
                115,
                105,
                116,
                105,
                118,
                101,
                32,
                105,
                110,
                116,
                101,
                103,
                101,
                114,
                32,
                116,
                121,
                112,
                101,
                105,
                100,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                78,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                46,
                118,
                98,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                32,
                116,
                121,
                112,
                101,
                32,
                39,
                36,
                123,
                100,
                125,
                39,
                32,
                116,
                119,
                105,
                99,
                101,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                91,
                97,
                93,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                76,
                97,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                77,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                97,
                41,
                32,
                38,
                38,
                32,
                40,
                98,
                32,
                61,
                32,
                77,
                91,
                97,
                93,
                44,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                77,
                91,
                97,
                93,
                44,
                32,
                98,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                101,
                41,
                32,
                61,
                62,
                32,
                101,
                40,
                41,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                79,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                32,
                61,
                32,
                123,
                125,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                79,
                97,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                81,
                97,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                97,
                46,
                79,
                97,
                46,
                82,
                97,
                46,
                81,
                97,
                46,
                110,
                97,
                109,
                101,
                32,
                43,
                32,
                34,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                97,
                108,
                114,
                101,
                97,
                100,
                121,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                82,
                97,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                83,
                97,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                84,
                97,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                61,
                61,
                61,
                32,
                99,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                99,
                46,
                85,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                84,
                97,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                46,
                85,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                97,
                32,
                63,
                32,
                110,
                117,
                108,
                108,
                32,
                58,
                32,
                99,
                46,
                111,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                85,
                97,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                86,
                97,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                87,
                97,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                98,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                34,
                112,
                116,
                114,
                32,
                115,
                104,
                111,
                117,
                108,
                100,
                32,
                110,
                111,
                116,
                32,
                98,
                101,
                32,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                59,
                32,
                97,
                46,
                85,
                97,
                59,
                32,
                41,
                32,
                98,
                32,
                61,
                32,
                97,
                46,
                101,
                98,
                40,
                98,
                41,
                44,
                32,
                97,
                32,
                61,
                32,
                97,
                46,
                85,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                86,
                97,
                91,
                98,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                89,
                97,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                82,
                97,
                32,
                124,
                124,
                32,
                33,
                98,
                46,
                80,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                40,
                34,
                109,
                97,
                107,
                101,
                67,
                108,
                97,
                115,
                115,
                72,
                97,
                110,
                100,
                108,
                101,
                32,
                114,
                101,
                113,
                117,
                105,
                114,
                101,
                115,
                32,
                112,
                116,
                114,
                32,
                97,
                110,
                100,
                32,
                112,
                116,
                114,
                84,
                121,
                112,
                101,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                33,
                98,
                46,
                86,
                97,
                32,
                33,
                61,
                61,
                32,
                33,
                33,
                98,
                46,
                84,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                40,
                34,
                66,
                111,
                116,
                104,
                32,
                115,
                109,
                97,
                114,
                116,
                80,
                116,
                114,
                84,
                121,
                112,
                101,
                32,
                97,
                110,
                100,
                32,
                115,
                109,
                97,
                114,
                116,
                80,
                116,
                114,
                32,
                109,
                117,
                115,
                116,
                32,
                98,
                101,
                32,
                115,
                112,
                101,
                99,
                105,
                102,
                105,
                101,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                46,
                99,
                111,
                117,
                110,
                116,
                32,
                61,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                49,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                88,
                97,
                40,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                40,
                97,
                44,
                32,
                123,
                32,
                79,
                97,
                58,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                98,
                44,
                32,
                119,
                114,
                105,
                116,
                97,
                98,
                108,
                101,
                58,
                32,
                116,
                114,
                117,
                101,
                32,
                125,
                32,
                125,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                88,
                97,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                61,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                70,
                105,
                110,
                97,
                108,
                105,
                122,
                97,
                116,
                105,
                111,
                110,
                82,
                101,
                103,
                105,
                115,
                116,
                114,
                121,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                88,
                97,
                32,
                61,
                32,
                40,
                98,
                41,
                32,
                61,
                62,
                32,
                98,
                44,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                70,
                105,
                110,
                97,
                108,
                105,
                122,
                97,
                116,
                105,
                111,
                110,
                82,
                101,
                103,
                105,
                115,
                116,
                114,
                121,
                40,
                40,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                98,
                46,
                79,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                45,
                98,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                98,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                32,
                38,
                38,
                32,
                40,
                98,
                46,
                84,
                97,
                32,
                63,
                32,
                98,
                46,
                86,
                97,
                46,
                89,
                97,
                40,
                98,
                46,
                84,
                97,
                41,
                32,
                58,
                32,
                98,
                46,
                82,
                97,
                46,
                81,
                97,
                46,
                89,
                97,
                40,
                98,
                46,
                80,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                97,
                32,
                61,
                32,
                40,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                79,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                84,
                97,
                32,
                38,
                38,
                32,
                82,
                97,
                46,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                40,
                98,
                44,
                32,
                123,
                32,
                79,
                97,
                58,
                32,
                99,
                32,
                125,
                44,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                97,
                32,
                61,
                32,
                40,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                97,
                46,
                117,
                110,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                88,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                90,
                97,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                36,
                97,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                100,
                101,
                102,
                105,
                110,
                101,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                98,
                44,
                32,
                34,
                110,
                97,
                109,
                101,
                34,
                44,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                97,
                32,
                125,
                41,
                44,
                32,
                98,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                97,
                91,
                98,
                93,
                46,
                83,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                97,
                91,
                98,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                91,
                98,
                93,
                32,
                61,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                46,
                46,
                46,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                97,
                91,
                98,
                93,
                46,
                83,
                97,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                101,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                70,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                39,
                36,
                123,
                99,
                125,
                39,
                32,
                99,
                97,
                108,
                108,
                101,
                100,
                32,
                119,
                105,
                116,
                104,
                32,
                97,
                110,
                32,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                110,
                117,
                109,
                98,
                101,
                114,
                32,
                111,
                102,
                32,
                97,
                114,
                103,
                117,
                109,
                101,
                110,
                116,
                115,
                32,
                40,
                36,
                123,
                101,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                125,
                41,
                32,
                45,
                32,
                101,
                120,
                112,
                101,
                99,
                116,
                115,
                32,
                111,
                110,
                101,
                32,
                111,
                102,
                32,
                40,
                36,
                123,
                97,
                91,
                98,
                93,
                46,
                83,
                97,
                125,
                41,
                33,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                91,
                98,
                93,
                46,
                83,
                97,
                91,
                101,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                93,
                46,
                97,
                112,
                112,
                108,
                121,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                91,
                98,
                93,
                46,
                83,
                97,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                91,
                98,
                93,
                46,
                83,
                97,
                91,
                100,
                46,
                97,
                98,
                93,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                99,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                107,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                99,
                32,
                124,
                124,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                107,
                91,
                97,
                93,
                46,
                83,
                97,
                32,
                38,
                38,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                107,
                91,
                97,
                93,
                46,
                83,
                97,
                91,
                99,
                93,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                32,
                112,
                117,
                98,
                108,
                105,
                99,
                32,
                110,
                97,
                109,
                101,
                32,
                39,
                36,
                123,
                97,
                125,
                39,
                32,
                116,
                119,
                105,
                99,
                101,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                98,
                40,
                107,
                44,
                32,
                97,
                44,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                107,
                91,
                97,
                93,
                46,
                83,
                97,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                99,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                32,
                109,
                117,
                108,
                116,
                105,
                112,
                108,
                101,
                32,
                111,
                118,
                101,
                114,
                108,
                111,
                97,
                100,
                115,
                32,
                111,
                102,
                32,
                97,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                119,
                105,
                116,
                104,
                32,
                116,
                104,
                101,
                32,
                115,
                97,
                109,
                101,
                32,
                110,
                117,
                109,
                98,
                101,
                114,
                32,
                111,
                102,
                32,
                97,
                114,
                103,
                117,
                109,
                101,
                110,
                116,
                115,
                32,
                40,
                36,
                123,
                99,
                125,
                41,
                33,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                91,
                97,
                93,
                46,
                83,
                97,
                91,
                99,
                93,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                107,
                91,
                97,
                93,
                32,
                61,
                32,
                98,
                44,
                32,
                107,
                91,
                97,
                93,
                46,
                97,
                98,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                100,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                97,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                47,
                91,
                94,
                97,
                45,
                122,
                65,
                45,
                90,
                48,
                45,
                57,
                95,
                93,
                47,
                103,
                44,
                32,
                34,
                36,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                52,
                56,
                32,
                60,
                61,
                32,
                98,
                32,
                38,
                38,
                32,
                53,
                55,
                32,
                62,
                61,
                32,
                98,
                32,
                63,
                32,
                96,
                95,
                36,
                123,
                97,
                125,
                96,
                32,
                58,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                101,
                98,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                36,
                97,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                89,
                97,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                85,
                97,
                32,
                61,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                113,
                98,
                32,
                61,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                101,
                98,
                32,
                61,
                32,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                111,
                98,
                32,
                61,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                120,
                98,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                59,
                32,
                98,
                32,
                33,
                61,
                61,
                32,
                99,
                59,
                32,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                101,
                98,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                69,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                32,
                110,
                117,
                108,
                108,
                32,
                111,
                114,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                111,
                102,
                32,
                36,
                123,
                99,
                46,
                110,
                97,
                109,
                101,
                125,
                44,
                32,
                103,
                111,
                116,
                32,
                97,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                111,
                102,
                32,
                36,
                123,
                98,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                98,
                46,
                101,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                98,
                46,
                85,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                103,
                98,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                104,
                98,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                110,
                117,
                108,
                108,
                32,
                105,
                115,
                32,
                110,
                111,
                116,
                32,
                97,
                32,
                118,
                97,
                108,
                105,
                100,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                79,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                34,
                36,
                123,
                104,
                98,
                40,
                98,
                41,
                125,
                34,
                32,
                97,
                115,
                32,
                97,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                79,
                97,
                46,
                80,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                100,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                32,
                97,
                115,
                32,
                97,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                98,
                40,
                98,
                46,
                79,
                97,
                46,
                80,
                97,
                44,
                32,
                98,
                46,
                79,
                97,
                46,
                82,
                97,
                46,
                81,
                97,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                81,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                98,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                104,
                98,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                110,
                117,
                108,
                108,
                32,
                105,
                115,
                32,
                110,
                111,
                116,
                32,
                97,
                32,
                118,
                97,
                108,
                105,
                100,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                103,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                105,
                98,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                97,
                32,
                38,
                38,
                32,
                97,
                46,
                112,
                117,
                115,
                104,
                40,
                116,
                104,
                105,
                115,
                46,
                89,
                97,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                32,
                124,
                124,
                32,
                33,
                98,
                46,
                79,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                34,
                36,
                123,
                104,
                98,
                40,
                98,
                41,
                125,
                34,
                32,
                97,
                115,
                32,
                97,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                79,
                97,
                46,
                80,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                100,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                32,
                97,
                115,
                32,
                97,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                102,
                98,
                32,
                38,
                38,
                32,
                98,
                46,
                79,
                97,
                46,
                82,
                97,
                46,
                102,
                98,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                118,
                101,
                114,
                116,
                32,
                97,
                114,
                103,
                117,
                109,
                101,
                110,
                116,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                98,
                46,
                79,
                97,
                46,
                86,
                97,
                32,
                63,
                32,
                98,
                46,
                79,
                97,
                46,
                86,
                97,
                46,
                110,
                97,
                109,
                101,
                32,
                58,
                32,
                98,
                46,
                79,
                97,
                46,
                82,
                97,
                46,
                110,
                97,
                109,
                101,
                125,
                32,
                116,
                111,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                102,
                98,
                40,
                98,
                46,
                79,
                97,
                46,
                80,
                97,
                44,
                32,
                98,
                46,
                79,
                97,
                46,
                82,
                97,
                46,
                81,
                97,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                81,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                103,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                98,
                46,
                79,
                97,
                46,
                84,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                34,
                80,
                97,
                115,
                115,
                105,
                110,
                103,
                32,
                114,
                97,
                119,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                116,
                111,
                32,
                115,
                109,
                97,
                114,
                116,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                105,
                115,
                32,
                105,
                108,
                108,
                101,
                103,
                97,
                108,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                67,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                48,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                46,
                79,
                97,
                46,
                86,
                97,
                32,
                61,
                61,
                61,
                32,
                116,
                104,
                105,
                115,
                41,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                79,
                97,
                46,
                84,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                118,
                101,
                114,
                116,
                32,
                97,
                114,
                103,
                117,
                109,
                101,
                110,
                116,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                98,
                46,
                79,
                97,
                46,
                86,
                97,
                32,
                63,
                32,
                98,
                46,
                79,
                97,
                46,
                86,
                97,
                46,
                110,
                97,
                109,
                101,
                32,
                58,
                32,
                98,
                46,
                79,
                97,
                46,
                82,
                97,
                46,
                110,
                97,
                109,
                101,
                125,
                32,
                116,
                111,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                49,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                79,
                97,
                46,
                84,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                50,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                46,
                79,
                97,
                46,
                86,
                97,
                32,
                61,
                61,
                61,
                32,
                116,
                104,
                105,
                115,
                41,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                79,
                97,
                46,
                84,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                46,
                99,
                108,
                111,
                110,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                121,
                98,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                106,
                98,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                100,
                91,
                34,
                100,
                101,
                108,
                101,
                116,
                101,
                34,
                93,
                40,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                97,
                32,
                38,
                38,
                32,
                97,
                46,
                112,
                117,
                115,
                104,
                40,
                116,
                104,
                105,
                115,
                46,
                89,
                97,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                34,
                85,
                110,
                115,
                117,
                112,
                112,
                111,
                114,
                116,
                105,
                110,
                103,
                32,
                115,
                104,
                97,
                114,
                105,
                110,
                103,
                32,
                112,
                111,
                108,
                105,
                99,
                121,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                107,
                98,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                104,
                98,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                110,
                117,
                108,
                108,
                32,
                105,
                115,
                32,
                110,
                111,
                116,
                32,
                97,
                32,
                118,
                97,
                108,
                105,
                100,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                79,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                34,
                36,
                123,
                104,
                98,
                40,
                98,
                41,
                125,
                34,
                32,
                97,
                115,
                32,
                97,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                79,
                97,
                46,
                80,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                100,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                32,
                97,
                115,
                32,
                97,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                46,
                79,
                97,
                46,
                82,
                97,
                46,
                102,
                98,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                118,
                101,
                114,
                116,
                32,
                97,
                114,
                103,
                117,
                109,
                101,
                110,
                116,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                98,
                46,
                79,
                97,
                46,
                82,
                97,
                46,
                110,
                97,
                109,
                101,
                125,
                32,
                116,
                111,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                98,
                40,
                98,
                46,
                79,
                97,
                46,
                80,
                97,
                44,
                32,
                98,
                46,
                79,
                97,
                46,
                82,
                97,
                46,
                81,
                97,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                81,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                108,
                98,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                44,
                32,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                81,
                97,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                104,
                98,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                98,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                103,
                98,
                32,
                61,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                119,
                98,
                32,
                61,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                67,
                98,
                32,
                61,
                32,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                109,
                98,
                32,
                61,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                105,
                98,
                32,
                61,
                32,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                121,
                98,
                32,
                61,
                32,
                109,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                89,
                97,
                32,
                61,
                32,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                124,
                124,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                98,
                46,
                85,
                97,
                32,
                63,
                32,
                116,
                104,
                105,
                115,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                32,
                61,
                32,
                105,
                98,
                32,
                58,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                32,
                61,
                32,
                100,
                32,
                63,
                32,
                103,
                98,
                32,
                58,
                32,
                107,
                98,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                88,
                97,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                109,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                107,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                97,
                41,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                40,
                34,
                82,
                101,
                112,
                108,
                97,
                99,
                105,
                110,
                103,
                32,
                110,
                111,
                110,
                101,
                120,
                105,
                115,
                116,
                101,
                110,
                116,
                32,
                112,
                117,
                98,
                108,
                105,
                99,
                32,
                115,
                121,
                109,
                98,
                111,
                108,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                107,
                91,
                97,
                93,
                46,
                83,
                97,
                32,
                38,
                38,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                99,
                32,
                63,
                32,
                107,
                91,
                97,
                93,
                46,
                83,
                97,
                91,
                99,
                93,
                32,
                61,
                32,
                98,
                32,
                58,
                32,
                40,
                107,
                91,
                97,
                93,
                32,
                61,
                32,
                98,
                44,
                32,
                107,
                91,
                97,
                93,
                46,
                97,
                98,
                32,
                61,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                83,
                44,
                32,
                110,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                32,
                61,
                32,
                91,
                93,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                106,
                34,
                41,
                32,
                63,
                32,
                40,
                97,
                32,
                61,
                32,
                97,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                47,
                112,
                47,
                103,
                44,
                32,
                34,
                105,
                34,
                41,
                44,
                32,
                98,
                32,
                61,
                32,
                40,
                48,
                44,
                32,
                107,
                91,
                34,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                34,
                32,
                43,
                32,
                97,
                93,
                41,
                40,
                98,
                44,
                32,
                46,
                46,
                46,
                99,
                41,
                41,
                32,
                58,
                32,
                98,
                32,
                61,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                98,
                41,
                40,
                46,
                46,
                46,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                111,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                40,
                46,
                46,
                46,
                99,
                41,
                32,
                61,
                62,
                32,
                110,
                98,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                44,
                32,
                84,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                81,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                97,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                106,
                34,
                41,
                32,
                63,
                32,
                111,
                98,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                58,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                33,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                99,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                117,
                110,
                107,
                110,
                111,
                119,
                110,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                119,
                105,
                116,
                104,
                32,
                115,
                105,
                103,
                110,
                97,
                116,
                117,
                114,
                101,
                32,
                36,
                123,
                97,
                125,
                58,
                32,
                36,
                123,
                98,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                112,
                98,
                44,
                32,
                114,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                113,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                81,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                115,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                99,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                91,
                102,
                93,
                32,
                124,
                124,
                32,
                78,
                91,
                102,
                93,
                32,
                124,
                124,
                32,
                40,
                76,
                97,
                91,
                102,
                93,
                32,
                63,
                32,
                76,
                97,
                91,
                102,
                93,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                99,
                41,
                32,
                58,
                32,
                40,
                100,
                46,
                112,
                117,
                115,
                104,
                40,
                102,
                41,
                44,
                32,
                101,
                91,
                102,
                93,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                101,
                32,
                61,
                32,
                123,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                112,
                98,
                40,
                96,
                36,
                123,
                97,
                125,
                58,
                32,
                96,
                32,
                43,
                32,
                100,
                46,
                109,
                97,
                112,
                40,
                114,
                98,
                41,
                46,
                106,
                111,
                105,
                110,
                40,
                91,
                34,
                44,
                32,
                34,
                93,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                116,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                100,
                32,
                61,
                32,
                48,
                59,
                32,
                100,
                32,
                60,
                32,
                97,
                59,
                32,
                100,
                43,
                43,
                41,
                32,
                99,
                46,
                112,
                117,
                115,
                104,
                40,
                66,
                91,
                98,
                32,
                43,
                32,
                52,
                32,
                42,
                32,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                117,
                98,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                49,
                59,
                32,
                98,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                98,
                41,
                32,
                105,
                102,
                32,
                40,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                97,
                91,
                98,
                93,
                32,
                38,
                38,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                97,
                91,
                98,
                93,
                46,
                88,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                118,
                98,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                98,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                32,
                62,
                32,
                102,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                34,
                97,
                114,
                103,
                84,
                121,
                112,
                101,
                115,
                32,
                97,
                114,
                114,
                97,
                121,
                32,
                115,
                105,
                122,
                101,
                32,
                109,
                105,
                115,
                109,
                97,
                116,
                99,
                104,
                33,
                32,
                77,
                117,
                115,
                116,
                32,
                97,
                116,
                32,
                108,
                101,
                97,
                115,
                116,
                32,
                103,
                101,
                116,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                97,
                110,
                100,
                32,
                39,
                116,
                104,
                105,
                115,
                39,
                32,
                116,
                121,
                112,
                101,
                115,
                33,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                98,
                91,
                49,
                93,
                32,
                38,
                38,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                99,
                44,
                32,
                103,
                32,
                61,
                32,
                117,
                98,
                40,
                98,
                41,
                44,
                32,
                108,
                32,
                61,
                32,
                34,
                118,
                111,
                105,
                100,
                34,
                32,
                33,
                61,
                61,
                32,
                98,
                91,
                48,
                93,
                46,
                110,
                97,
                109,
                101,
                44,
                32,
                109,
                32,
                61,
                32,
                102,
                32,
                45,
                32,
                50,
                44,
                32,
                110,
                32,
                61,
                32,
                65,
                114,
                114,
                97,
                121,
                40,
                109,
                41,
                44,
                32,
                112,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                116,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                98,
                40,
                97,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                46,
                46,
                46,
                69,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                61,
                32,
                104,
                32,
                63,
                32,
                50,
                32,
                58,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                91,
                48,
                93,
                32,
                61,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                104,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                118,
                32,
                61,
                32,
                98,
                91,
                49,
                93,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                116,
                44,
                32,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                91,
                49,
                93,
                32,
                61,
                32,
                118,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                119,
                32,
                61,
                32,
                48,
                59,
                32,
                119,
                32,
                60,
                32,
                109,
                59,
                32,
                43,
                43,
                119,
                41,
                32,
                110,
                91,
                119,
                93,
                32,
                61,
                32,
                98,
                91,
                119,
                32,
                43,
                32,
                50,
                93,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                116,
                44,
                32,
                69,
                91,
                119,
                93,
                41,
                44,
                32,
                112,
                46,
                112,
                117,
                115,
                104,
                40,
                110,
                91,
                119,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                69,
                32,
                61,
                32,
                100,
                40,
                46,
                46,
                46,
                112,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                103,
                41,
                32,
                75,
                97,
                40,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                119,
                32,
                61,
                32,
                104,
                32,
                63,
                32,
                49,
                32,
                58,
                32,
                50,
                59,
                32,
                119,
                32,
                60,
                32,
                98,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                119,
                43,
                43,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                72,
                32,
                61,
                32,
                49,
                32,
                61,
                61,
                61,
                32,
                119,
                32,
                63,
                32,
                118,
                32,
                58,
                32,
                110,
                91,
                119,
                32,
                45,
                32,
                50,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                98,
                91,
                119,
                93,
                46,
                88,
                97,
                32,
                38,
                38,
                32,
                98,
                91,
                119,
                93,
                46,
                88,
                97,
                40,
                72,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                32,
                61,
                32,
                108,
                32,
                63,
                32,
                98,
                91,
                48,
                93,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                69,
                41,
                32,
                58,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                119,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                97,
                46,
                116,
                114,
                105,
                109,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                32,
                61,
                32,
                97,
                46,
                105,
                110,
                100,
                101,
                120,
                79,
                102,
                40,
                34,
                40,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                45,
                49,
                32,
                33,
                61,
                61,
                32,
                98,
                32,
                63,
                32,
                97,
                46,
                115,
                117,
                98,
                115,
                116,
                114,
                40,
                48,
                44,
                32,
                98,
                41,
                32,
                58,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                121,
                98,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                86,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                122,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                57,
                32,
                60,
                32,
                97,
                32,
                38,
                38,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                45,
                45,
                86,
                91,
                97,
                32,
                43,
                32,
                49,
                93,
                32,
                38,
                38,
                32,
                40,
                86,
                91,
                97,
                93,
                32,
                61,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                44,
                32,
                121,
                98,
                46,
                112,
                117,
                115,
                104,
                40,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                65,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                34,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                117,
                115,
                101,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                100,
                32,
                118,
                97,
                108,
                46,
                32,
                104,
                97,
                110,
                100,
                108,
                101,
                32,
                61,
                32,
                34,
                32,
                43,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                86,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                106,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                50,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                110,
                117,
                108,
                108,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                116,
                114,
                117,
                101,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                54,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                102,
                97,
                108,
                115,
                101,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                56,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                32,
                61,
                32,
                121,
                98,
                46,
                112,
                111,
                112,
                40,
                41,
                32,
                124,
                124,
                32,
                86,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                86,
                91,
                98,
                93,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                86,
                91,
                98,
                32,
                43,
                32,
                49,
                93,
                32,
                61,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                66,
                98,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                34,
                101,
                109,
                115,
                99,
                114,
                105,
                112,
                116,
                101,
                110,
                58,
                58,
                118,
                97,
                108,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                65,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                122,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                106,
                98,
                40,
                98,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                76,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                97,
                58,
                32,
                110,
                117,
                108,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                67,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                49,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                117,
                91,
                100,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                120,
                91,
                100,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                50,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                121,
                91,
                100,
                32,
                62,
                62,
                32,
                49,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                122,
                91,
                100,
                32,
                62,
                62,
                32,
                49,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                52,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                65,
                91,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                66,
                91,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                105,
                110,
                116,
                101,
                103,
                101,
                114,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                40,
                36,
                123,
                98,
                125,
                41,
                58,
                32,
                36,
                123,
                97,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                68,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                78,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                99,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                97,
                32,
                61,
                32,
                96,
                36,
                123,
                98,
                125,
                32,
                104,
                97,
                115,
                32,
                117,
                110,
                107,
                110,
                111,
                119,
                110,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                114,
                98,
                40,
                97,
                41,
                125,
                96,
                44,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                104,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                110,
                117,
                108,
                108,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                111,
                98,
                106,
                101,
                99,
                116,
                34,
                32,
                61,
                61,
                61,
                32,
                98,
                32,
                124,
                124,
                32,
                34,
                97,
                114,
                114,
                97,
                121,
                34,
                32,
                61,
                61,
                61,
                32,
                98,
                32,
                124,
                124,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                61,
                32,
                98,
                32,
                63,
                32,
                97,
                46,
                116,
                111,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                41,
                32,
                58,
                32,
                34,
                34,
                32,
                43,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                69,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                52,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                111,
                97,
                91,
                99,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                56,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                112,
                97,
                91,
                99,
                32,
                62,
                62,
                32,
                51,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                102,
                108,
                111,
                97,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                40,
                36,
                123,
                98,
                125,
                41,
                58,
                32,
                36,
                123,
                97,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                70,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                49,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                117,
                91,
                100,
                93,
                32,
                58,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                120,
                91,
                100,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                50,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                121,
                91,
                100,
                32,
                62,
                62,
                32,
                49,
                93,
                32,
                58,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                122,
                91,
                100,
                32,
                62,
                62,
                32,
                49,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                52,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                65,
                91,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                58,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                66,
                91,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                105,
                110,
                116,
                101,
                103,
                101,
                114,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                40,
                36,
                123,
                98,
                125,
                41,
                58,
                32,
                36,
                123,
                97,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                71,
                98,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                97,
                115,
                115,
                105,
                103,
                110,
                40,
                123,
                32,
                111,
                112,
                116,
                105,
                111,
                110,
                97,
                108,
                58,
                32,
                116,
                114,
                117,
                101,
                32,
                125,
                44,
                32,
                66,
                98,
                41,
                44,
                32,
                72,
                98,
                32,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                33,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                84,
                101,
                120,
                116,
                68,
                101,
                99,
                111,
                100,
                101,
                114,
                32,
                63,
                32,
                110,
                101,
                119,
                32,
                84,
                101,
                120,
                116,
                68,
                101,
                99,
                111,
                100,
                101,
                114,
                40,
                34,
                117,
                116,
                102,
                45,
                49,
                54,
                108,
                101,
                34,
                41,
                32,
                58,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                44,
                32,
                73,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                97,
                32,
                62,
                62,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                99,
                32,
                43,
                32,
                98,
                32,
                47,
                32,
                50,
                59,
                32,
                33,
                40,
                99,
                32,
                62,
                61,
                32,
                100,
                41,
                32,
                38,
                38,
                32,
                122,
                91,
                99,
                93,
                59,
                32,
                41,
                32,
                43,
                43,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                60,
                60,
                61,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                51,
                50,
                32,
                60,
                32,
                99,
                32,
                45,
                32,
                97,
                32,
                38,
                38,
                32,
                72,
                98,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                72,
                98,
                46,
                100,
                101,
                99,
                111,
                100,
                101,
                40,
                120,
                46,
                115,
                117,
                98,
                97,
                114,
                114,
                97,
                121,
                40,
                97,
                44,
                32,
                99,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                34,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                100,
                32,
                61,
                32,
                48,
                59,
                32,
                33,
                40,
                100,
                32,
                62,
                61,
                32,
                98,
                32,
                47,
                32,
                50,
                41,
                59,
                32,
                43,
                43,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                121,
                91,
                97,
                32,
                43,
                32,
                50,
                32,
                42,
                32,
                100,
                32,
                62,
                62,
                32,
                49,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                48,
                32,
                61,
                61,
                32,
                101,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                74,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                63,
                63,
                32,
                40,
                99,
                32,
                61,
                32,
                50,
                49,
                52,
                55,
                52,
                56,
                51,
                54,
                52,
                55,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                32,
                62,
                32,
                99,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                45,
                61,
                32,
                50,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                99,
                32,
                60,
                32,
                50,
                32,
                42,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                63,
                32,
                99,
                32,
                47,
                32,
                50,
                32,
                58,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                48,
                59,
                32,
                101,
                32,
                60,
                32,
                99,
                59,
                32,
                43,
                43,
                101,
                41,
                32,
                121,
                91,
                98,
                32,
                62,
                62,
                32,
                49,
                93,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                101,
                41,
                44,
                32,
                98,
                32,
                43,
                61,
                32,
                50,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                121,
                91,
                98,
                32,
                62,
                62,
                32,
                49,
                93,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                32,
                45,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                75,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                50,
                32,
                42,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                44,
                32,
                76,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                48,
                44,
                32,
                100,
                32,
                61,
                32,
                34,
                34,
                59,
                32,
                33,
                40,
                99,
                32,
                62,
                61,
                32,
                98,
                32,
                47,
                32,
                52,
                41,
                59,
                32,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                65,
                91,
                97,
                32,
                43,
                32,
                52,
                32,
                42,
                32,
                99,
                32,
                62,
                62,
                32,
                50,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                48,
                32,
                61,
                61,
                32,
                101,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                43,
                43,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                60,
                61,
                32,
                101,
                32,
                63,
                32,
                40,
                101,
                32,
                45,
                61,
                32,
                54,
                53,
                53,
                51,
                54,
                44,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                53,
                53,
                50,
                57,
                54,
                32,
                124,
                32,
                101,
                32,
                62,
                62,
                32,
                49,
                48,
                44,
                32,
                53,
                54,
                51,
                50,
                48,
                32,
                124,
                32,
                101,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                41,
                41,
                32,
                58,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                77,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                63,
                63,
                32,
                40,
                99,
                32,
                61,
                32,
                50,
                49,
                52,
                55,
                52,
                56,
                51,
                54,
                52,
                55,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                52,
                32,
                62,
                32,
                99,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                100,
                32,
                43,
                32,
                99,
                32,
                45,
                32,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                48,
                59,
                32,
                101,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                53,
                53,
                50,
                57,
                54,
                32,
                60,
                61,
                32,
                102,
                32,
                38,
                38,
                32,
                53,
                55,
                51,
                52,
                51,
                32,
                62,
                61,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                43,
                43,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                32,
                61,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                43,
                32,
                40,
                40,
                102,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                41,
                32,
                60,
                60,
                32,
                49,
                48,
                41,
                32,
                124,
                32,
                104,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                65,
                91,
                98,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                43,
                61,
                32,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                43,
                32,
                52,
                32,
                62,
                32,
                99,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                65,
                91,
                98,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                32,
                45,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                78,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                48,
                44,
                32,
                99,
                32,
                61,
                32,
                48,
                59,
                32,
                99,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                53,
                53,
                50,
                57,
                54,
                32,
                60,
                61,
                32,
                100,
                32,
                38,
                38,
                32,
                53,
                55,
                51,
                52,
                51,
                32,
                62,
                61,
                32,
                100,
                32,
                38,
                38,
                32,
                43,
                43,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                43,
                61,
                32,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                79,
                98,
                32,
                61,
                32,
                48,
                44,
                32,
                80,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                97,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                100,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                38,
                38,
                32,
                40,
                66,
                91,
                98,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                106,
                98,
                40,
                100,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                81,
                98,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                82,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                81,
                98,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                81,
                98,
                46,
                112,
                117,
                115,
                104,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                83,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                44,
                32,
                100,
                32,
                61,
                32,
                48,
                59,
                32,
                100,
                32,
                60,
                32,
                97,
                59,
                32,
                43,
                43,
                100,
                41,
                32,
                99,
                91,
                100,
                93,
                32,
                61,
                32,
                68,
                98,
                40,
                66,
                91,
                98,
                32,
                43,
                32,
                52,
                32,
                42,
                32,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                44,
                32,
                34,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                32,
                34,
                32,
                43,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                84,
                98,
                32,
                61,
                32,
                82,
                101,
                102,
                108,
                101,
                99,
                116,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                44,
                32,
                85,
                98,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                86,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                40,
                97,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                66,
                97,
                32,
                124,
                124,
                32,
                34,
                117,
                110,
                119,
                105,
                110,
                100,
                34,
                32,
                61,
                61,
                32,
                97,
                41,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                87,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                97,
                32,
                124,
                124,
                32,
                48,
                32,
                60,
                32,
                79,
                98,
                32,
                124,
                124,
                32,
                40,
                107,
                46,
                111,
                110,
                69,
                120,
                105,
                116,
                63,
                46,
                40,
                97,
                41,
                44,
                32,
                109,
                97,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                66,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                88,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                109,
                97,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                97,
                40,
                41,
                44,
                32,
                33,
                40,
                68,
                97,
                32,
                124,
                124,
                32,
                48,
                32,
                60,
                32,
                79,
                98,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                32,
                61,
                32,
                97,
                32,
                61,
                32,
                110,
                97,
                44,
                32,
                87,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                86,
                98,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                86,
                98,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                89,
                98,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                36,
                98,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                90,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                83,
                69,
                82,
                58,
                32,
                34,
                119,
                101,
                98,
                95,
                117,
                115,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                76,
                79,
                71,
                78,
                65,
                77,
                69,
                58,
                32,
                34,
                119,
                101,
                98,
                95,
                117,
                115,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                65,
                84,
                72,
                58,
                32,
                34,
                47,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                87,
                68,
                58,
                32,
                34,
                47,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                72,
                79,
                77,
                69,
                58,
                32,
                34,
                47,
                104,
                111,
                109,
                101,
                47,
                119,
                101,
                98,
                95,
                117,
                115,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                76,
                65,
                78,
                71,
                58,
                32,
                40,
                34,
                111,
                98,
                106,
                101,
                99,
                116,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                110,
                97,
                118,
                105,
                103,
                97,
                116,
                111,
                114,
                32,
                38,
                38,
                32,
                110,
                97,
                118,
                105,
                103,
                97,
                116,
                111,
                114,
                46,
                108,
                97,
                110,
                103,
                117,
                97,
                103,
                101,
                115,
                32,
                38,
                38,
                32,
                110,
                97,
                118,
                105,
                103,
                97,
                116,
                111,
                114,
                46,
                108,
                97,
                110,
                103,
                117,
                97,
                103,
                101,
                115,
                91,
                48,
                93,
                32,
                124,
                124,
                32,
                34,
                67,
                34,
                41,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                45,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                95,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                32,
                43,
                32,
                34,
                46,
                85,
                84,
                70,
                45,
                56,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                58,
                32,
                101,
                97,
                32,
                124,
                124,
                32,
                34,
                46,
                47,
                116,
                104,
                105,
                115,
                46,
                112,
                114,
                111,
                103,
                114,
                97,
                109,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                98,
                32,
                105,
                110,
                32,
                89,
                98,
                41,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                89,
                98,
                91,
                98,
                93,
                32,
                63,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                97,
                91,
                98,
                93,
                32,
                58,
                32,
                97,
                91,
                98,
                93,
                32,
                61,
                32,
                89,
                98,
                91,
                98,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                98,
                32,
                105,
                110,
                32,
                97,
                41,
                32,
                99,
                46,
                112,
                117,
                115,
                104,
                40,
                96,
                36,
                123,
                98,
                125,
                61,
                36,
                123,
                97,
                91,
                98,
                93,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                90,
                98,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                90,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                90,
                98,
                44,
                32,
                97,
                99,
                32,
                61,
                32,
                91,
                110,
                117,
                108,
                108,
                44,
                32,
                91,
                93,
                44,
                32,
                91,
                93,
                93,
                44,
                32,
                98,
                99,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                34,
                111,
                98,
                106,
                101,
                99,
                116,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                99,
                114,
                121,
                112,
                116,
                111,
                32,
                38,
                38,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                99,
                114,
                121,
                112,
                116,
                111,
                46,
                103,
                101,
                116,
                82,
                97,
                110,
                100,
                111,
                109,
                86,
                97,
                108,
                117,
                101,
                115,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                99,
                114,
                121,
                112,
                116,
                111,
                46,
                103,
                101,
                116,
                82,
                97,
                110,
                100,
                111,
                109,
                86,
                97,
                108,
                117,
                101,
                115,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                40,
                34,
                105,
                110,
                105,
                116,
                82,
                97,
                110,
                100,
                111,
                109,
                68,
                101,
                118,
                105,
                99,
                101,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                99,
                99,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                40,
                99,
                99,
                32,
                61,
                32,
                98,
                99,
                40,
                41,
                41,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                77,
                97,
                32,
                61,
                32,
                107,
                46,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                69,
                114,
                114,
                111,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                101,
                120,
                116,
                101,
                110,
                100,
                115,
                32,
                69,
                114,
                114,
                111,
                114,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                112,
                101,
                114,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                34,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                69,
                114,
                114,
                111,
                114,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                100,
                99,
                32,
                61,
                32,
                65,
                114,
                114,
                97,
                121,
                40,
                50,
                53,
                54,
                41,
                44,
                32,
                101,
                99,
                32,
                61,
                32,
                48,
                59,
                32,
                50,
                53,
                54,
                32,
                62,
                32,
                101,
                99,
                59,
                32,
                43,
                43,
                101,
                99,
                41,
                32,
                100,
                99,
                91,
                101,
                99,
                93,
                32,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                101,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                97,
                32,
                61,
                32,
                100,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                32,
                61,
                32,
                107,
                46,
                66,
                105,
                110,
                100,
                105,
                110,
                103,
                69,
                114,
                114,
                111,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                101,
                120,
                116,
                101,
                110,
                100,
                115,
                32,
                69,
                114,
                114,
                111,
                114,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                112,
                101,
                114,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                34,
                66,
                105,
                110,
                100,
                105,
                110,
                103,
                69,
                114,
                114,
                111,
                114,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                97,
                115,
                115,
                105,
                103,
                110,
                40,
                36,
                97,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                65,
                108,
                105,
                97,
                115,
                79,
                102,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                40,
                116,
                104,
                105,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                36,
                97,
                32,
                38,
                38,
                32,
                97,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                36,
                97,
                41,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                82,
                97,
                46,
                81,
                97,
                44,
                32,
                99,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                80,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                79,
                97,
                32,
                61,
                32,
                97,
                46,
                79,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                97,
                46,
                79,
                97,
                46,
                82,
                97,
                46,
                81,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                97,
                32,
                61,
                32,
                97,
                46,
                79,
                97,
                46,
                80,
                97,
                59,
                32,
                98,
                46,
                85,
                97,
                59,
                32,
                41,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                101,
                98,
                40,
                99,
                41,
                44,
                32,
                98,
                32,
                61,
                32,
                98,
                46,
                85,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                59,
                32,
                100,
                46,
                85,
                97,
                59,
                32,
                41,
                32,
                97,
                32,
                61,
                32,
                100,
                46,
                101,
                98,
                40,
                97,
                41,
                44,
                32,
                100,
                32,
                61,
                32,
                100,
                46,
                85,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                32,
                61,
                61,
                61,
                32,
                100,
                32,
                38,
                38,
                32,
                99,
                32,
                61,
                61,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                108,
                111,
                110,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                80,
                97,
                32,
                124,
                124,
                32,
                81,
                97,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                99,
                98,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                32,
                43,
                61,
                32,
                49,
                44,
                32,
                116,
                104,
                105,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                32,
                61,
                32,
                88,
                97,
                44,
                32,
                98,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                44,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                44,
                32,
                100,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                103,
                101,
                116,
                80,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                79,
                102,
                40,
                116,
                104,
                105,
                115,
                41,
                44,
                32,
                101,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                97,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                99,
                97,
                108,
                108,
                40,
                98,
                44,
                32,
                100,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                97,
                58,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                123,
                32,
                99,
                111,
                117,
                110,
                116,
                58,
                32,
                101,
                46,
                99,
                111,
                117,
                110,
                116,
                44,
                32,
                98,
                98,
                58,
                32,
                101,
                46,
                98,
                98,
                44,
                32,
                99,
                98,
                58,
                32,
                101,
                46,
                99,
                98,
                44,
                32,
                80,
                97,
                58,
                32,
                101,
                46,
                80,
                97,
                44,
                32,
                82,
                97,
                58,
                32,
                101,
                46,
                82,
                97,
                44,
                32,
                84,
                97,
                58,
                32,
                101,
                46,
                84,
                97,
                44,
                32,
                86,
                97,
                58,
                32,
                101,
                46,
                86,
                97,
                32,
                125,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                79,
                97,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                32,
                43,
                61,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                79,
                97,
                46,
                98,
                98,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                91,
                34,
                100,
                101,
                108,
                101,
                116,
                101,
                34,
                93,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                80,
                97,
                32,
                124,
                124,
                32,
                81,
                97,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                98,
                98,
                32,
                38,
                38,
                32,
                33,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                99,
                98,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                34,
                79,
                98,
                106,
                101,
                99,
                116,
                32,
                97,
                108,
                114,
                101,
                97,
                100,
                121,
                32,
                115,
                99,
                104,
                101,
                100,
                117,
                108,
                101,
                100,
                32,
                102,
                111,
                114,
                32,
                100,
                101,
                108,
                101,
                116,
                105,
                111,
                110,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                97,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                45,
                97,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                97,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                32,
                38,
                38,
                32,
                40,
                97,
                46,
                84,
                97,
                32,
                63,
                32,
                97,
                46,
                86,
                97,
                46,
                89,
                97,
                40,
                97,
                46,
                84,
                97,
                41,
                32,
                58,
                32,
                97,
                46,
                82,
                97,
                46,
                81,
                97,
                46,
                89,
                97,
                40,
                97,
                46,
                80,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                99,
                98,
                32,
                124,
                124,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                84,
                97,
                32,
                61,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                80,
                97,
                32,
                61,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                68,
                101,
                108,
                101,
                116,
                101,
                100,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                33,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                80,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                76,
                97,
                116,
                101,
                114,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                80,
                97,
                32,
                124,
                124,
                32,
                81,
                97,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                98,
                98,
                32,
                38,
                38,
                32,
                33,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                99,
                98,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                34,
                79,
                98,
                106,
                101,
                99,
                116,
                32,
                97,
                108,
                114,
                101,
                97,
                100,
                121,
                32,
                115,
                99,
                104,
                101,
                100,
                117,
                108,
                101,
                100,
                32,
                102,
                111,
                114,
                32,
                100,
                101,
                108,
                101,
                116,
                105,
                111,
                110,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                90,
                97,
                46,
                112,
                117,
                115,
                104,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                46,
                98,
                98,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                97,
                115,
                115,
                105,
                103,
                110,
                40,
                108,
                98,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                98,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                109,
                98,
                32,
                38,
                38,
                32,
                40,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                109,
                98,
                40,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                98,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                89,
                97,
                63,
                46,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                76,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                98,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                103,
                98,
                32,
                63,
                32,
                89,
                97,
                40,
                116,
                104,
                105,
                115,
                46,
                81,
                97,
                46,
                36,
                97,
                44,
                32,
                123,
                32,
                82,
                97,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                119,
                98,
                44,
                32,
                80,
                97,
                58,
                32,
                99,
                44,
                32,
                86,
                97,
                58,
                32,
                116,
                104,
                105,
                115,
                44,
                32,
                84,
                97,
                58,
                32,
                97,
                32,
                125,
                41,
                32,
                58,
                32,
                89,
                97,
                40,
                116,
                104,
                105,
                115,
                46,
                81,
                97,
                46,
                36,
                97,
                44,
                32,
                123,
                32,
                82,
                97,
                58,
                32,
                116,
                104,
                105,
                115,
                44,
                32,
                80,
                97,
                58,
                32,
                97,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                114,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                99,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                107,
                98,
                40,
                97,
                41,
                44,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                87,
                97,
                40,
                116,
                104,
                105,
                115,
                46,
                81,
                97,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                48,
                32,
                61,
                61,
                61,
                32,
                100,
                46,
                79,
                97,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                100,
                46,
                79,
                97,
                46,
                80,
                97,
                32,
                61,
                32,
                99,
                44,
                32,
                100,
                46,
                79,
                97,
                46,
                84,
                97,
                32,
                61,
                32,
                97,
                44,
                32,
                100,
                46,
                99,
                108,
                111,
                110,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                100,
                46,
                99,
                108,
                111,
                110,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                107,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                81,
                97,
                46,
                113,
                98,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                85,
                97,
                91,
                100,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                100,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                46,
                99,
                97,
                108,
                108,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                98,
                32,
                63,
                32,
                100,
                46,
                110,
                98,
                32,
                58,
                32,
                100,
                46,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                84,
                121,
                112,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                84,
                97,
                40,
                99,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                81,
                97,
                44,
                32,
                100,
                46,
                81,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                101,
                32,
                63,
                32,
                98,
                46,
                99,
                97,
                108,
                108,
                40,
                116,
                104,
                105,
                115,
                41,
                32,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                103,
                98,
                32,
                63,
                32,
                89,
                97,
                40,
                100,
                46,
                81,
                97,
                46,
                36,
                97,
                44,
                32,
                123,
                32,
                82,
                97,
                58,
                32,
                100,
                44,
                32,
                80,
                97,
                58,
                32,
                101,
                44,
                32,
                86,
                97,
                58,
                32,
                116,
                104,
                105,
                115,
                44,
                32,
                84,
                97,
                58,
                32,
                97,
                32,
                125,
                41,
                32,
                58,
                32,
                89,
                97,
                40,
                100,
                46,
                81,
                97,
                46,
                36,
                97,
                44,
                32,
                123,
                32,
                82,
                97,
                58,
                32,
                100,
                44,
                32,
                80,
                97,
                58,
                32,
                101,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                98,
                32,
                61,
                32,
                107,
                46,
                85,
                110,
                98,
                111,
                117,
                110,
                100,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                32,
                61,
                32,
                40,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                97,
                98,
                40,
                98,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                100,
                41,
                46,
                115,
                116,
                97,
                99,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                100,
                32,
                38,
                38,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                115,
                116,
                97,
                99,
                107,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                116,
                111,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                41,
                32,
                43,
                32,
                34,
                92,
                110,
                34,
                32,
                43,
                32,
                100,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                47,
                94,
                69,
                114,
                114,
                111,
                114,
                40,
                58,
                91,
                94,
                92,
                110,
                93,
                42,
                41,
                63,
                92,
                110,
                47,
                44,
                32,
                34,
                34,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                40,
                97,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                46,
                116,
                111,
                83,
                116,
                114,
                105,
                110,
                103,
                32,
                61,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                32,
                63,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                58,
                32,
                96,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                58,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                125,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                40,
                69,
                114,
                114,
                111,
                114,
                44,
                32,
                34,
                85,
                110,
                98,
                111,
                117,
                110,
                100,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                86,
                46,
                112,
                117,
                115,
                104,
                40,
                48,
                44,
                32,
                49,
                44,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                44,
                32,
                49,
                44,
                32,
                110,
                117,
                108,
                108,
                44,
                32,
                49,
                44,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                49,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                99,
                111,
                117,
                110,
                116,
                95,
                101,
                109,
                118,
                97,
                108,
                95,
                104,
                97,
                110,
                100,
                108,
                101,
                115,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                86,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                47,
                32,
                50,
                32,
                45,
                32,
                53,
                32,
                45,
                32,
                121,
                98,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                120,
                99,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                118,
                97,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                65,
                115,
                115,
                101,
                114,
                116,
                105,
                111,
                110,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                58,
                32,
                36,
                123,
                97,
                32,
                63,
                32,
                71,
                40,
                120,
                44,
                32,
                97,
                41,
                32,
                58,
                32,
                34,
                34,
                125,
                44,
                32,
                97,
                116,
                58,
                32,
                96,
                32,
                43,
                32,
                91,
                98,
                32,
                63,
                32,
                98,
                32,
                63,
                32,
                71,
                40,
                120,
                44,
                32,
                98,
                41,
                32,
                58,
                32,
                34,
                34,
                32,
                58,
                32,
                34,
                117,
                110,
                107,
                110,
                111,
                119,
                110,
                32,
                102,
                105,
                108,
                101,
                110,
                97,
                109,
                101,
                34,
                44,
                32,
                99,
                44,
                32,
                100,
                32,
                63,
                32,
                100,
                32,
                63,
                32,
                71,
                40,
                120,
                44,
                32,
                100,
                41,
                32,
                58,
                32,
                34,
                34,
                32,
                58,
                32,
                34,
                117,
                110,
                107,
                110,
                111,
                119,
                110,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                93,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                72,
                97,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                70,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                91,
                100,
                46,
                80,
                97,
                32,
                43,
                32,
                49,
                54,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                91,
                100,
                46,
                80,
                97,
                32,
                43,
                32,
                52,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                91,
                100,
                46,
                80,
                97,
                32,
                43,
                32,
                56,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                73,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                73,
                97,
                43,
                43,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                73,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                73,
                32,
                124,
                124,
                32,
                40,
                73,
                32,
                61,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                73,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                84,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                81,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                86,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                118,
                97,
                40,
                34,
                34,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                74,
                97,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                74,
                97,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                105,
                98,
                44,
                32,
                100,
                32,
                61,
                32,
                98,
                46,
                89,
                97,
                44,
                32,
                101,
                32,
                61,
                32,
                98,
                46,
                108,
                98,
                44,
                32,
                102,
                32,
                61,
                32,
                101,
                46,
                109,
                97,
                112,
                40,
                40,
                104,
                41,
                32,
                61,
                62,
                32,
                104,
                46,
                117,
                98,
                41,
                46,
                99,
                111,
                110,
                99,
                97,
                116,
                40,
                101,
                46,
                109,
                97,
                112,
                40,
                40,
                104,
                41,
                32,
                61,
                62,
                32,
                104,
                46,
                65,
                98,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                40,
                91,
                97,
                93,
                44,
                32,
                102,
                44,
                32,
                40,
                104,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                103,
                32,
                61,
                32,
                123,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                108,
                44,
                32,
                109,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                110,
                32,
                61,
                32,
                104,
                91,
                109,
                93,
                44,
                32,
                112,
                32,
                61,
                32,
                108,
                46,
                115,
                98,
                44,
                32,
                116,
                32,
                61,
                32,
                108,
                46,
                116,
                98,
                44,
                32,
                69,
                32,
                61,
                32,
                104,
                91,
                109,
                32,
                43,
                32,
                101,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                93,
                44,
                32,
                118,
                32,
                61,
                32,
                108,
                46,
                122,
                98,
                44,
                32,
                119,
                32,
                61,
                32,
                108,
                46,
                66,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                91,
                108,
                46,
                112,
                98,
                93,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                58,
                32,
                40,
                72,
                41,
                32,
                61,
                62,
                32,
                110,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                112,
                40,
                116,
                44,
                32,
                72,
                41,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                114,
                105,
                116,
                101,
                58,
                32,
                40,
                72,
                44,
                32,
                102,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                70,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                40,
                119,
                44,
                32,
                72,
                44,
                32,
                69,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                70,
                44,
                32,
                102,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                75,
                97,
                40,
                70,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                46,
                110,
                97,
                109,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                108,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                109,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                110,
                32,
                105,
                110,
                32,
                103,
                41,
                32,
                109,
                91,
                110,
                93,
                32,
                61,
                32,
                103,
                91,
                110,
                93,
                46,
                114,
                101,
                97,
                100,
                40,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                40,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                108,
                44,
                32,
                109,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                110,
                32,
                105,
                110,
                32,
                103,
                41,
                32,
                105,
                102,
                32,
                40,
                33,
                40,
                110,
                32,
                105,
                110,
                32,
                109,
                41,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                77,
                105,
                115,
                115,
                105,
                110,
                103,
                32,
                102,
                105,
                101,
                108,
                100,
                58,
                32,
                34,
                36,
                123,
                110,
                125,
                34,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                112,
                32,
                61,
                32,
                99,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                110,
                32,
                105,
                110,
                32,
                103,
                41,
                32,
                103,
                91,
                110,
                93,
                46,
                119,
                114,
                105,
                116,
                101,
                40,
                112,
                44,
                32,
                109,
                91,
                110,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                108,
                32,
                38,
                38,
                32,
                108,
                46,
                112,
                117,
                115,
                104,
                40,
                100,
                44,
                32,
                112,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                112,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                76,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                97,
                58,
                32,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                72,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                97,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                81,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                97,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                33,
                33,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                101,
                44,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                32,
                63,
                32,
                99,
                32,
                58,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                120,
                91,
                101,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                97,
                58,
                32,
                110,
                117,
                108,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                44,
                32,
                110,
                44,
                32,
                112,
                44,
                32,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                32,
                61,
                32,
                81,
                40,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                32,
                61,
                32,
                84,
                40,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                38,
                38,
                32,
                40,
                103,
                32,
                61,
                32,
                84,
                40,
                104,
                44,
                32,
                103,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                32,
                38,
                38,
                32,
                40,
                109,
                32,
                61,
                32,
                84,
                40,
                108,
                44,
                32,
                109,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                32,
                61,
                32,
                84,
                40,
                112,
                44,
                32,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                69,
                32,
                61,
                32,
                100,
                98,
                40,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                98,
                40,
                69,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                98,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                32,
                36,
                123,
                110,
                125,
                32,
                100,
                117,
                101,
                32,
                116,
                111,
                32,
                117,
                110,
                98,
                111,
                117,
                110,
                100,
                32,
                116,
                121,
                112,
                101,
                115,
                96,
                44,
                32,
                91,
                100,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                40,
                91,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                93,
                44,
                32,
                100,
                32,
                63,
                32,
                91,
                100,
                93,
                32,
                58,
                32,
                91,
                93,
                44,
                32,
                40,
                118,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                32,
                61,
                32,
                118,
                91,
                48,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                119,
                32,
                61,
                32,
                118,
                46,
                81,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                72,
                32,
                61,
                32,
                119,
                46,
                36,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                72,
                32,
                61,
                32,
                36,
                97,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                32,
                61,
                32,
                97,
                98,
                40,
                110,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                46,
                46,
                46,
                80,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                103,
                101,
                116,
                80,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                79,
                102,
                40,
                116,
                104,
                105,
                115,
                41,
                32,
                33,
                61,
                61,
                32,
                102,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                34,
                85,
                115,
                101,
                32,
                39,
                110,
                101,
                119,
                39,
                32,
                116,
                111,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                32,
                34,
                32,
                43,
                32,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                70,
                46,
                90,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                110,
                32,
                43,
                32,
                34,
                32,
                104,
                97,
                115,
                32,
                110,
                111,
                32,
                97,
                99,
                99,
                101,
                115,
                115,
                105,
                98,
                108,
                101,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                120,
                98,
                32,
                61,
                32,
                70,
                46,
                90,
                97,
                91,
                80,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                120,
                98,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                84,
                114,
                105,
                101,
                100,
                32,
                116,
                111,
                32,
                105,
                110,
                118,
                111,
                107,
                101,
                32,
                99,
                116,
                111,
                114,
                32,
                111,
                102,
                32,
                36,
                123,
                110,
                125,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                110,
                117,
                109,
                98,
                101,
                114,
                32,
                111,
                102,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                115,
                32,
                40,
                36,
                123,
                80,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                125,
                41,
                32,
                45,
                32,
                101,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                32,
                40,
                36,
                123,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                107,
                101,
                121,
                115,
                40,
                70,
                46,
                90,
                97,
                41,
                46,
                116,
                111,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                41,
                125,
                41,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                115,
                32,
                105,
                110,
                115,
                116,
                101,
                97,
                100,
                33,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                120,
                98,
                46,
                97,
                112,
                112,
                108,
                121,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                80,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                97,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                40,
                72,
                44,
                32,
                123,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                58,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                118,
                32,
                125,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                32,
                61,
                32,
                102,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                70,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                101,
                98,
                40,
                110,
                44,
                32,
                118,
                44,
                32,
                102,
                97,
                44,
                32,
                116,
                44,
                32,
                119,
                44,
                32,
                102,
                44,
                32,
                103,
                44,
                32,
                109,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                70,
                46,
                85,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                104,
                97,
                32,
                61,
                32,
                70,
                46,
                85,
                97,
                41,
                46,
                106,
                98,
                32,
                63,
                63,
                32,
                40,
                104,
                97,
                46,
                106,
                98,
                32,
                61,
                32,
                91,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                70,
                46,
                85,
                97,
                46,
                106,
                98,
                46,
                112,
                117,
                115,
                104,
                40,
                70,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                108,
                98,
                40,
                110,
                44,
                32,
                70,
                44,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                108,
                98,
                40,
                110,
                32,
                43,
                32,
                34,
                42,
                34,
                44,
                32,
                70,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                72,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                108,
                98,
                40,
                110,
                32,
                43,
                32,
                34,
                32,
                99,
                111,
                110,
                115,
                116,
                42,
                34,
                44,
                32,
                70,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                97,
                91,
                97,
                93,
                32,
                61,
                32,
                123,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                84,
                121,
                112,
                101,
                58,
                32,
                104,
                97,
                44,
                32,
                110,
                98,
                58,
                32,
                72,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                98,
                40,
                69,
                44,
                32,
                118,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                119,
                44,
                32,
                104,
                97,
                44,
                32,
                72,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                116,
                98,
                40,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                84,
                40,
                100,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                40,
                91,
                93,
                44,
                32,
                91,
                97,
                93,
                44,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                61,
                32,
                103,
                91,
                48,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                96,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                32,
                36,
                123,
                103,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                103,
                46,
                81,
                97,
                46,
                90,
                97,
                32,
                38,
                38,
                32,
                40,
                103,
                46,
                81,
                97,
                46,
                90,
                97,
                32,
                61,
                32,
                91,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                103,
                46,
                81,
                97,
                46,
                90,
                97,
                91,
                98,
                32,
                45,
                32,
                49,
                93,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                32,
                109,
                117,
                108,
                116,
                105,
                112,
                108,
                101,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                115,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                101,
                110,
                116,
                105,
                99,
                97,
                108,
                32,
                110,
                117,
                109,
                98,
                101,
                114,
                32,
                111,
                102,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                115,
                32,
                40,
                36,
                123,
                98,
                32,
                45,
                32,
                49,
                125,
                41,
                32,
                102,
                111,
                114,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                39,
                36,
                123,
                103,
                46,
                110,
                97,
                109,
                101,
                125,
                39,
                33,
                32,
                79,
                118,
                101,
                114,
                108,
                111,
                97,
                100,
                32,
                114,
                101,
                115,
                111,
                108,
                117,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                108,
                121,
                32,
                111,
                110,
                108,
                121,
                32,
                112,
                101,
                114,
                102,
                111,
                114,
                109,
                101,
                100,
                32,
                117,
                115,
                105,
                110,
                103,
                32,
                116,
                104,
                101,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                32,
                99,
                111,
                117,
                110,
                116,
                44,
                32,
                110,
                111,
                116,
                32,
                97,
                99,
                116,
                117,
                97,
                108,
                32,
                116,
                121,
                112,
                101,
                32,
                105,
                110,
                102,
                111,
                33,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                46,
                81,
                97,
                46,
                90,
                97,
                91,
                98,
                32,
                45,
                32,
                49,
                93,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                98,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                32,
                36,
                123,
                103,
                46,
                110,
                97,
                109,
                101,
                125,
                32,
                100,
                117,
                101,
                32,
                116,
                111,
                32,
                117,
                110,
                98,
                111,
                117,
                110,
                100,
                32,
                116,
                121,
                112,
                101,
                115,
                96,
                44,
                32,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                40,
                91,
                93,
                44,
                32,
                104,
                44,
                32,
                40,
                109,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                46,
                115,
                112,
                108,
                105,
                99,
                101,
                40,
                49,
                44,
                32,
                48,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                46,
                81,
                97,
                46,
                90,
                97,
                91,
                98,
                32,
                45,
                32,
                49,
                93,
                32,
                61,
                32,
                118,
                98,
                40,
                108,
                44,
                32,
                109,
                44,
                32,
                110,
                117,
                108,
                108,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                116,
                98,
                40,
                99,
                44,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                81,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                119,
                98,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                32,
                61,
                32,
                84,
                40,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                40,
                91,
                93,
                44,
                32,
                91,
                97,
                93,
                44,
                32,
                40,
                109,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                98,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                97,
                108,
                108,
                32,
                36,
                123,
                112,
                125,
                32,
                100,
                117,
                101,
                32,
                116,
                111,
                32,
                117,
                110,
                98,
                111,
                117,
                110,
                100,
                32,
                116,
                121,
                112,
                101,
                115,
                96,
                44,
                32,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                32,
                61,
                32,
                109,
                91,
                48,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                112,
                32,
                61,
                32,
                96,
                36,
                123,
                109,
                46,
                110,
                97,
                109,
                101,
                125,
                46,
                36,
                123,
                98,
                125,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                46,
                115,
                116,
                97,
                114,
                116,
                115,
                87,
                105,
                116,
                104,
                40,
                34,
                64,
                64,
                34,
                41,
                32,
                38,
                38,
                32,
                40,
                98,
                32,
                61,
                32,
                83,
                121,
                109,
                98,
                111,
                108,
                91,
                98,
                46,
                115,
                117,
                98,
                115,
                116,
                114,
                105,
                110,
                103,
                40,
                50,
                41,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                38,
                38,
                32,
                109,
                46,
                81,
                97,
                46,
                120,
                98,
                46,
                112,
                117,
                115,
                104,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                116,
                32,
                61,
                32,
                109,
                46,
                81,
                97,
                46,
                36,
                97,
                44,
                32,
                69,
                32,
                61,
                32,
                116,
                91,
                98,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                69,
                32,
                124,
                124,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                69,
                46,
                83,
                97,
                32,
                38,
                38,
                32,
                69,
                46,
                99,
                108,
                97,
                115,
                115,
                78,
                97,
                109,
                101,
                32,
                33,
                61,
                61,
                32,
                109,
                46,
                110,
                97,
                109,
                101,
                32,
                38,
                38,
                32,
                69,
                46,
                97,
                98,
                32,
                61,
                61,
                61,
                32,
                99,
                32,
                45,
                32,
                50,
                32,
                63,
                32,
                40,
                110,
                46,
                97,
                98,
                32,
                61,
                32,
                99,
                32,
                45,
                32,
                50,
                44,
                32,
                110,
                46,
                99,
                108,
                97,
                115,
                115,
                78,
                97,
                109,
                101,
                32,
                61,
                32,
                109,
                46,
                110,
                97,
                109,
                101,
                44,
                32,
                116,
                91,
                98,
                93,
                32,
                61,
                32,
                110,
                41,
                32,
                58,
                32,
                40,
                98,
                98,
                40,
                116,
                44,
                32,
                98,
                44,
                32,
                112,
                41,
                44,
                32,
                116,
                91,
                98,
                93,
                46,
                83,
                97,
                91,
                99,
                32,
                45,
                32,
                50,
                93,
                32,
                61,
                32,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                40,
                91,
                93,
                44,
                32,
                108,
                44,
                32,
                40,
                118,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                32,
                61,
                32,
                118,
                98,
                40,
                112,
                44,
                32,
                118,
                44,
                32,
                109,
                44,
                32,
                102,
                44,
                32,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                116,
                91,
                98,
                93,
                46,
                83,
                97,
                32,
                63,
                32,
                40,
                118,
                46,
                97,
                98,
                32,
                61,
                32,
                99,
                32,
                45,
                32,
                50,
                44,
                32,
                116,
                91,
                98,
                93,
                32,
                61,
                32,
                118,
                41,
                32,
                58,
                32,
                116,
                91,
                98,
                93,
                46,
                83,
                97,
                91,
                99,
                32,
                45,
                32,
                50,
                93,
                32,
                61,
                32,
                118,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                97,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                79,
                40,
                97,
                44,
                32,
                66,
                98,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                121,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                81,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                46,
                118,
                97,
                108,
                117,
                101,
                115,
                32,
                61,
                32,
                123,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                97,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                58,
                32,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                46,
                118,
                97,
                108,
                117,
                101,
                115,
                91,
                102,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                102,
                44,
                32,
                104,
                41,
                32,
                61,
                62,
                32,
                104,
                46,
                118,
                97,
                108,
                117,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                67,
                98,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                97,
                58,
                32,
                110,
                117,
                108,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                98,
                40,
                98,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                68,
                98,
                40,
                97,
                44,
                32,
                34,
                101,
                110,
                117,
                109,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                81,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                100,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                40,
                100,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                99,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                58,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                97,
                98,
                40,
                96,
                36,
                123,
                100,
                46,
                110,
                97,
                109,
                101,
                125,
                95,
                36,
                123,
                98,
                125,
                96,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                118,
                97,
                108,
                117,
                101,
                115,
                91,
                99,
                93,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                91,
                98,
                93,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                69,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                81,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                97,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                100,
                44,
                32,
                101,
                41,
                32,
                61,
                62,
                32,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                69,
                98,
                40,
                98,
                44,
                32,
                99,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                97,
                58,
                32,
                110,
                117,
                108,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                116,
                98,
                40,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                81,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                119,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                84,
                40,
                100,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                98,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                98,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                97,
                108,
                108,
                32,
                36,
                123,
                97,
                125,
                32,
                100,
                117,
                101,
                32,
                116,
                111,
                32,
                117,
                110,
                98,
                111,
                117,
                110,
                100,
                32,
                116,
                121,
                112,
                101,
                115,
                96,
                44,
                32,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                45,
                32,
                49,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                40,
                91,
                93,
                44,
                32,
                104,
                44,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                98,
                40,
                97,
                44,
                32,
                118,
                98,
                40,
                97,
                44,
                32,
                91,
                103,
                91,
                48,
                93,
                44,
                32,
                110,
                117,
                108,
                108,
                93,
                46,
                99,
                111,
                110,
                99,
                97,
                116,
                40,
                103,
                46,
                115,
                108,
                105,
                99,
                101,
                40,
                49,
                41,
                41,
                44,
                32,
                110,
                117,
                108,
                108,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                44,
                32,
                98,
                32,
                45,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                81,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                49,
                32,
                61,
                61,
                61,
                32,
                101,
                32,
                38,
                38,
                32,
                40,
                101,
                32,
                61,
                32,
                52,
                50,
                57,
                52,
                57,
                54,
                55,
                50,
                57,
                53,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                48,
                32,
                61,
                61,
                61,
                32,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                51,
                50,
                32,
                45,
                32,
                56,
                32,
                42,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                103,
                32,
                60,
                60,
                32,
                102,
                32,
                62,
                62,
                62,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                98,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                117,
                110,
                115,
                105,
                103,
                110,
                101,
                100,
                34,
                41,
                32,
                63,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                103,
                44,
                32,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                108,
                32,
                62,
                62,
                62,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                103,
                44,
                32,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                97,
                44,
                32,
                123,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                101,
                44,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                104,
                44,
                32,
                87,
                97,
                58,
                32,
                56,
                44,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                70,
                98,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                100,
                41,
                44,
                32,
                88,
                97,
                58,
                32,
                110,
                117,
                108,
                108,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                100,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                101,
                119,
                32,
                101,
                40,
                117,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                44,
                32,
                66,
                91,
                102,
                32,
                43,
                32,
                52,
                32,
                62,
                62,
                32,
                50,
                93,
                44,
                32,
                66,
                91,
                102,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                91,
                73,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                73,
                110,
                116,
                49,
                54,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                85,
                105,
                110,
                116,
                49,
                54,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                73,
                110,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                85,
                105,
                110,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                70,
                108,
                111,
                97,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                70,
                108,
                111,
                97,
                116,
                54,
                52,
                65,
                114,
                114,
                97,
                121,
                93,
                91,
                98,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                81,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                97,
                44,
                32,
                123,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                99,
                44,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                100,
                44,
                32,
                87,
                97,
                58,
                32,
                56,
                44,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                100,
                32,
                125,
                44,
                32,
                123,
                32,
                118,
                98,
                58,
                32,
                116,
                114,
                117,
                101,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                120,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                97,
                44,
                32,
                71,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                44,
                32,
                110,
                44,
                32,
                112,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                81,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                32,
                61,
                32,
                84,
                40,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                61,
                32,
                84,
                40,
                104,
                44,
                32,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                32,
                61,
                32,
                84,
                40,
                108,
                44,
                32,
                109,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                32,
                61,
                32,
                84,
                40,
                110,
                44,
                32,
                112,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                40,
                91,
                97,
                93,
                44,
                32,
                91,
                98,
                93,
                44,
                32,
                40,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                32,
                61,
                32,
                116,
                91,
                48,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                110,
                101,
                119,
                32,
                108,
                98,
                40,
                99,
                44,
                32,
                116,
                46,
                81,
                97,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                116,
                44,
                32,
                100,
                44,
                32,
                102,
                44,
                32,
                103,
                44,
                32,
                109,
                44,
                32,
                112,
                41,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                97,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                81,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                97,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                66,
                91,
                99,
                32,
                62,
                62,
                32,
                50,
                93,
                44,
                32,
                101,
                32,
                61,
                32,
                99,
                32,
                43,
                32,
                52,
                44,
                32,
                102,
                44,
                32,
                104,
                32,
                61,
                32,
                101,
                44,
                32,
                103,
                32,
                61,
                32,
                48,
                59,
                32,
                103,
                32,
                60,
                61,
                32,
                100,
                59,
                32,
                43,
                43,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                101,
                32,
                43,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                103,
                32,
                61,
                61,
                32,
                100,
                32,
                124,
                124,
                32,
                48,
                32,
                61,
                61,
                32,
                120,
                91,
                108,
                93,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                32,
                61,
                32,
                104,
                32,
                63,
                32,
                71,
                40,
                120,
                44,
                32,
                104,
                44,
                32,
                108,
                32,
                45,
                32,
                104,
                41,
                32,
                58,
                32,
                34,
                34,
                44,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                102,
                32,
                63,
                32,
                102,
                32,
                61,
                32,
                104,
                32,
                58,
                32,
                40,
                102,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                48,
                41,
                44,
                32,
                102,
                32,
                43,
                61,
                32,
                104,
                41,
                44,
                32,
                104,
                32,
                61,
                32,
                108,
                32,
                43,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                99,
                44,
                32,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                38,
                38,
                32,
                40,
                100,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                100,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                44,
                32,
                102,
                32,
                61,
                32,
                34,
                115,
                116,
                114,
                105,
                110,
                103,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                40,
                102,
                32,
                124,
                124,
                32,
                100,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                32,
                124,
                124,
                32,
                100,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                85,
                105,
                110,
                116,
                56,
                67,
                108,
                97,
                109,
                112,
                101,
                100,
                65,
                114,
                114,
                97,
                121,
                32,
                124,
                124,
                32,
                100,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                73,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                34,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                110,
                111,
                110,
                45,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                116,
                111,
                32,
                115,
                116,
                100,
                58,
                58,
                115,
                116,
                114,
                105,
                110,
                103,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                101,
                32,
                61,
                32,
                48,
                59,
                32,
                104,
                32,
                60,
                32,
                100,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                104,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                103,
                32,
                61,
                32,
                100,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                49,
                50,
                55,
                32,
                62,
                61,
                32,
                103,
                32,
                63,
                32,
                101,
                43,
                43,
                32,
                58,
                32,
                50,
                48,
                52,
                55,
                32,
                62,
                61,
                32,
                103,
                32,
                63,
                32,
                101,
                32,
                43,
                61,
                32,
                50,
                32,
                58,
                32,
                53,
                53,
                50,
                57,
                54,
                32,
                60,
                61,
                32,
                103,
                32,
                38,
                38,
                32,
                53,
                55,
                51,
                52,
                51,
                32,
                62,
                61,
                32,
                103,
                32,
                63,
                32,
                40,
                101,
                32,
                43,
                61,
                32,
                52,
                44,
                32,
                43,
                43,
                104,
                41,
                32,
                58,
                32,
                101,
                32,
                43,
                61,
                32,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                101,
                32,
                61,
                32,
                100,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                32,
                61,
                32,
                102,
                99,
                40,
                52,
                32,
                43,
                32,
                101,
                32,
                43,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                61,
                32,
                104,
                32,
                43,
                32,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                91,
                104,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                41,
                32,
                75,
                40,
                100,
                44,
                32,
                103,
                44,
                32,
                101,
                32,
                43,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                102,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                102,
                32,
                61,
                32,
                48,
                59,
                32,
                102,
                32,
                60,
                32,
                101,
                59,
                32,
                43,
                43,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                100,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                53,
                53,
                32,
                60,
                32,
                108,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                85,
                40,
                103,
                41,
                44,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                34,
                83,
                116,
                114,
                105,
                110,
                103,
                32,
                104,
                97,
                115,
                32,
                85,
                84,
                70,
                45,
                49,
                54,
                32,
                99,
                111,
                100,
                101,
                32,
                117,
                110,
                105,
                116,
                115,
                32,
                116,
                104,
                97,
                116,
                32,
                100,
                111,
                32,
                110,
                111,
                116,
                32,
                102,
                105,
                116,
                32,
                105,
                110,
                32,
                56,
                32,
                98,
                105,
                116,
                115,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                120,
                91,
                103,
                32,
                43,
                32,
                102,
                93,
                32,
                61,
                32,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                102,
                111,
                114,
                32,
                40,
                102,
                32,
                61,
                32,
                48,
                59,
                32,
                102,
                32,
                60,
                32,
                101,
                59,
                32,
                43,
                43,
                102,
                41,
                32,
                120,
                91,
                103,
                32,
                43,
                32,
                102,
                93,
                32,
                61,
                32,
                100,
                91,
                102,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                99,
                32,
                38,
                38,
                32,
                99,
                46,
                112,
                117,
                115,
                104,
                40,
                85,
                44,
                32,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                76,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                97,
                40,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                65,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                81,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                32,
                61,
                61,
                61,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                73,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                74,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                75,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                122,
                91,
                103,
                32,
                62,
                62,
                32,
                49,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                52,
                32,
                61,
                61,
                61,
                32,
                98,
                32,
                38,
                38,
                32,
                40,
                100,
                32,
                61,
                32,
                76,
                98,
                44,
                32,
                101,
                32,
                61,
                32,
                77,
                98,
                44,
                32,
                102,
                32,
                61,
                32,
                78,
                98,
                44,
                32,
                104,
                32,
                61,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                66,
                91,
                103,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                97,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                66,
                91,
                103,
                32,
                62,
                62,
                32,
                50,
                93,
                44,
                32,
                109,
                44,
                32,
                110,
                32,
                61,
                32,
                103,
                32,
                43,
                32,
                52,
                44,
                32,
                112,
                32,
                61,
                32,
                48,
                59,
                32,
                112,
                32,
                60,
                61,
                32,
                108,
                59,
                32,
                43,
                43,
                112,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                116,
                32,
                61,
                32,
                103,
                32,
                43,
                32,
                52,
                32,
                43,
                32,
                112,
                32,
                42,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                112,
                32,
                61,
                61,
                32,
                108,
                32,
                124,
                124,
                32,
                48,
                32,
                61,
                61,
                32,
                104,
                40,
                116,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                32,
                61,
                32,
                100,
                40,
                110,
                44,
                32,
                116,
                32,
                45,
                32,
                110,
                41,
                44,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                109,
                32,
                63,
                32,
                109,
                32,
                61,
                32,
                110,
                32,
                58,
                32,
                40,
                109,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                48,
                41,
                44,
                32,
                109,
                32,
                43,
                61,
                32,
                110,
                41,
                44,
                32,
                110,
                32,
                61,
                32,
                116,
                32,
                43,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                40,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                103,
                44,
                32,
                108,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                34,
                115,
                116,
                114,
                105,
                110,
                103,
                34,
                32,
                33,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                108,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                82,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                110,
                111,
                110,
                45,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                116,
                111,
                32,
                67,
                43,
                43,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                99,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                109,
                32,
                61,
                32,
                102,
                40,
                108,
                41,
                44,
                32,
                110,
                32,
                61,
                32,
                102,
                99,
                40,
                52,
                32,
                43,
                32,
                109,
                32,
                43,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                91,
                110,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                109,
                32,
                47,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                40,
                108,
                44,
                32,
                110,
                32,
                43,
                32,
                52,
                44,
                32,
                109,
                32,
                43,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                103,
                32,
                38,
                38,
                32,
                103,
                46,
                112,
                117,
                115,
                104,
                40,
                85,
                44,
                32,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                76,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                97,
                40,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                40,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                74,
                97,
                91,
                97,
                93,
                32,
                61,
                32,
                123,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                81,
                40,
                98,
                41,
                44,
                32,
                105,
                98,
                58,
                32,
                84,
                40,
                99,
                44,
                32,
                100,
                41,
                44,
                32,
                89,
                97,
                58,
                32,
                84,
                40,
                101,
                44,
                32,
                102,
                41,
                44,
                32,
                108,
                98,
                58,
                32,
                91,
                93,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                74,
                97,
                91,
                97,
                93,
                46,
                108,
                98,
                46,
                112,
                117,
                115,
                104,
                40,
                123,
                32,
                112,
                98,
                58,
                32,
                81,
                40,
                98,
                41,
                44,
                32,
                117,
                98,
                58,
                32,
                99,
                44,
                32,
                115,
                98,
                58,
                32,
                84,
                40,
                100,
                44,
                32,
                101,
                41,
                44,
                32,
                116,
                98,
                58,
                32,
                102,
                44,
                32,
                65,
                98,
                58,
                32,
                104,
                44,
                32,
                122,
                98,
                58,
                32,
                84,
                40,
                103,
                44,
                32,
                108,
                41,
                44,
                32,
                66,
                98,
                58,
                32,
                109,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                97,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                81,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                97,
                44,
                32,
                123,
                32,
                68,
                98,
                58,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                32,
                87,
                97,
                58,
                32,
                48,
                44,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                97,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                98,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                73,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                73,
                110,
                102,
                105,
                110,
                105,
                116,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                70,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                65,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                68,
                98,
                40,
                98,
                44,
                32,
                34,
                101,
                109,
                118,
                97,
                108,
                58,
                58,
                97,
                115,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                80,
                98,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                106,
                97,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                81,
                98,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                65,
                98,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                40,
                110,
                117,
                108,
                108,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                77,
                58,
                32,
                122,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                97,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                83,
                98,
                40,
                97,
                44,
                32,
                98,
                41,
                44,
                32,
                101,
                32,
                61,
                32,
                100,
                46,
                115,
                104,
                105,
                102,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                45,
                45,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                96,
                109,
                101,
                116,
                104,
                111,
                100,
                67,
                97,
                108,
                108,
                101,
                114,
                60,
                40,
                36,
                123,
                100,
                46,
                109,
                97,
                112,
                40,
                40,
                104,
                41,
                32,
                61,
                62,
                32,
                104,
                46,
                110,
                97,
                109,
                101,
                41,
                46,
                106,
                111,
                105,
                110,
                40,
                34,
                44,
                32,
                34,
                41,
                125,
                41,
                32,
                61,
                62,
                32,
                36,
                123,
                101,
                46,
                110,
                97,
                109,
                101,
                125,
                62,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                82,
                98,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                98,
                40,
                98,
                44,
                32,
                40,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                110,
                32,
                61,
                32,
                48,
                44,
                32,
                112,
                32,
                61,
                32,
                48,
                59,
                32,
                112,
                32,
                60,
                32,
                97,
                59,
                32,
                43,
                43,
                112,
                41,
                32,
                102,
                91,
                112,
                93,
                32,
                61,
                32,
                100,
                91,
                112,
                93,
                46,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                40,
                109,
                32,
                43,
                32,
                110,
                41,
                44,
                32,
                110,
                32,
                43,
                61,
                32,
                100,
                91,
                112,
                93,
                46,
                87,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                32,
                61,
                32,
                49,
                32,
                61,
                61,
                61,
                32,
                99,
                32,
                63,
                32,
                84,
                98,
                40,
                103,
                44,
                32,
                102,
                41,
                32,
                58,
                32,
                103,
                46,
                97,
                112,
                112,
                108,
                121,
                40,
                104,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                80,
                98,
                40,
                101,
                44,
                32,
                108,
                44,
                32,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                97,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                57,
                32,
                60,
                32,
                97,
                32,
                38,
                38,
                32,
                40,
                86,
                91,
                97,
                32,
                43,
                32,
                49,
                93,
                32,
                43,
                61,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                97,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                65,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                75,
                97,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                122,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                68,
                98,
                40,
                97,
                44,
                32,
                34,
                95,
                101,
                109,
                118,
                97,
                108,
                95,
                116,
                97,
                107,
                101,
                95,
                118,
                97,
                108,
                117,
                101,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                97,
                46,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                106,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                75,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                98,
                91,
                97,
                93,
                32,
                38,
                38,
                32,
                40,
                99,
                108,
                101,
                97,
                114,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                85,
                98,
                91,
                97,
                93,
                46,
                105,
                100,
                41,
                44,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                85,
                98,
                91,
                97,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                85,
                98,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                98,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                103,
                99,
                40,
                97,
                44,
                32,
                112,
                101,
                114,
                102,
                111,
                114,
                109,
                97,
                110,
                99,
                101,
                46,
                110,
                111,
                119,
                40,
                41,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                98,
                91,
                97,
                93,
                32,
                61,
                32,
                123,
                32,
                105,
                100,
                58,
                32,
                99,
                44,
                32,
                69,
                98,
                58,
                32,
                98,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                76,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                40,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                68,
                97,
                116,
                101,
                40,
                41,
                41,
                46,
                103,
                101,
                116,
                70,
                117,
                108,
                108,
                89,
                101,
                97,
                114,
                40,
                41,
                44,
                32,
                102,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                68,
                97,
                116,
                101,
                40,
                101,
                44,
                32,
                48,
                44,
                32,
                49,
                41,
                46,
                103,
                101,
                116,
                84,
                105,
                109,
                101,
                122,
                111,
                110,
                101,
                79,
                102,
                102,
                115,
                101,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                68,
                97,
                116,
                101,
                40,
                101,
                44,
                32,
                54,
                44,
                32,
                49,
                41,
                46,
                103,
                101,
                116,
                84,
                105,
                109,
                101,
                122,
                111,
                110,
                101,
                79,
                102,
                102,
                115,
                101,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                91,
                97,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                54,
                48,
                32,
                42,
                32,
                77,
                97,
                116,
                104,
                46,
                109,
                97,
                120,
                40,
                102,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                65,
                91,
                98,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                78,
                117,
                109,
                98,
                101,
                114,
                40,
                102,
                32,
                33,
                61,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                40,
                104,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                103,
                32,
                61,
                32,
                77,
                97,
                116,
                104,
                46,
                97,
                98,
                115,
                40,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                96,
                85,
                84,
                67,
                36,
                123,
                48,
                32,
                60,
                61,
                32,
                104,
                32,
                63,
                32,
                34,
                45,
                34,
                32,
                58,
                32,
                34,
                43,
                34,
                125,
                36,
                123,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                77,
                97,
                116,
                104,
                46,
                102,
                108,
                111,
                111,
                114,
                40,
                103,
                32,
                47,
                32,
                54,
                48,
                41,
                41,
                46,
                112,
                97,
                100,
                83,
                116,
                97,
                114,
                116,
                40,
                50,
                44,
                32,
                34,
                48,
                34,
                41,
                125,
                36,
                123,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                103,
                32,
                37,
                32,
                54,
                48,
                41,
                46,
                112,
                97,
                100,
                83,
                116,
                97,
                114,
                116,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                50,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                48,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                125,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                98,
                40,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                98,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                60,
                32,
                102,
                32,
                63,
                32,
                40,
                75,
                40,
                97,
                44,
                32,
                99,
                44,
                32,
                49,
                55,
                41,
                44,
                32,
                75,
                40,
                98,
                44,
                32,
                100,
                44,
                32,
                49,
                55,
                41,
                41,
                32,
                58,
                32,
                40,
                75,
                40,
                97,
                44,
                32,
                100,
                44,
                32,
                49,
                55,
                41,
                44,
                32,
                75,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                49,
                55,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                112,
                101,
                114,
                102,
                111,
                114,
                109,
                97,
                110,
                99,
                101,
                46,
                110,
                111,
                119,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                120,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                62,
                62,
                62,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                49,
                52,
                55,
                52,
                56,
                51,
                54,
                52,
                56,
                32,
                60,
                32,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                49,
                59,
                32,
                52,
                32,
                62,
                61,
                32,
                99,
                59,
                32,
                99,
                32,
                42,
                61,
                32,
                50,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                32,
                42,
                32,
                40,
                49,
                32,
                43,
                32,
                48,
                46,
                50,
                32,
                47,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                77,
                97,
                116,
                104,
                46,
                109,
                105,
                110,
                40,
                100,
                44,
                32,
                97,
                32,
                43,
                32,
                49,
                48,
                48,
                54,
                54,
                51,
                50,
                57,
                54,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                40,
                77,
                97,
                116,
                104,
                46,
                109,
                105,
                110,
                40,
                50,
                49,
                52,
                55,
                52,
                56,
                51,
                54,
                52,
                56,
                44,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                42,
                32,
                77,
                97,
                116,
                104,
                46,
                99,
                101,
                105,
                108,
                40,
                77,
                97,
                116,
                104,
                46,
                109,
                97,
                120,
                40,
                97,
                44,
                32,
                100,
                41,
                32,
                47,
                32,
                54,
                53,
                53,
                51,
                54,
                41,
                41,
                32,
                45,
                32,
                108,
                97,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                46,
                98,
                121,
                116,
                101,
                76,
                101,
                110,
                103,
                116,
                104,
                32,
                43,
                32,
                54,
                53,
                53,
                51,
                53,
                41,
                32,
                47,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                124,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                46,
                103,
                114,
                111,
                119,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                113,
                97,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                114,
                101,
                97,
                107,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                90,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                36,
                98,
                40,
                41,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                100,
                44,
                32,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                98,
                32,
                43,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                66,
                91,
                97,
                32,
                43,
                32,
                52,
                32,
                42,
                32,
                101,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                102,
                32,
                61,
                32,
                48,
                59,
                32,
                102,
                32,
                60,
                32,
                100,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                102,
                41,
                32,
                117,
                91,
                101,
                43,
                43,
                93,
                32,
                61,
                32,
                100,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                91,
                101,
                93,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                43,
                61,
                32,
                100,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                43,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                36,
                98,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                91,
                97,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                99,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                101,
                41,
                32,
                61,
                62,
                32,
                100,
                32,
                43,
                61,
                32,
                101,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                43,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                91,
                98,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                53,
                50,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                53,
                50,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                48,
                44,
                32,
                102,
                32,
                61,
                32,
                48,
                59,
                32,
                102,
                32,
                60,
                32,
                99,
                59,
                32,
                102,
                43,
                43,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                66,
                91,
                98,
                32,
                62,
                62,
                32,
                50,
                93,
                44,
                32,
                103,
                32,
                61,
                32,
                66,
                91,
                98,
                32,
                43,
                32,
                52,
                32,
                62,
                62,
                32,
                50,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                43,
                61,
                32,
                56,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                48,
                59,
                32,
                108,
                32,
                60,
                32,
                103,
                59,
                32,
                108,
                43,
                43,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                109,
                32,
                61,
                32,
                97,
                44,
                32,
                110,
                32,
                61,
                32,
                120,
                91,
                104,
                32,
                43,
                32,
                108,
                93,
                44,
                32,
                112,
                32,
                61,
                32,
                97,
                99,
                91,
                109,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                110,
                32,
                124,
                124,
                32,
                49,
                48,
                32,
                61,
                61,
                61,
                32,
                110,
                32,
                63,
                32,
                40,
                40,
                49,
                32,
                61,
                61,
                61,
                32,
                109,
                32,
                63,
                32,
                106,
                97,
                32,
                58,
                32,
                114,
                41,
                40,
                71,
                40,
                112,
                41,
                41,
                44,
                32,
                112,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                61,
                32,
                48,
                41,
                32,
                58,
                32,
                112,
                46,
                112,
                117,
                115,
                104,
                40,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                43,
                61,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                91,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                36,
                58,
                32,
                104,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                97,
                58,
                32,
                105,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                74,
                58,
                32,
                106,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                106,
                58,
                32,
                107,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                58,
                32,
                108,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                58,
                32,
                109,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                58,
                32,
                110,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                122,
                58,
                32,
                111,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                58,
                32,
                112,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                58,
                32,
                113,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                58,
                32,
                114,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                58,
                32,
                115,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                58,
                32,
                116,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                111,
                58,
                32,
                117,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                113,
                58,
                32,
                118,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                71,
                58,
                32,
                119,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                58,
                32,
                87,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                99,
                40,
                120,
                46,
                115,
                117,
                98,
                97,
                114,
                114,
                97,
                121,
                40,
                97,
                44,
                32,
                97,
                32,
                43,
                32,
                98,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                87,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                97,
                115,
                121,
                110,
                99,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                97,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                32,
                61,
                32,
                100,
                46,
                101,
                120,
                112,
                111,
                114,
                116,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                32,
                61,
                32,
                87,
                46,
                109,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                113,
                97,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                32,
                61,
                32,
                87,
                46,
                114,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                97,
                46,
                117,
                110,
                115,
                104,
                105,
                102,
                116,
                40,
                87,
                46,
                110,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                45,
                45,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                109,
                111,
                110,
                105,
                116,
                111,
                114,
                82,
                117,
                110,
                68,
                101,
                112,
                101,
                110,
                100,
                101,
                110,
                99,
                105,
                101,
                115,
                63,
                46,
                40,
                67,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                61,
                61,
                32,
                67,
                32,
                38,
                38,
                32,
                68,
                32,
                38,
                38,
                32,
                40,
                100,
                32,
                61,
                32,
                68,
                44,
                32,
                68,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                44,
                32,
                100,
                40,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                87,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                43,
                43,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                109,
                111,
                110,
                105,
                116,
                111,
                114,
                82,
                117,
                110,
                68,
                101,
                112,
                101,
                110,
                100,
                101,
                110,
                99,
                105,
                101,
                115,
                63,
                46,
                40,
                67,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                123,
                32,
                97,
                58,
                32,
                120,
                99,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                107,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                87,
                97,
                115,
                109,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                107,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                87,
                97,
                115,
                109,
                40,
                98,
                44,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                40,
                96,
                77,
                111,
                100,
                117,
                108,
                101,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                87,
                97,
                115,
                109,
                32,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                32,
                119,
                105,
                116,
                104,
                32,
                101,
                114,
                114,
                111,
                114,
                58,
                32,
                36,
                123,
                100,
                125,
                96,
                41,
                44,
                32,
                98,
                97,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                120,
                97,
                32,
                63,
                63,
                32,
                40,
                120,
                97,
                32,
                61,
                32,
                119,
                97,
                40,
                34,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                34,
                41,
                32,
                63,
                32,
                34,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                34,
                32,
                58,
                32,
                107,
                46,
                108,
                111,
                99,
                97,
                116,
                101,
                70,
                105,
                108,
                101,
                32,
                63,
                32,
                107,
                46,
                108,
                111,
                99,
                97,
                116,
                101,
                70,
                105,
                108,
                101,
                40,
                34,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                34,
                44,
                32,
                113,
                41,
                32,
                58,
                32,
                113,
                32,
                43,
                32,
                34,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                65,
                97,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                40,
                99,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                99,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                40,
                102,
                99,
                32,
                61,
                32,
                87,
                46,
                111,
                97,
                41,
                40,
                97,
                41,
                44,
                32,
                113,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                40,
                113,
                98,
                32,
                61,
                32,
                87,
                46,
                112,
                97,
                41,
                40,
                97,
                41,
                44,
                32,
                85,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                40,
                85,
                32,
                61,
                32,
                87,
                46,
                113,
                97,
                41,
                40,
                97,
                41,
                44,
                32,
                103,
                99,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                40,
                103,
                99,
                32,
                61,
                32,
                87,
                46,
                115,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                41,
                44,
                32,
                88,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                40,
                88,
                32,
                61,
                32,
                87,
                46,
                116,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                41,
                44,
                32,
                74,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                40,
                74,
                32,
                61,
                32,
                87,
                46,
                117,
                97,
                41,
                40,
                97,
                41,
                44,
                32,
                89,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                40,
                89,
                32,
                61,
                32,
                87,
                46,
                118,
                97,
                41,
                40,
                97,
                41,
                44,
                32,
                90,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                40,
                90,
                32,
                61,
                32,
                87,
                46,
                119,
                97,
                41,
                40,
                41,
                44,
                32,
                71,
                97,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                40,
                71,
                97,
                32,
                61,
                32,
                87,
                46,
                120,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                106,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                106,
                106,
                32,
                61,
                32,
                87,
                46,
                121,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                105,
                106,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                105,
                106,
                106,
                32,
                61,
                32,
                87,
                46,
                122,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                106,
                105,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                106,
                105,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                65,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                121,
                99,
                32,
                61,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                105,
                106,
                106,
                106,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                41,
                32,
                61,
                62,
                32,
                40,
                121,
                99,
                32,
                61,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                105,
                106,
                106,
                106,
                106,
                32,
                61,
                32,
                87,
                46,
                66,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                106,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                106,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                67,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                68,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                102,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                102,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                69,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                70,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                32,
                61,
                32,
                87,
                46,
                71,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                105,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                105,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                72,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                102,
                102,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                102,
                102,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                73,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                74,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                105,
                105,
                106,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                105,
                105,
                106,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                75,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                106,
                32,
                61,
                32,
                87,
                46,
                76,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                106,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                106,
                106,
                32,
                61,
                32,
                87,
                46,
                77,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                105,
                106,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                105,
                106,
                106,
                32,
                61,
                32,
                87,
                46,
                78,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                114,
                99,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                100,
                32,
                33,
                61,
                61,
                32,
                100,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                110,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                104,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                104,
                32,
                33,
                61,
                61,
                32,
                104,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                115,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                32,
                33,
                61,
                61,
                32,
                101,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                116,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                32,
                33,
                61,
                61,
                32,
                102,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                107,
                99,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                100,
                32,
                33,
                61,
                61,
                32,
                100,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                118,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                103,
                32,
                33,
                61,
                61,
                32,
                103,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                113,
                99,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                32,
                33,
                61,
                61,
                32,
                99,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                117,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                104,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                104,
                32,
                33,
                61,
                61,
                32,
                104,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                112,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                109,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                109,
                32,
                33,
                61,
                61,
                32,
                109,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                109,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                109,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                32,
                33,
                61,
                61,
                32,
                102,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                108,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                32,
                33,
                61,
                61,
                32,
                101,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                111,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                103,
                32,
                33,
                61,
                61,
                32,
                103,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                32,
                33,
                61,
                61,
                32,
                102,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                104,
                99,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                100,
                32,
                33,
                61,
                61,
                32,
                100,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                106,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                32,
                33,
                61,
                61,
                32,
                101,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                119,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                110,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                121,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                112,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                112,
                32,
                33,
                61,
                61,
                32,
                112,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                112,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                122,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                32,
                61,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                65,
                99,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                122,
                99,
                32,
                124,
                124,
                32,
                66,
                99,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                122,
                99,
                32,
                124,
                124,
                32,
                40,
                68,
                32,
                61,
                32,
                65,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                66,
                99,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                97,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                122,
                99,
                32,
                38,
                38,
                32,
                40,
                122,
                99,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                107,
                46,
                99,
                97,
                108,
                108,
                101,
                100,
                82,
                117,
                110,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                33,
                109,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                40,
                115,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                97,
                40,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                111,
                110,
                82,
                117,
                110,
                116,
                105,
                109,
                101,
                73,
                110,
                105,
                116,
                105,
                97,
                108,
                105,
                122,
                101,
                100,
                63,
                46,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                107,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                107,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                32,
                38,
                38,
                32,
                40,
                107,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                32,
                61,
                32,
                91,
                107,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                93,
                41,
                59,
                32,
                107,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                107,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                46,
                115,
                104,
                105,
                102,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                97,
                46,
                117,
                110,
                115,
                104,
                105,
                102,
                116,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                40,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                40,
                48,
                32,
                60,
                32,
                67,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                107,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                41,
                32,
                102,
                111,
                114,
                32,
                40,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                107,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                32,
                38,
                38,
                32,
                40,
                107,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                32,
                61,
                32,
                91,
                107,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                93,
                41,
                59,
                32,
                107,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                41,
                32,
                117,
                97,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                40,
                114,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                60,
                32,
                67,
                32,
                124,
                124,
                32,
                40,
                107,
                46,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                117,
                115,
                32,
                63,
                32,
                40,
                107,
                46,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                117,
                115,
                40,
                34,
                82,
                117,
                110,
                110,
                105,
                110,
                103,
                46,
                46,
                46,
                34,
                41,
                44,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                107,
                46,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                117,
                115,
                40,
                34,
                34,
                41,
                44,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                49,
                41,
                41,
                32,
                58,
                32,
                97,
                40,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                107,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                107,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                32,
                38,
                38,
                32,
                40,
                107,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                32,
                61,
                32,
                91,
                107,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                93,
                41,
                59,
                32,
                48,
                32,
                60,
                32,
                107,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                41,
                32,
                107,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                46,
                112,
                111,
                112,
                40,
                41,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                99,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                82,
                116,
                110,
                32,
                61,
                32,
                99,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                82,
                116,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                125,
                41,
                40,
                41,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                95,
                112,
                108,
                97,
                121,
                101,
                114,
                95,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                32,
                61,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                77,
                111,
                100,
                117,
                108,
                101,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                99,
                111,
                114,
                101,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                45,
                119,
                97,
                115,
                109,
                45,
                108,
                111,
                97,
                100,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                87,
                97,
                115,
                109,
                76,
                111,
                97,
                100,
                101,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                34,
                82,
                101,
                110,
                100,
                101,
                114,
                101,
                114,
                76,
                111,
                97,
                100,
                101,
                114,
                32,
                105,
                115,
                32,
                97,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                97,
                110,
                100,
                32,
                99,
                97,
                110,
                110,
                111,
                116,
                32,
                98,
                101,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                100,
                46,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                95,
                116,
                114,
                121,
                76,
                111,
                97,
                100,
                40,
                117,
                114,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                95,
                112,
                108,
                97,
                121,
                101,
                114,
                95,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                40,
                123,
                32,
                108,
                111,
                99,
                97,
                116,
                101,
                70,
                105,
                108,
                101,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                117,
                114,
                108,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                84,
                114,
                105,
                101,
                115,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                116,
                104,
                101,
                32,
                87,
                65,
                83,
                77,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                32,
                102,
                114,
                111,
                109,
                32,
                116,
                104,
                101,
                32,
                112,
                114,
                105,
                109,
                97,
                114,
                121,
                32,
                85,
                82,
                76,
                44,
                32,
                102,
                97,
                108,
                108,
                105,
                110,
                103,
                32,
                98,
                97,
                99,
                107,
                32,
                116,
                111,
                32,
                97,
                32,
                98,
                97,
                99,
                107,
                117,
                112,
                32,
                85,
                82,
                76,
                32,
                105,
                102,
                32,
                110,
                101,
                99,
                101,
                115,
                115,
                97,
                114,
                121,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                84,
                104,
                114,
                111,
                119,
                115,
                32,
                97,
                110,
                32,
                101,
                114,
                114,
                111,
                114,
                32,
                105,
                102,
                32,
                98,
                111,
                116,
                104,
                32,
                85,
                82,
                76,
                115,
                32,
                102,
                97,
                105,
                108,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                116,
                104,
                101,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                60,
                77,
                111,
                100,
                117,
                108,
                101,
                62,
                32,
                45,
                32,
                65,
                32,
                112,
                114,
                111,
                109,
                105,
                115,
                101,
                32,
                116,
                104,
                97,
                116,
                32,
                114,
                101,
                115,
                111,
                108,
                118,
                101,
                115,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                95,
                108,
                111,
                97,
                100,
                87,
                105,
                116,
                104,
                66,
                97,
                99,
                107,
                117,
                112,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                77,
                111,
                100,
                117,
                108,
                101,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                77,
                111,
                100,
                117,
                108,
                101,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                116,
                114,
                121,
                76,
                111,
                97,
                100,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                119,
                97,
                115,
                109,
                85,
                82,
                76,
                41,
                46,
                99,
                97,
                116,
                99,
                104,
                40,
                97,
                115,
                121,
                110,
                99,
                32,
                40,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                69,
                114,
                114,
                111,
                114,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                97,
                99,
                107,
                117,
                112,
                85,
                114,
                108,
                32,
                61,
                32,
                96,
                104,
                116,
                116,
                112,
                115,
                58,
                47,
                47,
                117,
                110,
                112,
                107,
                103,
                46,
                99,
                111,
                109,
                47,
                36,
                123,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                78,
                65,
                77,
                69,
                125,
                64,
                36,
                123,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                86,
                69,
                82,
                83,
                73,
                79,
                78,
                125,
                47,
                100,
                105,
                115,
                116,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                45,
                112,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                119,
                97,
                114,
                110,
                40,
                96,
                80,
                114,
                105,
                109,
                97,
                114,
                121,
                32,
                87,
                65,
                83,
                77,
                32,
                108,
                111,
                97,
                100,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                32,
                102,
                114,
                111,
                109,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                95,
                119,
                97,
                115,
                109,
                85,
                82,
                76,
                125,
                46,
                32,
                69,
                114,
                114,
                111,
                114,
                58,
                32,
                36,
                123,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                69,
                114,
                114,
                111,
                114,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                119,
                97,
                114,
                110,
                40,
                96,
                65,
                116,
                116,
                101,
                109,
                112,
                116,
                105,
                110,
                103,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                87,
                65,
                83,
                77,
                32,
                102,
                114,
                111,
                109,
                32,
                98,
                97,
                99,
                107,
                117,
                112,
                32,
                85,
                82,
                76,
                58,
                32,
                36,
                123,
                98,
                97,
                99,
                107,
                117,
                112,
                85,
                114,
                108,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                116,
                114,
                121,
                76,
                111,
                97,
                100,
                40,
                98,
                97,
                99,
                107,
                117,
                112,
                85,
                114,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                98,
                97,
                99,
                107,
                117,
                112,
                69,
                114,
                114,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                101,
                114,
                114,
                111,
                114,
                40,
                96,
                80,
                114,
                105,
                109,
                97,
                114,
                121,
                32,
                87,
                65,
                83,
                77,
                32,
                85,
                82,
                76,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                58,
                32,
                36,
                123,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                69,
                114,
                114,
                111,
                114,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                101,
                114,
                114,
                111,
                114,
                40,
                96,
                66,
                97,
                99,
                107,
                117,
                112,
                32,
                87,
                65,
                83,
                77,
                32,
                85,
                82,
                76,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                58,
                32,
                36,
                123,
                98,
                97,
                99,
                107,
                117,
                112,
                69,
                114,
                114,
                111,
                114,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                34,
                87,
                65,
                83,
                77,
                32,
                108,
                111,
                97,
                100,
                105,
                110,
                103,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                32,
                102,
                114,
                111,
                109,
                32,
                97,
                108,
                108,
                32,
                115,
                111,
                117,
                114,
                99,
                101,
                115,
                46,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                77,
                111,
                100,
                117,
                108,
                101,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                80,
                117,
                98,
                108,
                105,
                99,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                116,
                104,
                101,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                85,
                116,
                105,
                108,
                105,
                122,
                101,
                115,
                32,
                97,
                32,
                112,
                114,
                105,
                109,
                97,
                114,
                121,
                32,
                97,
                110,
                100,
                32,
                98,
                97,
                99,
                107,
                117,
                112,
                32,
                85,
                82,
                76,
                32,
                102,
                111,
                114,
                32,
                114,
                111,
                98,
                117,
                115,
                116,
                110,
                101,
                115,
                115,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                60,
                77,
                111,
                100,
                117,
                108,
                101,
                62,
                32,
                45,
                32,
                65,
                32,
                112,
                114,
                111,
                109,
                105,
                115,
                101,
                32,
                116,
                104,
                97,
                116,
                32,
                114,
                101,
                115,
                111,
                108,
                118,
                101,
                115,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                108,
                111,
                97,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                87,
                105,
                116,
                104,
                66,
                97,
                99,
                107,
                117,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                83,
                101,
                116,
                115,
                32,
                97,
                32,
                110,
                101,
                119,
                32,
                85,
                82,
                76,
                32,
                102,
                111,
                114,
                32,
                116,
                104,
                101,
                32,
                87,
                65,
                83,
                77,
                32,
                102,
                105,
                108,
                101,
                32,
                97,
                110,
                100,
                32,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                97,
                116,
                101,
                115,
                32,
                116,
                104,
                101,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                32,
                112,
                114,
                111,
                109,
                105,
                115,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                45,
                32,
                32,
                84,
                104,
                101,
                32,
                110,
                101,
                119,
                32,
                85,
                82,
                76,
                32,
                102,
                111,
                114,
                32,
                116,
                104,
                101,
                32,
                87,
                65,
                83,
                77,
                32,
                102,
                105,
                108,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                115,
                101,
                116,
                87,
                97,
                115,
                109,
                85,
                114,
                108,
                40,
                117,
                114,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                117,
                114,
                108,
                32,
                61,
                61,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                119,
                97,
                115,
                109,
                85,
                82,
                76,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                119,
                97,
                115,
                109,
                85,
                82,
                76,
                32,
                61,
                32,
                117,
                114,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                77,
                111,
                100,
                117,
                108,
                101,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                47,
                47,
                32,
                101,
                115,
                108,
                105,
                110,
                116,
                45,
                100,
                105,
                115,
                97,
                98,
                108,
                101,
                45,
                110,
                101,
                120,
                116,
                45,
                108,
                105,
                110,
                101,
                32,
                64,
                116,
                121,
                112,
                101,
                115,
                99,
                114,
                105,
                112,
                116,
                45,
                101,
                115,
                108,
                105,
                110,
                116,
                47,
                110,
                97,
                109,
                105,
                110,
                103,
                45,
                99,
                111,
                110,
                118,
                101,
                110,
                116,
                105,
                111,
                110,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                87,
                97,
                115,
                109,
                76,
                111,
                97,
                100,
                101,
                114,
                44,
                32,
                34,
                95,
                77,
                111,
                100,
                117,
                108,
                101,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                47,
                47,
                32,
                85,
                82,
                76,
                32,
                102,
                111,
                114,
                32,
                116,
                104,
                101,
                32,
                87,
                65,
                83,
                77,
                32,
                102,
                105,
                108,
                101,
                44,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                101,
                100,
                32,
                117,
                115,
                105,
                110,
                103,
                32,
                112,
                97,
                99,
                107,
                97,
                103,
                101,
                32,
                105,
                110,
                102,
                111,
                114,
                109,
                97,
                116,
                105,
                111,
                110,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                87,
                97,
                115,
                109,
                76,
                111,
                97,
                100,
                101,
                114,
                44,
                32,
                34,
                95,
                119,
                97,
                115,
                109,
                85,
                82,
                76,
                34,
                44,
                32,
                96,
                104,
                116,
                116,
                112,
                115,
                58,
                47,
                47,
                99,
                100,
                110,
                46,
                106,
                115,
                100,
                101,
                108,
                105,
                118,
                114,
                46,
                110,
                101,
                116,
                47,
                110,
                112,
                109,
                47,
                36,
                123,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                78,
                65,
                77,
                69,
                125,
                64,
                36,
                123,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                86,
                69,
                82,
                83,
                73,
                79,
                78,
                125,
                47,
                100,
                105,
                115,
                116,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                45,
                112,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                96,
                41,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                101,
                118,
                101,
                110,
                116,
                45,
                109,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                69,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                34,
                44,
                32,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                112,
                40,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                101,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                103,
                101,
                116,
                40,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                83,
                101,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                115,
                101,
                116,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                97,
                100,
                100,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                103,
                101,
                116,
                40,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                115,
                105,
                122,
                101,
                32,
                61,
                61,
                61,
                32,
                48,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                103,
                101,
                116,
                40,
                101,
                118,
                101,
                110,
                116,
                46,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                63,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                61,
                62,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                109,
                111,
                118,
                101,
                65,
                108,
                108,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                99,
                108,
                101,
                97,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                111,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                45,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                95,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                116,
                101,
                114,
                115,
                101,
                99,
                116,
                105,
                111,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                32,
                61,
                32,
                40,
                101,
                110,
                116,
                114,
                105,
                101,
                115,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                110,
                116,
                114,
                105,
                101,
                115,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                101,
                110,
                116,
                114,
                121,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                103,
                101,
                116,
                40,
                101,
                110,
                116,
                114,
                121,
                46,
                116,
                97,
                114,
                103,
                101,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                110,
                116,
                114,
                121,
                46,
                105,
                115,
                73,
                110,
                116,
                101,
                114,
                115,
                101,
                99,
                116,
                105,
                110,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                73,
                110,
                116,
                101,
                114,
                115,
                101,
                99,
                116,
                105,
                111,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                105,
                110,
                116,
                101,
                114,
                115,
                101,
                99,
                116,
                105,
                111,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                101,
                115,
                104,
                111,
                108,
                100,
                58,
                32,
                48,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                104,
                97,
                115,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                115,
                101,
                116,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                63,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                63,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                115,
                105,
                122,
                101,
                32,
                61,
                61,
                61,
                32,
                48,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                63,
                46,
                100,
                105,
                115,
                99,
                111,
                110,
                110,
                101,
                99,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                44,
                32,
                34,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                44,
                32,
                34,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                34,
                44,
                32,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                112,
                40,
                41,
                41,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                114,
                101,
                115,
                105,
                122,
                101,
                45,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                82,
                69,
                83,
                73,
                90,
                69,
                95,
                68,
                69,
                66,
                79,
                85,
                78,
                67,
                69,
                95,
                84,
                73,
                77,
                69,
                32,
                61,
                32,
                49,
                48,
                48,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                95,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                105,
                122,
                101,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                32,
                61,
                32,
                40,
                101,
                110,
                116,
                114,
                105,
                101,
                115,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                110,
                116,
                114,
                105,
                101,
                115,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                101,
                110,
                116,
                114,
                121,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                103,
                101,
                116,
                40,
                101,
                110,
                116,
                114,
                121,
                46,
                116,
                97,
                114,
                103,
                101,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                91,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                44,
                32,
                116,
                105,
                109,
                101,
                111,
                117,
                116,
                93,
                32,
                61,
                32,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                108,
                101,
                97,
                114,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                116,
                105,
                109,
                101,
                111,
                117,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                110,
                101,
                119,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                32,
                61,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                82,
                69,
                83,
                73,
                90,
                69,
                95,
                68,
                69,
                66,
                79,
                85,
                78,
                67,
                69,
                95,
                84,
                73,
                77,
                69,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                115,
                101,
                116,
                40,
                101,
                110,
                116,
                114,
                121,
                46,
                116,
                97,
                114,
                103,
                101,
                116,
                44,
                32,
                91,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                44,
                32,
                110,
                101,
                119,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                114,
                101,
                115,
                105,
                122,
                101,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                104,
                97,
                115,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                115,
                101,
                116,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                91,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                44,
                32,
                48,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                63,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                103,
                101,
                116,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                116,
                105,
                109,
                101,
                111,
                117,
                116,
                73,
                100,
                32,
                61,
                32,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                91,
                49,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                105,
                109,
                101,
                111,
                117,
                116,
                73,
                100,
                41,
                32,
                99,
                108,
                101,
                97,
                114,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                116,
                105,
                109,
                101,
                111,
                117,
                116,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                63,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                115,
                105,
                122,
                101,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                100,
                105,
                115,
                99,
                111,
                110,
                110,
                101,
                99,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                44,
                32,
                34,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                44,
                32,
                34,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                34,
                44,
                32,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                112,
                40,
                41,
                41,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                117,
                116,
                105,
                108,
                115,
                46,
                116,
                115,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                72,
                101,
                120,
                67,
                111,
                108,
                111,
                114,
                40,
                99,
                111,
                108,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                47,
                94,
                35,
                40,
                91,
                92,
                100,
                97,
                45,
                102,
                93,
                123,
                54,
                125,
                124,
                91,
                92,
                100,
                97,
                45,
                102,
                93,
                123,
                56,
                125,
                41,
                36,
                47,
                105,
                117,
                46,
                116,
                101,
                115,
                116,
                40,
                99,
                111,
                108,
                111,
                114,
                41,
                59,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                104,
                101,
                120,
                83,
                116,
                114,
                105,
                110,
                103,
                84,
                111,
                82,
                71,
                66,
                65,
                73,
                110,
                116,
                40,
                99,
                111,
                108,
                111,
                114,
                72,
                101,
                120,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                115,
                72,
                101,
                120,
                67,
                111,
                108,
                111,
                114,
                40,
                99,
                111,
                108,
                111,
                114,
                72,
                101,
                120,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                108,
                101,
                116,
                32,
                104,
                101,
                120,
                32,
                61,
                32,
                99,
                111,
                108,
                111,
                114,
                72,
                101,
                120,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                34,
                35,
                34,
                44,
                32,
                34,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                104,
                101,
                120,
                32,
                61,
                32,
                104,
                101,
                120,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                61,
                61,
                61,
                32,
                54,
                32,
                63,
                32,
                96,
                36,
                123,
                104,
                101,
                120,
                125,
                102,
                102,
                96,
                32,
                58,
                32,
                104,
                101,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                112,
                97,
                114,
                115,
                101,
                73,
                110,
                116,
                40,
                104,
                101,
                120,
                44,
                32,
                49,
                54,
                41,
                59,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                46,
                98,
                121,
                116,
                101,
                76,
                101,
                110,
                103,
                116,
                104,
                32,
                60,
                32,
                52,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                102,
                105,
                108,
                101,
                83,
                105,
                103,
                110,
                97,
                116,
                117,
                114,
                101,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                46,
                115,
                108,
                105,
                99,
                101,
                40,
                48,
                44,
                32,
                90,
                73,
                80,
                95,
                83,
                73,
                71,
                78,
                65,
                84,
                85,
                82,
                69,
                46,
                98,
                121,
                116,
                101,
                76,
                101,
                110,
                103,
                116,
                104,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                108,
                101,
                116,
                32,
                105,
                32,
                61,
                32,
                48,
                59,
                32,
                105,
                32,
                60,
                32,
                90,
                73,
                80,
                95,
                83,
                73,
                71,
                78,
                65,
                84,
                85,
                82,
                69,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                105,
                32,
                43,
                61,
                32,
                49,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                90,
                73,
                80,
                95,
                83,
                73,
                71,
                78,
                65,
                84,
                85,
                82,
                69,
                91,
                105,
                93,
                32,
                33,
                61,
                61,
                32,
                102,
                105,
                108,
                101,
                83,
                105,
                103,
                110,
                97,
                116,
                117,
                114,
                101,
                91,
                105,
                93,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                74,
                83,
                79,
                78,
                40,
                106,
                115,
                111,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                76,
                79,
                84,
                84,
                73,
                69,
                95,
                74,
                83,
                79,
                78,
                95,
                77,
                65,
                78,
                68,
                65,
                84,
                79,
                82,
                89,
                95,
                70,
                73,
                69,
                76,
                68,
                83,
                46,
                101,
                118,
                101,
                114,
                121,
                40,
                40,
                102,
                105,
                101,
                108,
                100,
                41,
                32,
                61,
                62,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                46,
                99,
                97,
                108,
                108,
                40,
                106,
                115,
                111,
                110,
                44,
                32,
                102,
                105,
                101,
                108,
                100,
                41,
                41,
                59,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                61,
                61,
                32,
                34,
                115,
                116,
                114,
                105,
                110,
                103,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                74,
                83,
                79,
                78,
                40,
                74,
                83,
                79,
                78,
                46,
                112,
                97,
                114,
                115,
                101,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                95,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                74,
                83,
                79,
                78,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                103,
                101,
                116,
                68,
                101,
                102,
                97,
                117,
                108,
                116,
                68,
                80,
                82,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                100,
                112,
                114,
                32,
                61,
                32,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                63,
                32,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                58,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                49,
                32,
                43,
                32,
                40,
                100,
                112,
                114,
                32,
                45,
                32,
                49,
                41,
                32,
                42,
                32,
                68,
                69,
                70,
                65,
                85,
                76,
                84,
                95,
                68,
                80,
                82,
                95,
                70,
                65,
                67,
                84,
                79,
                82,
                59,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                73,
                110,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                99,
                116,
                32,
                61,
                32,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                46,
                103,
                101,
                116,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                67,
                108,
                105,
                101,
                110,
                116,
                82,
                101,
                99,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                114,
                101,
                99,
                116,
                46,
                116,
                111,
                112,
                32,
                62,
                61,
                32,
                48,
                32,
                38,
                38,
                32,
                114,
                101,
                99,
                116,
                46,
                108,
                101,
                102,
                116,
                32,
                62,
                61,
                32,
                48,
                32,
                38,
                38,
                32,
                114,
                101,
                99,
                116,
                46,
                98,
                111,
                116,
                116,
                111,
                109,
                32,
                60,
                61,
                32,
                40,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                105,
                110,
                110,
                101,
                114,
                72,
                101,
                105,
                103,
                104,
                116,
                32,
                124,
                124,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                46,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                46,
                99,
                108,
                105,
                101,
                110,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                41,
                32,
                38,
                38,
                32,
                114,
                101,
                99,
                116,
                46,
                114,
                105,
                103,
                104,
                116,
                32,
                60,
                61,
                32,
                40,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                105,
                110,
                110,
                101,
                114,
                87,
                105,
                100,
                116,
                104,
                32,
                124,
                124,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                46,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                46,
                99,
                108,
                105,
                101,
                110,
                116,
                87,
                105,
                100,
                116,
                104,
                41,
                59,
                10,
                32,
                32,
                125,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                77,
                111,
                100,
                101,
                32,
                61,
                32,
                40,
                109,
                111,
                100,
                101,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                34,
                114,
                101,
                118,
                101,
                114,
                115,
                101,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                77,
                111,
                100,
                101,
                46,
                82,
                101,
                118,
                101,
                114,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                34,
                98,
                111,
                117,
                110,
                99,
                101,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                77,
                111,
                100,
                101,
                46,
                66,
                111,
                117,
                110,
                99,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                34,
                114,
                101,
                118,
                101,
                114,
                115,
                101,
                45,
                98,
                111,
                117,
                110,
                99,
                101,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                77,
                111,
                100,
                101,
                46,
                82,
                101,
                118,
                101,
                114,
                115,
                101,
                66,
                111,
                117,
                110,
                99,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                77,
                111,
                100,
                101,
                46,
                70,
                111,
                114,
                119,
                97,
                114,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                70,
                105,
                116,
                32,
                61,
                32,
                40,
                102,
                105,
                116,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                99,
                111,
                110,
                116,
                97,
                105,
                110,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                67,
                111,
                110,
                116,
                97,
                105,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                99,
                111,
                118,
                101,
                114,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                67,
                111,
                118,
                101,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                105,
                108,
                108,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                105,
                116,
                45,
                104,
                101,
                105,
                103,
                104,
                116,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                105,
                116,
                45,
                119,
                105,
                100,
                116,
                104,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                116,
                87,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                78,
                111,
                110,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                32,
                61,
                32,
                40,
                97,
                108,
                105,
                103,
                110,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                86,
                101,
                99,
                116,
                111,
                114,
                70,
                108,
                111,
                97,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                46,
                112,
                117,
                115,
                104,
                95,
                98,
                97,
                99,
                107,
                40,
                97,
                108,
                105,
                103,
                110,
                91,
                48,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                46,
                112,
                117,
                115,
                104,
                95,
                98,
                97,
                99,
                107,
                40,
                97,
                108,
                105,
                103,
                110,
                91,
                49,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                59,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                111,
                114,
                101,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                86,
                101,
                99,
                116,
                111,
                114,
                70,
                108,
                111,
                97,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                33,
                61,
                61,
                32,
                50,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                111,
                114,
                101,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                114,
                101,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                112,
                117,
                115,
                104,
                95,
                98,
                97,
                99,
                107,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                91,
                48,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                114,
                101,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                112,
                117,
                115,
                104,
                95,
                98,
                97,
                99,
                107,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                91,
                49,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                111,
                114,
                101,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                76,
                97,
                121,
                111,
                117,
                116,
                32,
                61,
                32,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                108,
                97,
                121,
                111,
                117,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                68,
                101,
                102,
                97,
                117,
                108,
                116,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                108,
                105,
                103,
                110,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                97,
                108,
                105,
                103,
                110,
                32,
                63,
                63,
                32,
                91,
                48,
                46,
                53,
                44,
                32,
                48,
                46,
                53,
                93,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                105,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                70,
                105,
                116,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                102,
                105,
                116,
                32,
                63,
                63,
                32,
                34,
                99,
                111,
                110,
                116,
                97,
                105,
                110,
                34,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                34,
                44,
                32,
                123,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                34,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                77,
                101,
                116,
                104,
                111,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                77,
                101,
                116,
                104,
                111,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                77,
                101,
                116,
                104,
                111,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                77,
                101,
                116,
                104,
                111,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                77,
                101,
                116,
                104,
                111,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                99,
                97,
                110,
                118,
                97,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                69,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                63,
                46,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                124,
                124,
                32,
                103,
                101,
                116,
                68,
                101,
                102,
                97,
                117,
                108,
                116,
                68,
                80,
                82,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                47,
                47,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                32,
                105,
                115,
                32,
                116,
                114,
                117,
                101,
                32,
                98,
                121,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                32,
                116,
                111,
                32,
                112,
                114,
                101,
                118,
                101,
                110,
                116,
                32,
                117,
                110,
                110,
                101,
                99,
                101,
                115,
                115,
                97,
                114,
                121,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                105,
                110,
                103,
                32,
                119,
                104,
                101,
                110,
                32,
                116,
                104,
                101,
                32,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                115,
                32,
                111,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                63,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                32,
                63,
                63,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                87,
                97,
                115,
                109,
                76,
                111,
                97,
                100,
                101,
                114,
                46,
                108,
                111,
                97,
                100,
                40,
                41,
                46,
                116,
                104,
                101,
                110,
                40,
                40,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                32,
                63,
                63,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                32,
                63,
                63,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                58,
                32,
                48,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                108,
                111,
                111,
                112,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                111,
                100,
                101,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                77,
                111,
                100,
                101,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                109,
                111,
                100,
                101,
                32,
                63,
                63,
                32,
                34,
                102,
                111,
                114,
                119,
                97,
                114,
                100,
                34,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                63,
                63,
                32,
                91,
                93,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                112,
                101,
                101,
                100,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                112,
                101,
                101,
                100,
                32,
                63,
                63,
                32,
                49,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                32,
                63,
                63,
                32,
                116,
                114,
                117,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                32,
                63,
                63,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                114,
                101,
                97,
                100,
                121,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                68,
                97,
                116,
                97,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                114,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                83,
                114,
                99,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                114,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                115,
                101,
                116,
                66,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                46,
                99,
                97,
                116,
                99,
                104,
                40,
                40,
                101,
                114,
                114,
                111,
                114,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                114,
                114,
                111,
                114,
                58,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                70,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                119,
                97,
                115,
                109,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                58,
                32,
                36,
                123,
                101,
                114,
                114,
                111,
                114,
                125,
                96,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                77,
                101,
                116,
                104,
                111,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                77,
                101,
                116,
                104,
                111,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                77,
                101,
                116,
                104,
                111,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                77,
                101,
                116,
                104,
                111,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                77,
                101,
                116,
                104,
                111,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                76,
                101,
                97,
                118,
                101,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                101,
                114,
                114,
                111,
                114,
                40,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                32,
                101,
                114,
                114,
                111,
                114,
                58,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                41,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                95,
                102,
                101,
                116,
                99,
                104,
                68,
                97,
                116,
                97,
                40,
                115,
                114,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                102,
                101,
                116,
                99,
                104,
                40,
                115,
                114,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                46,
                111,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                70,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                102,
                101,
                116,
                99,
                104,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                100,
                97,
                116,
                97,
                32,
                102,
                114,
                111,
                109,
                32,
                85,
                82,
                76,
                58,
                32,
                36,
                123,
                115,
                114,
                99,
                125,
                46,
                32,
                36,
                123,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                46,
                115,
                116,
                97,
                116,
                117,
                115,
                125,
                58,
                32,
                36,
                123,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                46,
                115,
                116,
                97,
                116,
                117,
                115,
                84,
                101,
                120,
                116,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                100,
                97,
                116,
                97,
                32,
                61,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                46,
                97,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                105,
                115,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                100,
                97,
                116,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                100,
                97,
                116,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                101,
                119,
                32,
                84,
                101,
                120,
                116,
                68,
                101,
                99,
                111,
                100,
                101,
                114,
                40,
                41,
                46,
                100,
                101,
                99,
                111,
                100,
                101,
                40,
                100,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                68,
                97,
                116,
                97,
                40,
                100,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                101,
                116,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                97,
                116,
                97,
                32,
                61,
                61,
                61,
                32,
                34,
                115,
                116,
                114,
                105,
                110,
                103,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                100,
                97,
                116,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                73,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                58,
                32,
                84,
                104,
                101,
                32,
                112,
                114,
                111,
                118,
                105,
                100,
                101,
                100,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                102,
                111,
                114,
                109,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                32,
                102,
                111,
                114,
                109,
                97,
                116,
                46,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                68,
                97,
                116,
                97,
                40,
                100,
                97,
                116,
                97,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                100,
                97,
                116,
                97,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                115,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                100,
                97,
                116,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                73,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                58,
                32,
                84,
                104,
                101,
                32,
                112,
                114,
                111,
                118,
                105,
                100,
                101,
                100,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                102,
                111,
                114,
                109,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                102,
                111,
                114,
                109,
                97,
                116,
                46,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                108,
                111,
                97,
                100,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                68,
                97,
                116,
                97,
                40,
                100,
                97,
                116,
                97,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                97,
                116,
                97,
                32,
                61,
                61,
                61,
                32,
                34,
                111,
                98,
                106,
                101,
                99,
                116,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                100,
                97,
                116,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                73,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                58,
                32,
                84,
                104,
                101,
                32,
                112,
                114,
                111,
                118,
                105,
                100,
                101,
                100,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                102,
                111,
                114,
                109,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                32,
                102,
                111,
                114,
                109,
                97,
                116,
                46,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                68,
                97,
                116,
                97,
                40,
                74,
                83,
                79,
                78,
                46,
                115,
                116,
                114,
                105,
                110,
                103,
                105,
                102,
                121,
                40,
                100,
                97,
                116,
                97,
                41,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                85,
                110,
                115,
                117,
                112,
                112,
                111,
                114,
                116,
                101,
                100,
                32,
                100,
                97,
                116,
                97,
                32,
                116,
                121,
                112,
                101,
                32,
                102,
                111,
                114,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                100,
                97,
                116,
                97,
                46,
                32,
                69,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                58,
                32,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                40,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                40,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                32,
                40,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                41,
                46,
                32,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                101,
                99,
                101,
                105,
                118,
                101,
                100,
                58,
                32,
                36,
                123,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                97,
                116,
                97,
                125,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                111,
                97,
                100,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                97,
                100,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                102,
                114,
                97,
                109,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                112,
                108,
                97,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                112,
                108,
                97,
                121,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                114,
                97,
                119,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                101,
                114,
                114,
                111,
                114,
                40,
                34,
                115,
                111,
                109,
                101,
                116,
                104,
                105,
                110,
                103,
                32,
                119,
                101,
                110,
                116,
                32,
                119,
                114,
                111,
                110,
                103,
                44,
                32,
                116,
                104,
                101,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                119,
                97,
                115,
                32,
                115,
                117,
                112,
                112,
                111,
                115,
                101,
                32,
                116,
                111,
                32,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                97,
                117,
                116,
                111,
                82,
                101,
                115,
                105,
                122,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                34,
                70,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                100,
                97,
                116,
                97,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                83,
                114,
                99,
                40,
                115,
                114,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                101,
                116,
                99,
                104,
                68,
                97,
                116,
                97,
                40,
                115,
                114,
                99,
                41,
                46,
                116,
                104,
                101,
                110,
                40,
                40,
                100,
                97,
                116,
                97,
                41,
                32,
                61,
                62,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                68,
                97,
                116,
                97,
                40,
                100,
                97,
                116,
                97,
                41,
                41,
                46,
                99,
                97,
                116,
                99,
                104,
                40,
                40,
                101,
                114,
                114,
                111,
                114,
                41,
                32,
                61,
                62,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                70,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                100,
                97,
                116,
                97,
                32,
                102,
                114,
                111,
                109,
                32,
                85,
                82,
                76,
                58,
                32,
                36,
                123,
                115,
                114,
                99,
                125,
                46,
                32,
                36,
                123,
                101,
                114,
                114,
                111,
                114,
                125,
                96,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                98,
                117,
                102,
                102,
                101,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                97,
                99,
                116,
                105,
                118,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                97,
                99,
                116,
                105,
                118,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                97,
                99,
                116,
                105,
                118,
                101,
                84,
                104,
                101,
                109,
                101,
                73,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                97,
                99,
                116,
                105,
                118,
                101,
                84,
                104,
                101,
                109,
                101,
                73,
                100,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                108,
                105,
                103,
                110,
                58,
                32,
                91,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                97,
                108,
                105,
                103,
                110,
                46,
                103,
                101,
                116,
                40,
                48,
                41,
                44,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                97,
                108,
                105,
                103,
                110,
                46,
                103,
                101,
                116,
                40,
                49,
                41,
                93,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                105,
                116,
                58,
                32,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                102,
                105,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                70,
                105,
                116,
                46,
                67,
                111,
                110,
                116,
                97,
                105,
                110,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                99,
                111,
                110,
                116,
                97,
                105,
                110,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                70,
                105,
                116,
                46,
                67,
                111,
                118,
                101,
                114,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                99,
                111,
                118,
                101,
                114,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                108,
                108,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                102,
                105,
                108,
                108,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                102,
                105,
                116,
                45,
                104,
                101,
                105,
                103,
                104,
                116,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                116,
                87,
                105,
                100,
                116,
                104,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                102,
                105,
                116,
                45,
                119,
                105,
                100,
                116,
                104,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                70,
                105,
                116,
                46,
                78,
                111,
                110,
                101,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                110,
                111,
                110,
                101,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                99,
                111,
                110,
                116,
                97,
                105,
                110,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                40,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                33,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                74,
                115,
                111,
                110,
                32,
                61,
                32,
                74,
                83,
                79,
                78,
                46,
                112,
                97,
                114,
                115,
                101,
                40,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                107,
                101,
                121,
                115,
                40,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                74,
                115,
                111,
                110,
                41,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                61,
                61,
                61,
                32,
                48,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                74,
                115,
                111,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                95,
                101,
                114,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                38,
                38,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                115,
                105,
                122,
                101,
                40,
                41,
                32,
                61,
                61,
                61,
                32,
                50,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                103,
                101,
                116,
                40,
                48,
                41,
                44,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                103,
                101,
                116,
                40,
                49,
                41,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                108,
                111,
                111,
                112,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                108,
                111,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                109,
                111,
                100,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                111,
                100,
                101,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                109,
                111,
                100,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                77,
                111,
                100,
                101,
                46,
                82,
                101,
                118,
                101,
                114,
                115,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                114,
                101,
                118,
                101,
                114,
                115,
                101,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                77,
                111,
                100,
                101,
                46,
                66,
                111,
                117,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                98,
                111,
                117,
                110,
                99,
                101,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                77,
                111,
                100,
                101,
                46,
                82,
                101,
                118,
                101,
                114,
                115,
                101,
                66,
                111,
                117,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                114,
                101,
                118,
                101,
                114,
                115,
                101,
                45,
                98,
                111,
                117,
                110,
                99,
                101,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                102,
                111,
                114,
                119,
                97,
                114,
                100,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                32,
                63,
                63,
                32,
                34,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                115,
                112,
                101,
                101,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                115,
                112,
                101,
                101,
                100,
                32,
                63,
                63,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                82,
                101,
                97,
                100,
                121,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                33,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                40,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                80,
                97,
                117,
                115,
                101,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                105,
                115,
                80,
                97,
                117,
                115,
                101,
                100,
                40,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                83,
                116,
                111,
                112,
                112,
                101,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                105,
                115,
                83,
                116,
                111,
                112,
                112,
                101,
                100,
                40,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                77,
                97,
                116,
                104,
                46,
                114,
                111,
                117,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                41,
                32,
                42,
                32,
                49,
                48,
                48,
                41,
                32,
                47,
                32,
                49,
                48,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                108,
                111,
                111,
                112,
                67,
                111,
                117,
                110,
                116,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                108,
                111,
                111,
                112,
                67,
                111,
                117,
                110,
                116,
                40,
                41,
                32,
                63,
                63,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                116,
                111,
                116,
                97,
                108,
                70,
                114,
                97,
                109,
                101,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                116,
                111,
                116,
                97,
                108,
                70,
                114,
                97,
                109,
                101,
                115,
                40,
                41,
                32,
                63,
                63,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                63,
                63,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                68,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                68,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                63,
                63,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                99,
                97,
                110,
                118,
                97,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                33,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                32,
                63,
                63,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                32,
                63,
                63,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                58,
                32,
                48,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                108,
                111,
                111,
                112,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                111,
                100,
                101,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                77,
                111,
                100,
                101,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                109,
                111,
                100,
                101,
                32,
                63,
                63,
                32,
                34,
                102,
                111,
                114,
                119,
                97,
                114,
                100,
                34,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                63,
                63,
                32,
                91,
                93,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                112,
                101,
                101,
                100,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                112,
                101,
                101,
                100,
                32,
                63,
                63,
                32,
                49,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                32,
                63,
                63,
                32,
                116,
                114,
                117,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                32,
                63,
                63,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                68,
                97,
                116,
                97,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                114,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                83,
                114,
                99,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                114,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                115,
                101,
                116,
                66,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                32,
                63,
                63,
                32,
                34,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                32,
                38,
                38,
                32,
                34,
                103,
                101,
                116,
                67,
                111,
                110,
                116,
                101,
                120,
                116,
                34,
                32,
                105,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                38,
                38,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                103,
                101,
                116,
                67,
                111,
                110,
                116,
                101,
                120,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                103,
                101,
                116,
                67,
                111,
                110,
                116,
                101,
                120,
                116,
                40,
                34,
                50,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                114,
                101,
                110,
                100,
                101,
                114,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                117,
                102,
                102,
                101,
                114,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                101,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                76,
                101,
                110,
                103,
                116,
                104,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                32,
                42,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                42,
                32,
                66,
                89,
                84,
                69,
                83,
                95,
                80,
                69,
                82,
                95,
                80,
                73,
                88,
                69,
                76,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                117,
                102,
                102,
                101,
                114,
                46,
                98,
                121,
                116,
                101,
                76,
                101,
                110,
                103,
                116,
                104,
                32,
                33,
                61,
                61,
                32,
                101,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                76,
                101,
                110,
                103,
                116,
                104,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                119,
                97,
                114,
                110,
                40,
                96,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                115,
                105,
                122,
                101,
                32,
                109,
                105,
                115,
                109,
                97,
                116,
                99,
                104,
                58,
                32,
                103,
                111,
                116,
                32,
                36,
                123,
                98,
                117,
                102,
                102,
                101,
                114,
                46,
                98,
                121,
                116,
                101,
                76,
                101,
                110,
                103,
                116,
                104,
                125,
                44,
                32,
                101,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                32,
                36,
                123,
                101,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                76,
                101,
                110,
                103,
                116,
                104,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                101,
                116,
                32,
                105,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                108,
                97,
                109,
                112,
                101,
                100,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                67,
                108,
                97,
                109,
                112,
                101,
                100,
                65,
                114,
                114,
                97,
                121,
                40,
                98,
                117,
                102,
                102,
                101,
                114,
                44,
                32,
                48,
                44,
                32,
                98,
                117,
                102,
                102,
                101,
                114,
                46,
                98,
                121,
                116,
                101,
                76,
                101,
                110,
                103,
                116,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                73,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                61,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                73,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                46,
                100,
                97,
                116,
                97,
                46,
                115,
                101,
                116,
                40,
                99,
                108,
                97,
                109,
                112,
                101,
                100,
                66,
                117,
                102,
                102,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                73,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                40,
                99,
                108,
                97,
                109,
                112,
                101,
                100,
                66,
                117,
                102,
                102,
                101,
                114,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                112,
                117,
                116,
                73,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                40,
                105,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                44,
                32,
                48,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                114,
                101,
                110,
                100,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                100,
                114,
                97,
                119,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                110,
                101,
                120,
                116,
                70,
                114,
                97,
                109,
                101,
                32,
                61,
                32,
                77,
                97,
                116,
                104,
                46,
                114,
                111,
                117,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                41,
                32,
                42,
                32,
                49,
                101,
                51,
                41,
                32,
                47,
                32,
                49,
                101,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                117,
                112,
                100,
                97,
                116,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                110,
                101,
                120,
                116,
                70,
                114,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                117,
                112,
                100,
                97,
                116,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                102,
                114,
                97,
                109,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                114,
                101,
                110,
                100,
                101,
                114,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                105,
                115,
                67,
                111,
                109,
                112,
                108,
                101,
                116,
                101,
                40,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                108,
                111,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                111,
                112,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                67,
                111,
                117,
                110,
                116,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                108,
                111,
                111,
                112,
                67,
                111,
                117,
                110,
                116,
                40,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                99,
                111,
                109,
                112,
                108,
                101,
                116,
                101,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                114,
                97,
                119,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                101,
                114,
                114,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                101,
                114,
                114,
                111,
                114,
                40,
                34,
                69,
                114,
                114,
                111,
                114,
                32,
                105,
                110,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                102,
                114,
                97,
                109,
                101,
                58,
                34,
                44,
                32,
                101,
                114,
                114,
                111,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                32,
                101,
                114,
                114,
                111,
                114,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                114,
                114,
                111,
                114,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                46,
                82,
                117,
                110,
                116,
                105,
                109,
                101,
                69,
                114,
                114,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                108,
                97,
                121,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                33,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                111,
                107,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                112,
                108,
                97,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                111,
                107,
                32,
                124,
                124,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                112,
                108,
                97,
                121,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                114,
                97,
                119,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                32,
                38,
                38,
                32,
                33,
                105,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                73,
                110,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                97,
                117,
                115,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                111,
                107,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                112,
                97,
                117,
                115,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                111,
                107,
                32,
                124,
                124,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                105,
                115,
                80,
                97,
                117,
                115,
                101,
                100,
                40,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                112,
                97,
                117,
                115,
                101,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                111,
                112,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                111,
                107,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                116,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                111,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                102,
                114,
                97,
                109,
                101,
                34,
                44,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                115,
                116,
                111,
                112,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                102,
                114,
                97,
                109,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                114,
                97,
                109,
                101,
                32,
                60,
                32,
                48,
                32,
                124,
                124,
                32,
                102,
                114,
                97,
                109,
                101,
                32,
                62,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                116,
                111,
                116,
                97,
                108,
                70,
                114,
                97,
                109,
                101,
                115,
                40,
                41,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                111,
                107,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                101,
                107,
                40,
                102,
                114,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                111,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                102,
                114,
                97,
                109,
                101,
                34,
                44,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                112,
                101,
                101,
                100,
                40,
                115,
                112,
                101,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                112,
                101,
                101,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                66,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                40,
                99,
                111,
                108,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                115,
                116,
                121,
                108,
                101,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                32,
                61,
                32,
                99,
                111,
                108,
                111,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                58,
                32,
                104,
                101,
                120,
                83,
                116,
                114,
                105,
                110,
                103,
                84,
                111,
                82,
                71,
                66,
                65,
                73,
                110,
                116,
                40,
                99,
                111,
                108,
                111,
                114,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                32,
                61,
                32,
                99,
                111,
                108,
                111,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                76,
                111,
                111,
                112,
                40,
                108,
                111,
                111,
                112,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                108,
                111,
                111,
                112,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                85,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                40,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                33,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                65,
                108,
                108,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                108,
                101,
                97,
                110,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                102,
                114,
                101,
                101,
                122,
                101,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                33,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                114,
                97,
                119,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                124,
                124,
                32,
                33,
                116,
                104,
                105,
                115,
                46,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                100,
                112,
                114,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                124,
                124,
                32,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                124,
                124,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                58,
                32,
                99,
                108,
                105,
                101,
                110,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                58,
                32,
                99,
                108,
                105,
                101,
                110,
                116,
                87,
                105,
                100,
                116,
                104,
                32,
                125,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                103,
                101,
                116,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                67,
                108,
                105,
                101,
                110,
                116,
                82,
                101,
                99,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                108,
                105,
                101,
                110,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                32,
                33,
                61,
                61,
                32,
                48,
                32,
                38,
                38,
                32,
                99,
                108,
                105,
                101,
                110,
                116,
                87,
                105,
                100,
                116,
                104,
                32,
                33,
                61,
                61,
                32,
                48,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                99,
                108,
                105,
                101,
                110,
                116,
                87,
                105,
                100,
                116,
                104,
                32,
                42,
                32,
                100,
                112,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                99,
                108,
                105,
                101,
                110,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                32,
                42,
                32,
                100,
                112,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                111,
                107,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                111,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                115,
                116,
                97,
                114,
                116,
                70,
                114,
                97,
                109,
                101,
                44,
                32,
                101,
                110,
                100,
                70,
                114,
                97,
                109,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                91,
                115,
                116,
                97,
                114,
                116,
                70,
                114,
                97,
                109,
                101,
                44,
                32,
                101,
                110,
                100,
                70,
                114,
                97,
                109,
                101,
                93,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                77,
                111,
                100,
                101,
                40,
                109,
                111,
                100,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                111,
                100,
                101,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                77,
                111,
                100,
                101,
                40,
                109,
                111,
                100,
                101,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                82,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                44,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                44,
                32,
                46,
                46,
                46,
                114,
                101,
                115,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                32,
                125,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                114,
                101,
                115,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                47,
                47,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                105,
                115,
                32,
                97,
                32,
                115,
                112,
                101,
                99,
                105,
                97,
                108,
                32,
                99,
                97,
                115,
                101,
                44,
                32,
                105,
                116,
                32,
                115,
                104,
                111,
                117,
                108,
                100,
                32,
                98,
                101,
                32,
                115,
                101,
                116,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                105,
                102,
                32,
                105,
                116,
                39,
                115,
                32,
                110,
                111,
                116,
                32,
                112,
                114,
                111,
                118,
                105,
                100,
                101,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                58,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                124,
                124,
                32,
                103,
                101,
                116,
                68,
                101,
                102,
                97,
                117,
                108,
                116,
                68,
                80,
                82,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                58,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                32,
                63,
                63,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                97,
                117,
                116,
                111,
                82,
                101,
                115,
                105,
                122,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                40,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                97,
                99,
                116,
                105,
                118,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                40,
                41,
                32,
                61,
                61,
                61,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                40,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                111,
                97,
                100,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                97,
                100,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                114,
                114,
                111,
                114,
                58,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                70,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                58,
                36,
                123,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                125,
                96,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                77,
                97,
                114,
                107,
                101,
                114,
                40,
                109,
                97,
                114,
                107,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                108,
                101,
                116,
                32,
                105,
                32,
                61,
                32,
                48,
                59,
                32,
                105,
                32,
                60,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                46,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                32,
                105,
                32,
                43,
                61,
                32,
                49,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                32,
                61,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                46,
                103,
                101,
                116,
                40,
                105,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                46,
                112,
                117,
                115,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                46,
                110,
                97,
                109,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                105,
                109,
                101,
                58,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                46,
                116,
                105,
                109,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                46,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                40,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                40,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                114,
                101,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                40,
                116,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                40,
                116,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                108,
                111,
                116,
                115,
                40,
                115,
                108,
                111,
                116,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                83,
                108,
                111,
                116,
                115,
                40,
                115,
                108,
                111,
                116,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                120,
                44,
                32,
                121,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                120,
                44,
                32,
                121,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                115,
                101,
                116,
                87,
                97,
                115,
                109,
                85,
                114,
                108,
                40,
                117,
                114,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                87,
                97,
                115,
                109,
                76,
                111,
                97,
                100,
                101,
                114,
                46,
                115,
                101,
                116,
                87,
                97,
                115,
                109,
                85,
                114,
                108,
                40,
                117,
                114,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                111,
                97,
                100,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                114,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                111,
                112,
                101,
                110,
                85,
                114,
                108,
                32,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                68,
                101,
                102,
                97,
                117,
                108,
                116,
                79,
                112,
                101,
                110,
                85,
                82,
                76,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                114,
                116,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                114,
                116,
                40,
                111,
                112,
                101,
                110,
                85,
                114,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                115,
                116,
                97,
                114,
                116,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                101,
                116,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                115,
                116,
                97,
                114,
                116,
                101,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                111,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                111,
                112,
                112,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                111,
                112,
                40,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                115,
                116,
                111,
                112,
                112,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                108,
                101,
                97,
                110,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                115,
                116,
                111,
                112,
                112,
                101,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                99,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                103,
                101,
                116,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                67,
                108,
                105,
                101,
                110,
                116,
                82,
                101,
                99,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                99,
                97,
                108,
                101,
                88,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                32,
                47,
                32,
                114,
                101,
                99,
                116,
                46,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                99,
                97,
                108,
                101,
                89,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                47,
                32,
                114,
                101,
                99,
                116,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                124,
                124,
                32,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                124,
                124,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                46,
                99,
                108,
                105,
                101,
                110,
                116,
                88,
                32,
                45,
                32,
                114,
                101,
                99,
                116,
                46,
                108,
                101,
                102,
                116,
                41,
                32,
                42,
                32,
                115,
                99,
                97,
                108,
                101,
                88,
                32,
                47,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                46,
                99,
                108,
                105,
                101,
                110,
                116,
                89,
                32,
                45,
                32,
                114,
                101,
                99,
                116,
                46,
                116,
                111,
                112,
                41,
                32,
                42,
                32,
                115,
                99,
                97,
                108,
                101,
                89,
                32,
                47,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                120,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                121,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                120,
                44,
                32,
                121,
                32,
                125,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                120,
                44,
                32,
                121,
                32,
                125,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                120,
                44,
                32,
                121,
                32,
                125,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                120,
                44,
                32,
                121,
                32,
                125,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                76,
                101,
                97,
                118,
                101,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                120,
                44,
                32,
                121,
                32,
                125,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                86,
                101,
                99,
                116,
                111,
                114,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                70,
                114,
                97,
                109,
                101,
                119,
                111,
                114,
                107,
                83,
                101,
                116,
                117,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                108,
                101,
                116,
                32,
                105,
                32,
                61,
                32,
                48,
                59,
                32,
                105,
                32,
                60,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                86,
                101,
                99,
                116,
                111,
                114,
                46,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                32,
                105,
                32,
                43,
                61,
                32,
                49,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                112,
                117,
                115,
                104,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                86,
                101,
                99,
                116,
                111,
                114,
                46,
                103,
                101,
                116,
                40,
                105,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                115,
                101,
                116,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                33,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                103,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                34,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                117,
                112,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                34,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                100,
                111,
                119,
                110,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                34,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                109,
                111,
                118,
                101,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                34,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                101,
                110,
                116,
                101,
                114,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                34,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                108,
                101,
                97,
                118,
                101,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                99,
                108,
                101,
                97,
                110,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                117,
                112,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                100,
                111,
                119,
                110,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                109,
                111,
                118,
                101,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                101,
                110,
                116,
                101,
                114,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                108,
                101,
                97,
                118,
                101,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                111,
                97,
                100,
                68,
                97,
                116,
                97,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                83,
                105,
                122,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                83,
                105,
                122,
                101,
                40,
                41,
                46,
                103,
                101,
                116,
                40,
                48,
                41,
                32,
                63,
                63,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                83,
                105,
                122,
                101,
                40,
                41,
                46,
                103,
                101,
                116,
                40,
                49,
                41,
                32,
                63,
                63,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                66,
                111,
                111,
                108,
                101,
                97,
                110,
                67,
                111,
                110,
                116,
                101,
                120,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                101,
                116,
                66,
                111,
                111,
                108,
                101,
                97,
                110,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                78,
                117,
                109,
                101,
                114,
                105,
                99,
                67,
                111,
                110,
                116,
                101,
                120,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                101,
                116,
                78,
                117,
                109,
                101,
                114,
                105,
                99,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                114,
                105,
                110,
                103,
                67,
                111,
                110,
                116,
                101,
                120,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                101,
                116,
                83,
                116,
                114,
                105,
                110,
                103,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                71,
                101,
                116,
                32,
                116,
                104,
                101,
                32,
                79,
                114,
                105,
                101,
                110,
                116,
                101,
                100,
                32,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                32,
                66,
                111,
                120,
                32,
                40,
                79,
                66,
                66,
                41,
                32,
                112,
                111,
                105,
                110,
                116,
                115,
                32,
                111,
                102,
                32,
                97,
                32,
                108,
                97,
                121,
                101,
                114,
                32,
                98,
                121,
                32,
                105,
                116,
                115,
                32,
                110,
                97,
                109,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                108,
                97,
                121,
                101,
                114,
                78,
                97,
                109,
                101,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                110,
                97,
                109,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                108,
                97,
                121,
                101,
                114,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                65,
                110,
                32,
                97,
                114,
                114,
                97,
                121,
                32,
                111,
                102,
                32,
                56,
                32,
                110,
                117,
                109,
                98,
                101,
                114,
                115,
                32,
                114,
                101,
                112,
                114,
                101,
                115,
                101,
                110,
                116,
                105,
                110,
                103,
                32,
                52,
                32,
                112,
                111,
                105,
                110,
                116,
                115,
                32,
                40,
                120,
                44,
                121,
                41,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                79,
                66,
                66,
                32,
                105,
                110,
                32,
                99,
                108,
                111,
                99,
                107,
                119,
                105,
                115,
                101,
                32,
                111,
                114,
                100,
                101,
                114,
                32,
                115,
                116,
                97,
                114,
                116,
                105,
                110,
                103,
                32,
                102,
                114,
                111,
                109,
                32,
                116,
                111,
                112,
                45,
                108,
                101,
                102,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                91,
                120,
                48,
                44,
                32,
                121,
                48,
                44,
                32,
                120,
                49,
                44,
                32,
                121,
                49,
                44,
                32,
                120,
                50,
                44,
                32,
                121,
                50,
                44,
                32,
                120,
                51,
                44,
                32,
                121,
                51,
                93,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                97,
                109,
                112,
                108,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                96,
                96,
                96,
                116,
                121,
                112,
                101,
                115,
                99,
                114,
                105,
                112,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                47,
                47,
                32,
                68,
                114,
                97,
                119,
                32,
                97,
                32,
                112,
                111,
                108,
                121,
                103,
                111,
                110,
                32,
                97,
                114,
                111,
                117,
                110,
                100,
                32,
                116,
                104,
                101,
                32,
                108,
                97,
                121,
                101,
                114,
                32,
                39,
                76,
                97,
                121,
                101,
                114,
                32,
                49,
                39,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                39,
                114,
                101,
                110,
                100,
                101,
                114,
                39,
                44,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                32,
                61,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                103,
                101,
                116,
                76,
                97,
                121,
                101,
                114,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                66,
                111,
                120,
                40,
                39,
                76,
                97,
                121,
                101,
                114,
                32,
                49,
                39,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                98,
                101,
                103,
                105,
                110,
                80,
                97,
                116,
                104,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                109,
                111,
                118,
                101,
                84,
                111,
                40,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                48,
                93,
                44,
                32,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                49,
                93,
                41,
                59,
                32,
                47,
                47,
                32,
                70,
                105,
                114,
                115,
                116,
                32,
                112,
                111,
                105,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                108,
                105,
                110,
                101,
                84,
                111,
                40,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                50,
                93,
                44,
                32,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                51,
                93,
                41,
                59,
                32,
                47,
                47,
                32,
                83,
                101,
                99,
                111,
                110,
                100,
                32,
                112,
                111,
                105,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                108,
                105,
                110,
                101,
                84,
                111,
                40,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                52,
                93,
                44,
                32,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                53,
                93,
                41,
                59,
                32,
                47,
                47,
                32,
                84,
                104,
                105,
                114,
                100,
                32,
                112,
                111,
                105,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                108,
                105,
                110,
                101,
                84,
                111,
                40,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                54,
                93,
                44,
                32,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                55,
                93,
                41,
                59,
                32,
                47,
                47,
                32,
                70,
                111,
                117,
                114,
                116,
                104,
                32,
                112,
                111,
                105,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                99,
                108,
                111,
                115,
                101,
                80,
                97,
                116,
                104,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                115,
                116,
                114,
                111,
                107,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                96,
                96,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                76,
                97,
                121,
                101,
                114,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                66,
                111,
                120,
                40,
                108,
                97,
                121,
                101,
                114,
                78,
                97,
                109,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                111,
                117,
                110,
                100,
                115,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                103,
                101,
                116,
                76,
                97,
                121,
                101,
                114,
                66,
                111,
                117,
                110,
                100,
                115,
                40,
                108,
                97,
                121,
                101,
                114,
                78,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                111,
                117,
                110,
                100,
                115,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                111,
                117,
                110,
                100,
                115,
                46,
                115,
                105,
                122,
                101,
                40,
                41,
                32,
                33,
                61,
                61,
                32,
                56,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                112,
                111,
                105,
                110,
                116,
                115,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                108,
                101,
                116,
                32,
                105,
                32,
                61,
                32,
                48,
                59,
                32,
                105,
                32,
                60,
                32,
                56,
                59,
                32,
                105,
                32,
                43,
                61,
                32,
                49,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                111,
                105,
                110,
                116,
                115,
                46,
                112,
                117,
                115,
                104,
                40,
                98,
                111,
                117,
                110,
                100,
                115,
                46,
                103,
                101,
                116,
                40,
                105,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                112,
                111,
                105,
                110,
                116,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                116,
                114,
                97,
                110,
                115,
                102,
                111,
                114,
                109,
                84,
                104,
                101,
                109,
                101,
                84,
                111,
                76,
                111,
                116,
                116,
                105,
                101,
                83,
                108,
                111,
                116,
                115,
                40,
                116,
                104,
                101,
                109,
                101,
                44,
                32,
                115,
                108,
                111,
                116,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                116,
                114,
                97,
                110,
                115,
                102,
                111,
                114,
                109,
                84,
                104,
                101,
                109,
                101,
                84,
                111,
                76,
                111,
                116,
                116,
                105,
                101,
                83,
                108,
                111,
                116,
                115,
                40,
                116,
                104,
                101,
                109,
                101,
                44,
                32,
                115,
                108,
                111,
                116,
                115,
                41,
                32,
                63,
                63,
                32,
                34,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                44,
                32,
                34,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                119,
                111,
                114,
                107,
                101,
                114,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                46,
                119,
                111,
                114,
                107,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                32,
                61,
                32,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                118,
                101,
                110,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                77,
                97,
                112,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                121,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                82,
                101,
                97,
                100,
                121,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                109,
                112,
                108,
                101,
                116,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                67,
                111,
                109,
                112,
                108,
                101,
                116,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                97,
                100,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                76,
                111,
                97,
                100,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                108,
                111,
                97,
                100,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                76,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                114,
                114,
                111,
                114,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                114,
                114,
                111,
                114,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                82,
                101,
                110,
                100,
                101,
                114,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                114,
                114,
                111,
                114,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                111,
                112,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                76,
                111,
                111,
                112,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                108,
                111,
                111,
                112,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                108,
                97,
                121,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                112,
                108,
                97,
                121,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                80,
                108,
                97,
                121,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                112,
                108,
                97,
                121,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                97,
                117,
                115,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                112,
                97,
                117,
                115,
                101,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                80,
                97,
                117,
                115,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                112,
                97,
                117,
                115,
                101,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                111,
                112,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                111,
                112,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                83,
                116,
                111,
                112,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                115,
                116,
                111,
                112,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                102,
                114,
                97,
                109,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                102,
                114,
                97,
                109,
                101,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                102,
                114,
                97,
                109,
                101,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                82,
                101,
                110,
                100,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                70,
                114,
                101,
                101,
                122,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                85,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                68,
                101,
                115,
                116,
                114,
                111,
                121,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                111,
                109,
                109,
                97,
                110,
                100,
                115,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                83,
                116,
                97,
                116,
                101,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                67,
                111,
                117,
                110,
                116,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                111,
                111,
                112,
                67,
                111,
                117,
                110,
                116,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                80,
                97,
                117,
                115,
                101,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                80,
                97,
                117,
                115,
                101,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                83,
                116,
                111,
                112,
                112,
                101,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                83,
                116,
                111,
                112,
                112,
                101,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                111,
                111,
                112,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                111,
                100,
                101,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                109,
                111,
                100,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                112,
                101,
                101,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                112,
                101,
                101,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                116,
                97,
                108,
                70,
                114,
                97,
                109,
                101,
                115,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                116,
                111,
                116,
                97,
                108,
                70,
                114,
                97,
                109,
                101,
                115,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                99,
                116,
                105,
                118,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                97,
                99,
                116,
                105,
                118,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                99,
                116,
                105,
                118,
                101,
                84,
                104,
                101,
                109,
                101,
                73,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                97,
                99,
                116,
                105,
                118,
                101,
                84,
                104,
                101,
                109,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                68,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                68,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                82,
                101,
                97,
                100,
                121,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                82,
                101,
                97,
                100,
                121,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                58,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                103,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                69,
                118,
                101,
                110,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                69,
                118,
                101,
                110,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                69,
                118,
                101,
                110,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                114,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                114,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                111,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                111,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                111,
                97,
                100,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                111,
                97,
                100,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                104,
                97,
                115,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                97,
                108,
                114,
                101,
                97,
                100,
                121,
                32,
                101,
                120,
                105,
                115,
                116,
                115,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                115,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                101,
                118,
                101,
                110,
                116,
                115,
                32,
                61,
                32,
                91,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                99,
                111,
                109,
                112,
                108,
                101,
                116,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                102,
                114,
                97,
                109,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                108,
                111,
                97,
                100,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                108,
                111,
                111,
                112,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                112,
                97,
                117,
                115,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                112,
                108,
                97,
                121,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                115,
                116,
                111,
                112,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                102,
                114,
                101,
                101,
                122,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                114,
                101,
                110,
                100,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                114,
                101,
                97,
                100,
                121,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                115,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                101,
                118,
                101,
                110,
                116,
                44,
                32,
                101,
                118,
                101,
                110,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                77,
                97,
                112,
                91,
                101,
                118,
                101,
                110,
                116,
                93,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                111,
                97,
                100,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                40,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                40,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                116,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                116,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                40,
                116,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                97,
                117,
                115,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                97,
                117,
                115,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                108,
                97,
                121,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                108,
                97,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                105,
                122,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                58,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                66,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                66,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                40,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                102,
                114,
                97,
                109,
                101,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                102,
                114,
                97,
                109,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                102,
                114,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                77,
                111,
                100,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                111,
                100,
                101,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                109,
                111,
                100,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                77,
                111,
                100,
                101,
                40,
                109,
                111,
                100,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                82,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                82,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                91,
                48,
                93,
                44,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                91,
                49,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                112,
                101,
                101,
                100,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                112,
                101,
                101,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                115,
                112,
                101,
                101,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                83,
                112,
                101,
                101,
                100,
                40,
                115,
                112,
                101,
                101,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                85,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                85,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                40,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                87,
                97,
                115,
                109,
                85,
                114,
                108,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                115,
                101,
                116,
                87,
                97,
                115,
                109,
                85,
                114,
                108,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                117,
                114,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                111,
                112,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                120,
                44,
                32,
                121,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                83,
                105,
                122,
                101,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                125,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                83,
                105,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                105,
                100,
                116,
                104,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                77,
                97,
                114,
                107,
                101,
                114,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                77,
                97,
                114,
                107,
                101,
                114,
                40,
                109,
                97,
                114,
                107,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                58,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                76,
                111,
                111,
                112,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                111,
                112,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                108,
                111,
                111,
                112,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                76,
                111,
                111,
                112,
                40,
                108,
                111,
                111,
                112,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                58,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                101,
                120,
                101,
                99,
                117,
                116,
                101,
                67,
                111,
                109,
                109,
                97,
                110,
                100,
                40,
                114,
                112,
                99,
                82,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                32,
                61,
                32,
                114,
                112,
                99,
                82,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                109,
                101,
                116,
                104,
                111,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                99,
                111,
                109,
                109,
                97,
                110,
                100,
                115,
                91,
                109,
                101,
                116,
                104,
                111,
                100,
                93,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                111,
                109,
                109,
                97,
                110,
                100,
                115,
                91,
                109,
                101,
                116,
                104,
                111,
                100,
                93,
                40,
                114,
                112,
                99,
                82,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                77,
                101,
                116,
                104,
                111,
                100,
                32,
                36,
                123,
                109,
                101,
                116,
                104,
                111,
                100,
                125,
                32,
                105,
                115,
                32,
                110,
                111,
                116,
                32,
                105,
                109,
                112,
                108,
                101,
                109,
                101,
                110,
                116,
                101,
                100,
                32,
                105,
                110,
                32,
                99,
                111,
                109,
                109,
                97,
                110,
                100,
                115,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                111,
                110,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                32,
                61,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                32,
                61,
                32,
                101,
                120,
                101,
                99,
                117,
                116,
                101,
                67,
                111,
                109,
                109,
                97,
                110,
                100,
                40,
                101,
                118,
                101,
                110,
                116,
                46,
                100,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                101,
                118,
                101,
                110,
                116,
                46,
                100,
                97,
                116,
                97,
                46,
                105,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                101,
                118,
                101,
                110,
                116,
                46,
                100,
                97,
                116,
                97,
                46,
                109,
                101,
                116,
                104,
                111,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                101,
                114,
                114,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                101,
                114,
                114,
                111,
                114,
                82,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                101,
                118,
                101,
                110,
                116,
                46,
                100,
                97,
                116,
                97,
                46,
                105,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                101,
                118,
                101,
                110,
                116,
                46,
                100,
                97,
                116,
                97,
                46,
                109,
                101,
                116,
                104,
                111,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                114,
                114,
                111,
                114,
                58,
                32,
                101,
                114,
                114,
                111,
                114,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                101,
                114,
                114,
                111,
                114,
                82,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                117,
                109,
                109,
                121,
                32,
                61,
                32,
                34,
                34,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                95,
                119,
                111,
                114,
                107,
                101,
                114,
                95,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                32,
                61,
                32,
                100,
                117,
                109,
                109,
                121,
                59,
                10,
                125,
                41,
                40,
                41,
                59,
                10
            ])
        ], {
            type: "application/javascript"
        }), a = URL.createObjectURL(n), s = new Worker(a);
        return URL.revokeObjectURL(a), s;
    }
}, $66d31c93ca24442f$var$K2 = $66d31c93ca24442f$var$c2;
var $66d31c93ca24442f$var$k1 = class {
    constructor(){
        $66d31c93ca24442f$var$v(this, "_workers", new Map);
        $66d31c93ca24442f$var$v(this, "_animationWorkerMap", new Map);
    }
    getWorker(n) {
        return this._workers.has(n) || this._workers.set(n, new $66d31c93ca24442f$var$K2), this._workers.get(n);
    }
    assignAnimationToWorker(n, a) {
        this._animationWorkerMap.set(n, a);
    }
    unassignAnimationFromWorker(n) {
        this._animationWorkerMap.delete(n);
    }
    sendMessage(n, a, s) {
        this.getWorker(n).postMessage(a, s || []);
    }
    terminateWorker(n) {
        let a = this._workers.get(n);
        a && (a.terminate(), this._workers.delete(n));
    }
};
function $66d31c93ca24442f$var$e3(h, n) {
    if (h instanceof HTMLCanvasElement) {
        let { height: a, width: s } = h.getBoundingClientRect();
        if (a !== 0 && s !== 0) return {
            width: s * n,
            height: a * n
        };
    }
    return {
        width: h.width,
        height: h.height
    };
}
function $66d31c93ca24442f$var$t3() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
}
var $66d31c93ca24442f$var$B = class B {
    constructor(n){
        $66d31c93ca24442f$var$v(this, "_eventManager", new $66d31c93ca24442f$var$n1);
        $66d31c93ca24442f$var$v(this, "_id");
        $66d31c93ca24442f$var$v(this, "_worker");
        $66d31c93ca24442f$var$v(this, "_canvas");
        $66d31c93ca24442f$var$v(this, "_dotLottieInstanceState", {
            loopCount: 0,
            markers: [],
            autoplay: false,
            backgroundColor: "",
            currentFrame: 0,
            duration: 0,
            loop: false,
            mode: "forward",
            segment: [
                0,
                0
            ],
            segmentDuration: 0,
            speed: 1,
            totalFrames: 0,
            isLoaded: false,
            isPlaying: false,
            isPaused: false,
            isStopped: true,
            isFrozen: false,
            useFrameInterpolation: false,
            renderConfig: {
                devicePixelRatio: $66d31c93ca24442f$var$Q()
            },
            activeAnimationId: "",
            activeThemeId: "",
            layout: void 0,
            marker: void 0,
            isReady: false,
            manifest: null
        });
        $66d31c93ca24442f$var$v(this, "_created", false);
        $66d31c93ca24442f$var$v(this, "_pointerUpMethod");
        $66d31c93ca24442f$var$v(this, "_pointerDownMethod");
        $66d31c93ca24442f$var$v(this, "_pointerMoveMethod");
        $66d31c93ca24442f$var$v(this, "_pointerEnterMethod");
        $66d31c93ca24442f$var$v(this, "_pointerExitMethod");
        this._canvas = n.canvas, this._id = `dotlottie-${$66d31c93ca24442f$var$t3()}`;
        let a = n.workerId || "defaultWorker";
        this._worker = B._workerManager.getWorker(a), B._workerManager.assignAnimationToWorker(this._id, a), B._wasmUrl && this._sendMessage("setWasmUrl", {
            url: B._wasmUrl
        }), this._create({
            ...n,
            renderConfig: {
                ...n.renderConfig,
                devicePixelRatio: n.renderConfig?.devicePixelRatio || $66d31c93ca24442f$var$Q(),
                freezeOnOffscreen: n.renderConfig?.freezeOnOffscreen ?? true
            }
        }), this._worker.addEventListener("message", this._handleWorkerEvent.bind(this)), this._pointerUpMethod = this._onPointerUp.bind(this), this._pointerDownMethod = this._onPointerDown.bind(this), this._pointerMoveMethod = this._onPointerMove.bind(this), this._pointerEnterMethod = this._onPointerEnter.bind(this), this._pointerExitMethod = this._onPointerLeave.bind(this);
    }
    async _handleWorkerEvent(n) {
        let a = n.data;
        a.id || (a.method === "onLoad" && a.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(a.result.event), $66d31c93ca24442f$var$E && this._canvas instanceof HTMLCanvasElement && (this._dotLottieInstanceState.renderConfig.freezeOnOffscreen && $66d31c93ca24442f$var$k.observe(this._canvas, this), this._dotLottieInstanceState.renderConfig.autoResize && $66d31c93ca24442f$var$D.observe(this._canvas, this))), a.method === "onComplete" && a.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(a.result.event)), a.method === "onDestroy" && a.result.instanceId === this._id && this._eventManager.dispatch(a.result.event), a.method === "onUnfreeze" && a.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._dotLottieInstanceState.isFrozen = false, this._eventManager.dispatch(a.result.event)), a.method === "onFrame" && a.result.instanceId === this._id && (this._dotLottieInstanceState.currentFrame = a.result.event.currentFrame, this._eventManager.dispatch(a.result.event)), a.method === "onRender" && a.result.instanceId === this._id && this._eventManager.dispatch(a.result.event), a.method === "onFreeze" && a.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(a.result.event)), a.method === "onPause" && a.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(a.result.event)), a.method === "onPlay" && a.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(a.result.event)), a.method === "onStop" && a.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(a.result.event)), a.method === "onLoadError" && a.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(a.result.event)), a.method === "onRenderError" && a.result.instanceId === this._id && this._eventManager.dispatch(a.result.event), a.method === "onReady" && a.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(a.result.event)), a.method === "onLoop" && a.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(a.result.event)));
    }
    async _create(n) {
        let a;
        this._canvas instanceof HTMLCanvasElement ? a = this._canvas.transferControlToOffscreen() : a = this._canvas;
        let { instanceId: s } = await this._sendMessage("create", {
            instanceId: this._id,
            config: {
                ...n,
                canvas: a
            },
            ...$66d31c93ca24442f$var$e3(this._canvas, n.renderConfig?.devicePixelRatio || $66d31c93ca24442f$var$Q())
        }, [
            a
        ]);
        if (s !== this._id) throw new Error("Instance ID mismatch");
        this._created = true, await this._updateDotLottieInstanceState();
    }
    get loopCount() {
        return this._dotLottieInstanceState.loopCount;
    }
    get isLoaded() {
        return this._dotLottieInstanceState.isLoaded;
    }
    get isPlaying() {
        return this._dotLottieInstanceState.isPlaying;
    }
    get isPaused() {
        return this._dotLottieInstanceState.isPaused;
    }
    get isStopped() {
        return this._dotLottieInstanceState.isStopped;
    }
    get currentFrame() {
        return this._dotLottieInstanceState.currentFrame;
    }
    get isFrozen() {
        return this._dotLottieInstanceState.isFrozen;
    }
    get segmentDuration() {
        return this._dotLottieInstanceState.segmentDuration;
    }
    get totalFrames() {
        return this._dotLottieInstanceState.totalFrames;
    }
    get segment() {
        return this._dotLottieInstanceState.segment;
    }
    get speed() {
        return this._dotLottieInstanceState.speed;
    }
    get duration() {
        return this._dotLottieInstanceState.duration;
    }
    get isReady() {
        return this._dotLottieInstanceState.isReady;
    }
    get mode() {
        return this._dotLottieInstanceState.mode;
    }
    get canvas() {
        return this._canvas;
    }
    get autoplay() {
        return this._dotLottieInstanceState.autoplay;
    }
    get backgroundColor() {
        return this._dotLottieInstanceState.backgroundColor;
    }
    get loop() {
        return this._dotLottieInstanceState.loop;
    }
    get useFrameInterpolation() {
        return this._dotLottieInstanceState.useFrameInterpolation;
    }
    get renderConfig() {
        return this._dotLottieInstanceState.renderConfig;
    }
    get manifest() {
        return this._dotLottieInstanceState.manifest;
    }
    get activeAnimationId() {
        return this._dotLottieInstanceState.activeAnimationId;
    }
    get marker() {
        return this._dotLottieInstanceState.marker;
    }
    get activeThemeId() {
        return this._dotLottieInstanceState.activeThemeId;
    }
    get layout() {
        return this._dotLottieInstanceState.layout;
    }
    async play() {
        this._created && (await this._sendMessage("play", {
            instanceId: this._id
        }), await this._updateDotLottieInstanceState(), $66d31c93ca24442f$var$E && this._canvas instanceof HTMLCanvasElement && this._dotLottieInstanceState.renderConfig.freezeOnOffscreen && !$66d31c93ca24442f$var$A1(this._canvas) && await this.freeze());
    }
    async pause() {
        this._created && (await this._sendMessage("pause", {
            instanceId: this._id
        }), await this._updateDotLottieInstanceState());
    }
    async stop() {
        this._created && (await this._sendMessage("stop", {
            instanceId: this._id
        }), await this._updateDotLottieInstanceState());
    }
    async setSpeed(n) {
        this._created && (await this._sendMessage("setSpeed", {
            instanceId: this._id,
            speed: n
        }), await this._updateDotLottieInstanceState());
    }
    async setMode(n) {
        this._created && (await this._sendMessage("setMode", {
            instanceId: this._id,
            mode: n
        }), await this._updateDotLottieInstanceState());
    }
    async setFrame(n) {
        this._created && (await this._sendMessage("setFrame", {
            frame: n,
            instanceId: this._id
        }), await this._updateDotLottieInstanceState());
    }
    async setSegment(n, a) {
        this._created && (await this._sendMessage("setSegment", {
            instanceId: this._id,
            segment: [
                n,
                a
            ]
        }), await this._updateDotLottieInstanceState());
    }
    async setRenderConfig(n) {
        if (!this._created) return;
        let { devicePixelRatio: a, freezeOnOffscreen: s, ...m } = n;
        await this._sendMessage("setRenderConfig", {
            instanceId: this._id,
            renderConfig: {
                ...this._dotLottieInstanceState.renderConfig,
                ...m,
                devicePixelRatio: a || $66d31c93ca24442f$var$Q(),
                freezeOnOffscreen: s ?? true
            }
        }), await this._updateDotLottieInstanceState(), $66d31c93ca24442f$var$E && this._canvas instanceof HTMLCanvasElement && (this._dotLottieInstanceState.renderConfig.autoResize ? $66d31c93ca24442f$var$D.observe(this._canvas, this) : $66d31c93ca24442f$var$D.unobserve(this._canvas), this._dotLottieInstanceState.renderConfig.freezeOnOffscreen ? $66d31c93ca24442f$var$k.observe(this._canvas, this) : ($66d31c93ca24442f$var$k.unobserve(this._canvas), this._dotLottieInstanceState.isFrozen && await this.unfreeze()));
    }
    async setUseFrameInterpolation(n) {
        this._created && (await this._sendMessage("setUseFrameInterpolation", {
            instanceId: this._id,
            useFrameInterpolation: n
        }), await this._updateDotLottieInstanceState());
    }
    async setTheme(n) {
        if (!this._created) return false;
        let a = this._sendMessage("setTheme", {
            instanceId: this._id,
            themeId: n
        });
        return await this._updateDotLottieInstanceState(), a;
    }
    async load(n) {
        this._created && (await this._sendMessage("load", {
            config: n,
            instanceId: this._id
        }), await this._updateDotLottieInstanceState());
    }
    async setLoop(n) {
        this._created && (await this._sendMessage("setLoop", {
            instanceId: this._id,
            loop: n
        }), await this._updateDotLottieInstanceState());
    }
    async resize() {
        if (!this._created) return;
        let { height: n, width: a } = $66d31c93ca24442f$var$e3(this._canvas, this._dotLottieInstanceState.renderConfig.devicePixelRatio || $66d31c93ca24442f$var$Q());
        await this._sendMessage("resize", {
            height: n,
            instanceId: this._id,
            width: a
        }), await this._updateDotLottieInstanceState();
    }
    async destroy() {
        this._created && (this._created = false, await this._sendMessage("destroy", {
            instanceId: this._id
        }), this._cleanupStateMachineListeners(), B._workerManager.unassignAnimationFromWorker(this._id), this._eventManager.removeAllEventListeners(), $66d31c93ca24442f$var$E && this._canvas instanceof HTMLCanvasElement && ($66d31c93ca24442f$var$k.unobserve(this._canvas), $66d31c93ca24442f$var$D.unobserve(this._canvas)));
    }
    async freeze() {
        this._created && (await this._sendMessage("freeze", {
            instanceId: this._id
        }), await this._updateDotLottieInstanceState());
    }
    async unfreeze() {
        this._created && (await this._sendMessage("unfreeze", {
            instanceId: this._id
        }), await this._updateDotLottieInstanceState());
    }
    async setBackgroundColor(n) {
        this._created && (await this._sendMessage("setBackgroundColor", {
            instanceId: this._id,
            backgroundColor: n
        }), await this._updateDotLottieInstanceState());
    }
    async loadAnimation(n) {
        this._created && (await this._sendMessage("loadAnimation", {
            animationId: n,
            instanceId: this._id
        }), await this._updateDotLottieInstanceState());
    }
    async setLayout(n) {
        this._created && (await this._sendMessage("setLayout", {
            instanceId: this._id,
            layout: n
        }), await this._updateDotLottieInstanceState());
    }
    async _updateDotLottieInstanceState() {
        if (!this._created) return;
        let n = await this._sendMessage("getDotLottieInstanceState", {
            instanceId: this._id
        });
        this._dotLottieInstanceState = n.state;
    }
    markers() {
        return this._dotLottieInstanceState.markers;
    }
    async setMarker(n) {
        this._created && (await this._sendMessage("setMarker", {
            instanceId: this._id,
            marker: n
        }), await this._updateDotLottieInstanceState());
    }
    async setThemeData(n) {
        if (!this._created) return false;
        let a = await this._sendMessage("setThemeData", {
            instanceId: this._id,
            themeData: n
        });
        return await this._updateDotLottieInstanceState(), a;
    }
    async setViewport(n, a, s, m) {
        return this._created ? this._sendMessage("setViewport", {
            x: n,
            y: a,
            width: s,
            height: m,
            instanceId: this._id
        }) : false;
    }
    async animationSize() {
        return this._created ? this._sendMessage("animationSize", {
            instanceId: this._id
        }) : {
            height: 0,
            width: 0
        };
    }
    async _sendMessage(n, a, s) {
        let m = {
            id: `dotlottie-request-${$66d31c93ca24442f$var$t3()}`,
            method: n,
            params: a
        };
        return this._worker.postMessage(m, s || []), new Promise((P, H)=>{
            let z = (_1)=>{
                let A = _1.data;
                A.id === m.id && (this._worker.removeEventListener("message", z), A.error ? H(new Error(`Failed to execute method ${n}: ${A.error}`)) : P(A.result));
            };
            this._worker.addEventListener("message", z);
        });
    }
    addEventListener(n, a) {
        this._eventManager.addEventListener(n, a);
    }
    removeEventListener(n, a) {
        this._eventManager.removeEventListener(n, a);
    }
    static setWasmUrl(n) {
        B._wasmUrl = n;
    }
    async loadStateMachine(n) {
        if (!this._created) return false;
        let a = await this._sendMessage("loadStateMachine", {
            instanceId: this._id,
            stateMachineId: n
        });
        return await this._updateDotLottieInstanceState(), a;
    }
    async loadStateMachineData(n) {
        if (!this._created) return false;
        let a = await this._sendMessage("loadStateMachineData", {
            instanceId: this._id,
            stateMachineData: n
        });
        return await this._updateDotLottieInstanceState(), a;
    }
    async startStateMachine() {
        if (!this._created) return false;
        this._setupStateMachineListeners();
        let n = await this._sendMessage("startStateMachine", {
            instanceId: this._id
        });
        return await this._updateDotLottieInstanceState(), n;
    }
    async stopStateMachine() {
        return this._created ? (this._cleanupStateMachineListeners(), this._sendMessage("stopStateMachine", {
            instanceId: this._id
        })) : false;
    }
    async getStateMachineListeners() {
        return this._created ? this._sendMessage("getStateMachineListeners", {
            instanceId: this._id
        }) : [];
    }
    _getPointerPosition(n) {
        let a = this._canvas.getBoundingClientRect(), s = this._canvas.width / a.width, m = this._canvas.height / a.height, P = this._dotLottieInstanceState.renderConfig.devicePixelRatio || window.devicePixelRatio || 1, H = (n.clientX - a.left) * s / P, z = (n.clientY - a.top) * m / P;
        return {
            x: H,
            y: z
        };
    }
    _onPointerUp(n) {
        let { x: a, y: s } = this._getPointerPosition(n);
        this._sendMessage("postPointerUpEvent", {
            instanceId: this._id,
            x: a,
            y: s
        });
    }
    _onPointerDown(n) {
        let { x: a, y: s } = this._getPointerPosition(n);
        this._sendMessage("postPointerDownEvent", {
            instanceId: this._id,
            x: a,
            y: s
        });
    }
    _onPointerMove(n) {
        let { x: a, y: s } = this._getPointerPosition(n);
        this._sendMessage("postPointerMoveEvent", {
            instanceId: this._id,
            x: a,
            y: s
        });
    }
    _onPointerEnter(n) {
        let { x: a, y: s } = this._getPointerPosition(n);
        this._sendMessage("postPointerEnterEvent", {
            instanceId: this._id,
            x: a,
            y: s
        });
    }
    _onPointerLeave(n) {
        let { x: a, y: s } = this._getPointerPosition(n);
        this._sendMessage("postPointerExitEvent", {
            instanceId: this._id,
            x: a,
            y: s
        });
    }
    async _setupStateMachineListeners() {
        if ($66d31c93ca24442f$var$E && this._canvas instanceof HTMLCanvasElement && this.isLoaded) {
            let n = await this._sendMessage("getStateMachineListeners", {
                instanceId: this._id
            });
            n.includes("PointerUp") && this._canvas.addEventListener("pointerup", this._pointerUpMethod), n.includes("PointerDown") && this._canvas.addEventListener("pointerdown", this._pointerDownMethod), n.includes("PointerMove") && this._canvas.addEventListener("pointermove", this._pointerMoveMethod), n.includes("PointerEnter") && this._canvas.addEventListener("pointerenter", this._pointerEnterMethod), n.includes("PointerExit") && this._canvas.addEventListener("pointerleave", this._pointerExitMethod);
        }
    }
    _cleanupStateMachineListeners() {
        $66d31c93ca24442f$var$E && this._canvas instanceof HTMLCanvasElement && (this._canvas.removeEventListener("pointerup", this._pointerUpMethod), this._canvas.removeEventListener("pointerdown", this._pointerDownMethod), this._canvas.removeEventListener("pointermove", this._pointerMoveMethod), this._canvas.removeEventListener("pointerenter", this._pointerEnterMethod), this._canvas.removeEventListener("pointerleave", this._pointerExitMethod));
    }
};
$66d31c93ca24442f$var$v($66d31c93ca24442f$var$B, "_workerManager", new $66d31c93ca24442f$var$k1), $66d31c93ca24442f$var$v($66d31c93ca24442f$var$B, "_wasmUrl", "");
var $66d31c93ca24442f$export$ab8c8a3fed0b35de = $66d31c93ca24442f$var$B;
 //# sourceMappingURL=index.js.map

});

parcelRegister("kOgzt", function(module, exports) {
$parcel$export(module.exports, "b64_decode", () => (parcelRequire("77crt")).b64_decode);
$parcel$export(module.exports, "getColorHexValue", () => (parcelRequire("3IaSv")).getColorHexValue);
$parcel$export(module.exports, "getAllCookies", () => (parcelRequire("ceOOn")).getAllCookies);
$parcel$export(module.exports, "elementReady", () => (parcelRequire("a3TA1")).elementReady);
$parcel$export(module.exports, "addWindowResizeEvent", () => (parcelRequire("6oLIz")).addWindowResizeEvent);
$parcel$export(module.exports, "addWindowScrollEvent", () => (parcelRequire("6oLIz")).addWindowScrollEvent);
$parcel$export(module.exports, "getReCAPTCHAResponse", () => (parcelRequire("isKkJ")).getReCAPTCHAResponse);
$parcel$export(module.exports, "slideDown", () => (parcelRequire("h30hJ")).slideDown);
$parcel$export(module.exports, "slideUp", () => (parcelRequire("h30hJ")).slideUp);
$parcel$export(module.exports, "scrollToElement", () => (parcelRequire("jWfAU")).scrollToElement);
$parcel$export(module.exports, "getThemeData", () => (parcelRequire("6sEQA")).getThemeData);
$parcel$export(module.exports, "waitForElement", () => (parcelRequire("hxRak")).waitForElement);
parcelRequire("77crt");
parcelRequire("3IaSv");
parcelRequire("ceOOn");
parcelRequire("a3TA1");
parcelRequire("6oLIz");
parcelRequire("isKkJ");
parcelRequire("h30hJ");
parcelRequire("jWfAU");
parcelRequire("6sEQA");
parcelRequire("hxRak");

});
parcelRegister("77crt", function(module, exports) {

$parcel$export(module.exports, "b64_decode", () => $52e2d69231a1aae4$export$bf9d481ba07b53f9);
const $52e2d69231a1aae4$export$3c2a198a9c1ae5f3 = (string)=>{
    return window.btoa(unescape(encodeURIComponent(string)));
};
const $52e2d69231a1aae4$export$bf9d481ba07b53f9 = (string)=>{
    return decodeURIComponent(escape(window.atob(string)));
};

});

parcelRegister("3IaSv", function(module, exports) {

$parcel$export(module.exports, "getColorHexValue", () => $2b3deb4eff4b3150$export$be9603b40fb67b4a);

var $b8TNY = parcelRequire("b8TNY");
const $2b3deb4eff4b3150$export$be9603b40fb67b4a = (id, opacity = 1, useTransparency = false)=>{
    const bodyColorValue = getComputedStyle(document.body).getPropertyValue(`--color-body`);
    const baseColorValue = getComputedStyle(document.body).getPropertyValue(`--color-${id}`);
    if (useTransparency) return (0, $b8TNY.default)(baseColorValue).alpha(opacity).hex();
    else return (0, $b8TNY.default)(baseColorValue).mix(bodyColorValue, 1 - opacity).hex();
};

});
parcelRegister("b8TNY", function(module, exports) {

$parcel$export(module.exports, "default", () => $81cbbacd84e74401$export$2e2bcd8739ae039);
// feel free to comment out anything to rollup
// a smaller chroma.js bundle

var $gaK1V = parcelRequire("gaK1V");
parcelRequire("cF22K");
parcelRequire("iygXn");
parcelRequire("QEjK4");
parcelRequire("kytU9");
parcelRequire("kn0Pa");
parcelRequire("hDPZe");
parcelRequire("eDzBg");
parcelRequire("7pAyc");
parcelRequire("kXega");
parcelRequire("8P76D");
parcelRequire("bEZjX");
parcelRequire("jywIV");
parcelRequire("4Zhp6");
parcelRequire("kMTGA");
parcelRequire("dkzY3");
parcelRequire("gac9F");
parcelRequire("fWmFX");
parcelRequire("3s82t");
parcelRequire("75dqB");
parcelRequire("2ISBM");
parcelRequire("52gBS");
parcelRequire("3wKag");

var $8UmTp = parcelRequire("8UmTp");

var $9u72g = parcelRequire("9u72g");

var $hKhjA = parcelRequire("hKhjA");

var $jpCQy = parcelRequire("jpCQy");

var $dvq8W = parcelRequire("dvq8W");

var $eIGWI = parcelRequire("eIGWI");

var $4ZQS0 = parcelRequire("4ZQS0");

var $cgHIr = parcelRequire("cgHIr");

var $5BDZu = parcelRequire("5BDZu");

var $iM4ga = parcelRequire("iM4ga");

var $xkLDw = parcelRequire("xkLDw");

var $iB6ta = parcelRequire("iB6ta");

var $dID0y = parcelRequire("dID0y");

var $lT4NS = parcelRequire("lT4NS");

var $1vtEw = parcelRequire("1vtEw");

var $2LSBy = parcelRequire("2LSBy");

var $6Sny4 = parcelRequire("6Sny4");

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("7hd9c");
parcelRequire("cIiSk");
parcelRequire("kBR14");
parcelRequire("hskHC");
parcelRequire("bmZFS");
parcelRequire("2yZD4");
parcelRequire("fbI2I");
parcelRequire("7Z9E2");
parcelRequire("996dd");
parcelRequire("getAx");
parcelRequire("eSrDz");
parcelRequire("ayOPU");
parcelRequire("i89Hq");
parcelRequire("j6weT");
parcelRequire("35MHU");
Object.assign((0, $gaK1V.default), {
    analyze: $cgHIr.analyze,
    average: $8UmTp.default,
    bezier: $9u72g.default,
    blend: $hKhjA.default,
    brewer: $6Sny4.default,
    Color: $e7KSJ.default,
    colors: $2LSBy.default,
    contrast: $5BDZu.default,
    contrastAPCA: $iM4ga.default,
    cubehelix: $jpCQy.default,
    deltaE: $xkLDw.default,
    distance: $iB6ta.default,
    input: $lT4NS.default,
    interpolate: (0, $dvq8W.default),
    limits: $cgHIr.limits,
    mix: $dvq8W.default,
    random: $eIGWI.default,
    scale: $4ZQS0.default,
    scales: $1vtEw.default,
    valid: $dID0y.default
});
var $81cbbacd84e74401$export$2e2bcd8739ae039 = (0, $gaK1V.default);

});
parcelRegister("gaK1V", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc61491d55326ff6$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");

var $6QlZc = parcelRequire("6QlZc");
const $bc61491d55326ff6$var$chroma = (...args)=>{
    return new (0, $e7KSJ.default)(...args);
};
$bc61491d55326ff6$var$chroma.version = (0, $6QlZc.version);
var $bc61491d55326ff6$export$2e2bcd8739ae039 = $bc61491d55326ff6$var$chroma;

});
parcelRegister("e7KSJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a48615e4fc00386b$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $8TO5X = parcelRequire("8TO5X");
var $7ElX1 = parcelRequire("7ElX1");
var $hMEmV = parcelRequire("hMEmV");

var $lT4NS = parcelRequire("lT4NS");
class $a48615e4fc00386b$var$Color {
    constructor(...args){
        const me = this;
        if ((0, $hMEmV.default)(args[0]) === 'object' && args[0].constructor && args[0].constructor === this.constructor) // the argument is already a Color instance
        return args[0];
        // last argument could be the mode
        let mode = (0, $7ElX1.default)(args);
        let autodetect = false;
        if (!mode) {
            autodetect = true;
            if (!(0, $lT4NS.default).sorted) {
                (0, $lT4NS.default).autodetect = (0, $lT4NS.default).autodetect.sort((a, b)=>b.p - a.p);
                (0, $lT4NS.default).sorted = true;
            }
            // auto-detect format
            for (let chk of (0, $lT4NS.default).autodetect){
                mode = chk.test(...args);
                if (mode) break;
            }
        }
        if ((0, $lT4NS.default).format[mode]) {
            const rgb = (0, $lT4NS.default).format[mode].apply(null, autodetect ? args : args.slice(0, -1));
            me._rgb = (0, $8TO5X.default)(rgb);
        } else throw new Error('unknown format: ' + args);
        // add alpha channel
        if (me._rgb.length === 3) me._rgb.push(1);
    }
    toString() {
        if ((0, $hMEmV.default)(this.hex) == 'function') return this.hex();
        return `[${this._rgb.join(',')}]`;
    }
}
var $a48615e4fc00386b$export$2e2bcd8739ae039 = $a48615e4fc00386b$var$Color;

});
parcelRegister("i4gda", function(module, exports) {

$parcel$export(module.exports, "min", () => $0364fc9895a99d2c$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $0364fc9895a99d2c$export$8960430cfd85939f);
$parcel$export(module.exports, "rnd2", () => $0364fc9895a99d2c$export$c6d486233e29f7d1);
$parcel$export(module.exports, "rnd3", () => $0364fc9895a99d2c$export$6ed426801b9660b8);
$parcel$export(module.exports, "TWOPI", () => $0364fc9895a99d2c$export$af54f71c879f5ba9);
$parcel$export(module.exports, "PITHIRD", () => $0364fc9895a99d2c$export$e734282486210baf);
$parcel$export(module.exports, "DEG2RAD", () => $0364fc9895a99d2c$export$460c4029b1a54a2e);
$parcel$export(module.exports, "RAD2DEG", () => $0364fc9895a99d2c$export$914076c8150813e5);
$parcel$export(module.exports, "reverse3", () => $0364fc9895a99d2c$export$d0e1128e52417073);
$parcel$export(module.exports, "clip_rgb", () => (parcelRequire("8TO5X")).default);
$parcel$export(module.exports, "limit", () => (parcelRequire("gb2Ug")).default);
$parcel$export(module.exports, "type", () => (parcelRequire("hMEmV")).default);
$parcel$export(module.exports, "unpack", () => (parcelRequire("43ZPL")).default);
$parcel$export(module.exports, "last", () => (parcelRequire("7ElX1")).default);

var $8TO5X = parcelRequire("8TO5X");

var $gb2Ug = parcelRequire("gb2Ug");

var $hMEmV = parcelRequire("hMEmV");

var $43ZPL = parcelRequire("43ZPL");

var $7ElX1 = parcelRequire("7ElX1");
const { PI: $0364fc9895a99d2c$export$6b5c1ceb16d01dc3, min: $0364fc9895a99d2c$export$96ec731ed4dcb222, max: $0364fc9895a99d2c$export$8960430cfd85939f } = Math;
const $0364fc9895a99d2c$export$c6d486233e29f7d1 = (a)=>Math.round(a * 100) / 100;
const $0364fc9895a99d2c$export$6ed426801b9660b8 = (a)=>Math.round(a * 100) / 100;
const $0364fc9895a99d2c$export$af54f71c879f5ba9 = $0364fc9895a99d2c$export$6b5c1ceb16d01dc3 * 2;
const $0364fc9895a99d2c$export$e734282486210baf = $0364fc9895a99d2c$export$6b5c1ceb16d01dc3 / 3;
const $0364fc9895a99d2c$export$460c4029b1a54a2e = $0364fc9895a99d2c$export$6b5c1ceb16d01dc3 / 180;
const $0364fc9895a99d2c$export$914076c8150813e5 = 180 / $0364fc9895a99d2c$export$6b5c1ceb16d01dc3;
/**
 * Reverse the first three elements of an array
 *
 * @param {any[]} arr
 * @returns {any[]}
 */ function $0364fc9895a99d2c$export$d0e1128e52417073(arr) {
    return [
        ...arr.slice(0, 3).reverse(),
        ...arr.slice(3)
    ];
}

});
parcelRegister("8TO5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $67aa519ab0061f26$export$2e2bcd8739ae039);

var $gb2Ug = parcelRequire("gb2Ug");
var $67aa519ab0061f26$export$2e2bcd8739ae039 = (rgb)=>{
    rgb._clipped = false;
    rgb._unclipped = rgb.slice(0);
    for(let i = 0; i <= 3; i++){
        if (i < 3) {
            if (rgb[i] < 0 || rgb[i] > 255) rgb._clipped = true;
            rgb[i] = (0, $gb2Ug.default)(rgb[i], 0, 255);
        } else if (i === 3) rgb[i] = (0, $gb2Ug.default)(rgb[i], 0, 1);
    }
    return rgb;
};

});
parcelRegister("gb2Ug", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc6fed995261efd6$export$2e2bcd8739ae039);
const { min: $bc6fed995261efd6$var$min, max: $bc6fed995261efd6$var$max } = Math;
var $bc6fed995261efd6$export$2e2bcd8739ae039 = (x, low = 0, high = 1)=>{
    return $bc6fed995261efd6$var$min($bc6fed995261efd6$var$max(low, x), high);
};

});


parcelRegister("hMEmV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf263bc72046187c$export$2e2bcd8739ae039);
// ported from jQuery's $.type
const $cf263bc72046187c$var$classToType = {};
for (let name of [
    'Boolean',
    'Number',
    'String',
    'Function',
    'Array',
    'Date',
    'RegExp',
    'Undefined',
    'Null'
])$cf263bc72046187c$var$classToType[`[object ${name}]`] = name.toLowerCase();
function $cf263bc72046187c$export$2e2bcd8739ae039(obj) {
    return $cf263bc72046187c$var$classToType[Object.prototype.toString.call(obj)] || 'object';
}

});

parcelRegister("43ZPL", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f57682b2b3fd0b6$export$2e2bcd8739ae039);

var $hMEmV = parcelRequire("hMEmV");
var $2f57682b2b3fd0b6$export$2e2bcd8739ae039 = (args, keyOrder = null)=>{
    // if called with more than 3 arguments, we return the arguments
    if (args.length >= 3) return Array.prototype.slice.call(args);
    // with less than 3 args we check if first arg is object
    // and use the keyOrder string to extract and sort properties
    if ((0, $hMEmV.default)(args[0]) == 'object' && keyOrder) return keyOrder.split('').filter((k)=>args[0][k] !== undefined).map((k)=>args[0][k]);
    // otherwise we just return the first argument
    // (which we suppose is an array of args)
    return args[0].slice(0);
};

});

parcelRegister("7ElX1", function(module, exports) {

$parcel$export(module.exports, "default", () => $591d4bdad7401082$export$2e2bcd8739ae039);

var $hMEmV = parcelRequire("hMEmV");
var $591d4bdad7401082$export$2e2bcd8739ae039 = (args)=>{
    if (args.length < 2) return null;
    const l = args.length - 1;
    if ((0, $hMEmV.default)(args[l]) == 'string') return args[l].toLowerCase();
    return null;
};

});


parcelRegister("lT4NS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fef275e9b9623611$export$2e2bcd8739ae039);
var $fef275e9b9623611$export$2e2bcd8739ae039 = {
    format: {},
    autodetect: []
};

});


parcelRegister("6QlZc", function(module, exports) {

$parcel$export(module.exports, "version", () => $4fb8a75d624eee90$export$83d89fbfd8236492);
// this gets updated automatically
const $4fb8a75d624eee90$export$83d89fbfd8236492 = '3.1.2';

});


parcelRegister("cF22K", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $2LSBy = parcelRequire("2LSBy");

var $2BpKe = parcelRequire("2BpKe");

var $eL95G = parcelRequire("eL95G");
(0, $e7KSJ.default).prototype.name = function() {
    const hex = (0, $eL95G.default)(this._rgb, 'rgb');
    for (let n of Object.keys((0, $2LSBy.default))){
        if ((0, $2LSBy.default)[n] === hex) return n.toLowerCase();
    }
    return hex;
};
(0, $lT4NS.default).format.named = (name)=>{
    name = name.toLowerCase();
    if ((0, $2LSBy.default)[name]) return (0, $2BpKe.default)((0, $2LSBy.default)[name]);
    throw new Error('unknown color name: ' + name);
};
(0, $lT4NS.default).autodetect.push({
    p: 5,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $hMEmV.default)(h) === 'string' && (0, $2LSBy.default)[h.toLowerCase()]) return 'named';
    }
});

});
parcelRegister("2LSBy", function(module, exports) {

$parcel$export(module.exports, "default", () => $204a53f04c74292a$export$2e2bcd8739ae039);
/**
	X11 color names

	http://www.w3.org/TR/css3-color/#svg-color
*/ const $204a53f04c74292a$var$w3cx11 = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    gold: '#ffd700',
    goldenrod: '#daa520',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    laserlemon: '#ffff54',
    lavender: '#e6e6fa',
    lavenderblush: '#fff0f5',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrod: '#fafad2',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    maroon2: '#7f0000',
    maroon3: '#b03060',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    purple2: '#7f007f',
    purple3: '#a020f0',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32'
};
var $204a53f04c74292a$export$2e2bcd8739ae039 = $204a53f04c74292a$var$w3cx11;

});

parcelRegister("2BpKe", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e5301da89c3e9c8$export$2e2bcd8739ae039);
const $1e5301da89c3e9c8$var$RE_HEX = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
const $1e5301da89c3e9c8$var$RE_HEXA = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/;
const $1e5301da89c3e9c8$var$hex2rgb = (hex)=>{
    if (hex.match($1e5301da89c3e9c8$var$RE_HEX)) {
        // remove optional leading #
        if (hex.length === 4 || hex.length === 7) hex = hex.substr(1);
        // expand short-notation to full six-digit
        if (hex.length === 3) {
            hex = hex.split('');
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        const u = parseInt(hex, 16);
        const r = u >> 16;
        const g = u >> 8 & 0xff;
        const b = u & 0xff;
        return [
            r,
            g,
            b,
            1
        ];
    }
    // match rgba hex format, eg #FF000077
    if (hex.match($1e5301da89c3e9c8$var$RE_HEXA)) {
        if (hex.length === 5 || hex.length === 9) // remove optional leading #
        hex = hex.substr(1);
        // expand short-notation to full eight-digit
        if (hex.length === 4) {
            hex = hex.split('');
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
        }
        const u = parseInt(hex, 16);
        const r = u >> 24 & 0xff;
        const g = u >> 16 & 0xff;
        const b = u >> 8 & 0xff;
        const a = Math.round((u & 0xff) / 0xff * 100) / 100;
        return [
            r,
            g,
            b,
            a
        ];
    }
    // we used to check for css colors here
    // if _input.css? and rgb = _input.css hex
    //     return rgb
    throw new Error(`unknown hex color: ${hex}`);
};
var $1e5301da89c3e9c8$export$2e2bcd8739ae039 = $1e5301da89c3e9c8$var$hex2rgb;

});

parcelRegister("eL95G", function(module, exports) {

$parcel$export(module.exports, "default", () => $abec81afd0345325$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $7ElX1 = parcelRequire("7ElX1");
var $43ZPL = parcelRequire("43ZPL");
const { round: $abec81afd0345325$var$round } = Math;
const $abec81afd0345325$var$rgb2hex = (...args)=>{
    let [r, g, b, a] = (0, $43ZPL.default)(args, 'rgba');
    let mode = (0, $7ElX1.default)(args) || 'auto';
    if (a === undefined) a = 1;
    if (mode === 'auto') mode = a < 1 ? 'rgba' : 'rgb';
    r = $abec81afd0345325$var$round(r);
    g = $abec81afd0345325$var$round(g);
    b = $abec81afd0345325$var$round(b);
    const u = r << 16 | g << 8 | b;
    let str = '000000' + u.toString(16); //#.toUpperCase();
    str = str.substr(str.length - 6);
    let hxa = '0' + $abec81afd0345325$var$round(a * 255).toString(16);
    hxa = hxa.substr(hxa.length - 2);
    switch(mode.toLowerCase()){
        case 'rgba':
            return `#${str}${hxa}`;
        case 'argb':
            return `#${hxa}${str}`;
        default:
            return `#${str}`;
    }
};
var $abec81afd0345325$export$2e2bcd8739ae039 = $abec81afd0345325$var$rgb2hex;

});


parcelRegister("iygXn", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
(0, $e7KSJ.default).prototype.alpha = function(a, mutate = false) {
    if (a !== undefined && (0, $hMEmV.default)(a) === 'number') {
        if (mutate) {
            this._rgb[3] = a;
            return this;
        }
        return new (0, $e7KSJ.default)([
            this._rgb[0],
            this._rgb[1],
            this._rgb[2],
            a
        ], 'rgb');
    }
    return this._rgb[3];
};

});

parcelRegister("QEjK4", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
(0, $e7KSJ.default).prototype.clipped = function() {
    return this._rgb._clipped || false;
};

});

parcelRegister("kytU9", function(module, exports) {
parcelRequire("996dd");

var $e7KSJ = parcelRequire("e7KSJ");

var $8weUB = parcelRequire("8weUB");
(0, $e7KSJ.default).prototype.darken = function(amount = 1) {
    const me = this;
    const lab = me.lab();
    lab[0] -= (0, $8weUB.default).Kn * amount;
    return new (0, $e7KSJ.default)(lab, 'lab').alpha(me.alpha(), true);
};
(0, $e7KSJ.default).prototype.brighten = function(amount = 1) {
    return this.darken(-amount);
};
(0, $e7KSJ.default).prototype.darker = (0, $e7KSJ.default).prototype.darken;
(0, $e7KSJ.default).prototype.brighter = (0, $e7KSJ.default).prototype.brighten;

});
parcelRegister("996dd", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $jenZn = parcelRequire("jenZn");

var $luvnN = parcelRequire("luvnN");

var $8weUB = parcelRequire("8weUB");
(0, $e7KSJ.default).prototype.lab = function() {
    return (0, $luvnN.default)(this._rgb);
};
const $6a89c5f2d5780cd3$export$c83fb8f9027a6338 = (...args)=>new (0, $e7KSJ.default)(...args, 'lab');
Object.assign((0, $gaK1V.default), {
    lab: $6a89c5f2d5780cd3$export$c83fb8f9027a6338,
    getLabWhitePoint: $8weUB.getLabWhitePoint,
    setLabWhitePoint: $8weUB.setLabWhitePoint
});
(0, $lT4NS.default).format.lab = (0, $jenZn.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'lab');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'lab';
    }
});

});
parcelRegister("jenZn", function(module, exports) {

$parcel$export(module.exports, "xyz2rgb", () => $e001eed8d7ff32c4$export$22cbacf088b0f5c6);
$parcel$export(module.exports, "default", () => $e001eed8d7ff32c4$export$2e2bcd8739ae039);

var $8weUB = parcelRequire("8weUB");
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
/*
 * L* [0..100]
 * a [-100..100]
 * b [-100..100]
 */ const $e001eed8d7ff32c4$var$lab2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'lab');
    const [L, a, b] = args;
    const [x, y, z] = $e001eed8d7ff32c4$var$lab2xyz(L, a, b);
    const [r, g, b_] = $e001eed8d7ff32c4$export$22cbacf088b0f5c6(x, y, z);
    return [
        r,
        g,
        b_,
        args.length > 3 ? args[3] : 1
    ];
};
const $e001eed8d7ff32c4$var$lab2xyz = (L, a, b)=>{
    const { kE: kE, kK: kK, kKE: kKE, Xn: Xn, Yn: Yn, Zn: Zn } = (0, $8weUB.default);
    const fy = (L + 16.0) / 116.0;
    const fx = 0.002 * a + fy;
    const fz = fy - 0.005 * b;
    const fx3 = fx * fx * fx;
    const fz3 = fz * fz * fz;
    const xr = fx3 > kE ? fx3 : (116.0 * fx - 16.0) / kK;
    const yr = L > kKE ? Math.pow((L + 16.0) / 116.0, 3.0) : L / kK;
    const zr = fz3 > kE ? fz3 : (116.0 * fz - 16.0) / kK;
    const x = xr * Xn;
    const y = yr * Yn;
    const z = zr * Zn;
    return [
        x,
        y,
        z
    ];
};
const $e001eed8d7ff32c4$var$compand = (linear)=>{
    /* sRGB */ const sign = Math.sign(linear);
    linear = Math.abs(linear);
    return (linear <= 0.0031308 ? linear * 12.92 : 1.055 * Math.pow(linear, 1.0 / 2.4) - 0.055) * sign;
};
const $e001eed8d7ff32c4$export$22cbacf088b0f5c6 = (x, y, z)=>{
    const { MtxAdaptMa: MtxAdaptMa, MtxAdaptMaI: MtxAdaptMaI, MtxXYZ2RGB: MtxXYZ2RGB, RefWhiteRGB: RefWhiteRGB, Xn: Xn, Yn: Yn, Zn: Zn } = (0, $8weUB.default);
    const As = Xn * MtxAdaptMa.m00 + Yn * MtxAdaptMa.m10 + Zn * MtxAdaptMa.m20;
    const Bs = Xn * MtxAdaptMa.m01 + Yn * MtxAdaptMa.m11 + Zn * MtxAdaptMa.m21;
    const Cs = Xn * MtxAdaptMa.m02 + Yn * MtxAdaptMa.m12 + Zn * MtxAdaptMa.m22;
    const Ad = RefWhiteRGB.X * MtxAdaptMa.m00 + RefWhiteRGB.Y * MtxAdaptMa.m10 + RefWhiteRGB.Z * MtxAdaptMa.m20;
    const Bd = RefWhiteRGB.X * MtxAdaptMa.m01 + RefWhiteRGB.Y * MtxAdaptMa.m11 + RefWhiteRGB.Z * MtxAdaptMa.m21;
    const Cd = RefWhiteRGB.X * MtxAdaptMa.m02 + RefWhiteRGB.Y * MtxAdaptMa.m12 + RefWhiteRGB.Z * MtxAdaptMa.m22;
    const X1 = (x * MtxAdaptMa.m00 + y * MtxAdaptMa.m10 + z * MtxAdaptMa.m20) * (Ad / As);
    const Y1 = (x * MtxAdaptMa.m01 + y * MtxAdaptMa.m11 + z * MtxAdaptMa.m21) * (Bd / Bs);
    const Z1 = (x * MtxAdaptMa.m02 + y * MtxAdaptMa.m12 + z * MtxAdaptMa.m22) * (Cd / Cs);
    const X2 = X1 * MtxAdaptMaI.m00 + Y1 * MtxAdaptMaI.m10 + Z1 * MtxAdaptMaI.m20;
    const Y2 = X1 * MtxAdaptMaI.m01 + Y1 * MtxAdaptMaI.m11 + Z1 * MtxAdaptMaI.m21;
    const Z2 = X1 * MtxAdaptMaI.m02 + Y1 * MtxAdaptMaI.m12 + Z1 * MtxAdaptMaI.m22;
    const r = $e001eed8d7ff32c4$var$compand(X2 * MtxXYZ2RGB.m00 + Y2 * MtxXYZ2RGB.m10 + Z2 * MtxXYZ2RGB.m20);
    const g = $e001eed8d7ff32c4$var$compand(X2 * MtxXYZ2RGB.m01 + Y2 * MtxXYZ2RGB.m11 + Z2 * MtxXYZ2RGB.m21);
    const b = $e001eed8d7ff32c4$var$compand(X2 * MtxXYZ2RGB.m02 + Y2 * MtxXYZ2RGB.m12 + Z2 * MtxXYZ2RGB.m22);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
var $e001eed8d7ff32c4$export$2e2bcd8739ae039 = $e001eed8d7ff32c4$var$lab2rgb;

});
parcelRegister("8weUB", function(module, exports) {

$parcel$export(module.exports, "default", () => $633ce119b108995d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "setLabWhitePoint", () => $633ce119b108995d$export$23f27f4cae67c045);
$parcel$export(module.exports, "getLabWhitePoint", () => $633ce119b108995d$export$922c3afbcbc31cb3);
const $633ce119b108995d$var$labConstants = {
    // Corresponds roughly to RGB brighter/darker
    Kn: 18,
    // D65 standard referent
    labWhitePoint: 'd65',
    Xn: 0.95047,
    Yn: 1,
    Zn: 1.08883,
    t0: 0.137931034,
    t1: 0.206896552,
    t2: 0.12841855,
    t3: 0.008856452,
    kE: 216.0 / 24389.0,
    kKE: 8.0,
    kK: 24389.0 / 27.0,
    RefWhiteRGB: {
        // sRGB
        X: 0.95047,
        Y: 1,
        Z: 1.08883
    },
    MtxRGB2XYZ: {
        m00: 0.4124564390896922,
        m01: 0.21267285140562253,
        m02: 0.0193338955823293,
        m10: 0.357576077643909,
        m11: 0.715152155287818,
        m12: 0.11919202588130297,
        m20: 0.18043748326639894,
        m21: 0.07217499330655958,
        m22: 0.9503040785363679
    },
    MtxXYZ2RGB: {
        m00: 3.2404541621141045,
        m01: -0.9692660305051868,
        m02: 0.055643430959114726,
        m10: -1.5371385127977166,
        m11: 1.8760108454466942,
        m12: -0.2040259135167538,
        m20: -0.498531409556016,
        m21: 0.041556017530349834,
        m22: 1.0572251882231791
    },
    // used in rgb2xyz
    As: 0.9414285350000001,
    Bs: 1.040417467,
    Cs: 1.089532651,
    MtxAdaptMa: {
        m00: 0.8951,
        m01: -0.7502,
        m02: 0.0389,
        m10: 0.2664,
        m11: 1.7135,
        m12: -0.0685,
        m20: -0.1614,
        m21: 0.0367,
        m22: 1.0296
    },
    MtxAdaptMaI: {
        m00: 0.9869929054667123,
        m01: 0.43230526972339456,
        m02: -0.008528664575177328,
        m10: -0.14705425642099013,
        m11: 0.5183602715367776,
        m12: 0.04004282165408487,
        m20: 0.15996265166373125,
        m21: 0.0492912282128556,
        m22: 0.9684866957875502
    }
};
var $633ce119b108995d$export$2e2bcd8739ae039 = $633ce119b108995d$var$labConstants;
// taken from https://de.mathworks.com/help/images/ref/whitepoint.html
const $633ce119b108995d$var$ILLUMINANTS = new Map([
    // ASTM E308-01
    [
        'a',
        [
            1.0985,
            0.35585
        ]
    ],
    // Wyszecki & Stiles, p. 769
    [
        'b',
        [
            1.0985,
            0.35585
        ]
    ],
    // C ASTM E308-01
    [
        'c',
        [
            0.98074,
            1.18232
        ]
    ],
    // D50 (ASTM E308-01)
    [
        'd50',
        [
            0.96422,
            0.82521
        ]
    ],
    // D55 (ASTM E308-01)
    [
        'd55',
        [
            0.95682,
            0.92149
        ]
    ],
    // D65 (ASTM E308-01)
    [
        'd65',
        [
            0.95047,
            1.08883
        ]
    ],
    // E (ASTM E308-01)
    [
        'e',
        [
            1,
            1,
            1
        ]
    ],
    // F2 (ASTM E308-01)
    [
        'f2',
        [
            0.99186,
            0.67393
        ]
    ],
    // F7 (ASTM E308-01)
    [
        'f7',
        [
            0.95041,
            1.08747
        ]
    ],
    // F11 (ASTM E308-01)
    [
        'f11',
        [
            1.00962,
            0.6435
        ]
    ],
    [
        'icc',
        [
            0.96422,
            0.82521
        ]
    ]
]);
function $633ce119b108995d$export$23f27f4cae67c045(name) {
    const ill = $633ce119b108995d$var$ILLUMINANTS.get(String(name).toLowerCase());
    if (!ill) throw new Error('unknown Lab illuminant ' + name);
    $633ce119b108995d$var$labConstants.labWhitePoint = name;
    $633ce119b108995d$var$labConstants.Xn = ill[0];
    $633ce119b108995d$var$labConstants.Zn = ill[1];
}
function $633ce119b108995d$export$922c3afbcbc31cb3() {
    return $633ce119b108995d$var$labConstants.labWhitePoint;
}

});


parcelRegister("luvnN", function(module, exports) {

$parcel$export(module.exports, "rgb2xyz", () => $fa54be4b38a62f7b$export$fca6d690f89f5907);
$parcel$export(module.exports, "default", () => $fa54be4b38a62f7b$export$2e2bcd8739ae039);

var $8weUB = parcelRequire("8weUB");
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $fa54be4b38a62f7b$var$rgb2lab = (...args)=>{
    const [r, g, b, ...rest] = (0, $43ZPL.default)(args, 'rgb');
    const [x, y, z] = $fa54be4b38a62f7b$export$fca6d690f89f5907(r, g, b);
    const [L, a, b_] = $fa54be4b38a62f7b$var$xyz2lab(x, y, z);
    return [
        L,
        a,
        b_,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
function $fa54be4b38a62f7b$var$xyz2lab(x, y, z) {
    const { Xn: Xn, Yn: Yn, Zn: Zn, kE: kE, kK: kK } = (0, $8weUB.default);
    const xr = x / Xn;
    const yr = y / Yn;
    const zr = z / Zn;
    const fx = xr > kE ? Math.pow(xr, 1.0 / 3.0) : (kK * xr + 16.0) / 116.0;
    const fy = yr > kE ? Math.pow(yr, 1.0 / 3.0) : (kK * yr + 16.0) / 116.0;
    const fz = zr > kE ? Math.pow(zr, 1.0 / 3.0) : (kK * zr + 16.0) / 116.0;
    return [
        116.0 * fy - 16.0,
        500.0 * (fx - fy),
        200.0 * (fy - fz)
    ];
}
function $fa54be4b38a62f7b$var$gammaAdjustSRGB(companded) {
    const sign = Math.sign(companded);
    companded = Math.abs(companded);
    const linear = companded <= 0.04045 ? companded / 12.92 : Math.pow((companded + 0.055) / 1.055, 2.4);
    return linear * sign;
}
const $fa54be4b38a62f7b$export$fca6d690f89f5907 = (r, g, b)=>{
    // normalize and gamma adjust
    r = $fa54be4b38a62f7b$var$gammaAdjustSRGB(r / 255);
    g = $fa54be4b38a62f7b$var$gammaAdjustSRGB(g / 255);
    b = $fa54be4b38a62f7b$var$gammaAdjustSRGB(b / 255);
    const { MtxRGB2XYZ: MtxRGB2XYZ, MtxAdaptMa: MtxAdaptMa, MtxAdaptMaI: MtxAdaptMaI, Xn: Xn, Yn: Yn, Zn: Zn, As: As, Bs: Bs, Cs: Cs } = (0, $8weUB.default);
    let x = r * MtxRGB2XYZ.m00 + g * MtxRGB2XYZ.m10 + b * MtxRGB2XYZ.m20;
    let y = r * MtxRGB2XYZ.m01 + g * MtxRGB2XYZ.m11 + b * MtxRGB2XYZ.m21;
    let z = r * MtxRGB2XYZ.m02 + g * MtxRGB2XYZ.m12 + b * MtxRGB2XYZ.m22;
    const Ad = Xn * MtxAdaptMa.m00 + Yn * MtxAdaptMa.m10 + Zn * MtxAdaptMa.m20;
    const Bd = Xn * MtxAdaptMa.m01 + Yn * MtxAdaptMa.m11 + Zn * MtxAdaptMa.m21;
    const Cd = Xn * MtxAdaptMa.m02 + Yn * MtxAdaptMa.m12 + Zn * MtxAdaptMa.m22;
    let X = x * MtxAdaptMa.m00 + y * MtxAdaptMa.m10 + z * MtxAdaptMa.m20;
    let Y = x * MtxAdaptMa.m01 + y * MtxAdaptMa.m11 + z * MtxAdaptMa.m21;
    let Z = x * MtxAdaptMa.m02 + y * MtxAdaptMa.m12 + z * MtxAdaptMa.m22;
    X *= Ad / As;
    Y *= Bd / Bs;
    Z *= Cd / Cs;
    x = X * MtxAdaptMaI.m00 + Y * MtxAdaptMaI.m10 + Z * MtxAdaptMaI.m20;
    y = X * MtxAdaptMaI.m01 + Y * MtxAdaptMaI.m11 + Z * MtxAdaptMaI.m21;
    z = X * MtxAdaptMaI.m02 + Y * MtxAdaptMaI.m12 + Z * MtxAdaptMaI.m22;
    return [
        x,
        y,
        z
    ];
};
var $fa54be4b38a62f7b$export$2e2bcd8739ae039 = $fa54be4b38a62f7b$var$rgb2lab;

});



parcelRegister("kn0Pa", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
(0, $e7KSJ.default).prototype.get = function(mc) {
    const [mode, channel] = mc.split('.');
    const src = this[mode]();
    if (channel) {
        const i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
        if (i > -1) return src[i];
        throw new Error(`unknown channel ${channel} in mode ${mode}`);
    } else return src;
};

});

parcelRegister("hDPZe", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
const { pow: $cd7e67a33d66dde3$var$pow } = Math;
const $cd7e67a33d66dde3$var$EPS = 1e-7;
const $cd7e67a33d66dde3$var$MAX_ITER = 20;
(0, $e7KSJ.default).prototype.luminance = function(lum, mode = 'rgb') {
    if (lum !== undefined && (0, $hMEmV.default)(lum) === 'number') {
        if (lum === 0) // return pure black
        return new (0, $e7KSJ.default)([
            0,
            0,
            0,
            this._rgb[3]
        ], 'rgb');
        if (lum === 1) // return pure white
        return new (0, $e7KSJ.default)([
            255,
            255,
            255,
            this._rgb[3]
        ], 'rgb');
        // compute new color using...
        let cur_lum = this.luminance();
        let max_iter = $cd7e67a33d66dde3$var$MAX_ITER;
        const test = (low, high)=>{
            const mid = low.interpolate(high, 0.5, mode);
            const lm = mid.luminance();
            if (Math.abs(lum - lm) < $cd7e67a33d66dde3$var$EPS || !max_iter--) // close enough
            return mid;
            return lm > lum ? test(low, mid) : test(mid, high);
        };
        const rgb = (cur_lum > lum ? test(new (0, $e7KSJ.default)([
            0,
            0,
            0
        ]), this) : test(this, new (0, $e7KSJ.default)([
            255,
            255,
            255
        ]))).rgb();
        return new (0, $e7KSJ.default)([
            ...rgb,
            this._rgb[3]
        ]);
    }
    return $cd7e67a33d66dde3$var$rgb2luminance(...this._rgb.slice(0, 3));
};
const $cd7e67a33d66dde3$var$rgb2luminance = (r, g, b)=>{
    // relative luminance
    // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
    r = $cd7e67a33d66dde3$var$luminance_x(r);
    g = $cd7e67a33d66dde3$var$luminance_x(g);
    b = $cd7e67a33d66dde3$var$luminance_x(b);
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
const $cd7e67a33d66dde3$var$luminance_x = (x)=>{
    x /= 255;
    return x <= 0.03928 ? x / 12.92 : $cd7e67a33d66dde3$var$pow((x + 0.055) / 1.055, 2.4);
};

});

parcelRegister("eDzBg", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $dvq8W = parcelRequire("dvq8W");
(0, $e7KSJ.default).prototype.mix = (0, $e7KSJ.default).prototype.interpolate = function(col2, f = 0.5, ...rest) {
    return (0, $dvq8W.default)(this, col2, f, ...rest);
};

});
parcelRegister("dvq8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d52731f6acc42df$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $5flPP = parcelRequire("5flPP");
var $9d52731f6acc42df$export$2e2bcd8739ae039 = (col1, col2, f = 0.5, ...rest)=>{
    let mode = rest[0] || 'lrgb';
    if (!(0, $5flPP.default)[mode] && !rest.length) // fall back to the first supported mode
    mode = Object.keys((0, $5flPP.default))[0];
    if (!(0, $5flPP.default)[mode]) throw new Error(`interpolation mode ${mode} is not defined`);
    if ((0, $hMEmV.default)(col1) !== 'object') col1 = new (0, $e7KSJ.default)(col1);
    if ((0, $hMEmV.default)(col2) !== 'object') col2 = new (0, $e7KSJ.default)(col2);
    return (0, $5flPP.default)[mode](col1, col2, f).alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
};

});
parcelRegister("5flPP", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d1f4a69308124ed$export$2e2bcd8739ae039);
var $3d1f4a69308124ed$export$2e2bcd8739ae039 = {};

});



parcelRegister("7pAyc", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
(0, $e7KSJ.default).prototype.premultiply = function(mutate = false) {
    const rgb = this._rgb;
    const a = rgb[3];
    if (mutate) {
        this._rgb = [
            rgb[0] * a,
            rgb[1] * a,
            rgb[2] * a,
            a
        ];
        return this;
    } else return new (0, $e7KSJ.default)([
        rgb[0] * a,
        rgb[1] * a,
        rgb[2] * a,
        a
    ], 'rgb');
};

});

parcelRegister("kXega", function(module, exports) {
parcelRequire("getAx");

var $e7KSJ = parcelRequire("e7KSJ");

var $8weUB = parcelRequire("8weUB");
(0, $e7KSJ.default).prototype.saturate = function(amount = 1) {
    const me = this;
    const lch = me.lch();
    lch[1] += (0, $8weUB.default).Kn * amount;
    if (lch[1] < 0) lch[1] = 0;
    return new (0, $e7KSJ.default)(lch, 'lch').alpha(me.alpha(), true);
};
(0, $e7KSJ.default).prototype.desaturate = function(amount = 1) {
    return this.saturate(-amount);
};

});
parcelRegister("getAx", function(module, exports) {

var $i4gda = parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $g4jd5 = parcelRequire("g4jd5");

var $c2Ykn = parcelRequire("c2Ykn");

var $jSfgf = parcelRequire("jSfgf");
(0, $e7KSJ.default).prototype.lch = function() {
    return (0, $jSfgf.default)(this._rgb);
};
(0, $e7KSJ.default).prototype.hcl = function() {
    return (0, $i4gda.reverse3)((0, $jSfgf.default)(this._rgb));
};
const $bd14e7c45dd3e1a2$export$5a21418738164530 = (...args)=>new (0, $e7KSJ.default)(...args, 'lch');
const $bd14e7c45dd3e1a2$export$d0e870ba50062ff1 = (...args)=>new (0, $e7KSJ.default)(...args, 'hcl');
Object.assign((0, $gaK1V.default), {
    lch: $bd14e7c45dd3e1a2$export$5a21418738164530,
    hcl: $bd14e7c45dd3e1a2$export$d0e870ba50062ff1
});
(0, $lT4NS.default).format.lch = (0, $g4jd5.default);
(0, $lT4NS.default).format.hcl = (0, $c2Ykn.default);
[
    'lch',
    'hcl'
].forEach((m)=>(0, $lT4NS.default).autodetect.push({
        p: 2,
        test: (...args)=>{
            args = (0, $43ZPL.default)(args, m);
            if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return m;
        }
    }));

});
parcelRegister("g4jd5", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb2bebced39c863d$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $d6n2X = parcelRequire("d6n2X");

var $jenZn = parcelRequire("jenZn");
const $bb2bebced39c863d$var$lch2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'lch');
    const [l, c, h] = args;
    const [L, a, b_] = (0, $d6n2X.default)(l, c, h);
    const [r, g, b] = (0, $jenZn.default)(L, a, b_);
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $bb2bebced39c863d$export$2e2bcd8739ae039 = $bb2bebced39c863d$var$lch2rgb;

});
parcelRegister("d6n2X", function(module, exports) {

$parcel$export(module.exports, "default", () => $989db6829fcafd4a$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { sin: $989db6829fcafd4a$var$sin, cos: $989db6829fcafd4a$var$cos } = Math;
const $989db6829fcafd4a$var$lch2lab = (...args)=>{
    /*
    Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
    These formulas were invented by David Dalrymple to obtain maximum contrast without going
    out of gamut if the parameters are in the range 0-1.

    A saturation multiplier was added by Gregor Aisch
    */ let [l, c, h] = (0, $43ZPL.default)(args, 'lch');
    if (isNaN(h)) h = 0;
    h = h * (0, $i4gda.DEG2RAD);
    return [
        l,
        $989db6829fcafd4a$var$cos(h) * c,
        $989db6829fcafd4a$var$sin(h) * c
    ];
};
var $989db6829fcafd4a$export$2e2bcd8739ae039 = $989db6829fcafd4a$var$lch2lab;

});


parcelRegister("c2Ykn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c5477bbf42a48d0$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $g4jd5 = parcelRequire("g4jd5");
const $8c5477bbf42a48d0$var$hcl2rgb = (...args)=>{
    const hcl = (0, $i4gda.reverse3)((0, $43ZPL.default)(args, 'hcl'));
    return (0, $g4jd5.default)(...hcl);
};
var $8c5477bbf42a48d0$export$2e2bcd8739ae039 = $8c5477bbf42a48d0$var$hcl2rgb;

});

parcelRegister("jSfgf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e77ee5fe83442dbf$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $luvnN = parcelRequire("luvnN");

var $36WLn = parcelRequire("36WLn");
const $e77ee5fe83442dbf$var$rgb2lch = (...args)=>{
    const [r, g, b, ...rest] = (0, $43ZPL.default)(args, 'rgb');
    const [l, a, b_] = (0, $luvnN.default)(r, g, b);
    const [L, c, h] = (0, $36WLn.default)(l, a, b_);
    return [
        L,
        c,
        h,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
var $e77ee5fe83442dbf$export$2e2bcd8739ae039 = $e77ee5fe83442dbf$var$rgb2lch;

});
parcelRegister("36WLn", function(module, exports) {

$parcel$export(module.exports, "default", () => $243f83c61b0760ca$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { sqrt: $243f83c61b0760ca$var$sqrt, atan2: $243f83c61b0760ca$var$atan2, round: $243f83c61b0760ca$var$round } = Math;
const $243f83c61b0760ca$var$lab2lch = (...args)=>{
    const [l, a, b] = (0, $43ZPL.default)(args, 'lab');
    const c = $243f83c61b0760ca$var$sqrt(a * a + b * b);
    let h = ($243f83c61b0760ca$var$atan2(b, a) * (0, $i4gda.RAD2DEG) + 360) % 360;
    if ($243f83c61b0760ca$var$round(c * 10000) === 0) h = Number.NaN;
    return [
        l,
        c,
        h
    ];
};
var $243f83c61b0760ca$export$2e2bcd8739ae039 = $243f83c61b0760ca$var$lab2lch;

});




parcelRegister("8P76D", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
(0, $e7KSJ.default).prototype.set = function(mc, value, mutate = false) {
    const [mode, channel] = mc.split('.');
    const src = this[mode]();
    if (channel) {
        const i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
        if (i > -1) {
            if ((0, $hMEmV.default)(value) == 'string') switch(value.charAt(0)){
                case '+':
                    src[i] += +value;
                    break;
                case '-':
                    src[i] += +value;
                    break;
                case '*':
                    src[i] *= +value.substr(1);
                    break;
                case '/':
                    src[i] /= +value.substr(1);
                    break;
                default:
                    src[i] = +value;
            }
            else if ((0, $hMEmV.default)(value) === 'number') src[i] = value;
            else throw new Error(`unsupported value for Color.set`);
            const out = new (0, $e7KSJ.default)(src, mode);
            if (mutate) {
                this._rgb = out._rgb;
                return this;
            }
            return out;
        }
        throw new Error(`unknown channel ${channel} in mode ${mode}`);
    } else return src;
};

});

parcelRegister("bEZjX", function(module, exports) {
parcelRequire("996dd");

var $e7KSJ = parcelRequire("e7KSJ");

var $dvq8W = parcelRequire("dvq8W");
(0, $e7KSJ.default).prototype.tint = function(f = 0.5, ...rest) {
    return (0, $dvq8W.default)(this, 'white', f, ...rest);
};
(0, $e7KSJ.default).prototype.shade = function(f = 0.5, ...rest) {
    return (0, $dvq8W.default)(this, 'black', f, ...rest);
};

});

parcelRegister("jywIV", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $5flPP = parcelRequire("5flPP");
const $e3ca93847035084a$var$rgb = (col1, col2, f)=>{
    const xyz0 = col1._rgb;
    const xyz1 = col2._rgb;
    return new (0, $e7KSJ.default)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'rgb');
};
// register interpolator
(0, $5flPP.default).rgb = $e3ca93847035084a$var$rgb;
var $e3ca93847035084a$export$2e2bcd8739ae039 = $e3ca93847035084a$var$rgb;

});

parcelRegister("4Zhp6", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $5flPP = parcelRequire("5flPP");
const { sqrt: $3a1a5bf678f2834b$var$sqrt, pow: $3a1a5bf678f2834b$var$pow } = Math;
const $3a1a5bf678f2834b$var$lrgb = (col1, col2, f)=>{
    const [x1, y1, z1] = col1._rgb;
    const [x2, y2, z2] = col2._rgb;
    return new (0, $e7KSJ.default)($3a1a5bf678f2834b$var$sqrt($3a1a5bf678f2834b$var$pow(x1, 2) * (1 - f) + $3a1a5bf678f2834b$var$pow(x2, 2) * f), $3a1a5bf678f2834b$var$sqrt($3a1a5bf678f2834b$var$pow(y1, 2) * (1 - f) + $3a1a5bf678f2834b$var$pow(y2, 2) * f), $3a1a5bf678f2834b$var$sqrt($3a1a5bf678f2834b$var$pow(z1, 2) * (1 - f) + $3a1a5bf678f2834b$var$pow(z2, 2) * f), 'rgb');
};
// register interpolator
(0, $5flPP.default).lrgb = $3a1a5bf678f2834b$var$lrgb;
var $3a1a5bf678f2834b$export$2e2bcd8739ae039 = $3a1a5bf678f2834b$var$lrgb;

});

parcelRegister("kMTGA", function(module, exports) {
parcelRequire("996dd");

var $5flPP = parcelRequire("5flPP");

var $e7KSJ = parcelRequire("e7KSJ");
const $f2237c656cb48337$var$lab = (col1, col2, f)=>{
    const xyz0 = col1.lab();
    const xyz1 = col2.lab();
    return new (0, $e7KSJ.default)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'lab');
};
// register interpolator
(0, $5flPP.default).lab = $f2237c656cb48337$var$lab;
var $f2237c656cb48337$export$2e2bcd8739ae039 = $f2237c656cb48337$var$lab;

});

parcelRegister("dkzY3", function(module, exports) {
parcelRequire("getAx");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $9b490b0c3a354cd6$var$lch = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'lch');
};
// register interpolator
(0, $5flPP.default).lch = $9b490b0c3a354cd6$var$lch;
(0, $5flPP.default).hcl = $9b490b0c3a354cd6$var$lch;
var $9b490b0c3a354cd6$export$2e2bcd8739ae039 = $9b490b0c3a354cd6$var$lch;

});
parcelRegister("9mSMN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d20aa787a33a4e5$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
var $6d20aa787a33a4e5$export$2e2bcd8739ae039 = (col1, col2, f, m)=>{
    let xyz0, xyz1;
    if (m === 'hsl') {
        xyz0 = col1.hsl();
        xyz1 = col2.hsl();
    } else if (m === 'hsv') {
        xyz0 = col1.hsv();
        xyz1 = col2.hsv();
    } else if (m === 'hcg') {
        xyz0 = col1.hcg();
        xyz1 = col2.hcg();
    } else if (m === 'hsi') {
        xyz0 = col1.hsi();
        xyz1 = col2.hsi();
    } else if (m === 'lch' || m === 'hcl') {
        m = 'hcl';
        xyz0 = col1.hcl();
        xyz1 = col2.hcl();
    } else if (m === 'oklch') {
        xyz0 = col1.oklch().reverse();
        xyz1 = col2.oklch().reverse();
    }
    let hue0, hue1, sat0, sat1, lbv0, lbv1;
    if (m.substr(0, 1) === 'h' || m === 'oklch') {
        [hue0, sat0, lbv0] = xyz0;
        [hue1, sat1, lbv1] = xyz1;
    }
    let sat, hue, lbv, dh;
    if (!isNaN(hue0) && !isNaN(hue1)) {
        // both colors have hue
        if (hue1 > hue0 && hue1 - hue0 > 180) dh = hue1 - (hue0 + 360);
        else if (hue1 < hue0 && hue0 - hue1 > 180) dh = hue1 + 360 - hue0;
        else dh = hue1 - hue0;
        hue = hue0 + f * dh;
    } else if (!isNaN(hue0)) {
        hue = hue0;
        if ((lbv1 == 1 || lbv1 == 0) && m != 'hsv') sat = sat0;
    } else if (!isNaN(hue1)) {
        hue = hue1;
        if ((lbv0 == 1 || lbv0 == 0) && m != 'hsv') sat = sat1;
    } else hue = Number.NaN;
    if (sat === undefined) sat = sat0 + f * (sat1 - sat0);
    lbv = lbv0 + f * (lbv1 - lbv0);
    return m === 'oklch' ? new (0, $e7KSJ.default)([
        lbv,
        sat,
        hue
    ], m) : new (0, $e7KSJ.default)([
        hue,
        sat,
        lbv
    ], m);
};

});


parcelRegister("gac9F", function(module, exports) {
parcelRequire("eSrDz");

var $5flPP = parcelRequire("5flPP");

var $e7KSJ = parcelRequire("e7KSJ");
const $bc4702376fdac141$var$num = (col1, col2, f)=>{
    const c1 = col1.num();
    const c2 = col2.num();
    return new (0, $e7KSJ.default)(c1 + f * (c2 - c1), 'num');
};
// register interpolator
(0, $5flPP.default).num = $bc4702376fdac141$var$num;
var $bc4702376fdac141$export$2e2bcd8739ae039 = $bc4702376fdac141$var$num;

});
parcelRegister("eSrDz", function(module, exports) {

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $2UY7c = parcelRequire("2UY7c");

var $gkdTd = parcelRequire("gkdTd");
(0, $e7KSJ.default).prototype.num = function() {
    return (0, $gkdTd.default)(this._rgb);
};
const $ad4b8c09bf38a2ac$export$61cc6a0be4938a2a = (...args)=>new (0, $e7KSJ.default)(...args, 'num');
Object.assign((0, $gaK1V.default), {
    num: $ad4b8c09bf38a2ac$export$61cc6a0be4938a2a
});
(0, $lT4NS.default).format.num = (0, $2UY7c.default);
(0, $lT4NS.default).autodetect.push({
    p: 5,
    test: (...args)=>{
        if (args.length === 1 && (0, $hMEmV.default)(args[0]) === 'number' && args[0] >= 0 && args[0] <= 0xffffff) return 'num';
    }
});

});
parcelRegister("2UY7c", function(module, exports) {

$parcel$export(module.exports, "default", () => $21ff7154ad573d00$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
const $21ff7154ad573d00$var$num2rgb = (num)=>{
    if ((0, $hMEmV.default)(num) == 'number' && num >= 0 && num <= 0xffffff) {
        const r = num >> 16;
        const g = num >> 8 & 0xff;
        const b = num & 0xff;
        return [
            r,
            g,
            b,
            1
        ];
    }
    throw new Error('unknown num color: ' + num);
};
var $21ff7154ad573d00$export$2e2bcd8739ae039 = $21ff7154ad573d00$var$num2rgb;

});

parcelRegister("gkdTd", function(module, exports) {

$parcel$export(module.exports, "default", () => $be2949c4ecd598fe$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $be2949c4ecd598fe$var$rgb2num = (...args)=>{
    const [r, g, b] = (0, $43ZPL.default)(args, 'rgb');
    return (r << 16) + (g << 8) + b;
};
var $be2949c4ecd598fe$export$2e2bcd8739ae039 = $be2949c4ecd598fe$var$rgb2num;

});



parcelRegister("fWmFX", function(module, exports) {
parcelRequire("hskHC");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $b9addcb425bc1f3f$var$hcg = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'hcg');
};
// register interpolator
(0, $5flPP.default).hcg = $b9addcb425bc1f3f$var$hcg;
var $b9addcb425bc1f3f$export$2e2bcd8739ae039 = $b9addcb425bc1f3f$var$hcg;

});
parcelRegister("hskHC", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $lQebz = parcelRequire("lQebz");

var $66Tfa = parcelRequire("66Tfa");
(0, $e7KSJ.default).prototype.hcg = function() {
    return (0, $66Tfa.default)(this._rgb);
};
const $cb551c44f4ef224a$export$e588e1c8c259384c = (...args)=>new (0, $e7KSJ.default)(...args, 'hcg');
(0, $gaK1V.default).hcg = $cb551c44f4ef224a$export$e588e1c8c259384c;
(0, $lT4NS.default).format.hcg = (0, $lQebz.default);
(0, $lT4NS.default).autodetect.push({
    p: 1,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'hcg');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'hcg';
    }
});

});
parcelRegister("lQebz", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe697541ee37e71b$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { floor: $fe697541ee37e71b$var$floor } = Math;
/*
 * this is basically just HSV with some minor tweaks
 *
 * hue.. [0..360]
 * chroma .. [0..1]
 * grayness .. [0..1]
 */ const $fe697541ee37e71b$var$hcg2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'hcg');
    let [h, c, _g] = args;
    let r, g, b;
    _g = _g * 255;
    const _c = c * 255;
    if (c === 0) r = g = b = _g;
    else {
        if (h === 360) h = 0;
        if (h > 360) h -= 360;
        if (h < 0) h += 360;
        h /= 60;
        const i = $fe697541ee37e71b$var$floor(h);
        const f = h - i;
        const p = _g * (1 - c);
        const q = p + _c * (1 - f);
        const t = p + _c * f;
        const v = p + _c;
        switch(i){
            case 0:
                [r, g, b] = [
                    v,
                    t,
                    p
                ];
                break;
            case 1:
                [r, g, b] = [
                    q,
                    v,
                    p
                ];
                break;
            case 2:
                [r, g, b] = [
                    p,
                    v,
                    t
                ];
                break;
            case 3:
                [r, g, b] = [
                    p,
                    q,
                    v
                ];
                break;
            case 4:
                [r, g, b] = [
                    t,
                    p,
                    v
                ];
                break;
            case 5:
                [r, g, b] = [
                    v,
                    p,
                    q
                ];
                break;
        }
    }
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $fe697541ee37e71b$export$2e2bcd8739ae039 = $fe697541ee37e71b$var$hcg2rgb;

});

parcelRegister("66Tfa", function(module, exports) {

$parcel$export(module.exports, "default", () => $472e27dbd8c4997e$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $472e27dbd8c4997e$var$rgb2hcg = (...args)=>{
    const [r, g, b] = (0, $43ZPL.default)(args, 'rgb');
    const minRgb = (0, $i4gda.min)(r, g, b);
    const maxRgb = (0, $i4gda.max)(r, g, b);
    const delta = maxRgb - minRgb;
    const c = delta * 100 / 255;
    const _g = minRgb / (255 - delta) * 100;
    let h;
    if (delta === 0) h = Number.NaN;
    else {
        if (r === maxRgb) h = (g - b) / delta;
        if (g === maxRgb) h = 2 + (b - r) / delta;
        if (b === maxRgb) h = 4 + (r - g) / delta;
        h *= 60;
        if (h < 0) h += 360;
    }
    return [
        h,
        c,
        _g
    ];
};
var $472e27dbd8c4997e$export$2e2bcd8739ae039 = $472e27dbd8c4997e$var$rgb2hcg;

});



parcelRegister("3s82t", function(module, exports) {
parcelRequire("2yZD4");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $283a38fc382f3b9d$var$hsi = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'hsi');
};
// register interpolator
(0, $5flPP.default).hsi = $283a38fc382f3b9d$var$hsi;
var $283a38fc382f3b9d$export$2e2bcd8739ae039 = $283a38fc382f3b9d$var$hsi;

});
parcelRegister("2yZD4", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $l5tcy = parcelRequire("l5tcy");

var $jIBUL = parcelRequire("jIBUL");
(0, $e7KSJ.default).prototype.hsi = function() {
    return (0, $jIBUL.default)(this._rgb);
};
const $1dde90099f253c78$export$ec0e0a10cc3c404a = (...args)=>new (0, $e7KSJ.default)(...args, 'hsi');
(0, $gaK1V.default).hsi = $1dde90099f253c78$export$ec0e0a10cc3c404a;
(0, $lT4NS.default).format.hsi = (0, $l5tcy.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'hsi');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'hsi';
    }
});

});
parcelRegister("l5tcy", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5a0b7662948a353$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $gb2Ug = parcelRequire("gb2Ug");
var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { cos: $f5a0b7662948a353$var$cos } = Math;
/*
 * hue [0..360]
 * saturation [0..1]
 * intensity [0..1]
 */ const $f5a0b7662948a353$var$hsi2rgb = (...args)=>{
    /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
    */ args = (0, $43ZPL.default)(args, 'hsi');
    let [h, s, i] = args;
    let r, g, b;
    if (isNaN(h)) h = 0;
    if (isNaN(s)) s = 0;
    // normalize hue
    if (h > 360) h -= 360;
    if (h < 0) h += 360;
    h /= 360;
    if (h < 1 / 3) {
        b = (1 - s) / 3;
        r = (1 + s * $f5a0b7662948a353$var$cos((0, $i4gda.TWOPI) * h) / $f5a0b7662948a353$var$cos((0, $i4gda.PITHIRD) - (0, $i4gda.TWOPI) * h)) / 3;
        g = 1 - (b + r);
    } else if (h < 2 / 3) {
        h -= 1 / 3;
        r = (1 - s) / 3;
        g = (1 + s * $f5a0b7662948a353$var$cos((0, $i4gda.TWOPI) * h) / $f5a0b7662948a353$var$cos((0, $i4gda.PITHIRD) - (0, $i4gda.TWOPI) * h)) / 3;
        b = 1 - (r + g);
    } else {
        h -= 2 / 3;
        g = (1 - s) / 3;
        b = (1 + s * $f5a0b7662948a353$var$cos((0, $i4gda.TWOPI) * h) / $f5a0b7662948a353$var$cos((0, $i4gda.PITHIRD) - (0, $i4gda.TWOPI) * h)) / 3;
        r = 1 - (g + b);
    }
    r = (0, $gb2Ug.default)(i * r * 3);
    g = (0, $gb2Ug.default)(i * g * 3);
    b = (0, $gb2Ug.default)(i * b * 3);
    return [
        r * 255,
        g * 255,
        b * 255,
        args.length > 3 ? args[3] : 1
    ];
};
var $f5a0b7662948a353$export$2e2bcd8739ae039 = $f5a0b7662948a353$var$hsi2rgb;

});

parcelRegister("jIBUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5af8966c377d585$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { min: $e5af8966c377d585$var$min, sqrt: $e5af8966c377d585$var$sqrt, acos: $e5af8966c377d585$var$acos } = Math;
const $e5af8966c377d585$var$rgb2hsi = (...args)=>{
    /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
    */ let [r, g, b] = (0, $43ZPL.default)(args, 'rgb');
    r /= 255;
    g /= 255;
    b /= 255;
    let h;
    const min_ = $e5af8966c377d585$var$min(r, g, b);
    const i = (r + g + b) / 3;
    const s = i > 0 ? 1 - min_ / i : 0;
    if (s === 0) h = NaN;
    else {
        h = (r - g + (r - b)) / 2;
        h /= $e5af8966c377d585$var$sqrt((r - g) * (r - g) + (r - b) * (g - b));
        h = $e5af8966c377d585$var$acos(h);
        if (b > g) h = (0, $i4gda.TWOPI) - h;
        h /= (0, $i4gda.TWOPI);
    }
    return [
        h * 360,
        s,
        i
    ];
};
var $e5af8966c377d585$export$2e2bcd8739ae039 = $e5af8966c377d585$var$rgb2hsi;

});



parcelRegister("75dqB", function(module, exports) {
parcelRequire("fbI2I");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $52836a91adc4a3f4$var$hsl = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'hsl');
};
// register interpolator
(0, $5flPP.default).hsl = $52836a91adc4a3f4$var$hsl;
var $52836a91adc4a3f4$export$2e2bcd8739ae039 = $52836a91adc4a3f4$var$hsl;

});
parcelRegister("fbI2I", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $7PGtI = parcelRequire("7PGtI");

var $f9fTr = parcelRequire("f9fTr");
(0, $e7KSJ.default).prototype.hsl = function() {
    return (0, $f9fTr.default)(this._rgb);
};
const $b0ea0c19eddc0159$export$8f4a7c0bb78e6ea8 = (...args)=>new (0, $e7KSJ.default)(...args, 'hsl');
(0, $gaK1V.default).hsl = $b0ea0c19eddc0159$export$8f4a7c0bb78e6ea8;
(0, $lT4NS.default).format.hsl = (0, $7PGtI.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'hsl');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'hsl';
    }
});

});
parcelRegister("7PGtI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b3e3f1c3bcf972f$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $5b3e3f1c3bcf972f$var$hsl2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'hsl');
    const [h, s, l] = args;
    let r, g, b;
    if (s === 0) r = g = b = l * 255;
    else {
        const t3 = [
            0,
            0,
            0
        ];
        const c = [
            0,
            0,
            0
        ];
        const t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const t1 = 2 * l - t2;
        const h_ = h / 360;
        t3[0] = h_ + 1 / 3;
        t3[1] = h_;
        t3[2] = h_ - 1 / 3;
        for(let i = 0; i < 3; i++){
            if (t3[i] < 0) t3[i] += 1;
            if (t3[i] > 1) t3[i] -= 1;
            if (6 * t3[i] < 1) c[i] = t1 + (t2 - t1) * 6 * t3[i];
            else if (2 * t3[i] < 1) c[i] = t2;
            else if (3 * t3[i] < 2) c[i] = t1 + (t2 - t1) * (2 / 3 - t3[i]) * 6;
            else c[i] = t1;
        }
        [r, g, b] = [
            c[0] * 255,
            c[1] * 255,
            c[2] * 255
        ];
    }
    if (args.length > 3) // keep alpha channel
    return [
        r,
        g,
        b,
        args[3]
    ];
    return [
        r,
        g,
        b,
        1
    ];
};
var $5b3e3f1c3bcf972f$export$2e2bcd8739ae039 = $5b3e3f1c3bcf972f$var$hsl2rgb;

});

parcelRegister("f9fTr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0740654f8b78640$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
/*
 * supported arguments:
 * - rgb2hsl(r,g,b)
 * - rgb2hsl(r,g,b,a)
 * - rgb2hsl([r,g,b])
 * - rgb2hsl([r,g,b,a])
 * - rgb2hsl({r,g,b,a})
 */ const $b0740654f8b78640$var$rgb2hsl = (...args)=>{
    args = (0, $43ZPL.default)(args, 'rgba');
    let [r, g, b] = args;
    r /= 255;
    g /= 255;
    b /= 255;
    const minRgb = (0, $i4gda.min)(r, g, b);
    const maxRgb = (0, $i4gda.max)(r, g, b);
    const l = (maxRgb + minRgb) / 2;
    let s, h;
    if (maxRgb === minRgb) {
        s = 0;
        h = Number.NaN;
    } else s = l < 0.5 ? (maxRgb - minRgb) / (maxRgb + minRgb) : (maxRgb - minRgb) / (2 - maxRgb - minRgb);
    if (r == maxRgb) h = (g - b) / (maxRgb - minRgb);
    else if (g == maxRgb) h = 2 + (b - r) / (maxRgb - minRgb);
    else if (b == maxRgb) h = 4 + (r - g) / (maxRgb - minRgb);
    h *= 60;
    if (h < 0) h += 360;
    if (args.length > 3 && args[3] !== undefined) return [
        h,
        s,
        l,
        args[3]
    ];
    return [
        h,
        s,
        l
    ];
};
var $b0740654f8b78640$export$2e2bcd8739ae039 = $b0740654f8b78640$var$rgb2hsl;

});



parcelRegister("2ISBM", function(module, exports) {
parcelRequire("7Z9E2");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $1fba0cefa8ec10d2$var$hsv = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'hsv');
};
// register interpolator
(0, $5flPP.default).hsv = $1fba0cefa8ec10d2$var$hsv;
var $1fba0cefa8ec10d2$export$2e2bcd8739ae039 = $1fba0cefa8ec10d2$var$hsv;

});
parcelRegister("7Z9E2", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $eNZr2 = parcelRequire("eNZr2");

var $8GFTU = parcelRequire("8GFTU");
(0, $e7KSJ.default).prototype.hsv = function() {
    return (0, $8GFTU.default)(this._rgb);
};
const $5d05b62ca5e0b832$export$a5d7c789f12d2213 = (...args)=>new (0, $e7KSJ.default)(...args, 'hsv');
(0, $gaK1V.default).hsv = $5d05b62ca5e0b832$export$a5d7c789f12d2213;
(0, $lT4NS.default).format.hsv = (0, $eNZr2.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'hsv');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'hsv';
    }
});

});
parcelRegister("eNZr2", function(module, exports) {

$parcel$export(module.exports, "default", () => $02c815df05a1cd8b$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { floor: $02c815df05a1cd8b$var$floor } = Math;
const $02c815df05a1cd8b$var$hsv2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'hsv');
    let [h, s, v] = args;
    let r, g, b;
    v *= 255;
    if (s === 0) r = g = b = v;
    else {
        if (h === 360) h = 0;
        if (h > 360) h -= 360;
        if (h < 0) h += 360;
        h /= 60;
        const i = $02c815df05a1cd8b$var$floor(h);
        const f = h - i;
        const p = v * (1 - s);
        const q = v * (1 - s * f);
        const t = v * (1 - s * (1 - f));
        switch(i){
            case 0:
                [r, g, b] = [
                    v,
                    t,
                    p
                ];
                break;
            case 1:
                [r, g, b] = [
                    q,
                    v,
                    p
                ];
                break;
            case 2:
                [r, g, b] = [
                    p,
                    v,
                    t
                ];
                break;
            case 3:
                [r, g, b] = [
                    p,
                    q,
                    v
                ];
                break;
            case 4:
                [r, g, b] = [
                    t,
                    p,
                    v
                ];
                break;
            case 5:
                [r, g, b] = [
                    v,
                    p,
                    q
                ];
                break;
        }
    }
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $02c815df05a1cd8b$export$2e2bcd8739ae039 = $02c815df05a1cd8b$var$hsv2rgb;

});

parcelRegister("8GFTU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6532bf9b6866bc48$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { min: $6532bf9b6866bc48$var$min, max: $6532bf9b6866bc48$var$max } = Math;
/*
 * supported arguments:
 * - rgb2hsv(r,g,b)
 * - rgb2hsv([r,g,b])
 * - rgb2hsv({r,g,b})
 */ const $6532bf9b6866bc48$var$rgb2hsl = (...args)=>{
    args = (0, $43ZPL.default)(args, 'rgb');
    let [r, g, b] = args;
    const min_ = $6532bf9b6866bc48$var$min(r, g, b);
    const max_ = $6532bf9b6866bc48$var$max(r, g, b);
    const delta = max_ - min_;
    let h, s, v;
    v = max_ / 255.0;
    if (max_ === 0) {
        h = Number.NaN;
        s = 0;
    } else {
        s = delta / max_;
        if (r === max_) h = (g - b) / delta;
        if (g === max_) h = 2 + (b - r) / delta;
        if (b === max_) h = 4 + (r - g) / delta;
        h *= 60;
        if (h < 0) h += 360;
    }
    return [
        h,
        s,
        v
    ];
};
var $6532bf9b6866bc48$export$2e2bcd8739ae039 = $6532bf9b6866bc48$var$rgb2hsl;

});



parcelRegister("52gBS", function(module, exports) {
parcelRequire("j6weT");

var $5flPP = parcelRequire("5flPP");

var $e7KSJ = parcelRequire("e7KSJ");
const $3aaa060894ca8484$var$oklab = (col1, col2, f)=>{
    const xyz0 = col1.oklab();
    const xyz1 = col2.oklab();
    return new (0, $e7KSJ.default)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'oklab');
};
// register interpolator
(0, $5flPP.default).oklab = $3aaa060894ca8484$var$oklab;
var $3aaa060894ca8484$export$2e2bcd8739ae039 = $3aaa060894ca8484$var$oklab;

});
parcelRegister("j6weT", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $5D4bx = parcelRequire("5D4bx");

var $eJb2q = parcelRequire("eJb2q");
(0, $e7KSJ.default).prototype.oklab = function() {
    return (0, $eJb2q.default)(this._rgb);
};
const $de8795def78a20d0$export$b14b17e4e916d621 = (...args)=>new (0, $e7KSJ.default)(...args, 'oklab');
Object.assign((0, $gaK1V.default), {
    oklab: $de8795def78a20d0$export$b14b17e4e916d621
});
(0, $lT4NS.default).format.oklab = (0, $5D4bx.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'oklab');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'oklab';
    }
});

});
parcelRegister("5D4bx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4193d753772cec6b$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $iIsar = parcelRequire("iIsar");

var $jenZn = parcelRequire("jenZn");
const $4193d753772cec6b$var$oklab2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'lab');
    const [L, a, b, ...rest] = args;
    const [X, Y, Z] = $4193d753772cec6b$var$OKLab_to_XYZ([
        L,
        a,
        b
    ]);
    const [r, g, b_] = (0, $jenZn.xyz2rgb)(X, Y, Z);
    return [
        r,
        g,
        b_,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
// from https://www.w3.org/TR/css-color-4/#color-conversion-code
function $4193d753772cec6b$var$OKLab_to_XYZ(OKLab) {
    // Given OKLab, convert to XYZ relative to D65
    var LMStoXYZ = [
        [
            1.2268798758459243,
            -0.5578149944602171,
            0.2813910456659647
        ],
        [
            -0.0405757452148008,
            1.112286803280317,
            -0.0717110580655164
        ],
        [
            -0.0763729366746601,
            -0.4214933324022432,
            1.5869240198367816
        ]
    ];
    var OKLabtoLMS = [
        [
            1.0,
            0.3963377773761749,
            0.2158037573099136
        ],
        [
            1.0,
            -0.1055613458156586,
            -0.0638541728258133
        ],
        [
            1.0,
            -0.0894841775298119,
            -1.2914855480194092
        ]
    ];
    var LMSnl = (0, $iIsar.default)(OKLabtoLMS, OKLab);
    return (0, $iIsar.default)(LMStoXYZ, LMSnl.map((c)=>c ** 3));
}
var $4193d753772cec6b$export$2e2bcd8739ae039 = $4193d753772cec6b$var$oklab2rgb;

});
parcelRegister("iIsar", function(module, exports) {

$parcel$export(module.exports, "default", () => $da022f8598f5340d$export$2e2bcd8739ae039);
// from https://www.w3.org/TR/css-color-4/multiply-matrices.js
function $da022f8598f5340d$export$2e2bcd8739ae039(A, B) {
    let m = A.length;
    if (!Array.isArray(A[0])) // A is vector, convert to [[a, b, c, ...]]
    A = [
        A
    ];
    if (!Array.isArray(B[0])) // B is vector, convert to [[a], [b], [c], ...]]
    B = B.map((x)=>[
            x
        ]);
    let p = B[0].length;
    let B_cols = B[0].map((_, i)=>B.map((x)=>x[i])); // transpose B
    let product = A.map((row)=>B_cols.map((col)=>{
            if (!Array.isArray(row)) return col.reduce((a, c)=>a + c * row, 0);
            return row.reduce((a, c, i)=>a + c * (col[i] || 0), 0);
        }));
    if (m === 1) product = product[0]; // Avoid [[a, b, c, ...]]
    if (p === 1) return product.map((x)=>x[0]); // Avoid [[a], [b], [c], ...]]
    return product;
}

});


parcelRegister("eJb2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab8dd493bc48c920$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $iIsar = parcelRequire("iIsar");

var $luvnN = parcelRequire("luvnN");
const $ab8dd493bc48c920$var$rgb2oklab = (...args)=>{
    const [r, g, b, ...rest] = (0, $43ZPL.default)(args, 'rgb');
    const xyz = (0, $luvnN.rgb2xyz)(r, g, b);
    const oklab = $ab8dd493bc48c920$var$XYZ_to_OKLab(xyz);
    return [
        ...oklab,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
// from https://www.w3.org/TR/css-color-4/#color-conversion-code
function $ab8dd493bc48c920$var$XYZ_to_OKLab(XYZ) {
    // Given XYZ relative to D65, convert to OKLab
    const XYZtoLMS = [
        [
            0.819022437996703,
            0.3619062600528904,
            -0.1288737815209879
        ],
        [
            0.0329836539323885,
            0.9292868615863434,
            0.0361446663506424
        ],
        [
            0.0481771893596242,
            0.2642395317527308,
            0.6335478284694309
        ]
    ];
    const LMStoOKLab = [
        [
            0.210454268309314,
            0.7936177747023054,
            -0.0040720430116193
        ],
        [
            1.9779985324311684,
            -2.42859224204858,
            0.450593709617411
        ],
        [
            0.0259040424655478,
            0.7827717124575296,
            -0.8086757549230774
        ]
    ];
    const LMS = (0, $iIsar.default)(XYZtoLMS, XYZ);
    // JavaScript Math.cbrt returns a sign-matched cube root
    // beware if porting to other languages
    // especially if tempted to use a general power function
    return (0, $iIsar.default)(LMStoOKLab, LMS.map((c)=>Math.cbrt(c)));
// L in range [0,1]. For use in CSS, multiply by 100 and add a percent
}
var $ab8dd493bc48c920$export$2e2bcd8739ae039 = $ab8dd493bc48c920$var$rgb2oklab;

});



parcelRegister("3wKag", function(module, exports) {
parcelRequire("getAx");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $29182b9272ebb9ac$var$oklch = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'oklch');
};
// register interpolator
(0, $5flPP.default).oklch = $29182b9272ebb9ac$var$oklch;
var $29182b9272ebb9ac$export$2e2bcd8739ae039 = $29182b9272ebb9ac$var$oklch;

});

parcelRegister("8UmTp", function(module, exports) {

$parcel$export(module.exports, "default", () => $67c54fb1da1f0bdc$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("i4gda");
var $8TO5X = parcelRequire("8TO5X");
const { pow: $67c54fb1da1f0bdc$var$pow, sqrt: $67c54fb1da1f0bdc$var$sqrt, PI: $67c54fb1da1f0bdc$var$PI, cos: $67c54fb1da1f0bdc$var$cos, sin: $67c54fb1da1f0bdc$var$sin, atan2: $67c54fb1da1f0bdc$var$atan2 } = Math;
var $67c54fb1da1f0bdc$export$2e2bcd8739ae039 = (colors, mode = 'lrgb', weights = null)=>{
    const l = colors.length;
    if (!weights) weights = Array.from(new Array(l)).map(()=>1);
    // normalize weights
    const k = l / weights.reduce(function(a, b) {
        return a + b;
    });
    weights.forEach((w, i)=>{
        weights[i] *= k;
    });
    // convert colors to Color objects
    colors = colors.map((c)=>new (0, $e7KSJ.default)(c));
    if (mode === 'lrgb') return $67c54fb1da1f0bdc$var$_average_lrgb(colors, weights);
    const first = colors.shift();
    const xyz = first.get(mode);
    const cnt = [];
    let dx = 0;
    let dy = 0;
    // initial color
    for(let i = 0; i < xyz.length; i++){
        xyz[i] = (xyz[i] || 0) * weights[0];
        cnt.push(isNaN(xyz[i]) ? 0 : weights[0]);
        if (mode.charAt(i) === 'h' && !isNaN(xyz[i])) {
            const A = xyz[i] / 180 * $67c54fb1da1f0bdc$var$PI;
            dx += $67c54fb1da1f0bdc$var$cos(A) * weights[0];
            dy += $67c54fb1da1f0bdc$var$sin(A) * weights[0];
        }
    }
    let alpha = first.alpha() * weights[0];
    colors.forEach((c, ci)=>{
        const xyz2 = c.get(mode);
        alpha += c.alpha() * weights[ci + 1];
        for(let i = 0; i < xyz.length; i++)if (!isNaN(xyz2[i])) {
            cnt[i] += weights[ci + 1];
            if (mode.charAt(i) === 'h') {
                const A = xyz2[i] / 180 * $67c54fb1da1f0bdc$var$PI;
                dx += $67c54fb1da1f0bdc$var$cos(A) * weights[ci + 1];
                dy += $67c54fb1da1f0bdc$var$sin(A) * weights[ci + 1];
            } else xyz[i] += xyz2[i] * weights[ci + 1];
        }
    });
    for(let i = 0; i < xyz.length; i++)if (mode.charAt(i) === 'h') {
        let A = $67c54fb1da1f0bdc$var$atan2(dy / cnt[i], dx / cnt[i]) / $67c54fb1da1f0bdc$var$PI * 180;
        while(A < 0)A += 360;
        while(A >= 360)A -= 360;
        xyz[i] = A;
    } else xyz[i] = xyz[i] / cnt[i];
    alpha /= l;
    return new (0, $e7KSJ.default)(xyz, mode).alpha(alpha > 0.99999 ? 1 : alpha, true);
};
const $67c54fb1da1f0bdc$var$_average_lrgb = (colors, weights)=>{
    const l = colors.length;
    const xyz = [
        0,
        0,
        0,
        0
    ];
    for(let i = 0; i < colors.length; i++){
        const col = colors[i];
        const f = weights[i] / l;
        const rgb = col._rgb;
        xyz[0] += $67c54fb1da1f0bdc$var$pow(rgb[0], 2) * f;
        xyz[1] += $67c54fb1da1f0bdc$var$pow(rgb[1], 2) * f;
        xyz[2] += $67c54fb1da1f0bdc$var$pow(rgb[2], 2) * f;
        xyz[3] += rgb[3] * f;
    }
    xyz[0] = $67c54fb1da1f0bdc$var$sqrt(xyz[0]);
    xyz[1] = $67c54fb1da1f0bdc$var$sqrt(xyz[1]);
    xyz[2] = $67c54fb1da1f0bdc$var$sqrt(xyz[2]);
    if (xyz[3] > 0.9999999) xyz[3] = 1;
    return new (0, $e7KSJ.default)((0, $8TO5X.default)(xyz));
};

});

parcelRegister("9u72g", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e7c5f855046555e$export$2e2bcd8739ae039);
//
// interpolates between a set of colors uzing a bezier spline
//
// @requires utils lab

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("996dd");

var $4ZQS0 = parcelRequire("4ZQS0");
// nth row of the pascal triangle
const $6e7c5f855046555e$var$binom_row = function(n) {
    let row = [
        1,
        1
    ];
    for(let i = 1; i < n; i++){
        let newrow = [
            1
        ];
        for(let j = 1; j <= row.length; j++)newrow[j] = (row[j] || 0) + row[j - 1];
        row = newrow;
    }
    return row;
};
const $6e7c5f855046555e$var$bezier = function(colors) {
    let I, lab0, lab1, lab2;
    colors = colors.map((c)=>new (0, $e7KSJ.default)(c));
    if (colors.length === 2) {
        // linear interpolation
        [lab0, lab1] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>lab0[i] + t * (lab1[i] - lab0[i]));
            return new (0, $e7KSJ.default)(lab, 'lab');
        };
    } else if (colors.length === 3) {
        // quadratic bezier interpolation
        [lab0, lab1, lab2] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>(1 - t) * (1 - t) * lab0[i] + 2 * (1 - t) * t * lab1[i] + t * t * lab2[i]);
            return new (0, $e7KSJ.default)(lab, 'lab');
        };
    } else if (colors.length === 4) {
        // cubic bezier interpolation
        let lab3;
        [lab0, lab1, lab2, lab3] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>(1 - t) * (1 - t) * (1 - t) * lab0[i] + 3 * (1 - t) * (1 - t) * t * lab1[i] + 3 * (1 - t) * t * t * lab2[i] + t * t * t * lab3[i]);
            return new (0, $e7KSJ.default)(lab, 'lab');
        };
    } else if (colors.length >= 5) {
        // general case (degree n bezier)
        let labs, row, n;
        labs = colors.map((c)=>c.lab());
        n = colors.length - 1;
        row = $6e7c5f855046555e$var$binom_row(n);
        I = function(t) {
            const u = 1 - t;
            const lab = [
                0,
                1,
                2
            ].map((i)=>labs.reduce((sum, el, j)=>sum + row[j] * u ** (n - j) * t ** j * el[i], 0));
            return new (0, $e7KSJ.default)(lab, 'lab');
        };
    } else throw new RangeError('No point in running bezier with only one color.');
    return I;
};
var $6e7c5f855046555e$export$2e2bcd8739ae039 = (colors)=>{
    const f = $6e7c5f855046555e$var$bezier(colors);
    f.scale = ()=>(0, $4ZQS0.default)(f);
    return f;
};

});
parcelRegister("4ZQS0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a35ded86e36da0d$export$2e2bcd8739ae039);
// minimal multi-purpose interface
// @requires utils color analyze

var $gaK1V = parcelRequire("gaK1V");
parcelRequire("i4gda");
var $gb2Ug = parcelRequire("gb2Ug");
var $hMEmV = parcelRequire("hMEmV");
const { pow: $3a35ded86e36da0d$var$pow } = Math;
function $3a35ded86e36da0d$export$2e2bcd8739ae039(colors) {
    // constructor
    let _mode = 'rgb';
    let _nacol = (0, $gaK1V.default)('#ccc');
    let _spread = 0;
    // const _fixed = false;
    let _domain = [
        0,
        1
    ];
    let _pos = [];
    let _padding = [
        0,
        0
    ];
    let _classes = false;
    let _colors = [];
    let _out = false;
    let _min = 0;
    let _max = 1;
    let _correctLightness = false;
    let _colorCache = {};
    let _useCache = true;
    let _gamma = 1;
    // private methods
    const setColors = function(colors) {
        colors = colors || [
            '#fff',
            '#000'
        ];
        if (colors && (0, $hMEmV.default)(colors) === 'string' && (0, $gaK1V.default).brewer && (0, $gaK1V.default).brewer[colors.toLowerCase()]) colors = (0, $gaK1V.default).brewer[colors.toLowerCase()];
        if ((0, $hMEmV.default)(colors) === 'array') {
            // handle single color
            if (colors.length === 1) colors = [
                colors[0],
                colors[0]
            ];
            // make a copy of the colors
            colors = colors.slice(0);
            // convert to chroma classes
            for(let c = 0; c < colors.length; c++)colors[c] = (0, $gaK1V.default)(colors[c]);
            // auto-fill color position
            _pos.length = 0;
            for(let c = 0; c < colors.length; c++)_pos.push(c / (colors.length - 1));
        }
        resetCache();
        return _colors = colors;
    };
    const getClass = function(value) {
        if (_classes != null) {
            const n = _classes.length - 1;
            let i = 0;
            while(i < n && value >= _classes[i])i++;
            return i - 1;
        }
        return 0;
    };
    let tMapLightness = (t)=>t;
    let tMapDomain = (t)=>t;
    // const classifyValue = function(value) {
    //     let val = value;
    //     if (_classes.length > 2) {
    //         const n = _classes.length-1;
    //         const i = getClass(value);
    //         const minc = _classes[0] + ((_classes[1]-_classes[0]) * (0 + (_spread * 0.5)));  // center of 1st class
    //         const maxc = _classes[n-1] + ((_classes[n]-_classes[n-1]) * (1 - (_spread * 0.5)));  // center of last class
    //         val = _min + ((((_classes[i] + ((_classes[i+1] - _classes[i]) * 0.5)) - minc) / (maxc-minc)) * (_max - _min));
    //     }
    //     return val;
    // };
    const getColor = function(val, bypassMap) {
        let col, t;
        if (bypassMap == null) bypassMap = false;
        if (isNaN(val) || val === null) return _nacol;
        if (!bypassMap) {
            if (_classes && _classes.length > 2) {
                // find the class
                const c = getClass(val);
                t = c / (_classes.length - 2);
            } else if (_max !== _min) // just interpolate between min/max
            t = (val - _min) / (_max - _min);
            else t = 1;
        } else t = val;
        // domain map
        t = tMapDomain(t);
        if (!bypassMap) t = tMapLightness(t); // lightness correction
        if (_gamma !== 1) t = $3a35ded86e36da0d$var$pow(t, _gamma);
        t = _padding[0] + t * (1 - _padding[0] - _padding[1]);
        t = (0, $gb2Ug.default)(t, 0, 1);
        const k = Math.floor(t * 10000);
        if (_useCache && _colorCache[k]) col = _colorCache[k];
        else {
            if ((0, $hMEmV.default)(_colors) === 'array') //for i in [0.._pos.length-1]
            for(let i = 0; i < _pos.length; i++){
                const p = _pos[i];
                if (t <= p) {
                    col = _colors[i];
                    break;
                }
                if (t >= p && i === _pos.length - 1) {
                    col = _colors[i];
                    break;
                }
                if (t > p && t < _pos[i + 1]) {
                    t = (t - p) / (_pos[i + 1] - p);
                    col = (0, $gaK1V.default).interpolate(_colors[i], _colors[i + 1], t, _mode);
                    break;
                }
            }
            else if ((0, $hMEmV.default)(_colors) === 'function') col = _colors(t);
            if (_useCache) _colorCache[k] = col;
        }
        return col;
    };
    var resetCache = ()=>_colorCache = {};
    setColors(colors);
    // public interface
    const f = function(v) {
        const c = (0, $gaK1V.default)(getColor(v));
        if (_out && c[_out]) return c[_out]();
        else return c;
    };
    f.classes = function(classes) {
        if (classes != null) {
            if ((0, $hMEmV.default)(classes) === 'array') {
                _classes = classes;
                _domain = [
                    classes[0],
                    classes[classes.length - 1]
                ];
            } else {
                const d = (0, $gaK1V.default).analyze(_domain);
                if (classes === 0) _classes = [
                    d.min,
                    d.max
                ];
                else _classes = (0, $gaK1V.default).limits(d, 'e', classes);
            }
            return f;
        }
        return _classes;
    };
    f.domain = function(domain) {
        if (!arguments.length) return _domain;
        _min = domain[0];
        _max = domain[domain.length - 1];
        _pos = [];
        const k = _colors.length;
        if (domain.length === k && _min !== _max) // update positions
        for (let d of Array.from(domain))_pos.push((d - _min) / (_max - _min));
        else {
            for(let c = 0; c < k; c++)_pos.push(c / (k - 1));
            if (domain.length > 2) {
                // set domain map
                const tOut = domain.map((d, i)=>i / (domain.length - 1));
                const tBreaks = domain.map((d)=>(d - _min) / (_max - _min));
                if (!tBreaks.every((val, i)=>tOut[i] === val)) tMapDomain = (t)=>{
                    if (t <= 0 || t >= 1) return t;
                    let i = 0;
                    while(t >= tBreaks[i + 1])i++;
                    const f = (t - tBreaks[i]) / (tBreaks[i + 1] - tBreaks[i]);
                    const out = tOut[i] + f * (tOut[i + 1] - tOut[i]);
                    return out;
                };
            }
        }
        _domain = [
            _min,
            _max
        ];
        return f;
    };
    f.mode = function(_m) {
        if (!arguments.length) return _mode;
        _mode = _m;
        resetCache();
        return f;
    };
    f.range = function(colors, _pos) {
        setColors(colors, _pos);
        return f;
    };
    f.out = function(_o) {
        _out = _o;
        return f;
    };
    f.spread = function(val) {
        if (!arguments.length) return _spread;
        _spread = val;
        return f;
    };
    f.correctLightness = function(v) {
        if (v == null) v = true;
        _correctLightness = v;
        resetCache();
        if (_correctLightness) tMapLightness = function(t) {
            const L0 = getColor(0, true).lab()[0];
            const L1 = getColor(1, true).lab()[0];
            const pol = L0 > L1;
            let L_actual = getColor(t, true).lab()[0];
            const L_ideal = L0 + (L1 - L0) * t;
            let L_diff = L_actual - L_ideal;
            let t0 = 0;
            let t1 = 1;
            let max_iter = 20;
            while(Math.abs(L_diff) > 1e-2 && max_iter-- > 0)(function() {
                if (pol) L_diff *= -1;
                if (L_diff < 0) {
                    t0 = t;
                    t += (t1 - t) * 0.5;
                } else {
                    t1 = t;
                    t += (t0 - t) * 0.5;
                }
                L_actual = getColor(t, true).lab()[0];
                return L_diff = L_actual - L_ideal;
            })();
            return t;
        };
        else tMapLightness = (t)=>t;
        return f;
    };
    f.padding = function(p) {
        if (p != null) {
            if ((0, $hMEmV.default)(p) === 'number') p = [
                p,
                p
            ];
            _padding = p;
            return f;
        } else return _padding;
    };
    f.colors = function(numColors, out) {
        // If no arguments are given, return the original colors that were provided
        if (arguments.length < 2) out = 'hex';
        let result = [];
        if (arguments.length === 0) result = _colors.slice(0);
        else if (numColors === 1) result = [
            f(0.5)
        ];
        else if (numColors > 1) {
            const dm = _domain[0];
            const dd = _domain[1] - dm;
            result = $3a35ded86e36da0d$var$__range__(0, numColors, false).map((i)=>f(dm + i / (numColors - 1) * dd));
        } else {
            // returns all colors based on the defined classes
            colors = [];
            let samples = [];
            if (_classes && _classes.length > 2) for(let i = 1, end = _classes.length, asc = 1 <= end; asc ? i < end : i > end; asc ? i++ : i--)samples.push((_classes[i - 1] + _classes[i]) * 0.5);
            else samples = _domain;
            result = samples.map((v)=>f(v));
        }
        if ((0, $gaK1V.default)[out]) result = result.map((c)=>c[out]());
        return result;
    };
    f.cache = function(c) {
        if (c != null) {
            _useCache = c;
            return f;
        } else return _useCache;
    };
    f.gamma = function(g) {
        if (g != null) {
            _gamma = g;
            return f;
        } else return _gamma;
    };
    f.nodata = function(d) {
        if (d != null) {
            _nacol = (0, $gaK1V.default)(d);
            return f;
        } else return _nacol;
    };
    return f;
}
function $3a35ded86e36da0d$var$__range__(left, right, inclusive) {
    let range = [];
    let ascending = left < right;
    let end = !inclusive ? right : ascending ? right + 1 : right - 1;
    for(let i = left; ascending ? i < end : i > end; ascending ? i++ : i--)range.push(i);
    return range;
}

});


parcelRegister("hKhjA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceb429f3a9f3c855$export$2e2bcd8739ae039);
/*
 * interpolates between a set of colors uzing a bezier spline
 * blend mode formulas taken from https://web.archive.org/web/20180110014946/http://www.venture-ware.com/kevin/coding/lets-learn-math-photoshop-blend-modes/
 */ parcelRequire("ayOPU");

var $gaK1V = parcelRequire("gaK1V");
const $ceb429f3a9f3c855$var$blend = (bottom, top, mode)=>{
    if (!$ceb429f3a9f3c855$var$blend[mode]) throw new Error('unknown blend mode ' + mode);
    return $ceb429f3a9f3c855$var$blend[mode](bottom, top);
};
const $ceb429f3a9f3c855$var$blend_f = (f)=>(bottom, top)=>{
        const c0 = (0, $gaK1V.default)(top).rgb();
        const c1 = (0, $gaK1V.default)(bottom).rgb();
        return (0, $gaK1V.default).rgb(f(c0, c1));
    };
const $ceb429f3a9f3c855$var$each = (f)=>(c0, c1)=>{
        const out = [];
        out[0] = f(c0[0], c1[0]);
        out[1] = f(c0[1], c1[1]);
        out[2] = f(c0[2], c1[2]);
        return out;
    };
const $ceb429f3a9f3c855$var$normal = (a)=>a;
const $ceb429f3a9f3c855$var$multiply = (a, b)=>a * b / 255;
const $ceb429f3a9f3c855$var$darken = (a, b)=>a > b ? b : a;
const $ceb429f3a9f3c855$var$lighten = (a, b)=>a > b ? a : b;
const $ceb429f3a9f3c855$var$screen = (a, b)=>255 * (1 - (1 - a / 255) * (1 - b / 255));
const $ceb429f3a9f3c855$var$overlay = (a, b)=>b < 128 ? 2 * a * b / 255 : 255 * (1 - 2 * (1 - a / 255) * (1 - b / 255));
const $ceb429f3a9f3c855$var$burn = (a, b)=>255 * (1 - (1 - b / 255) / (a / 255));
const $ceb429f3a9f3c855$var$dodge = (a, b)=>{
    if (a === 255) return 255;
    a = 255 * (b / 255) / (1 - a / 255);
    return a > 255 ? 255 : a;
};
// # add = (a,b) ->
// #     if (a + b > 255) then 255 else a + b
$ceb429f3a9f3c855$var$blend.normal = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$normal));
$ceb429f3a9f3c855$var$blend.multiply = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$multiply));
$ceb429f3a9f3c855$var$blend.screen = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$screen));
$ceb429f3a9f3c855$var$blend.overlay = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$overlay));
$ceb429f3a9f3c855$var$blend.darken = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$darken));
$ceb429f3a9f3c855$var$blend.lighten = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$lighten));
$ceb429f3a9f3c855$var$blend.dodge = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$dodge));
$ceb429f3a9f3c855$var$blend.burn = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$burn));
var // blend.add = blend_f(each(add));
$ceb429f3a9f3c855$export$2e2bcd8739ae039 = $ceb429f3a9f3c855$var$blend;

});
parcelRegister("ayOPU", function(module, exports) {

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");
const { round: $7b04835af4de31ed$var$round } = Math;
(0, $e7KSJ.default).prototype.rgb = function(rnd = true) {
    if (rnd === false) return this._rgb.slice(0, 3);
    return this._rgb.slice(0, 3).map($7b04835af4de31ed$var$round);
};
(0, $e7KSJ.default).prototype.rgba = function(rnd = true) {
    return this._rgb.slice(0, 4).map((v, i)=>{
        return i < 3 ? rnd === false ? v : $7b04835af4de31ed$var$round(v) : v;
    });
};
const $7b04835af4de31ed$export$8972dc0e6ad9238f = (...args)=>new (0, $e7KSJ.default)(...args, 'rgb');
Object.assign((0, $gaK1V.default), {
    rgb: $7b04835af4de31ed$export$8972dc0e6ad9238f
});
(0, $lT4NS.default).format.rgb = (...args)=>{
    const rgba = (0, $43ZPL.default)(args, 'rgba');
    if (rgba[3] === undefined) rgba[3] = 1;
    return rgba;
};
(0, $lT4NS.default).autodetect.push({
    p: 3,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'rgba');
        if ((0, $hMEmV.default)(args) === 'array' && (args.length === 3 || args.length === 4 && (0, $hMEmV.default)(args[3]) == 'number' && args[3] >= 0 && args[3] <= 1)) return 'rgb';
    }
});

});


parcelRegister("jpCQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e21e7c3c7180c018$export$2e2bcd8739ae039);
// cubehelix interpolation
// based on D.A. Green "A colour scheme for the display of astronomical intensity images"
// http://astron-soc.in/bulletin/11June/289392011.pdf
parcelRequire("i4gda");
var $8TO5X = parcelRequire("8TO5X");
var $i4gda = parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $gaK1V = parcelRequire("gaK1V");
const { pow: $e21e7c3c7180c018$var$pow, sin: $e21e7c3c7180c018$var$sin, cos: $e21e7c3c7180c018$var$cos } = Math;
function $e21e7c3c7180c018$export$2e2bcd8739ae039(start = 300, rotations = -1.5, hue = 1, gamma = 1, lightness = [
    0,
    1
]) {
    let dh = 0, dl;
    if ((0, $hMEmV.default)(lightness) === 'array') dl = lightness[1] - lightness[0];
    else {
        dl = 0;
        lightness = [
            lightness,
            lightness
        ];
    }
    const f = function(fract) {
        const a = (0, $i4gda.TWOPI) * ((start + 120) / 360 + rotations * fract);
        const l = $e21e7c3c7180c018$var$pow(lightness[0] + dl * fract, gamma);
        const h = dh !== 0 ? hue[0] + fract * dh : hue;
        const amp = h * l * (1 - l) / 2;
        const cos_a = $e21e7c3c7180c018$var$cos(a);
        const sin_a = $e21e7c3c7180c018$var$sin(a);
        const r = l + amp * (-0.14861 * cos_a + 1.78277 * sin_a);
        const g = l + amp * (-0.29227 * cos_a - 0.90649 * sin_a);
        const b = l + amp * (1.97294 * cos_a);
        return (0, $gaK1V.default)((0, $8TO5X.default)([
            r * 255,
            g * 255,
            b * 255,
            1
        ]));
    };
    f.start = function(s) {
        if (s == null) return start;
        start = s;
        return f;
    };
    f.rotations = function(r) {
        if (r == null) return rotations;
        rotations = r;
        return f;
    };
    f.gamma = function(g) {
        if (g == null) return gamma;
        gamma = g;
        return f;
    };
    f.hue = function(h) {
        if (h == null) return hue;
        hue = h;
        if ((0, $hMEmV.default)(hue) === 'array') {
            dh = hue[1] - hue[0];
            if (dh === 0) hue = hue[1];
        } else dh = 0;
        return f;
    };
    f.lightness = function(h) {
        if (h == null) return lightness;
        if ((0, $hMEmV.default)(h) === 'array') {
            lightness = h;
            dl = h[1] - h[0];
        } else {
            lightness = [
                h,
                h
            ];
            dl = 0;
        }
        return f;
    };
    f.scale = ()=>(0, $gaK1V.default).scale(f);
    f.hue(hue);
    return f;
}

});

parcelRegister("eIGWI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab767cecc86e20d8$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
const $ab767cecc86e20d8$var$digits = '0123456789abcdef';
const { floor: $ab767cecc86e20d8$var$floor, random: $ab767cecc86e20d8$var$random } = Math;
var $ab767cecc86e20d8$export$2e2bcd8739ae039 = ()=>{
    let code = '#';
    for(let i = 0; i < 6; i++)code += $ab767cecc86e20d8$var$digits.charAt($ab767cecc86e20d8$var$floor($ab767cecc86e20d8$var$random() * 16));
    return new (0, $e7KSJ.default)(code, 'hex');
};

});

parcelRegister("cgHIr", function(module, exports) {

$parcel$export(module.exports, "analyze", () => $8ee8e3ba2352afc1$export$7cbcccfbecde6416);
$parcel$export(module.exports, "limits", () => $8ee8e3ba2352afc1$export$e331ca4ad6a82555);

var $hMEmV = parcelRequire("hMEmV");
const { log: $8ee8e3ba2352afc1$var$log, pow: $8ee8e3ba2352afc1$var$pow, floor: $8ee8e3ba2352afc1$var$floor, abs: $8ee8e3ba2352afc1$var$abs } = Math;
function $8ee8e3ba2352afc1$export$7cbcccfbecde6416(data, key = null) {
    const r = {
        min: Number.MAX_VALUE,
        max: Number.MAX_VALUE * -1,
        sum: 0,
        values: [],
        count: 0
    };
    if ((0, $hMEmV.default)(data) === 'object') data = Object.values(data);
    data.forEach((val)=>{
        if (key && (0, $hMEmV.default)(val) === 'object') val = val[key];
        if (val !== undefined && val !== null && !isNaN(val)) {
            r.values.push(val);
            r.sum += val;
            if (val < r.min) r.min = val;
            if (val > r.max) r.max = val;
            r.count += 1;
        }
    });
    r.domain = [
        r.min,
        r.max
    ];
    r.limits = (mode, num)=>$8ee8e3ba2352afc1$export$e331ca4ad6a82555(r, mode, num);
    return r;
}
function $8ee8e3ba2352afc1$export$e331ca4ad6a82555(data, mode = 'equal', num = 7) {
    if ((0, $hMEmV.default)(data) == 'array') data = $8ee8e3ba2352afc1$export$7cbcccfbecde6416(data);
    const { min: min, max: max } = data;
    const values = data.values.sort((a, b)=>a - b);
    if (num === 1) return [
        min,
        max
    ];
    const limits1 = [];
    if (mode.substr(0, 1) === 'c') {
        // continuous
        limits1.push(min);
        limits1.push(max);
    }
    if (mode.substr(0, 1) === 'e') {
        // equal interval
        limits1.push(min);
        for(let i = 1; i < num; i++)limits1.push(min + i / num * (max - min));
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'l') {
        // log scale
        if (min <= 0) throw new Error('Logarithmic scales are only possible for values > 0');
        const min_log = Math.LOG10E * $8ee8e3ba2352afc1$var$log(min);
        const max_log = Math.LOG10E * $8ee8e3ba2352afc1$var$log(max);
        limits1.push(min);
        for(let i = 1; i < num; i++)limits1.push($8ee8e3ba2352afc1$var$pow(10, min_log + i / num * (max_log - min_log)));
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'q') {
        // quantile scale
        limits1.push(min);
        for(let i = 1; i < num; i++){
            const p = (values.length - 1) * i / num;
            const pb = $8ee8e3ba2352afc1$var$floor(p);
            if (pb === p) limits1.push(values[pb]);
            else {
                // p > pb
                const pr = p - pb;
                limits1.push(values[pb] * (1 - pr) + values[pb + 1] * pr);
            }
        }
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'k') {
        // k-means clustering
        /*
        implementation based on
        http://code.google.com/p/figue/source/browse/trunk/figue.js#336
        simplified for 1-d input values
        */ let cluster;
        const n = values.length;
        const assignments = new Array(n);
        const clusterSizes = new Array(num);
        let repeat = true;
        let nb_iters = 0;
        let centroids = null;
        // get seed values
        centroids = [];
        centroids.push(min);
        for(let i = 1; i < num; i++)centroids.push(min + i / num * (max - min));
        centroids.push(max);
        while(repeat){
            // assignment step
            for(let j = 0; j < num; j++)clusterSizes[j] = 0;
            for(let i = 0; i < n; i++){
                const value = values[i];
                let mindist = Number.MAX_VALUE;
                let best;
                for(let j = 0; j < num; j++){
                    const dist = $8ee8e3ba2352afc1$var$abs(centroids[j] - value);
                    if (dist < mindist) {
                        mindist = dist;
                        best = j;
                    }
                    clusterSizes[best]++;
                    assignments[i] = best;
                }
            }
            // update centroids step
            const newCentroids = new Array(num);
            for(let j = 0; j < num; j++)newCentroids[j] = null;
            for(let i = 0; i < n; i++){
                cluster = assignments[i];
                if (newCentroids[cluster] === null) newCentroids[cluster] = values[i];
                else newCentroids[cluster] += values[i];
            }
            for(let j = 0; j < num; j++)newCentroids[j] *= 1 / clusterSizes[j];
            // check convergence
            repeat = false;
            for(let j = 0; j < num; j++)if (newCentroids[j] !== centroids[j]) {
                repeat = true;
                break;
            }
            centroids = newCentroids;
            nb_iters++;
            if (nb_iters > 200) repeat = false;
        }
        // finished k-means clustering
        // the next part is borrowed from gabrielflor.it
        const kClusters = {};
        for(let j = 0; j < num; j++)kClusters[j] = [];
        for(let i = 0; i < n; i++){
            cluster = assignments[i];
            kClusters[cluster].push(values[i]);
        }
        let tmpKMeansBreaks = [];
        for(let j = 0; j < num; j++){
            tmpKMeansBreaks.push(kClusters[j][0]);
            tmpKMeansBreaks.push(kClusters[j][kClusters[j].length - 1]);
        }
        tmpKMeansBreaks = tmpKMeansBreaks.sort((a, b)=>a - b);
        limits1.push(tmpKMeansBreaks[0]);
        for(let i = 1; i < tmpKMeansBreaks.length; i += 2){
            const v = tmpKMeansBreaks[i];
            if (!isNaN(v) && limits1.indexOf(v) === -1) limits1.push(v);
        }
    }
    return limits1;
}

});

parcelRegister("5BDZu", function(module, exports) {

$parcel$export(module.exports, "default", () => $414f6dca23b2a9de$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("hDPZe");
var $414f6dca23b2a9de$export$2e2bcd8739ae039 = (a, b)=>{
    // WCAG contrast ratio
    // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
    a = new (0, $e7KSJ.default)(a);
    b = new (0, $e7KSJ.default)(b);
    const l1 = a.luminance();
    const l2 = b.luminance();
    return l1 > l2 ? (l1 + 0.05) / (l2 + 0.05) : (l2 + 0.05) / (l1 + 0.05);
};

});

parcelRegister("iM4ga", function(module, exports) {

$parcel$export(module.exports, "default", () => $dab003980244b19f$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");

var $dvq8W = parcelRequire("dvq8W");
/**
 * @license
 *
 * The APCA contrast prediction algorithm is based of the formulas published
 * in the APCA-1.0.98G specification by Myndex. The specification is available at:
 * https://raw.githubusercontent.com/Myndex/apca-w3/master/images/APCAw3_0.1.17_APCA0.0.98G.svg
 *
 * Note that the APCA implementation is still beta, so please update to
 * future versions of chroma.js when they become available.
 *
 * You can read more about the APCA Readability Criterion at
 * https://readtech.org/ARC/
 */ // constants
const $dab003980244b19f$var$W_offset = 0.027;
const $dab003980244b19f$var$P_in = 0.0005;
const $dab003980244b19f$var$P_out = 0.1;
const $dab003980244b19f$var$R_scale = 1.14;
const $dab003980244b19f$var$B_threshold = 0.022;
const $dab003980244b19f$var$B_exp = 1.414;
var $dab003980244b19f$export$2e2bcd8739ae039 = (text, bg)=>{
    // parse input colors
    text = new (0, $e7KSJ.default)(text);
    bg = new (0, $e7KSJ.default)(bg);
    // if text color has alpha, blend against background
    if (text.alpha() < 1) text = (0, $dvq8W.default)(bg, text, text.alpha(), 'rgb');
    const l_text = $dab003980244b19f$var$lum(...text.rgb());
    const l_bg = $dab003980244b19f$var$lum(...bg.rgb());
    // soft clamp black levels
    const Y_text = l_text >= $dab003980244b19f$var$B_threshold ? l_text : l_text + Math.pow($dab003980244b19f$var$B_threshold - l_text, $dab003980244b19f$var$B_exp);
    const Y_bg = l_bg >= $dab003980244b19f$var$B_threshold ? l_bg : l_bg + Math.pow($dab003980244b19f$var$B_threshold - l_bg, $dab003980244b19f$var$B_exp);
    // normal polarity (dark text on light background)
    const S_norm = Math.pow(Y_bg, 0.56) - Math.pow(Y_text, 0.57);
    // reverse polarity (light text on dark background)
    const S_rev = Math.pow(Y_bg, 0.65) - Math.pow(Y_text, 0.62);
    // clamp noise then scale
    const C = Math.abs(Y_bg - Y_text) < $dab003980244b19f$var$P_in ? 0 : Y_text < Y_bg ? S_norm * $dab003980244b19f$var$R_scale : S_rev * $dab003980244b19f$var$R_scale;
    // clamp minimum contrast then offset
    const S_apc = Math.abs(C) < $dab003980244b19f$var$P_out ? 0 : C > 0 ? C - $dab003980244b19f$var$W_offset : C + $dab003980244b19f$var$W_offset;
    // scale to 100
    return S_apc * 100;
};
function $dab003980244b19f$var$lum(r, g, b) {
    return 0.2126729 * Math.pow(r / 255, 2.4) + 0.7151522 * Math.pow(g / 255, 2.4) + 0.072175 * Math.pow(b / 255, 2.4);
}

});

parcelRegister("xkLDw", function(module, exports) {

$parcel$export(module.exports, "default", () => $064331241a6f3932$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
const { sqrt: $064331241a6f3932$var$sqrt, pow: $064331241a6f3932$var$pow, min: $064331241a6f3932$var$min, max: $064331241a6f3932$var$max, atan2: $064331241a6f3932$var$atan2, abs: $064331241a6f3932$var$abs, cos: $064331241a6f3932$var$cos, sin: $064331241a6f3932$var$sin, exp: $064331241a6f3932$var$exp, PI: $064331241a6f3932$var$PI } = Math;
function $064331241a6f3932$export$2e2bcd8739ae039(a, b, Kl = 1, Kc = 1, Kh = 1) {
    // Delta E (CIE 2000)
    // see http://www.brucelindbloom.com/index.html?Eqn_DeltaE_CIE2000.html
    var rad2deg = function(rad) {
        return 360 * rad / (2 * $064331241a6f3932$var$PI);
    };
    var deg2rad = function(deg) {
        return 2 * $064331241a6f3932$var$PI * deg / 360;
    };
    a = new (0, $e7KSJ.default)(a);
    b = new (0, $e7KSJ.default)(b);
    const [L1, a1, b1] = Array.from(a.lab());
    const [L2, a2, b2] = Array.from(b.lab());
    const avgL = (L1 + L2) / 2;
    const C1 = $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(a1, 2) + $064331241a6f3932$var$pow(b1, 2));
    const C2 = $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(a2, 2) + $064331241a6f3932$var$pow(b2, 2));
    const avgC = (C1 + C2) / 2;
    const G = 0.5 * (1 - $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(avgC, 7) / ($064331241a6f3932$var$pow(avgC, 7) + $064331241a6f3932$var$pow(25, 7))));
    const a1p = a1 * (1 + G);
    const a2p = a2 * (1 + G);
    const C1p = $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(a1p, 2) + $064331241a6f3932$var$pow(b1, 2));
    const C2p = $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(a2p, 2) + $064331241a6f3932$var$pow(b2, 2));
    const avgCp = (C1p + C2p) / 2;
    const arctan1 = rad2deg($064331241a6f3932$var$atan2(b1, a1p));
    const arctan2 = rad2deg($064331241a6f3932$var$atan2(b2, a2p));
    const h1p = arctan1 >= 0 ? arctan1 : arctan1 + 360;
    const h2p = arctan2 >= 0 ? arctan2 : arctan2 + 360;
    const avgHp = $064331241a6f3932$var$abs(h1p - h2p) > 180 ? (h1p + h2p + 360) / 2 : (h1p + h2p) / 2;
    const T = 1 - 0.17 * $064331241a6f3932$var$cos(deg2rad(avgHp - 30)) + 0.24 * $064331241a6f3932$var$cos(deg2rad(2 * avgHp)) + 0.32 * $064331241a6f3932$var$cos(deg2rad(3 * avgHp + 6)) - 0.2 * $064331241a6f3932$var$cos(deg2rad(4 * avgHp - 63));
    let deltaHp = h2p - h1p;
    deltaHp = $064331241a6f3932$var$abs(deltaHp) <= 180 ? deltaHp : h2p <= h1p ? deltaHp + 360 : deltaHp - 360;
    deltaHp = 2 * $064331241a6f3932$var$sqrt(C1p * C2p) * $064331241a6f3932$var$sin(deg2rad(deltaHp) / 2);
    const deltaL = L2 - L1;
    const deltaCp = C2p - C1p;
    const sl = 1 + 0.015 * $064331241a6f3932$var$pow(avgL - 50, 2) / $064331241a6f3932$var$sqrt(20 + $064331241a6f3932$var$pow(avgL - 50, 2));
    const sc = 1 + 0.045 * avgCp;
    const sh = 1 + 0.015 * avgCp * T;
    const deltaTheta = 30 * $064331241a6f3932$var$exp(-$064331241a6f3932$var$pow((avgHp - 275) / 25, 2));
    const Rc = 2 * $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(avgCp, 7) / ($064331241a6f3932$var$pow(avgCp, 7) + $064331241a6f3932$var$pow(25, 7)));
    const Rt = -Rc * $064331241a6f3932$var$sin(2 * deg2rad(deltaTheta));
    const result = $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(deltaL / (Kl * sl), 2) + $064331241a6f3932$var$pow(deltaCp / (Kc * sc), 2) + $064331241a6f3932$var$pow(deltaHp / (Kh * sh), 2) + Rt * (deltaCp / (Kc * sc)) * (deltaHp / (Kh * sh)));
    return $064331241a6f3932$var$max(0, $064331241a6f3932$var$min(100, result));
}

});

parcelRegister("iB6ta", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8a0b365443a1f76$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
function $d8a0b365443a1f76$export$2e2bcd8739ae039(a, b, mode = 'lab') {
    // Delta E (CIE 1976)
    // see http://www.brucelindbloom.com/index.html?Equations.html
    a = new (0, $e7KSJ.default)(a);
    b = new (0, $e7KSJ.default)(b);
    const l1 = a.get(mode);
    const l2 = b.get(mode);
    let sum_sq = 0;
    for(let i in l1){
        const d = (l1[i] || 0) - (l2[i] || 0);
        sum_sq += d * d;
    }
    return Math.sqrt(sum_sq);
}

});

parcelRegister("dID0y", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fcda4939aef1ea4$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
var $9fcda4939aef1ea4$export$2e2bcd8739ae039 = (...args)=>{
    try {
        new (0, $e7KSJ.default)(...args);
        return true;
    // eslint-disable-next-line
    } catch (e) {
        return false;
    }
};

});

parcelRegister("1vtEw", function(module, exports) {

$parcel$export(module.exports, "default", () => $118fb0138dc62de8$export$2e2bcd8739ae039);
// some pre-defined color scales:

var $gaK1V = parcelRequire("gaK1V");
parcelRequire("fbI2I");

var $4ZQS0 = parcelRequire("4ZQS0");
var $118fb0138dc62de8$export$2e2bcd8739ae039 = {
    cool () {
        return (0, $4ZQS0.default)([
            (0, $gaK1V.default).hsl(180, 1, 0.9),
            (0, $gaK1V.default).hsl(250, 0.7, 0.4)
        ]);
    },
    hot () {
        return (0, $4ZQS0.default)([
            '#000',
            '#f00',
            '#ff0',
            '#fff'
        ], [
            0,
            0.25,
            0.75,
            1
        ]).mode('rgb');
    }
};

});

parcelRegister("6Sny4", function(module, exports) {

$parcel$export(module.exports, "default", () => $501a0d7a311e121c$export$2e2bcd8739ae039);
/**
    ColorBrewer colors for chroma.js

    Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The
    Pennsylvania State University.

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at
    http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software distributed
    under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
    CONDITIONS OF ANY KIND, either express or implied. See the License for the
    specific language governing permissions and limitations under the License.
*/ const $501a0d7a311e121c$var$colorbrewer = {
    // sequential
    OrRd: [
        '#fff7ec',
        '#fee8c8',
        '#fdd49e',
        '#fdbb84',
        '#fc8d59',
        '#ef6548',
        '#d7301f',
        '#b30000',
        '#7f0000'
    ],
    PuBu: [
        '#fff7fb',
        '#ece7f2',
        '#d0d1e6',
        '#a6bddb',
        '#74a9cf',
        '#3690c0',
        '#0570b0',
        '#045a8d',
        '#023858'
    ],
    BuPu: [
        '#f7fcfd',
        '#e0ecf4',
        '#bfd3e6',
        '#9ebcda',
        '#8c96c6',
        '#8c6bb1',
        '#88419d',
        '#810f7c',
        '#4d004b'
    ],
    Oranges: [
        '#fff5eb',
        '#fee6ce',
        '#fdd0a2',
        '#fdae6b',
        '#fd8d3c',
        '#f16913',
        '#d94801',
        '#a63603',
        '#7f2704'
    ],
    BuGn: [
        '#f7fcfd',
        '#e5f5f9',
        '#ccece6',
        '#99d8c9',
        '#66c2a4',
        '#41ae76',
        '#238b45',
        '#006d2c',
        '#00441b'
    ],
    YlOrBr: [
        '#ffffe5',
        '#fff7bc',
        '#fee391',
        '#fec44f',
        '#fe9929',
        '#ec7014',
        '#cc4c02',
        '#993404',
        '#662506'
    ],
    YlGn: [
        '#ffffe5',
        '#f7fcb9',
        '#d9f0a3',
        '#addd8e',
        '#78c679',
        '#41ab5d',
        '#238443',
        '#006837',
        '#004529'
    ],
    Reds: [
        '#fff5f0',
        '#fee0d2',
        '#fcbba1',
        '#fc9272',
        '#fb6a4a',
        '#ef3b2c',
        '#cb181d',
        '#a50f15',
        '#67000d'
    ],
    RdPu: [
        '#fff7f3',
        '#fde0dd',
        '#fcc5c0',
        '#fa9fb5',
        '#f768a1',
        '#dd3497',
        '#ae017e',
        '#7a0177',
        '#49006a'
    ],
    Greens: [
        '#f7fcf5',
        '#e5f5e0',
        '#c7e9c0',
        '#a1d99b',
        '#74c476',
        '#41ab5d',
        '#238b45',
        '#006d2c',
        '#00441b'
    ],
    YlGnBu: [
        '#ffffd9',
        '#edf8b1',
        '#c7e9b4',
        '#7fcdbb',
        '#41b6c4',
        '#1d91c0',
        '#225ea8',
        '#253494',
        '#081d58'
    ],
    Purples: [
        '#fcfbfd',
        '#efedf5',
        '#dadaeb',
        '#bcbddc',
        '#9e9ac8',
        '#807dba',
        '#6a51a3',
        '#54278f',
        '#3f007d'
    ],
    GnBu: [
        '#f7fcf0',
        '#e0f3db',
        '#ccebc5',
        '#a8ddb5',
        '#7bccc4',
        '#4eb3d3',
        '#2b8cbe',
        '#0868ac',
        '#084081'
    ],
    Greys: [
        '#ffffff',
        '#f0f0f0',
        '#d9d9d9',
        '#bdbdbd',
        '#969696',
        '#737373',
        '#525252',
        '#252525',
        '#000000'
    ],
    YlOrRd: [
        '#ffffcc',
        '#ffeda0',
        '#fed976',
        '#feb24c',
        '#fd8d3c',
        '#fc4e2a',
        '#e31a1c',
        '#bd0026',
        '#800026'
    ],
    PuRd: [
        '#f7f4f9',
        '#e7e1ef',
        '#d4b9da',
        '#c994c7',
        '#df65b0',
        '#e7298a',
        '#ce1256',
        '#980043',
        '#67001f'
    ],
    Blues: [
        '#f7fbff',
        '#deebf7',
        '#c6dbef',
        '#9ecae1',
        '#6baed6',
        '#4292c6',
        '#2171b5',
        '#08519c',
        '#08306b'
    ],
    PuBuGn: [
        '#fff7fb',
        '#ece2f0',
        '#d0d1e6',
        '#a6bddb',
        '#67a9cf',
        '#3690c0',
        '#02818a',
        '#016c59',
        '#014636'
    ],
    Viridis: [
        '#440154',
        '#482777',
        '#3f4a8a',
        '#31678e',
        '#26838f',
        '#1f9d8a',
        '#6cce5a',
        '#b6de2b',
        '#fee825'
    ],
    // diverging
    Spectral: [
        '#9e0142',
        '#d53e4f',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#ffffbf',
        '#e6f598',
        '#abdda4',
        '#66c2a5',
        '#3288bd',
        '#5e4fa2'
    ],
    RdYlGn: [
        '#a50026',
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#ffffbf',
        '#d9ef8b',
        '#a6d96a',
        '#66bd63',
        '#1a9850',
        '#006837'
    ],
    RdBu: [
        '#67001f',
        '#b2182b',
        '#d6604d',
        '#f4a582',
        '#fddbc7',
        '#f7f7f7',
        '#d1e5f0',
        '#92c5de',
        '#4393c3',
        '#2166ac',
        '#053061'
    ],
    PiYG: [
        '#8e0152',
        '#c51b7d',
        '#de77ae',
        '#f1b6da',
        '#fde0ef',
        '#f7f7f7',
        '#e6f5d0',
        '#b8e186',
        '#7fbc41',
        '#4d9221',
        '#276419'
    ],
    PRGn: [
        '#40004b',
        '#762a83',
        '#9970ab',
        '#c2a5cf',
        '#e7d4e8',
        '#f7f7f7',
        '#d9f0d3',
        '#a6dba0',
        '#5aae61',
        '#1b7837',
        '#00441b'
    ],
    RdYlBu: [
        '#a50026',
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee090',
        '#ffffbf',
        '#e0f3f8',
        '#abd9e9',
        '#74add1',
        '#4575b4',
        '#313695'
    ],
    BrBG: [
        '#543005',
        '#8c510a',
        '#bf812d',
        '#dfc27d',
        '#f6e8c3',
        '#f5f5f5',
        '#c7eae5',
        '#80cdc1',
        '#35978f',
        '#01665e',
        '#003c30'
    ],
    RdGy: [
        '#67001f',
        '#b2182b',
        '#d6604d',
        '#f4a582',
        '#fddbc7',
        '#ffffff',
        '#e0e0e0',
        '#bababa',
        '#878787',
        '#4d4d4d',
        '#1a1a1a'
    ],
    PuOr: [
        '#7f3b08',
        '#b35806',
        '#e08214',
        '#fdb863',
        '#fee0b6',
        '#f7f7f7',
        '#d8daeb',
        '#b2abd2',
        '#8073ac',
        '#542788',
        '#2d004b'
    ],
    // qualitative
    Set2: [
        '#66c2a5',
        '#fc8d62',
        '#8da0cb',
        '#e78ac3',
        '#a6d854',
        '#ffd92f',
        '#e5c494',
        '#b3b3b3'
    ],
    Accent: [
        '#7fc97f',
        '#beaed4',
        '#fdc086',
        '#ffff99',
        '#386cb0',
        '#f0027f',
        '#bf5b17',
        '#666666'
    ],
    Set1: [
        '#e41a1c',
        '#377eb8',
        '#4daf4a',
        '#984ea3',
        '#ff7f00',
        '#ffff33',
        '#a65628',
        '#f781bf',
        '#999999'
    ],
    Set3: [
        '#8dd3c7',
        '#ffffb3',
        '#bebada',
        '#fb8072',
        '#80b1d3',
        '#fdb462',
        '#b3de69',
        '#fccde5',
        '#d9d9d9',
        '#bc80bd',
        '#ccebc5',
        '#ffed6f'
    ],
    Dark2: [
        '#1b9e77',
        '#d95f02',
        '#7570b3',
        '#e7298a',
        '#66a61e',
        '#e6ab02',
        '#a6761d',
        '#666666'
    ],
    Paired: [
        '#a6cee3',
        '#1f78b4',
        '#b2df8a',
        '#33a02c',
        '#fb9a99',
        '#e31a1c',
        '#fdbf6f',
        '#ff7f00',
        '#cab2d6',
        '#6a3d9a',
        '#ffff99',
        '#b15928'
    ],
    Pastel2: [
        '#b3e2cd',
        '#fdcdac',
        '#cbd5e8',
        '#f4cae4',
        '#e6f5c9',
        '#fff2ae',
        '#f1e2cc',
        '#cccccc'
    ],
    Pastel1: [
        '#fbb4ae',
        '#b3cde3',
        '#ccebc5',
        '#decbe4',
        '#fed9a6',
        '#ffffcc',
        '#e5d8bd',
        '#fddaec',
        '#f2f2f2'
    ]
};
const $501a0d7a311e121c$var$colorbrewerTypes = Object.keys($501a0d7a311e121c$var$colorbrewer);
const $501a0d7a311e121c$var$typeMap = new Map($501a0d7a311e121c$var$colorbrewerTypes.map((key)=>[
        key.toLowerCase(),
        key
    ]));
// use Proxy to allow case-insensitive access to palettes
const $501a0d7a311e121c$var$colorbrewerProxy = typeof Proxy === 'function' ? new Proxy($501a0d7a311e121c$var$colorbrewer, {
    get (target, prop) {
        const lower = prop.toLowerCase();
        if ($501a0d7a311e121c$var$typeMap.has(lower)) return target[$501a0d7a311e121c$var$typeMap.get(lower)];
    },
    getOwnPropertyNames () {
        return Object.getOwnPropertyNames($501a0d7a311e121c$var$colorbrewerTypes);
    }
}) : $501a0d7a311e121c$var$colorbrewer;
var $501a0d7a311e121c$export$2e2bcd8739ae039 = $501a0d7a311e121c$var$colorbrewerProxy;

});

parcelRegister("7hd9c", function(module, exports) {

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $jKxIE = parcelRequire("jKxIE");

var $2o2Lo = parcelRequire("2o2Lo");
(0, $e7KSJ.default).prototype.cmyk = function() {
    return (0, $2o2Lo.default)(this._rgb);
};
const $54c451bcc042ac64$export$358b1a66a3c77756 = (...args)=>new (0, $e7KSJ.default)(...args, 'cmyk');
Object.assign((0, $gaK1V.default), {
    cmyk: $54c451bcc042ac64$export$358b1a66a3c77756
});
(0, $lT4NS.default).format.cmyk = (0, $jKxIE.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'cmyk');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 4) return 'cmyk';
    }
});

});
parcelRegister("jKxIE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e60c7822c37b0c25$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $e60c7822c37b0c25$var$cmyk2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'cmyk');
    const [c, m, y, k] = args;
    const alpha = args.length > 4 ? args[4] : 1;
    if (k === 1) return [
        0,
        0,
        0,
        alpha
    ];
    return [
        c >= 1 ? 0 : 255 * (1 - c) * (1 - k),
        m >= 1 ? 0 : 255 * (1 - m) * (1 - k),
        y >= 1 ? 0 : 255 * (1 - y) * (1 - k),
        alpha
    ];
};
var $e60c7822c37b0c25$export$2e2bcd8739ae039 = $e60c7822c37b0c25$var$cmyk2rgb;

});

parcelRegister("2o2Lo", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bcff769908141f5$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { max: $1bcff769908141f5$var$max } = Math;
const $1bcff769908141f5$var$rgb2cmyk = (...args)=>{
    let [r, g, b] = (0, $43ZPL.default)(args, 'rgb');
    r = r / 255;
    g = g / 255;
    b = b / 255;
    const k = 1 - $1bcff769908141f5$var$max(r, $1bcff769908141f5$var$max(g, b));
    const f = k < 1 ? 1 / (1 - k) : 0;
    const c = (1 - r - k) * f;
    const m = (1 - g - k) * f;
    const y = (1 - b - k) * f;
    return [
        c,
        m,
        y,
        k
    ];
};
var $1bcff769908141f5$export$2e2bcd8739ae039 = $1bcff769908141f5$var$rgb2cmyk;

});


parcelRegister("cIiSk", function(module, exports) {

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $iwUkC = parcelRequire("iwUkC");

var $lmq0O = parcelRequire("lmq0O");
(0, $e7KSJ.default).prototype.css = function(mode) {
    return (0, $iwUkC.default)(this._rgb, mode);
};
const $94183c5a55123dcc$export$dbf350e5966cf602 = (...args)=>new (0, $e7KSJ.default)(...args, 'css');
(0, $gaK1V.default).css = $94183c5a55123dcc$export$dbf350e5966cf602;
(0, $lT4NS.default).format.css = (0, $lmq0O.default);
(0, $lT4NS.default).autodetect.push({
    p: 5,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $hMEmV.default)(h) === 'string' && (0, $lmq0O.default).test(h)) return 'css';
    }
});

});
parcelRegister("iwUkC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7d6e97251c964b7$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $7ElX1 = parcelRequire("7ElX1");
var $43ZPL = parcelRequire("43ZPL");

var $8r7If = parcelRequire("8r7If");

var $f9fTr = parcelRequire("f9fTr");

var $6Sszj = parcelRequire("6Sszj");

var $luvnN = parcelRequire("luvnN");

var $c020c = parcelRequire("c020c");

var $jSfgf = parcelRequire("jSfgf");

var $eJb2q = parcelRequire("eJb2q");

var $5KW7E = parcelRequire("5KW7E");

var $855Nw = parcelRequire("855Nw");

var $a0o1I = parcelRequire("a0o1I");

var $8weUB = parcelRequire("8weUB");
const { round: $d7d6e97251c964b7$var$round } = Math;
/*
 * supported arguments:
 * - rgb2css(r,g,b)
 * - rgb2css(r,g,b,a)
 * - rgb2css([r,g,b], mode)
 * - rgb2css([r,g,b,a], mode)
 * - rgb2css({r,g,b,a}, mode)
 */ const $d7d6e97251c964b7$var$rgb2css = (...args)=>{
    const rgba = (0, $43ZPL.default)(args, 'rgba');
    let mode = (0, $7ElX1.default)(args) || 'rgb';
    if (mode.substr(0, 3) === 'hsl') return (0, $8r7If.default)((0, $f9fTr.default)(rgba), mode);
    if (mode.substr(0, 3) === 'lab') {
        // change to D50 lab whitepoint since this is what W3C is using for CSS Lab colors
        const prevWhitePoint = (0, $8weUB.getLabWhitePoint)();
        (0, $8weUB.setLabWhitePoint)('d50');
        const cssColor = (0, $6Sszj.default)((0, $luvnN.default)(rgba), mode);
        (0, $8weUB.setLabWhitePoint)(prevWhitePoint);
        return cssColor;
    }
    if (mode.substr(0, 3) === 'lch') {
        // change to D50 lab whitepoint since this is what W3C is using for CSS Lab colors
        const prevWhitePoint = (0, $8weUB.getLabWhitePoint)();
        (0, $8weUB.setLabWhitePoint)('d50');
        const cssColor = (0, $c020c.default)((0, $jSfgf.default)(rgba), mode);
        (0, $8weUB.setLabWhitePoint)(prevWhitePoint);
        return cssColor;
    }
    if (mode.substr(0, 5) === 'oklab') return (0, $5KW7E.default)((0, $eJb2q.default)(rgba));
    if (mode.substr(0, 5) === 'oklch') return (0, $a0o1I.default)((0, $855Nw.default)(rgba));
    rgba[0] = $d7d6e97251c964b7$var$round(rgba[0]);
    rgba[1] = $d7d6e97251c964b7$var$round(rgba[1]);
    rgba[2] = $d7d6e97251c964b7$var$round(rgba[2]);
    if (mode === 'rgba' || rgba.length > 3 && rgba[3] < 1) {
        rgba[3] = '/ ' + (rgba.length > 3 ? rgba[3] : 1);
        mode = 'rgba';
    }
    return `${mode.substr(0, 3)}(${rgba.slice(0, mode === 'rgb' ? 3 : 4).join(' ')})`;
};
var $d7d6e97251c964b7$export$2e2bcd8739ae039 = $d7d6e97251c964b7$var$rgb2css;

});
parcelRegister("8r7If", function(module, exports) {

$parcel$export(module.exports, "default", () => $6246d3ee765f7d54$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $7ElX1 = parcelRequire("7ElX1");
var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
/*
 * supported arguments:
 * - hsl2css(h,s,l)
 * - hsl2css(h,s,l,a)
 * - hsl2css([h,s,l], mode)
 * - hsl2css([h,s,l,a], mode)
 * - hsl2css({h,s,l,a}, mode)
 */ const $6246d3ee765f7d54$var$hsl2css = (...args)=>{
    const hsla = (0, $43ZPL.default)(args, 'hsla');
    let mode = (0, $7ElX1.default)(args) || 'lsa';
    hsla[0] = (0, $i4gda.rnd2)(hsla[0] || 0) + 'deg';
    hsla[1] = (0, $i4gda.rnd2)(hsla[1] * 100) + '%';
    hsla[2] = (0, $i4gda.rnd2)(hsla[2] * 100) + '%';
    if (mode === 'hsla' || hsla.length > 3 && hsla[3] < 1) {
        hsla[3] = '/ ' + (hsla.length > 3 ? hsla[3] : 1);
        mode = 'hsla';
    } else hsla.length = 3;
    return `${mode.substr(0, 3)}(${hsla.join(' ')})`;
};
var $6246d3ee765f7d54$export$2e2bcd8739ae039 = $6246d3ee765f7d54$var$hsl2css;

});

parcelRegister("6Sszj", function(module, exports) {

$parcel$export(module.exports, "default", () => $501df25942503107$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $7ElX1 = parcelRequire("7ElX1");
var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
/*
 * supported arguments:
 * - lab2css(l,a,b)
 * - lab2css(l,a,b,alpha)
 * - lab2css([l,a,b], mode)
 * - lab2css([l,a,b,alpha], mode)
 */ const $501df25942503107$var$lab2css = (...args)=>{
    const laba = (0, $43ZPL.default)(args, 'lab');
    let mode = (0, $7ElX1.default)(args) || 'lab';
    laba[0] = (0, $i4gda.rnd2)(laba[0]) + '%';
    laba[1] = (0, $i4gda.rnd2)(laba[1]);
    laba[2] = (0, $i4gda.rnd2)(laba[2]);
    if (mode === 'laba' || laba.length > 3 && laba[3] < 1) laba[3] = '/ ' + (laba.length > 3 ? laba[3] : 1);
    else laba.length = 3;
    return `lab(${laba.join(' ')})`;
};
var $501df25942503107$export$2e2bcd8739ae039 = $501df25942503107$var$lab2css;

});

parcelRegister("c020c", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bc709b6cfda3284$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $7ElX1 = parcelRequire("7ElX1");
var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
/*
 * supported arguments:
 * - lab2css(l,a,b)
 * - lab2css(l,a,b,alpha)
 * - lab2css([l,a,b], mode)
 * - lab2css([l,a,b,alpha], mode)
 */ const $8bc709b6cfda3284$var$lch2css = (...args)=>{
    const lcha = (0, $43ZPL.default)(args, 'lch');
    let mode = (0, $7ElX1.default)(args) || 'lab';
    lcha[0] = (0, $i4gda.rnd2)(lcha[0]) + '%';
    lcha[1] = (0, $i4gda.rnd2)(lcha[1]);
    lcha[2] = isNaN(lcha[2]) ? 'none' : (0, $i4gda.rnd2)(lcha[2]) + 'deg'; // add deg unit to hue
    if (mode === 'lcha' || lcha.length > 3 && lcha[3] < 1) lcha[3] = '/ ' + (lcha.length > 3 ? lcha[3] : 1);
    else lcha.length = 3;
    return `lch(${lcha.join(' ')})`;
};
var $8bc709b6cfda3284$export$2e2bcd8739ae039 = $8bc709b6cfda3284$var$lch2css;

});

parcelRegister("5KW7E", function(module, exports) {

$parcel$export(module.exports, "default", () => $430e55826084c20e$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $430e55826084c20e$var$oklab2css = (...args)=>{
    const laba = (0, $43ZPL.default)(args, 'lab');
    laba[0] = (0, $i4gda.rnd2)(laba[0] * 100) + '%';
    laba[1] = (0, $i4gda.rnd3)(laba[1]);
    laba[2] = (0, $i4gda.rnd3)(laba[2]);
    if (laba.length > 3 && laba[3] < 1) laba[3] = '/ ' + (laba.length > 3 ? laba[3] : 1);
    else laba.length = 3;
    return `oklab(${laba.join(' ')})`;
};
var $430e55826084c20e$export$2e2bcd8739ae039 = $430e55826084c20e$var$oklab2css;

});

parcelRegister("855Nw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e2349b11f40bce3$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $eJb2q = parcelRequire("eJb2q");

var $36WLn = parcelRequire("36WLn");
const $5e2349b11f40bce3$var$rgb2oklch = (...args)=>{
    const [r, g, b, ...rest] = (0, $43ZPL.default)(args, 'rgb');
    const [l, a, b_] = (0, $eJb2q.default)(r, g, b);
    const [L, c, h] = (0, $36WLn.default)(l, a, b_);
    return [
        L,
        c,
        h,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
var $5e2349b11f40bce3$export$2e2bcd8739ae039 = $5e2349b11f40bce3$var$rgb2oklch;

});

parcelRegister("a0o1I", function(module, exports) {

$parcel$export(module.exports, "default", () => $748c8aa705dcdecb$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $748c8aa705dcdecb$var$oklch2css = (...args)=>{
    const lcha = (0, $43ZPL.default)(args, 'lch');
    lcha[0] = (0, $i4gda.rnd2)(lcha[0] * 100) + '%';
    lcha[1] = (0, $i4gda.rnd3)(lcha[1]);
    lcha[2] = isNaN(lcha[2]) ? 'none' : (0, $i4gda.rnd2)(lcha[2]) + 'deg'; // add deg unit to hue
    if (lcha.length > 3 && lcha[3] < 1) lcha[3] = '/ ' + (lcha.length > 3 ? lcha[3] : 1);
    else lcha.length = 3;
    return `oklch(${lcha.join(' ')})`;
};
var $748c8aa705dcdecb$export$2e2bcd8739ae039 = $748c8aa705dcdecb$var$oklch2css;

});


parcelRegister("lmq0O", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8cfd480aa486045$export$2e2bcd8739ae039);

var $7PGtI = parcelRequire("7PGtI");

var $jenZn = parcelRequire("jenZn");

var $g4jd5 = parcelRequire("g4jd5");

var $5D4bx = parcelRequire("5D4bx");

var $9cCPH = parcelRequire("9cCPH");

var $lT4NS = parcelRequire("lT4NS");

var $gb2Ug = parcelRequire("gb2Ug");

var $8weUB = parcelRequire("8weUB");
const $f8cfd480aa486045$var$INT_OR_PCT = /((?:-?\d+)|(?:-?\d+(?:\.\d+)?)%|none)/.source;
const $f8cfd480aa486045$var$FLOAT_OR_PCT = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)%?)|none)/.source;
const $f8cfd480aa486045$var$PCT = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)%)|none)/.source;
const $f8cfd480aa486045$var$RE_S = /\s*/.source;
const $f8cfd480aa486045$var$SEP = /\s+/.source;
const $f8cfd480aa486045$var$COMMA = /\s*,\s*/.source;
const $f8cfd480aa486045$var$ANLGE = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)(?:deg)?)|none)/.source;
const $f8cfd480aa486045$var$ALPHA = /\s*(?:\/\s*((?:[01]|[01]?\.\d+)|\d+(?:\.\d+)?%))?/.source;
// e.g. rgb(250 20 0), rgb(100% 50% 20%), rgb(100% 50% 20% / 0.5)
const $f8cfd480aa486045$var$RE_RGB = new RegExp('^rgba?\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const $f8cfd480aa486045$var$RE_RGB_LEGACY = new RegExp('^rgb\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT
].join($f8cfd480aa486045$var$COMMA) + $f8cfd480aa486045$var$RE_S + '\\)$');
const $f8cfd480aa486045$var$RE_RGBA_LEGACY = new RegExp('^rgba\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT
].join($f8cfd480aa486045$var$COMMA) + $f8cfd480aa486045$var$RE_S + '\\)$');
const $f8cfd480aa486045$var$RE_HSL = new RegExp('^hsla?\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$ANLGE,
    $f8cfd480aa486045$var$PCT,
    $f8cfd480aa486045$var$PCT
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const $f8cfd480aa486045$var$RE_HSL_LEGACY = new RegExp('^hsl?\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$ANLGE,
    $f8cfd480aa486045$var$PCT,
    $f8cfd480aa486045$var$PCT
].join($f8cfd480aa486045$var$COMMA) + $f8cfd480aa486045$var$RE_S + '\\)$');
const $f8cfd480aa486045$var$RE_HSLA_LEGACY = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
const $f8cfd480aa486045$var$RE_LAB = new RegExp('^lab\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const $f8cfd480aa486045$var$RE_LCH = new RegExp('^lch\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$ANLGE
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const $f8cfd480aa486045$var$RE_OKLAB = new RegExp('^oklab\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const $f8cfd480aa486045$var$RE_OKLCH = new RegExp('^oklch\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$ANLGE
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const { round: $f8cfd480aa486045$var$round } = Math;
const $f8cfd480aa486045$var$roundRGB = (rgb)=>{
    return rgb.map((v, i)=>i <= 2 ? (0, $gb2Ug.default)($f8cfd480aa486045$var$round(v), 0, 255) : v);
};
const $f8cfd480aa486045$var$percentToAbsolute = (pct, min = 0, max = 100, signed = false)=>{
    if (typeof pct === 'string' && pct.endsWith('%')) {
        pct = parseFloat(pct.substring(0, pct.length - 1)) / 100;
        if (signed) // signed percentages are in the range -100% to 100%
        pct = min + (pct + 1) * 0.5 * (max - min);
        else pct = min + pct * (max - min);
    }
    return +pct;
};
const $f8cfd480aa486045$var$noneToValue = (v, noneValue)=>{
    return v === 'none' ? noneValue : v;
};
const $f8cfd480aa486045$var$css2rgb = (css)=>{
    css = css.toLowerCase().trim();
    if (css === 'transparent') return [
        0,
        0,
        0,
        0
    ];
    let m;
    if ((0, $lT4NS.default).format.named) try {
        return (0, $lT4NS.default).format.named(css);
    // eslint-disable-next-line
    } catch (e) {}
    // rgb(250 20 0) or rgb(250,20,0)
    if ((m = css.match($f8cfd480aa486045$var$RE_RGB)) || (m = css.match($f8cfd480aa486045$var$RE_RGB_LEGACY))) {
        let rgb = m.slice(1, 4);
        for(let i = 0; i < 3; i++)rgb[i] = +$f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(rgb[i], 0), 0, 255);
        rgb = $f8cfd480aa486045$var$roundRGB(rgb);
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha; // default alpha
        return rgb;
    }
    // rgba(250,20,0,0.4)
    if (m = css.match($f8cfd480aa486045$var$RE_RGBA_LEGACY)) {
        const rgb = m.slice(1, 5);
        for(let i = 0; i < 4; i++)rgb[i] = +$f8cfd480aa486045$var$percentToAbsolute(rgb[i], 0, 255);
        return rgb;
    }
    // hsl(0,100%,50%)
    if ((m = css.match($f8cfd480aa486045$var$RE_HSL)) || (m = css.match($f8cfd480aa486045$var$RE_HSL_LEGACY))) {
        const hsl = m.slice(1, 4);
        hsl[0] = +$f8cfd480aa486045$var$noneToValue(hsl[0].replace('deg', ''), 0);
        hsl[1] = +$f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(hsl[1], 0), 0, 100) * 0.01;
        hsl[2] = +$f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(hsl[2], 0), 0, 100) * 0.01;
        const rgb = $f8cfd480aa486045$var$roundRGB((0, $7PGtI.default)(hsl));
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    // hsla(0,100%,50%,0.5)
    if (m = css.match($f8cfd480aa486045$var$RE_HSLA_LEGACY)) {
        const hsl = m.slice(1, 4);
        hsl[1] *= 0.01;
        hsl[2] *= 0.01;
        const rgb = (0, $7PGtI.default)(hsl);
        for(let i = 0; i < 3; i++)rgb[i] = $f8cfd480aa486045$var$round(rgb[i]);
        rgb[3] = +m[4]; // default alpha = 1
        return rgb;
    }
    if (m = css.match($f8cfd480aa486045$var$RE_LAB)) {
        const lab = m.slice(1, 4);
        lab[0] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(lab[0], 0), 0, 100);
        lab[1] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(lab[1], 0), -125, 125, true);
        lab[2] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(lab[2], 0), -125, 125, true);
        // convert to D50 Lab whitepoint
        const wp = (0, $8weUB.getLabWhitePoint)();
        (0, $8weUB.setLabWhitePoint)('d50');
        const rgb = $f8cfd480aa486045$var$roundRGB((0, $jenZn.default)(lab));
        // convert back to original Lab whitepoint
        (0, $8weUB.setLabWhitePoint)(wp);
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    if (m = css.match($f8cfd480aa486045$var$RE_LCH)) {
        const lch = m.slice(1, 4);
        lch[0] = $f8cfd480aa486045$var$percentToAbsolute(lch[0], 0, 100);
        lch[1] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(lch[1], 0), 0, 150, false);
        lch[2] = +$f8cfd480aa486045$var$noneToValue(lch[2].replace('deg', ''), 0);
        // convert to D50 Lab whitepoint
        const wp = (0, $8weUB.getLabWhitePoint)();
        (0, $8weUB.setLabWhitePoint)('d50');
        const rgb = $f8cfd480aa486045$var$roundRGB((0, $g4jd5.default)(lch));
        // convert back to original Lab whitepoint
        (0, $8weUB.setLabWhitePoint)(wp);
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    if (m = css.match($f8cfd480aa486045$var$RE_OKLAB)) {
        const oklab = m.slice(1, 4);
        oklab[0] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(oklab[0], 0), 0, 1);
        oklab[1] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(oklab[1], 0), -0.4, 0.4, true);
        oklab[2] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(oklab[2], 0), -0.4, 0.4, true);
        const rgb = $f8cfd480aa486045$var$roundRGB((0, $5D4bx.default)(oklab));
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    if (m = css.match($f8cfd480aa486045$var$RE_OKLCH)) {
        const oklch = m.slice(1, 4);
        oklch[0] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(oklch[0], 0), 0, 1);
        oklch[1] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(oklch[1], 0), 0, 0.4, false);
        oklch[2] = +$f8cfd480aa486045$var$noneToValue(oklch[2].replace('deg', ''), 0);
        const rgb = $f8cfd480aa486045$var$roundRGB((0, $9cCPH.default)(oklch));
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
};
$f8cfd480aa486045$var$css2rgb.test = (s)=>{
    return(// modern
    $f8cfd480aa486045$var$RE_RGB.test(s) || $f8cfd480aa486045$var$RE_HSL.test(s) || $f8cfd480aa486045$var$RE_LAB.test(s) || $f8cfd480aa486045$var$RE_LCH.test(s) || $f8cfd480aa486045$var$RE_OKLAB.test(s) || $f8cfd480aa486045$var$RE_OKLCH.test(s) || // legacy
    $f8cfd480aa486045$var$RE_RGB_LEGACY.test(s) || $f8cfd480aa486045$var$RE_RGBA_LEGACY.test(s) || $f8cfd480aa486045$var$RE_HSL_LEGACY.test(s) || $f8cfd480aa486045$var$RE_HSLA_LEGACY.test(s) || s === 'transparent');
};
var $f8cfd480aa486045$export$2e2bcd8739ae039 = $f8cfd480aa486045$var$css2rgb;

});
parcelRegister("9cCPH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b335b6c71084560$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $d6n2X = parcelRequire("d6n2X");

var $5D4bx = parcelRequire("5D4bx");
const $6b335b6c71084560$var$oklch2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'lch');
    const [l, c, h, ...rest] = args;
    const [L, a, b_] = (0, $d6n2X.default)(l, c, h);
    const [r, g, b] = (0, $5D4bx.default)(L, a, b_);
    return [
        r,
        g,
        b,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
var $6b335b6c71084560$export$2e2bcd8739ae039 = $6b335b6c71084560$var$oklch2rgb;

});



parcelRegister("kBR14", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $gaK1V = parcelRequire("gaK1V");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
(0, $lT4NS.default).format.gl = (...args)=>{
    const rgb = (0, $43ZPL.default)(args, 'rgba');
    rgb[0] *= 255;
    rgb[1] *= 255;
    rgb[2] *= 255;
    return rgb;
};
const $f010634c2ba757fa$export$5822a9d0880a5d82 = (...args)=>new (0, $e7KSJ.default)(...args, 'gl');
(0, $gaK1V.default).gl = $f010634c2ba757fa$export$5822a9d0880a5d82;
(0, $e7KSJ.default).prototype.gl = function() {
    const rgb = this._rgb;
    return [
        rgb[0] / 255,
        rgb[1] / 255,
        rgb[2] / 255,
        rgb[3]
    ];
};

});

parcelRegister("bmZFS", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $gaK1V = parcelRequire("gaK1V");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $lT4NS = parcelRequire("lT4NS");

var $2BpKe = parcelRequire("2BpKe");

var $eL95G = parcelRequire("eL95G");
(0, $e7KSJ.default).prototype.hex = function(mode) {
    return (0, $eL95G.default)(this._rgb, mode);
};
const $84719710001139ea$export$834dfc94dde4b3d8 = (...args)=>new (0, $e7KSJ.default)(...args, 'hex');
(0, $gaK1V.default).hex = $84719710001139ea$export$834dfc94dde4b3d8;
(0, $lT4NS.default).format.hex = (0, $2BpKe.default);
(0, $lT4NS.default).autodetect.push({
    p: 4,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $hMEmV.default)(h) === 'string' && [
            3,
            4,
            5,
            6,
            7,
            8,
            9
        ].indexOf(h.length) >= 0) return 'hex';
    }
});

});

parcelRegister("i89Hq", function(module, exports) {

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $4vyUC = parcelRequire("4vyUC");

var $1X2Gd = parcelRequire("1X2Gd");
(0, $e7KSJ.default).prototype.temp = (0, $e7KSJ.default).prototype.kelvin = (0, $e7KSJ.default).prototype.temperature = function() {
    return (0, $1X2Gd.default)(this._rgb);
};
const $d3307f7157ff91e7$export$8d72b093afd1813e = (...args)=>new (0, $e7KSJ.default)(...args, 'temp');
Object.assign((0, $gaK1V.default), {
    temp: $d3307f7157ff91e7$export$8d72b093afd1813e,
    kelvin: $d3307f7157ff91e7$export$8d72b093afd1813e,
    temperature: $d3307f7157ff91e7$export$8d72b093afd1813e
});
(0, $lT4NS.default).format.temp = (0, $lT4NS.default).format.kelvin = (0, $lT4NS.default).format.temperature = (0, $4vyUC.default);

});
parcelRegister("4vyUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $34852385cec165f3$export$2e2bcd8739ae039);
/*
 * Based on implementation by Neil Bartlett
 * https://github.com/neilbartlett/color-temperature
 */ const { log: $34852385cec165f3$var$log } = Math;
const $34852385cec165f3$var$temperature2rgb = (kelvin)=>{
    const temp = kelvin / 100;
    let r, g, b;
    if (temp < 66) {
        r = 255;
        g = temp < 6 ? 0 : -155.25485562709179 - 0.44596950469579133 * (g = temp - 2) + 104.49216199393888 * $34852385cec165f3$var$log(g);
        b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp - 10) + 115.67994401066147 * $34852385cec165f3$var$log(b);
    } else {
        r = 351.97690566805693 + 0.114206453784165 * (r = temp - 55) - 40.25366309332127 * $34852385cec165f3$var$log(r);
        g = 325.4494125711974 + 0.07943456536662342 * (g = temp - 50) - 28.0852963507957 * $34852385cec165f3$var$log(g);
        b = 255;
    }
    return [
        r,
        g,
        b,
        1
    ];
};
var $34852385cec165f3$export$2e2bcd8739ae039 = $34852385cec165f3$var$temperature2rgb;

});

parcelRegister("1X2Gd", function(module, exports) {

$parcel$export(module.exports, "default", () => $16bd614d337f08eb$export$2e2bcd8739ae039);
/*
 * Based on implementation by Neil Bartlett
 * https://github.com/neilbartlett/color-temperature
 **/ 
var $4vyUC = parcelRequire("4vyUC");
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { round: $16bd614d337f08eb$var$round } = Math;
const $16bd614d337f08eb$var$rgb2temperature = (...args)=>{
    const rgb = (0, $43ZPL.default)(args, 'rgb');
    const r = rgb[0], b = rgb[2];
    let minTemp = 1000;
    let maxTemp = 40000;
    const eps = 0.4;
    let temp;
    while(maxTemp - minTemp > eps){
        temp = (maxTemp + minTemp) * 0.5;
        const rgb = (0, $4vyUC.default)(temp);
        if (rgb[2] / rgb[0] >= b / r) maxTemp = temp;
        else minTemp = temp;
    }
    return $16bd614d337f08eb$var$round(temp);
};
var $16bd614d337f08eb$export$2e2bcd8739ae039 = $16bd614d337f08eb$var$rgb2temperature;

});


parcelRegister("35MHU", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $9cCPH = parcelRequire("9cCPH");

var $855Nw = parcelRequire("855Nw");
(0, $e7KSJ.default).prototype.oklch = function() {
    return (0, $855Nw.default)(this._rgb);
};
const $24079ef8e8403722$export$c21b932a666e3753 = (...args)=>new (0, $e7KSJ.default)(...args, 'oklch');
Object.assign((0, $gaK1V.default), {
    oklch: $24079ef8e8403722$export$c21b932a666e3753
});
(0, $lT4NS.default).format.oklch = (0, $9cCPH.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'oklch');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'oklch';
    }
});

});



parcelRegister("ceOOn", function(module, exports) {

$parcel$export(module.exports, "getAllCookies", () => $8e8e34fa89bb9263$export$1191989ae3ee4c15);
const $8e8e34fa89bb9263$export$1191989ae3ee4c15 = ()=>{
    const cookies = document.cookie.split('; ');
    const allCookies = [];
    cookies.forEach((cookie)=>{
        const cookieParts = cookie.split('=');
        allCookies[cookieParts[0]] = cookieParts[1];
    });
    return allCookies;
};

});

parcelRegister("a3TA1", function(module, exports) {

$parcel$export(module.exports, "elementReady", () => $75354c334d353ce6$export$5a68694636710d38);
const $75354c334d353ce6$export$5a68694636710d38 = (selector)=>new Promise((resolve)=>{
        const el = document.querySelectorAll(selector);
        if (el.length) {
            resolve(el);
            return;
        }
        new MutationObserver(()=>{
            // Query for elements matching the specified selector
            Array.from(document.querySelectorAll(selector)).forEach((element)=>{
                resolve(element);
            });
        }).observe(document.documentElement, {
            childList: true,
            subtree: true
        });
    });

});

parcelRegister("6oLIz", function(module, exports) {

$parcel$export(module.exports, "addWindowResizeEvent", () => $4a89ffbcc8257418$export$5f2cd73bfe4df536);
$parcel$export(module.exports, "addWindowScrollEvent", () => $4a89ffbcc8257418$export$b502183889628ce0);
const $4a89ffbcc8257418$export$5f2cd73bfe4df536 = (callback)=>{
    let timeout;
    window.addEventListener('resize', ()=>{
        clearTimeout(timeout);
        timeout = setTimeout(callback, 250);
    });
};
const $4a89ffbcc8257418$export$b502183889628ce0 = (callback)=>{
    let timeout;
    window.addEventListener('scroll', ()=>{
        clearTimeout(timeout);
        timeout = setTimeout(callback, 250);
    });
};

});

parcelRegister("isKkJ", function(module, exports) {

$parcel$export(module.exports, "getReCAPTCHAResponse", () => $d70ec861cf7f176b$export$26ae508a4c7ca84d);

var $6sEQA = parcelRequire("6sEQA");
const $d70ec861cf7f176b$export$26ae508a4c7ca84d = async (action)=>{
    try {
        const themeData = await (0, $6sEQA.getThemeData)();
        if (!themeData.recaptcha_site_key) throw new Error('Missing Google reCAPTCHA Site Key in theme configuration');
        if (!themeData.ajax_actions?.recaptcha_verify) throw new Error('Missing AJAX route to verify reCAPTCHA token');
        if (!themeData.ajax_route) throw new Error('Missing global AJAX route');
        return new Promise((resolve, reject)=>{
            if (window.grecaptcha === undefined) {
                console.warn('Google reCAPTCHA is not loaded');
                resolve({
                    success: true,
                    score: 1
                });
            } else grecaptcha.ready(function() {
                grecaptcha.execute(themeData.recaptcha_site_key, {
                    action: action
                }).then(async function(token) {
                    const formData = new FormData();
                    formData.append('action', themeData.ajax_actions.recaptcha_verify);
                    // Determine if request is just a test
                    const testParam = 'e2e-test';
                    const url = new URL(window.location);
                    if (url.searchParams.has(testParam)) token = 'e2e-test-valid-user';
                    // Set reCATPCHA token
                    formData.append('recaptcha_token', token);
                    try {
                        const response = await fetch(themeData.ajax_route, {
                            method: 'POST',
                            body: formData
                        });
                        const json = await response.json();
                        if (json.success) resolve(json);
                        else if (json['error-codes']) {
                            /**
								 * reCATPCHA verification error codes
								 * @link https://developers.google.com/recaptcha/docs/verify#error_code_reference
								 *
								 * missing-input-secret	  The secret parameter is missing.
								 * invalid-input-secret	  The secret parameter is invalid or malformed.
								 * missing-input-response	The response parameter is missing.
								 * invalid-input-response	The response parameter is invalid or malformed.
								 * bad-request	          The request is invalid or malformed.
								 * timeout-or-duplicate	  The response is no longer valid: either is too old or has been used previously.
								 */ let errorMessages = [];
                            json['error-codes'].forEach((errorCode)=>{
                                switch(errorCode){
                                    case 'missing-input-secret':
                                        errorMessages.push('The secret parameter is missing.');
                                        break;
                                    case 'invalid-input-secret':
                                        errorMessages.push('The secret parameter is invalid or malformed.');
                                        break;
                                    case 'missing-input-response':
                                        errorMessages.push('The response parameter is missing.');
                                        break;
                                    case 'invalid-input-response':
                                        errorMessages.push('The response parameter is invalid or malformed.');
                                        break;
                                    case 'bad-request':
                                        errorMessages.push('The request is invalid or malformed.');
                                        break;
                                    case 'timeout-or-duplicate':
                                        errorMessages.push('The response is no longer valid: either is too old or has been used previously.');
                                        break;
                                    default:
                                        errorMessages.push('Unknown reCATPCHA error code');
                                }
                            });
                            throw new Error(`There was an error when trying to verify the user's response by reCATPCHA:\n${errorMessages.join('\n')}`);
                        } else if (json.data) throw new Error(`The request to verify the reCAPTCHA user token failed: ${response.data}`);
                        else throw new Error('Unknown error occurred when trying to verify the reCATPCHA user token');
                    } catch (e) {
                        reject(e);
                    }
                });
            });
        });
    } catch (e) {
        console.error(e);
    }
};

});
parcelRegister("6sEQA", function(module, exports) {

$parcel$export(module.exports, "getThemeData", () => $4b450af9f6d18c72$export$3c72f11fd9e5031f);
const $4b450af9f6d18c72$export$3c72f11fd9e5031f = ()=>{
    if (!window.themeDataRestUrl) throw new Error('Missing themeDataRestUrl in global context');
    else {
        const sessionStorageKey = 'themeData';
        return new Promise((resolve, reject)=>{
            if (sessionStorage.getItem('themeData')) resolve(JSON.parse(sessionStorage.getItem(sessionStorageKey)));
            else fetch(window.themeDataRestUrl).then((res)=>res.json()).then((data)=>{
                try {
                    sessionStorage.setItem(sessionStorageKey, JSON.stringify(data));
                } catch (e) {
                    console.warn(e);
                }
                resolve(data);
            }).catch((e)=>reject(e));
        });
    }
};

});


parcelRegister("h30hJ", function(module, exports) {

$parcel$export(module.exports, "slideUp", () => $c692f0128d3d0bc1$export$deed561b1a0ff1ea);
$parcel$export(module.exports, "slideDown", () => $c692f0128d3d0bc1$export$abdd11a06a163232);
const $c692f0128d3d0bc1$export$deed561b1a0ff1ea = (target, duration = 500)=>{
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    [
        'height',
        'paddingTop',
        'paddingBottom',
        'marginTop',
        'marginBottom'
    ].forEach((prop)=>{
        target.style[prop] = 0;
    });
    window.setTimeout(()=>{
        target.style.display = 'none';
        [
            'height',
            'padding-top',
            'padding-bottom',
            'margin-top',
            'margin-bottom',
            'overflow',
            'transition-duration',
            'transition-property'
        ].forEach((prop)=>target.style.removeProperty(prop));
    }, duration);
};
const $c692f0128d3d0bc1$export$abdd11a06a163232 = (target, duration = 500)=>{
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    display === 'none' && (display = 'block');
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    [
        'height',
        'paddingTop',
        'paddingBottom',
        'marginTop',
        'marginBottom'
    ].forEach((prop)=>{
        target.style[prop] = 0;
    });
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    [
        'padding-top',
        'padding-bottom',
        'margin-top',
        'margin-bottom'
    ].forEach((prop)=>target.style.removeProperty(prop));
    window.setTimeout(()=>{
        [
            'height',
            'overflow',
            'transition-duration',
            'transition-property'
        ].forEach((prop)=>target.style.removeProperty(prop));
    }, duration);
};
const $c692f0128d3d0bc1$export$715de50cedc228a8 = (target, duration = 500)=>window.getComputedStyle(target).display === 'none' ? $c692f0128d3d0bc1$export$abdd11a06a163232(target, duration) : $c692f0128d3d0bc1$export$deed561b1a0ff1ea(target, duration);

});

parcelRegister("jWfAU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e83f87d19c5951a4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "scrollToElement", () => $e83f87d19c5951a4$export$2353115f31f4d15);
var $e83f87d19c5951a4$export$2e2bcd8739ae039 = ()=>{
    // ! Important: Wait until page has fully loaded before scrolling (#Chrome bug)
    window.addEventListener('load', ()=>{
        if (window.location.hash) {
            window.scrollTo(0, 0);
            setTimeout(()=>{
                $e83f87d19c5951a4$export$2353115f31f4d15(window.location.hash);
            }, 1);
        }
    });
    document.addEventListener('click', function(e) {
        // loop parent nodes from the target to the delegation node
        for(let target = e.target; target && target != this; target = target.parentNode)if (target.matches('a[href^="#"]:not([href="#"]):not([href="#/"]):not(._brlbs-btn)')) {
            e.preventDefault();
            $e83f87d19c5951a4$export$2353115f31f4d15(target.getAttribute('href'));
            break;
        }
    }, false);
};
const $e83f87d19c5951a4$export$2353115f31f4d15 = (selector)=>{
    const targetEl = document.querySelector(selector);
    if (!targetEl) return;
    // Set initial scroll to an offset to increase headroom
    let scrollOffset = 32;
    // Add header height to offset if necessary
    const headerBar = document.querySelector('header.nav');
    scrollOffset += headerBar?.getBoundingClientRect().height || 0;
    // Add height of WP admin bar for logged in users
    if (document.querySelector('#wpadminbar')) scrollOffset += document.querySelector('#wpadminbar').getBoundingClientRect().height;
    // Start scrolling
    window.scrollTo(0, window.scrollY + targetEl.getBoundingClientRect().top - scrollOffset);
};

});

parcelRegister("hxRak", function(module, exports) {

$parcel$export(module.exports, "waitForElement", () => $cc5ec25473bb8d84$export$1a1c301579a08d1e);
const $cc5ec25473bb8d84$export$1a1c301579a08d1e = (selector)=>{
    return new Promise((resolve)=>{
        if (document.querySelector(selector)) return resolve(document.querySelector(selector));
        const observer = new MutationObserver(()=>{
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
};

});



const $4ba57f732accc08f$export$5fce62f50756dbf = (ctr)=>ctr.getAttribute('data-loaded') === '1';
const $4ba57f732accc08f$export$2246872225591b96 = (ctr)=>ctr.getAttribute('data-autoplay') === '1';
const $4ba57f732accc08f$export$1232c5f90e8c2039 = (ctr)=>ctr.getAttribute('data-paused') === '1';



var $afiXk = parcelRequire("afiXk");



const $450f0b4846eddfbf$export$e1252723db1c541 = {
    primaryCtr: '.theater',
    stage: '.theater__stage',
    content: '.theater__content',
    nav: '.theater__entry',
    video: 'video',
    animation: 'div',
    image: 'img'
};
const $450f0b4846eddfbf$export$ce4ab0c55987d1ff = {
    desktop: 'theater--desktop',
    mobile: 'theater--mobile',
    activeContent: 'theater__content--active',
    activeNav: 'theater__entry--active',
    navPause: 'theater__entry--pause',
    bottomNav: 'theater--bottom'
};
const $450f0b4846eddfbf$export$b5ef74bd35083b44 = 1400;


// If a individual loop count was set, add additional values For animations and videos.
const $1978b87e680830c9$export$116573485d69d323 = (contentObj, duration, loop = false)=>{
    contentObj.duration = duration;
    if (loop) {
        loop = parseInt(loop);
        if (isNaN(loop)) loop = 1;
        contentObj.loopCount = loop;
    }
    if (loop) contentObj.loopDuration = loop * duration;
};
const $1978b87e680830c9$export$b4857183b9139656 = (frames, frameRate)=>{
    const seconds = frames / frameRate;
    const milliseconds = parseInt(seconds * 1000);
    return milliseconds;
};
const $1978b87e680830c9$export$ddfa24987dade61b = (el)=>parseInt(el.getAttribute('data-index'));


const $06264ab06a79ab44$export$8df663c6555011e8 = (item)=>{
    item.addEventListener('mouseenter', (0, $8f8def4a642b99bc$export$d2eb08982f612b79));
    item.addEventListener('mouseleave', (0, $8f8def4a642b99bc$export$d2eb08982f612b79));
};
const $06264ab06a79ab44$export$7377921a7fe72fdd = (item)=>{
    item.addEventListener('click', (event)=>{
        let { elm: elm, ctr: ctr, ctrId: ctrId } = (0, $8f8def4a642b99bc$export$8ca11fb3bdf9750b)(event);
        // Remove autoplay functions
        ctr.setAttribute('data-autoplay', '0');
        ctr.querySelectorAll(`${(0, $450f0b4846eddfbf$export$e1252723db1c541).nav}, ${(0, $450f0b4846eddfbf$export$e1252723db1c541).content}`).forEach((el)=>{
            el.removeEventListener('mouseenter', (0, $8f8def4a642b99bc$export$d2eb08982f612b79));
            el.removeEventListener('mouseleave', (0, $8f8def4a642b99bc$export$d2eb08982f612b79));
        });
        if (!event.target.classList.contains((0, $450f0b4846eddfbf$export$ce4ab0c55987d1ff).navEntry)) elm = event.target.closest((0, $450f0b4846eddfbf$export$e1252723db1c541).nav);
        (0, $8f8def4a642b99bc$export$b8807798937ecb34)(ctrId);
        (0, $8f8def4a642b99bc$export$634d248e7e1720c0)(ctrId, $1978b87e680830c9$export$ddfa24987dade61b(elm));
    });
};




const $4f867c5a43670b7a$export$a7db06668cad9adb = {};
window.theater = $4f867c5a43670b7a$export$a7db06668cad9adb;
// Set the height of the container to the height of the highest element.
const $4f867c5a43670b7a$var$setCtrHeight = (ctr, ctrId)=>{
    const largest = $4f867c5a43670b7a$export$a7db06668cad9adb[ctrId].objs.reduce((prev, current)=>{
        return prev.height < current.height ? prev : current;
    });
    ctr.querySelector((0, $450f0b4846eddfbf$export$e1252723db1c541).stage).setAttribute('style', `--height: ${largest.height}px`);
};
// Checks if all elements have been loaded by checking an array of objects for the loaded flag.
// ! Currently not in use because of a too long init delay
// TODO: Remove if not needed anymore
// const onStageContentLoaded = (ctrId) => {
// 	// Show content as soon as every stage content has loaded.
// 	if (!content[ctrId].objs.find((el) => el.loaded === false)) {
// 		showContent(ctrId);
// 	}
// };
// Sets the loaded attribute to the primary container, which displays the entire component.
const $4f867c5a43670b7a$var$showContent = (ctrId)=>{
    const ctr = document.getElementById(ctrId);
    if (!$4ba57f732accc08f$export$5fce62f50756dbf(ctr)) (0, $8f8def4a642b99bc$export$634d248e7e1720c0)(ctrId);
    if (ctr.classList.contains((0, $450f0b4846eddfbf$export$ce4ab0c55987d1ff).desktop)) {
        if ($4ba57f732accc08f$export$1232c5f90e8c2039(ctr)) (0, $8f8def4a642b99bc$export$6c199204c8227f12)(ctrId);
        $4f867c5a43670b7a$var$setCtrHeight(ctr, ctrId);
    }
    document.getElementById(ctrId).setAttribute('data-loaded', '1');
};
// Sets up an array of the primary elements for each component instance for easy reference at any time.
const $4f867c5a43670b7a$var$setInstanceIndex = (ctrId, index, el, nav)=>{
    $4f867c5a43670b7a$export$a7db06668cad9adb[ctrId].objs[index] = {
        ctr: el,
        nav: nav,
        el: {},
        loaded: false,
        active: false
    };
};
// Object entries that all content entries have in common.
const $4f867c5a43670b7a$var$fillContentObjectWithValues = (contentObj, type, node, height = 0)=>{
    contentObj.type = type;
    contentObj.el = node;
    contentObj.loaded = true;
    contentObj.height = height;
};
const $4f867c5a43670b7a$export$1b500f7ebc862766 = (ctr)=>{
    ctr.addEventListener('theaterFirstItemLoaded', ()=>{
        $4f867c5a43670b7a$var$showContent(ctr.id);
    });
    // Add container data to global content
    $4f867c5a43670b7a$export$a7db06668cad9adb[ctr.id] = {
        session: {
            index: 0,
            duration: 0,
            timeLeft: 0
        }
    };
    // Initialize empty array
    $4f867c5a43670b7a$export$a7db06668cad9adb[ctr.id].objs = [];
    const theaterContentSlides = ctr.querySelectorAll((0, $450f0b4846eddfbf$export$e1252723db1c541).content);
    const theaterNavEntries = ctr.querySelectorAll((0, $450f0b4846eddfbf$export$e1252723db1c541).nav);
    // Event Listeners
    if ($4ba57f732accc08f$export$2246872225591b96(ctr)) {
        theaterContentSlides.forEach((0, $06264ab06a79ab44$export$8df663c6555011e8));
        theaterNavEntries.forEach((0, $06264ab06a79ab44$export$8df663c6555011e8));
    }
    theaterNavEntries.forEach((0, $06264ab06a79ab44$export$7377921a7fe72fdd));
    // Prefill an array of content objects to let the instance know what to load.
    theaterContentSlides.forEach((contentSlide, index)=>{
        $4f867c5a43670b7a$var$setInstanceIndex(ctr.id, index, contentSlide, theaterNavEntries[index]);
    });
    theaterContentSlides.forEach((el)=>{
        const type = el.getAttribute('data-type');
        const index = $1978b87e680830c9$export$ddfa24987dade61b(el);
        const loop = el.getAttribute('data-loop');
        const contentObj = $4f867c5a43670b7a$export$a7db06668cad9adb[ctr.id].objs[index];
        const isFirstSlide = index === 0;
        switch(type){
            case 'video':
                {
                    /**
				 * Video
				 */ const video = el.querySelector((0, $450f0b4846eddfbf$export$e1252723db1c541).video);
                    video.load();
                    video.addEventListener('loadeddata', (event)=>{
                        $4f867c5a43670b7a$var$fillContentObjectWithValues(contentObj, type, video, el.offsetHeight);
                        // Remove the thousand indicator from the number and get back a integer.
                        const milliseconds = parseInt(event.target.duration.toString().replace('.', ''));
                        $1978b87e680830c9$export$116573485d69d323(contentObj, milliseconds, loop);
                        isFirstSlide && ctr.dispatchEvent(new Event('theaterFirstItemLoaded'));
                    });
                    break;
                }
            case 'animation':
                {
                    /**
				 * Animation
				 */ const canvas = el.querySelector('canvas');
                    new (0, $afiXk.Animation)(canvas, canvas.getAttribute('data-src'), {
                        autoplay: true,
                        loop: true,
                        workerId: 'theater',
                        onLoad: (animation)=>{
                            $4f867c5a43670b7a$var$fillContentObjectWithValues(contentObj, type, animation, el.offsetHeight);
                            contentObj.totalFrames = animation.totalFrames;
                            contentObj.frameRate = animation.frameRate;
                            $1978b87e680830c9$export$116573485d69d323(contentObj, $1978b87e680830c9$export$b4857183b9139656(contentObj.totalFrames, contentObj.frameRate), loop);
                            isFirstSlide && ctr.dispatchEvent(new Event('theaterFirstItemLoaded'));
                        }
                    });
                    break;
                }
            case 'image':
                {
                    /**
				 * Image
				 */ const image = el.querySelector((0, $450f0b4846eddfbf$export$e1252723db1c541).image);
                    $4f867c5a43670b7a$var$fillContentObjectWithValues(contentObj, type, image, el.offsetHeight);
                    isFirstSlide && ctr.dispatchEvent(new Event('theaterFirstItemLoaded'));
                    break;
                }
        }
        $4f867c5a43670b7a$export$a7db06668cad9adb[ctr.id].objs[index] = contentObj;
    });
};




const $8f8def4a642b99bc$var$loopInterval = {};
const $8f8def4a642b99bc$var$loopTimeout = {};
const $8f8def4a642b99bc$export$b8807798937ecb34 = (ctrId)=>{
    clearTimeout($8f8def4a642b99bc$var$loopTimeout[ctrId]);
    clearInterval($8f8def4a642b99bc$var$loopInterval[ctrId]);
};
const $8f8def4a642b99bc$export$b4a54ea986b5c77 = (ctrId, elm, type, active = true)=>{
    if ([
        'video',
        'animation'
    ].includes(type)) {
        if (active) {
            if (!$4ba57f732accc08f$export$2246872225591b96(document.getElementById(ctrId))) // Make sure the content begins from new when it is clicked
            switch(type){
                case 'video':
                    elm.currentTime = 0;
                    break;
                case 'animation':
                    elm.stop();
                    break;
            }
            elm.play();
        } else elm.pause();
    }
};
const $8f8def4a642b99bc$export$634d248e7e1720c0 = (ctrId, elmId = 0)=>{
    const prevElm = (0, $4f867c5a43670b7a$export$a7db06668cad9adb)[ctrId].objs.find((elm)=>elm.active === true), currentElm = (0, $4f867c5a43670b7a$export$a7db06668cad9adb)[ctrId].objs[elmId];
    if (prevElm) {
        prevElm.ctr.classList.remove((0, $450f0b4846eddfbf$export$ce4ab0c55987d1ff).activeContent);
        prevElm.nav.classList.remove((0, $450f0b4846eddfbf$export$ce4ab0c55987d1ff).activeNav);
        prevElm.nav.querySelector('.h6').setAttribute('role', 'button');
        prevElm.active = false;
        $8f8def4a642b99bc$export$b4a54ea986b5c77(ctrId, prevElm.el, prevElm.type, false);
    }
    currentElm.ctr.classList.add((0, $450f0b4846eddfbf$export$ce4ab0c55987d1ff).activeContent);
    currentElm.nav.classList.add((0, $450f0b4846eddfbf$export$ce4ab0c55987d1ff).activeNav);
    currentElm.nav.querySelector('.h6').removeAttribute('role');
    currentElm.active = true;
    $8f8def4a642b99bc$export$b4a54ea986b5c77(ctrId, currentElm.el, currentElm.type);
};
const $8f8def4a642b99bc$export$6c199204c8227f12 = (ctrId, sessionDuration = null)=>{
    const ctr = document.getElementById(ctrId), defaultDuration = parseInt(ctr.getAttribute('data-default-duration')), intervalSpeed = 100;
    let index = (0, $4f867c5a43670b7a$export$a7db06668cad9adb)[ctrId].session.index, duration = (0, $4f867c5a43670b7a$export$a7db06668cad9adb)[ctrId].objs[index].loopDuration ? (0, $4f867c5a43670b7a$export$a7db06668cad9adb)[ctrId].objs[index].loopDuration : defaultDuration;
    // If the session was interrupted, the remaining time overwrites the duration.
    if (sessionDuration !== null) duration = sessionDuration;
    (0, $4f867c5a43670b7a$export$a7db06668cad9adb)[ctrId].session = {
        ...(0, $4f867c5a43670b7a$export$a7db06668cad9adb)[ctrId].session,
        duration: duration,
        timeLeft: duration
    };
    const nav = (0, $4f867c5a43670b7a$export$a7db06668cad9adb)[ctrId].objs[index].nav.querySelector('.inner');
    // Set the initial animation to start at 100% if it was not interrupted.
    if (sessionDuration === null || sessionDuration === 0) (0, $4f867c5a43670b7a$export$a7db06668cad9adb)[ctrId].session.animation = nav.animate([
        {
            strokeDasharray: '100 0'
        },
        {
            strokeDasharray: '0 100'
        }
    ], {
        duration: duration
    });
    else (0, $4f867c5a43670b7a$export$a7db06668cad9adb)[ctrId].session.animation.play();
    // The timeout function handles the process for automatically displaying the next element.
    // only if Container has autoplay active switch between slides and restart animation on index switch
    if ($4ba57f732accc08f$export$2246872225591b96(document.getElementById(ctrId))) $8f8def4a642b99bc$var$loopTimeout[ctrId] = setTimeout(()=>{
        if (index < (0, $4f867c5a43670b7a$export$a7db06668cad9adb)[ctrId].objs.length - 1) // Continue to next slide
        index++;
        else // Start with first slide again
        index = 0;
        (0, $4f867c5a43670b7a$export$a7db06668cad9adb)[ctrId].session.index = index;
        $8f8def4a642b99bc$export$b8807798937ecb34(ctrId);
        $8f8def4a642b99bc$export$634d248e7e1720c0(ctrId, index);
        $8f8def4a642b99bc$export$6c199204c8227f12(ctrId);
    }, duration);
    else $8f8def4a642b99bc$var$loopTimeout[ctrId] = setTimeout(()=>{
        $8f8def4a642b99bc$export$b8807798937ecb34(ctrId);
        $8f8def4a642b99bc$export$6c199204c8227f12(ctrId);
    }, duration);
    // The interval captures the remaining time when the loop is interrupted.
    $8f8def4a642b99bc$var$loopInterval[ctrId] = setInterval(()=>{
        (0, $4f867c5a43670b7a$export$a7db06668cad9adb)[ctrId].session.timeLeft = (0, $4f867c5a43670b7a$export$a7db06668cad9adb)[ctrId].session.timeLeft - intervalSpeed;
    }, intervalSpeed);
};
const $8f8def4a642b99bc$export$8ca11fb3bdf9750b = (event)=>{
    const elm = event.target;
    const ctr = elm.closest((0, $450f0b4846eddfbf$export$e1252723db1c541).primaryCtr);
    return {
        elm: elm,
        ctr: ctr,
        ctrId: ctr.id
    };
};
const $8f8def4a642b99bc$export$d2eb08982f612b79 = (event)=>{
    const { elm: elm, ctrId: ctrId } = $8f8def4a642b99bc$export$8ca11fb3bdf9750b(event);
    const contentElm = (0, $4f867c5a43670b7a$export$a7db06668cad9adb)[ctrId].objs[$1978b87e680830c9$export$ddfa24987dade61b(elm)];
    if (elm.classList.contains((0, $450f0b4846eddfbf$export$ce4ab0c55987d1ff).activeNav) || elm.classList.contains((0, $450f0b4846eddfbf$export$ce4ab0c55987d1ff).activeContent)) {
        if ($4ba57f732accc08f$export$2246872225591b96(elm.closest((0, $450f0b4846eddfbf$export$e1252723db1c541).primaryCtr))) {
            if (event.type === 'mouseenter') {
                $8f8def4a642b99bc$export$733bc5d7b00b32a9(contentElm, ctrId);
                $8f8def4a642b99bc$export$b4a54ea986b5c77(ctrId, contentElm.el, contentElm.type);
            } else {
                $8f8def4a642b99bc$export$c85c451981efa27f(contentElm, ctrId);
                $8f8def4a642b99bc$export$b4a54ea986b5c77(ctrId, contentElm.el, contentElm.type);
            }
        }
    }
};
const $8f8def4a642b99bc$export$733bc5d7b00b32a9 = (contentElm, ctrId)=>{
    document.getElementById(ctrId).setAttribute('data-paused', 1);
    contentElm.nav.classList.add((0, $450f0b4846eddfbf$export$ce4ab0c55987d1ff).navPause);
    contentElm.type !== 'image' && contentElm.el.pause(); // trigger only on Animations or Videos
    clearTimeout($8f8def4a642b99bc$var$loopTimeout[ctrId]);
    clearInterval($8f8def4a642b99bc$var$loopInterval[ctrId]);
};
const $8f8def4a642b99bc$export$c85c451981efa27f = (contentElm, ctrId)=>{
    document.getElementById(ctrId).setAttribute('data-paused', 0);
    contentElm.nav.classList.remove((0, $450f0b4846eddfbf$export$ce4ab0c55987d1ff).navPause);
    contentElm.type !== 'image' && contentElm.el?.play(); // trigger only on Animations or Videos
    $8f8def4a642b99bc$export$6c199204c8227f12(ctrId, (0, $4f867c5a43670b7a$export$a7db06668cad9adb)[ctrId].session.timeLeft);
};









// Checks if the first element already has the loaded flag and if not, loops the query until it arrives.
const $c1e0a4ba42f45077$var$firstElementLoaded = (elem)=>{
    const interval = setInterval(()=>{
        if (elem.loaded) {
            const ctr = elem.ctr.closest((0, $450f0b4846eddfbf$export$e1252723db1c541).primaryCtr);
            clearInterval(interval);
            (0, $8f8def4a642b99bc$export$c85c451981efa27f)(elem, ctr.id);
            return elem;
        }
    }, 100);
};
const $c1e0a4ba42f45077$var$intersectionCallback = (entries)=>{
    entries.forEach((entry)=>{
        let elem = entry.target;
        const ctr = elem.closest((0, $450f0b4846eddfbf$export$e1252723db1c541).primaryCtr);
        const index = $1978b87e680830c9$export$ddfa24987dade61b(elem);
        let contentElm = (0, $4f867c5a43670b7a$export$a7db06668cad9adb)[ctr.id].objs[index];
        if (entry.isIntersecting) {
            (0, $8f8def4a642b99bc$export$634d248e7e1720c0)(ctr.id, index);
            if (contentElm.loaded) (0, $8f8def4a642b99bc$export$c85c451981efa27f)(contentElm, ctr.id);
        } else if (contentElm.loaded) (0, $8f8def4a642b99bc$export$733bc5d7b00b32a9)(contentElm, ctr.id);
        // When the IntersectionObserver checks what is in the viewport, the content does not necessarily have to be loaded.
        // Therefore, the first element must be verified to be loaded and then played.
        if (contentElm.loaded === false) $c1e0a4ba42f45077$var$firstElementLoaded(contentElm);
        else (0, $8f8def4a642b99bc$export$c85c451981efa27f)(contentElm, ctr.id);
    });
};
const $c1e0a4ba42f45077$export$796a22222043445c = (ctr)=>{
    let options = {
        root: ctr,
        rootMargin: '0px',
        threshold: 0.9
    };
    let observer = new IntersectionObserver($c1e0a4ba42f45077$var$intersectionCallback, options);
    let targets = ctr.querySelectorAll((0, $450f0b4846eddfbf$export$e1252723db1c541).nav);
    targets.forEach((t)=>{
        observer.observe(t);
    });
};


const $431278aa36a8625f$var$observer = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        const ctr = entry.target;
        const theater = (0, $4f867c5a43670b7a$export$a7db06668cad9adb)[ctr.id].objs.filter((t)=>t.active === true)[0];
        if (entry.isIntersecting) {
            if ($4ba57f732accc08f$export$5fce62f50756dbf(ctr) && $4ba57f732accc08f$export$1232c5f90e8c2039(ctr)) (0, $8f8def4a642b99bc$export$c85c451981efa27f)(theater, ctr.id);
        } else if ($4ba57f732accc08f$export$5fce62f50756dbf(ctr)) (0, $8f8def4a642b99bc$export$733bc5d7b00b32a9)(theater, ctr.id);
    });
});
const $431278aa36a8625f$var$containers = document.querySelectorAll((0, $450f0b4846eddfbf$export$e1252723db1c541).primaryCtr);
$431278aa36a8625f$var$containers.forEach((ctr)=>{
    const isMobile = ctr.classList.contains((0, $450f0b4846eddfbf$export$ce4ab0c55987d1ff).mobile);
    (0, $4f867c5a43670b7a$export$1b500f7ebc862766)(ctr);
    // Decide whether mobile processing should be done.
    if (isMobile) (0, $c1e0a4ba42f45077$export$796a22222043445c)(ctr);
    else if (!ctr.classList.contains((0, $450f0b4846eddfbf$export$ce4ab0c55987d1ff).bottomNav)) window.addEventListener('resize', ()=>{
        const windowWidth = document.querySelector('html').clientWidth;
        windowWidth < (0, $450f0b4846eddfbf$export$b5ef74bd35083b44) ? ctr.classList.add((0, $450f0b4846eddfbf$export$ce4ab0c55987d1ff).bottomNav) : ctr.classList.remove((0, $450f0b4846eddfbf$export$ce4ab0c55987d1ff).bottomNav);
    });
    $431278aa36a8625f$var$observer.observe(ctr);
});

})();
//# sourceMappingURL=theater.min.js.map
